import { __awaiter, __generator, __spread, __values, __assign } from 'tslib';
import { Injectable, ɵɵdefineInjectable, ɵɵinject, EventEmitter, Component, Input, Output, Renderer2, ViewChild, NgModule, Pipe, Directive, ElementRef, HostBinding, ChangeDetectorRef, ChangeDetectionStrategy, InjectionToken, Inject } from '@angular/core';
import { PopoverController, Events, ModalController, Platform, ToastController, AlertController, IonicModule, ActionSheetController, LoadingController } from '@ionic/angular';
import { CommonModule, Location } from '@angular/common';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Subscription, Subject, throwError } from 'rxjs';
import { cloneDeep, pickBy, identity, assign, toNumber, concat, map, indexOf, find, sumBy, join, isArray, isObject, orderBy, some, startCase, merge, filter, sortBy, findIndex, reverse } from 'lodash';
import * as moment_ from 'moment';
import { TableModule } from 'primeng/table';
import { Validators, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule, FileUploader } from 'ng2-file-upload';
import { TooltipModule } from 'primeng/tooltip';
import { TooltipModule as TooltipModule$1 } from 'primeng/primeng';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { map as map$1, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { OverlayPanelModule } from 'primeng/overlaypanel';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderListService = /** @class */ (function () {
    function OrderListService(http) {
        this.http = http;
        this.orders = new BehaviorSubject(null);
    }
    /**
     * @param {?} url
     * @param {?=} reqParams
     * @return {?}
     */
    OrderListService.prototype.query = /**
     * @param {?} url
     * @param {?=} reqParams
     * @return {?}
     */
    function (url, reqParams) {
        /** @type {?} */
        var params = new HttpParams({ fromObject: reqParams });
        /* return this.http.get<IOrder[]>(url, {params}).subscribe(data => {
          this.orders.next(data);
          return data;
        });*/
        return this.http.get(url, {
            params: params,
            observe: "response",
        });
    };
    /**
     * @param {?} id
     * @return {?}
     */
    OrderListService.prototype.removeOrder = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.delete("/core/pickup-order/" + id, {});
    };
    OrderListService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    OrderListService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ OrderListService.ngInjectableDef = ɵɵdefineInjectable({ factory: function OrderListService_Factory() { return new OrderListService(ɵɵinject(HttpClient)); }, token: OrderListService, providedIn: "root" });
    return OrderListService;
}());
if (false) {
    /** @type {?} */
    OrderListService.prototype.orders;
    /**
     * @type {?}
     * @private
     */
    OrderListService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * An object used to get page information from the server
 */
var Page = /** @class */ (function () {
    function Page() {
        this.size = 10;
        this.page = 0;
        this.totalCount = 0;
        this.sort = "createdDate,desc";
    }
    return Page;
}());
if (false) {
    /** @type {?} */
    Page.prototype.totalCount;
    /** @type {?} */
    Page.prototype.size;
    /** @type {?} */
    Page.prototype.page;
    /** @type {?} */
    Page.prototype.sort;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var RCYL_ORDERS_GLOBALS = {
    EVENTS_TO_PUBLISH: {
        MANAGE_COLUMN_STATE_CHANGED: "state_changed",
        REFRESH_ORDERS: "refreshOrders",
        // rcyl-orderList:needRefresh {appChannelName, channelName, reason}
        ORDERS_LOADED: "RCYL_ORDERS_LOADED",
        // rcyl-orderList:loaded [this.page, this.settings.channelName]
        ANALYTICS: "RCYL_ORDERS_ANALYTICS",
        // rcyl-order-list-analytics {eventName, params}
        ORDER_CHANGED: "RCYL_ORDER_CHANGED",
        // rcyl-orderList:changed  [orderStatus, relevantData] , possible status ORDER_DOCUMENTS
        ORDER_DOCUMENTS_UPDATED: "RCYL_ORDER_DOCUMENTS_UPDATED",
        ORDER_LOGISTIC_DETAILS_UPDATED: "",
        MARKET_ORDER_WEIGH_BRIDGE_DOCUMENTS_UPDATED: "RCYL_MARKET_ORDER_WEIGH_BRIDGE_DOCUMENTS_UPDATED",
        // rcyl-marketOrderWeighBridgeDocumentsUpdated [TYPE, DOCS]
        MARKET_ORDER_LAB_REPORT_UPDATED: "RCYL_MARKET_ORDER_LAB_REPORT_UPDATED",
        SHOW_TOAST: "RCYL_SHOW_TOAST",
        // {message: string, color?: string, duration?: number, closeBtnText?: string},
        VIEW_BG: "RCYL_VIEW_BG_COLOR",
    },
    ORDER_MAX_UPLOAD_FILES_LIMIT_PER_TYPE: 6,
    REGEX: {
        NUMBER_STRING_AND_SPACES_ONLY: "[0-9A-Za-z ]*",
        AADHAR_NUMBER: "[0-9]{12}",
        PAN_NUMBER: "[A-Za-z]{5}\\d{4}[A-Za-z]{1}",
        DRIVING_LICENCE: "",
        PASSPORT_NUMBER: "[A-Z]{1}[0-9]{7}",
        VEHICLE_NUMBER: "^[A-Za-z]{2}\\s{0,1}[0-9]{2}\\s{0,1}[A-Za-z]{1,2}\\s{0,1}[0-9]{1,4}$",
        VOTER_ID: "",
        UPI_ID: "^\\w+@\\w+$",
        PIN_CODE: "^[ ]*[1-9][0-9]{5}[ ]*$",
        GSTIN: "\\d{2}[A-Z]{5}\\d{4}[A-Z]{1}[A-Z\\d]{1}[Z]{1}[A-Z\\d]{1}",
        IFSC: "^[ ]*[A-Za-z]{4}0[A-Z0-9a-z]{6}[ ]*$",
        EMAIL: "^[ ]*[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}[ ]*$",
        // in email we are allowing heading & trailing whitespaces
        MOBILE_NO: "^[ ]*[0-9]{10,10}[ ]*$",
    },
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ManageColumnsComponent = /** @class */ (function () {
    function ManageColumnsComponent(popoverController, events) {
        this.popoverController = popoverController;
        this.events = events;
        this.selected = new EventEmitter();
        this.change = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ManageColumnsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    ManageColumnsComponent.prototype.onStateChanged = /**
     * @return {?}
     */
    function () {
        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.MANAGE_COLUMN_STATE_CHANGED, this.columns);
    };
    ManageColumnsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-manage-columns",
                    template: "<ion-list>\n  <ion-item *ngFor=\"let data of columns\" lines=\"none\" [hidden]=\"data.fixed\">\n    <ion-checkbox\n      class=\"location-checkbox\"\n      (ionChange)=\"onStateChanged()\"\n      [(ngModel)]=\"data.display\"\n      name=\"{{ data.label }}\"\n      slot=\"start\"\n      [checked]=\"data.display\"\n    ></ion-checkbox>\n    <ion-label class=\"location-label\" font-regular=\"\" text-small>\n      {{ data.label }}</ion-label\n    >\n  </ion-item>\n</ion-list>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ManageColumnsComponent.ctorParameters = function () { return [
        { type: PopoverController },
        { type: Events }
    ]; };
    ManageColumnsComponent.propDecorators = {
        columns: [{ type: Input }],
        selected: [{ type: Output }],
        change: [{ type: Output }]
    };
    return ManageColumnsComponent;
}());
if (false) {
    /** @type {?} */
    ManageColumnsComponent.prototype.columns;
    /** @type {?} */
    ManageColumnsComponent.prototype.selected;
    /** @type {?} */
    ManageColumnsComponent.prototype.change;
    /**
     * @type {?}
     * @private
     */
    ManageColumnsComponent.prototype.popoverController;
    /**
     * @type {?}
     * @private
     */
    ManageColumnsComponent.prototype.events;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectPickupExecutiveService = /** @class */ (function () {
    function SelectPickupExecutiveService(http, rcylOrdersService) {
        this.http = http;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @return {?}
     */
    SelectPickupExecutiveService.prototype.getPickupPersons = /**
     * @return {?}
     */
    function () {
        return this.http.get("/stakeholders/pickup-people");
    };
    /**
     * @param {?} err
     * @return {?}
     */
    SelectPickupExecutiveService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    SelectPickupExecutiveService.prototype.markAsScheduled = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/assign-executive", data);
    };
    SelectPickupExecutiveService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    SelectPickupExecutiveService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: RcylOrdersService }
    ]; };
    /** @nocollapse */ SelectPickupExecutiveService.ngInjectableDef = ɵɵdefineInjectable({ factory: function SelectPickupExecutiveService_Factory() { return new SelectPickupExecutiveService(ɵɵinject(HttpClient), ɵɵinject(RcylOrdersService)); }, token: SelectPickupExecutiveService, providedIn: "root" });
    return SelectPickupExecutiveService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    SelectPickupExecutiveService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    SelectPickupExecutiveService.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var SelectPickupExecutiveComponent = /** @class */ (function () {
    function SelectPickupExecutiveComponent(modalCtrl, pickupPersonService, rcylOrdersService) {
        this.modalCtrl = modalCtrl;
        this.pickupPersonService = pickupPersonService;
        this.rcylOrdersService = rcylOrdersService;
        this.pickupPersons = [];
        this.select = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SelectPickupExecutiveComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.loadPickupPersons();
        if (this.selectedPickupPersonId) {
            this.assignedPersonId = this.selectedPickupPersonId;
        }
    };
    /**
     * @return {?}
     */
    SelectPickupExecutiveComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss(null);
    };
    /**
     * @private
     * @return {?}
     */
    SelectPickupExecutiveComponent.prototype.loadPickupPersons = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.pickupPersonService.getPickupPersons().subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.pickupPersons = res;
        }));
    };
    /**
     * @return {?}
     */
    SelectPickupExecutiveComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var data = {
            executiveId: this.selectedPersonId,
            orderIds: typeof this.orderId === "number" ? [this.orderId] : this.orderId,
        };
        if (this.selectedPersonId === this.selectedPickupPersonId) {
            this.rcylOrdersService.presentToast("Cannot assign same executive person. Please select another person");
            return;
        }
        else {
            this.pickupPersonService.markAsScheduled(data).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                _this.rcylOrdersService.presentToast("Pickup Executive assigned successfully");
                _this.modalCtrl.dismiss(res);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                // this.pickupPersonService.onFailed(error);
            }));
        }
    };
    /**
     * @param {?} person
     * @return {?}
     */
    SelectPickupExecutiveComponent.prototype.setPickupPerson = /**
     * @param {?} person
     * @return {?}
     */
    function (person) {
        this.assignedPersonId = person.id;
        this.selectedPerson = person;
        this.selectedPersonId = this.assignedPersonId;
    };
    SelectPickupExecutiveComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-select-pickup-executive",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title text-center> Select Pickup Executive </ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon\n          class=\"position-rule\"\n          slot=\"icon-only\"\n          name=\"close-circle\"\n        ></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-grid *ngIf=\"pickupPersons && pickupPersons?.length > 0\">\n    <ion-row\n      *ngFor=\"let person of pickupPersons\"\n      (click)=\"setPickupPerson(person)\"\n    >\n      <ion-col size=\"12\">\n        <ion-item lines=\"none\" color=\"light\" class=\"my-item\">\n          <ion-col size=\"12\">\n            <ion-text font-bold text-regular=\"\" color=\"dark\">\n              {{ person?.userName }}\n            </ion-text>\n            <br />\n            <ion-text font-regular=\"\" text-regular=\"\" color=\"medium\">\n              {{ person?.mobileNumber }}\n            </ion-text>\n          </ion-col>\n          <ion-icon\n            class=\"icon-color\"\n            name=\"radio-button-off\"\n            slot=\"end\"\n            [hidden]=\"assignedPersonId === person?.id\"\n          ></ion-icon>\n          <ion-icon\n            name=\"checkmark-circle\"\n            slot=\"end\"\n            color=\"primary\"\n            [hidden]=\"assignedPersonId != person?.id\"\n          ></ion-icon>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n  <ion-grid *ngIf=\"pickupPersons?.length === 0\">\n    <ion-row>\n      <ion-col size=\"12\" class=\"ion-text-center\">\n        <ion-text color=\"dark\" class=\"text-medium font-medium\"\n          >There are no pickup executives</ion-text\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-content>\n<ion-footer no-box-shadow>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-button\n          centered=\"\"\n          [disabled]=\"!selectedPersonId\"\n          (click)=\"submit()\"\n          recykal-button=\"\"\n          size=\"large\"\n          expand=\"block\"\n          color=\"primary\"\n        >\n          Done\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [".icon-color{color:#c7d2d8}"]
                }] }
    ];
    /** @nocollapse */
    SelectPickupExecutiveComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: SelectPickupExecutiveService },
        { type: RcylOrdersService }
    ]; };
    SelectPickupExecutiveComponent.propDecorators = {
        orderId: [{ type: Input }],
        type: [{ type: Input }],
        selectedPickupPersonId: [{ type: Input }],
        select: [{ type: Output }]
    };
    return SelectPickupExecutiveComponent;
}());
if (false) {
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.pickupPersons;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.orderId;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.type;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.selectedPickupPersonId;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.select;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.selectedPersonId;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.assignedPersonId;
    /** @type {?} */
    SelectPickupExecutiveComponent.prototype.selectedPerson;
    /**
     * @type {?}
     * @private
     */
    SelectPickupExecutiveComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    SelectPickupExecutiveComponent.prototype.pickupPersonService;
    /**
     * @type {?}
     * @private
     */
    SelectPickupExecutiveComponent.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var moment = moment_;
/**
 * @record
 */
function IOrderListOptions() { }
if (false) {
    /** @type {?} */
    IOrderListOptions.prototype.url;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.filters;
    /** @type {?} */
    IOrderListOptions.prototype.orderType;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.status;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.page;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.selectable;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.columns;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.extraColumns;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.actions;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.orderInfo;
    /** @type {?|undefined} */
    IOrderListOptions.prototype.channelName;
}
var OrderListComponent = /** @class */ (function () {
    function OrderListComponent(orderConfig, orderService, popoverController, events, modalCtrl, platform) {
        var _this = this;
        this.orderConfig = orderConfig;
        this.orderService = orderService;
        this.popoverController = popoverController;
        this.events = events;
        this.modalCtrl = modalCtrl;
        this.platform = platform;
        this.firstTimeLoad = true;
        this.loadingIndicator = false;
        this.selectedOrders = [];
        this.rowClicked = new EventEmitter();
        this.onOrderDataLoaded = new EventEmitter();
        /**
         * Refresh market order data and simple order data separately.
         * Refresh list if any or order changed.
         */
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS, (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data.appChannel === "RECYKAL") {
                if (data.channelName === _this.options.channelName) {
                    _this.setPage();
                }
            }
            else {
                _this.setPage();
            }
        }));
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.setPage();
        }));
    }
    /**
     * @return {?}
     */
    OrderListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var initialValues = cloneDeep(this.options);
        this.initialData = initialValues;
        this.loadOrders(false);
        this.setActiveView(); // To set view of order (MOBILE or DESKTOP)
    };
    /**
     * @return {?}
     */
    OrderListComponent.prototype.setActiveView = /**
     * @return {?}
     */
    function () {
        if (this.orderConfig.channel === "STARGAZE") {
            this.activeView = "DESKTOP";
        }
        else {
            if (this.platform.is("mobile")) {
                this.activeView = "MOBILE";
            }
            else {
                this.activeView = "DESKTOP";
            }
        }
    };
    /**
     * @param {?=} isLoadMore
     * @param {?=} infiniteScrollEvent
     * @return {?}
     */
    OrderListComponent.prototype.loadOrders = /**
     * @param {?=} isLoadMore
     * @param {?=} infiniteScrollEvent
     * @return {?}
     */
    function (isLoadMore, infiniteScrollEvent) {
        var _this = this;
        this.selectedOrders = [];
        this.loadingIndicator = true;
        /** @type {?} */
        var filters = pickBy(this.options.filters, identity);
        /** @type {?} */
        var params = {};
        assign(params, this.options.page, { status: this.options.status || "" }, filters);
        if (this.options.channelName) {
            assign(params, { channelName: this.options.channelName });
        }
        this.orderService.query(this.options.url, params).subscribe((/**
         * @param {?} response
         * @return {?}
         */
        function (response) {
            _this.options.page.totalCount = toNumber(response.headers.get("X-Total-Count"));
            console.log("orders", response);
            _this.onOrderDataLoaded.emit({
                order: response,
                isFirstTime: _this.firstTimeLoad,
                page: _this.options.page,
                filterData: filters,
            });
            _this.firstTimeLoad = false;
            if (isLoadMore) {
                _this.orders = concat(_this.orders, response.body);
                infiniteScrollEvent.target.complete();
            }
            else {
                _this.orders = response.body;
            }
            map(_this.orders, (/**
             * @param {?} order
             * @return {?}
             */
            function (order) {
                if (order.orderType === "PICKUP") {
                    if (order.timeSlot && order.timeSlot.startTime) {
                        /** @type {?} */
                        var dateDiff = moment(order.timeSlot.startTime)
                            .startOf("day")
                            .diff(moment(Date.now()).startOf("day"), "days");
                        if (dateDiff < 0) {
                            order.delay = Math.abs(dateDiff);
                        }
                    }
                    else {
                        order.delay = 0;
                    }
                }
            }));
            _this.loadingIndicator = false;
            _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDERS_LOADED, _this.options.page, _this.options.channelName);
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            _this.loadingIndicator = false;
        }));
    };
    /**
     * @param {?} object
     * @param {?} path
     * @return {?}
     */
    OrderListComponent.prototype.printData = /**
     * @param {?} object
     * @param {?} path
     * @return {?}
     */
    function (object, path) {
        /** @type {?} */
        var stack = path.split(">");
        while (stack.length > 1) {
            object = object[stack.shift()];
        }
        /** @type {?} */
        var data = object[stack.shift()];
        if (data) {
            return data;
        }
        else {
            return "-";
        }
    };
    /**
     * Populate the table with new data based on the page number
     * @param pageInfo The page to select
     */
    /**
     * Populate the table with new data based on the page number
     * @param {?=} pageInfo The page to select
     * @return {?}
     */
    OrderListComponent.prototype.setPage = /**
     * Populate the table with new data based on the page number
     * @param {?=} pageInfo The page to select
     * @return {?}
     */
    function (pageInfo) {
        this.currentPage = this.options.page.page;
        if (!this.currentPage) {
            this.currentPage = 0;
        }
        this.options.page.page = pageInfo ? pageInfo.first / pageInfo.rows : 0;
        this.loadOrders();
    };
    /**
     * @param {?} type
     * @return {?}
     */
    OrderListComponent.prototype.showActionButton = /**
     * @param {?} type
     * @return {?}
     */
    function (type) {
        /** @type {?} */
        var isPresent = indexOf(this.options.actions, type) >= 0;
        return isPresent;
    };
    /**
     * sort the current table with one of props
     */
    /**
     * sort the current table with one of props
     * @param {?} event
     * @return {?}
     */
    OrderListComponent.prototype.onSort = /**
     * sort the current table with one of props
     * @param {?} event
     * @return {?}
     */
    function (event) {
        // event was triggered, start sort sequence
        console.log("Sort Event", event);
        /** @type {?} */
        var sortObj = event.multisortmeta[0];
        if (sortObj) {
            /** @type {?} */
            var columnProp = sortObj.field;
            if (columnProp === "orderId") {
                columnProp = "id";
            }
            this.options.page.sort =
                columnProp + "," + "" + (sortObj.order > 0 ? "asc" : "desc");
        }
    };
    /**
     * called on clicking/selecting row item
     * @output selected
     */
    /**
     * called on clicking/selecting row item
     * \@output selected
     * @param {?} $event
     * @return {?}
     */
    OrderListComponent.prototype.onRowClick = /**
     * called on clicking/selecting row item
     * \@output selected
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        console.log("event", $event);
        if ($event.type === "row") {
        }
        if ($event.type === "checkbox") {
        }
    };
    /**
     * called on clicking/selecting row item
     * @output selected
     */
    /**
     * called on clicking/selecting row item
     * \@output selected
     * @param {?} $event
     * @return {?}
     */
    OrderListComponent.prototype.onRowUnselect = /**
     * called on clicking/selecting row item
     * \@output selected
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        console.log("event", $event);
        if ($event.type === "row") {
        }
        if ($event.type === "checkbox") {
        }
    };
    /**
     * @output viewDetails of an order
     */
    /**
     * \@output viewDetails of an order
     * @param {?} order
     * @param {?} rowIndex
     * @return {?}
     */
    OrderListComponent.prototype.viewDetails = /**
     * \@output viewDetails of an order
     * @param {?} order
     * @param {?} rowIndex
     * @return {?}
     */
    function (order, rowIndex) {
        this.selectedOrders = [];
        // this.events.publish('order:view', {order});
        this.rowClicked.emit(order);
    };
    /**
     * Manage extra columns
     */
    /**
     * Manage extra columns
     * @param {?} ev
     * @return {?}
     */
    OrderListComponent.prototype.manageColumns = /**
     * Manage extra columns
     * @param {?} ev
     * @return {?}
     */
    function (ev) {
        return __awaiter(this, void 0, void 0, function () {
            var popover;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.popoverController.create({
                            component: ManageColumnsComponent,
                            componentProps: {
                                columns: this.options.columns,
                            },
                            event: ev,
                            mode: "ios",
                            showBackdrop: true,
                            cssClass: "custom-popover",
                        })];
                    case 1:
                        popover = _a.sent();
                        popover.onDidDismiss().then((/**
                         * @param {?} response
                         * @return {?}
                         */
                        function (response) {
                            console.log(response.data);
                            _this.events.unsubscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.MANAGE_COLUMN_STATE_CHANGED);
                        }));
                        popover.present().then((/**
                         * @param {?} pop
                         * @return {?}
                         */
                        function (pop) {
                            _this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.MANAGE_COLUMN_STATE_CHANGED, (/**
                             * @param {?} data
                             * @return {?}
                             */
                            function (data) {
                                console.log("state", data);
                                // this.filterDataByLocation(data);
                                _this.options.columns = data;
                            }));
                        }));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Manage extra columns
     */
    /**
     * Manage extra columns
     * @param {?=} order
     * @return {?}
     */
    OrderListComponent.prototype.selectPickupExecutive = /**
     * Manage extra columns
     * @param {?=} order
     * @return {?}
     */
    function (order) {
        return __awaiter(this, void 0, void 0, function () {
            var orderIds, modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderIds = null;
                        if (order) {
                            this.selectedPickupPerson = order.pickupPerson;
                            orderIds = order.id;
                        }
                        else if (this.selectedOrders.length > 1) {
                            orderIds = map(this.selectedOrders, "id");
                        }
                        return [4 /*yield*/, this.modalCtrl.create({
                                component: SelectPickupExecutiveComponent,
                                componentProps: {
                                    orderId: orderIds,
                                    selectedPickupPersonId: this.selectedPickupPerson
                                        ? this.selectedPickupPerson.id
                                        : null,
                                },
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.loadOrders();
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    OrderListComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.selectedOrders = [];
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    OrderListComponent.prototype.makePayment = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.loadOrders();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    OrderListComponent.prototype.verifyInvoice = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.loadOrders();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    OrderListComponent.prototype.applyFilter = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.options.page = new Page();
        this.options.filters = data;
        this.setPage();
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    OrderListComponent.prototype.idClicked = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        /** @type {?} */
        var order = $event;
        this.viewDetails(order, null);
    };
    /**
     * loadmore order for mobile view
     */
    /**
     * loadmore order for mobile view
     * @param {?} event
     * @return {?}
     */
    OrderListComponent.prototype.loadMore = /**
     * loadmore order for mobile view
     * @param {?} event
     * @return {?}
     */
    function (event) {
        this.options.page.page++;
        this.loadOrders(true, event);
    };
    /**
     * @return {?}
     */
    OrderListComponent.prototype.refreshOrders = /**
     * @return {?}
     */
    function () {
        this.options = cloneDeep(this.initialData);
        this.options.page.page = 0;
        this.options.page.totalCount = 0;
        this.setPage();
    };
    /**
     * @param {?} order
     * @return {?}
     */
    OrderListComponent.prototype.downloadProforma = /**
     * @param {?} order
     * @return {?}
     */
    function (order) {
        this.events.publish("PROFORMA_DOWNLOAD_FORM_LIST", order);
    };
    OrderListComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-order-list",
                    template: "<div [ngSwitch]=\"activeView\">\n  <ng-template [ngSwitchCase]=\"'DESKTOP'\">\n    <div>\n      <ion-grid class=\"ion-no-padding\">\n        <ion-row>\n          <ion-col style=\"padding: 0; align-items: center; display: flex\">\n            <div>\n              <ion-text\n                style=\"font-style: italic; font-size: 0.8571rem\"\n                color=\"medium\"\n                >{{ options?.orderInfo }}</ion-text\n              >\n            </div>\n          </ion-col>\n          <ion-col size=\"auto\" float-right>\n            <!--            <ion-button color=\"dgrey\" fill=\"outline\" float-end class=\"table-action-btns\" tooltipPosition=\"bottom\" pTooltip=\"Export\" tooltipStyleClass=\"tooltip-bg-white\"  ><ion-icon [src]=\"'./assets/export.svg'\" color=\"dgrey\" size=\"small\"></ion-icon></ion-button>-->\n            <ion-button\n              color=\"dgrey\"\n              fill=\"outline\"\n              float-end\n              class=\"table-action-btns\"\n              tooltipPosition=\"bottom\"\n              pTooltip=\"Add column\"\n              tooltipStyleClass=\"tooltip-bg-white\"\n              (click)=\"manageColumns($event)\"\n              ><ion-icon\n                [src]=\"'./assets/add-column.svg'\"\n                color=\"dgrey\"\n                size=\"small\"\n              ></ion-icon\n            ></ion-button>\n            <ion-button\n              color=\"dgrey\"\n              fill=\"outline\"\n              float-end\n              class=\"table-action-btns\"\n              tooltipPosition=\"bottom\"\n              pTooltip=\"Refresh\"\n              tooltipStyleClass=\"tooltip-bg-white\"\n              (click)=\"refreshOrders()\"\n              ><ion-icon\n                name=\"refresh\"\n                mode=\"ios\"\n                color=\"dgrey\"\n                size=\"small\"\n              ></ion-icon\n            ></ion-button>\n            <ion-button\n              color=\"dgrey\"\n              fill=\"outline\"\n              float-end\n              class=\"table-action-btns\"\n              tooltipPosition=\"bottom\"\n              pTooltip=\"You can bulk assign executives from here.\"\n              (click)=\"selectPickupExecutive()\"\n              tooltipStyleClass=\"tooltip-bg-white\"\n              *ngIf=\"\n                selectedOrders.length > 1 && showActionButton('assignExecutive')\n              \"\n              ><ion-icon name=\"person-add\" color=\"dgrey\" size=\"small\"></ion-icon\n            ></ion-button>\n            <rcyl-make-payment-button\n              *ngIf=\"\n                showActionButton('makePayment') && selectedOrders.length > 1\n              \"\n              [selectedOrders]=\"selectedOrders\"\n              (paymentStatus)=\"makePayment($event)\"\n            ></rcyl-make-payment-button>\n          </ion-col>\n        </ion-row>\n      </ion-grid>\n      <p-table\n        #dt\n        [value]=\"orders\"\n        [paginator]=\"\n          options?.page?.totalCount > options?.page?.size ? true : false\n        \"\n        [lazy]=\"true\"\n        [rows]=\"options.page.size\"\n        [(first)]=\"currentPage\"\n        [totalRecords]=\"options.page.totalCount\"\n        (onLazyLoad)=\"setPage($event)\"\n        sortMode=\"multiple\"\n        (onSort)=\"onSort($event)\"\n        [scrollable]=\"orders?.length > 0 ? true : false\"\n        [style]=\"{ width: '100%' }\"\n        [selectionMode]=\"'multiple'\"\n        [tableStyleClass]=\"\n          orders?.length > 0 ? 'ui-table-responsive' : 'normal-table'\n        \"\n        [tableStyle]=\"{ 'background-color': '#fff' }\"\n        (onRowSelect)=\"onRowClick($event)\"\n        (onRowUnselect)=\"onRowUnselect($event)\"\n        [loading]=\"loadingIndicator\"\n        [(selection)]=\"selectedOrders\"\n      >\n        <ng-template pTemplate=\"emptymessage\" let-columns>\n          <tr padding=\"\" *ngIf=\"!loadingIndicator\">\n            <td text-center=\"\" colspan=\"100%\">No Orders found</td>\n          </tr>\n        </ng-template>\n        <ng-template pTemplate=\"colgroup\">\n          <colgroup>\n            <col *ngIf=\"options.selectable\" style=\"width: 100px\" />\n            <col\n              *ngFor=\"let col of options.columns\"\n              [hidden]=\"!col.display\"\n              [ngStyle]=\"{ width: col.width || '100px' }\"\n            />\n            <col\n              *ngIf=\"showActionButton('showPaymentStatusCol')\"\n              style=\"width: 150px\"\n            />\n            <col\n              *ngIf=\"\n                showActionButton('assignExecutive') ||\n                showActionButton('makePayment')\n              \"\n              style=\"width: 150px\"\n            />\n            <col\n              *ngIf=\"options.actions.length > 0 && showActionButton('view')\"\n              style=\"width: 50px\"\n              class=\"action-col\"\n            />\n          </colgroup>\n        </ng-template>\n        <ng-template pTemplate=\"header\" [ngIf]=\"orders?.length > 0\">\n          <tr>\n            <th *ngIf=\"options.selectable\"></th>\n            <th *ngFor=\"let thCol of options.columns\" [hidden]=\"!thCol.display\">\n              {{ thCol?.label }}\n              <p-sortIcon\n                *ngIf=\"thCol?.sort\"\n                pSortableColumn=\"{{ thCol?.sort }}\"\n                [field]=\"thCol.sort\"\n              ></p-sortIcon>\n            </th>\n            <th *ngIf=\"showActionButton('showPaymentStatusCol')\">\n              Payment Status\n            </th>\n            <th\n              *ngIf=\"\n                showActionButton('assignExecutive') ||\n                showActionButton('makePayment')\n              \"\n              style=\"width: 150px\"\n            >\n              Actions\n            </th>\n            <th\n              *ngIf=\"options.actions.length > 0 && showActionButton('view')\"\n              style=\"width: 50px\"\n            ></th>\n          </tr>\n          <tr>\n            <th class=\"filter-col\" *ngIf=\"options.selectable\"></th>\n            <th\n              class=\"filter-col\"\n              *ngFor=\"let thCol of options.columns\"\n              [hidden]=\"!thCol.display\"\n            >\n              <rcyl-data-filter-inputs\n                *ngIf=\"thCol.filterOptions\"\n                [filterOptions]=\"options.filters\"\n                [inputData]=\"thCol.filterOptions\"\n                (applyFilters)=\"applyFilter($event)\"\n              ></rcyl-data-filter-inputs>\n            </th>\n            <th\n              class=\"filter-col\"\n              *ngIf=\"showActionButton('showPaymentStatusCol')\"\n            ></th>\n            <th\n              class=\"filter-col\"\n              *ngIf=\"\n                showActionButton('assignExecutive') ||\n                showActionButton('makePayment')\n              \"\n            ></th>\n            <th\n              class=\"filter-col\"\n              *ngIf=\"options.actions.length > 0 && showActionButton('view')\"\n            ></th>\n          </tr>\n        </ng-template>\n        <ng-template pTemplate=\"body\" let-order>\n          <tr>\n            <td *ngIf=\"options.selectable\">\n              <p-tableCheckbox [value]=\"order\"></p-tableCheckbox>\n            </td>\n            <td\n              *ngFor=\"let tdCol of options.columns\"\n              [hidden]=\"!tdCol.display\"\n              [pSelectableRow]=\"order\"\n            >\n              <!--dynamic data START-->\n              <rcyl-order-list-data\n                [order]=\"order\"\n                [column]=\"tdCol\"\n                (idClicked)=\"idClicked($event)\"\n              ></rcyl-order-list-data>\n              <!--dynamic data END-->\n            </td>\n            <td *ngIf=\"showActionButton('showPaymentStatusCol')\">\n              <div [ngSwitch]=\"order.paymentStatus\">\n                <ng-template [ngSwitchCase]=\"'INVOICE_PENDING'\">\n                  <div class=\"status-display\">\n                    <div class=\"status-dot invoice_pending\"></div>\n                    <div>\n                      <ion-text color=\"medium\" text-regular=\"\"\n                        >Invoice Pending</ion-text\n                      >\n                    </div>\n                  </div>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'INVOICE_VERIFICATION_PENDING'\">\n                  <rcyl-verify-invoice-button\n                    [formattedId]=\"order.formattedId\"\n                    [id]=\"order.id\"\n                    (verifiedStatus)=\"verifyInvoice($event)\"\n                  ></rcyl-verify-invoice-button>\n                </ng-template>\n                <ng-template [ngSwitchCase]=\"'INVOICE_REJECTED'\">\n                  <div class=\"status-display\">\n                    <div class=\"status-dot invoice_rejected\"></div>\n                    <div>\n                      <ion-text color=\"medium\" text-regular=\"\"\n                        >Invoice Rejected</ion-text\n                      >\n                    </div>\n                  </div>\n                </ng-template>\n              </div>\n            </td>\n            <td\n              *ngIf=\"\n                showActionButton('assignExecutive') ||\n                showActionButton('makePayment')\n              \"\n              style=\"width: 150px\"\n            >\n              <div d-flex=\"\" class=\"ion-align-items-center\">\n                <ion-button\n                  *ngIf=\"\n                    showActionButton('assignExecutive') &&\n                    selectedOrders.length < 2 &&\n                    order.orderType === 'PICKUP'\n                  \"\n                  (click)=\"selectPickupExecutive(order)\"\n                  color=\"primary\"\n                >\n                  Assign Executive\n                </ion-button>\n                <rcyl-make-payment-button\n                  *ngIf=\"\n                    showActionButton('makePayment') && selectedOrders.length < 2\n                  \"\n                  [selectOrder]=\"order?.id\"\n                  [order]=\"order\"\n                  [tradeType]=\"order?.tradeType\"\n                  (paymentStatus)=\"makePayment($event)\"\n                ></rcyl-make-payment-button>\n              </div>\n            </td>\n            <td\n              *ngIf=\"options.actions.length > 0 && showActionButton('view')\"\n              style=\"width: 50px\"\n              class=\"action-col\"\n            >\n              <div d-flex=\"\" class=\"ion-align-items-center\">\n                <ion-button\n                  *ngIf=\"showActionButton('proformaDownload')\"\n                  tooltipPosition=\"bottom\"\n                  pTooltip=\"Download Proforma Invoice\"\n                  (click)=\"downloadProforma(order)\"\n                  class=\"proforma-downloaf-btn view-btn\"\n                >\n                  <ion-icon class=\"ion-margin-start\" name=\"download\"></ion-icon>\n                </ion-button>\n                <ion-button\n                  [hidden]=\"\n                    selectedOrders.length > 2 &&\n                    orderConfig.channel === 'STARGAZE' &&\n                    showActionButton('assignExecutive')\n                  \"\n                  (click)=\"viewDetails(order, null)\"\n                  class=\"view-btn\"\n                >\n                  <ion-icon class=\"ion-margin-start\" name=\"eye\"></ion-icon>\n                </ion-button>\n              </div>\n            </td>\n          </tr>\n        </ng-template>\n      </p-table>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'MOBILE'\">\n    <div *ngIf=\"options.channelName !== 'Marketplace'\">\n      <order-card\n        [order]=\"order\"\n        *ngFor=\"let order of orders\"\n        (onOrderClicked)=\"viewDetails($event, null)\"\n      ></order-card>\n    </div>\n    <div *ngIf=\"options.channelName == 'Marketplace'\">\n      <market-order-card\n        [order]=\"order\"\n        *ngFor=\"let order of orders\"\n        (onOrderClicked)=\"viewDetails($event, null)\"\n      ></market-order-card>\n    </div>\n    <ion-grid\n      d-flex\n      style=\"height: 95%\"\n      *ngIf=\"loadingIndicator && orders?.length <= 0\"\n    >\n      <ion-row style=\"height: 95%; width: 100%\">\n        <ion-col text-center d-flex align-self-center justify-content-center>\n          <div><ion-spinner name=\"crescent\"></ion-spinner></div>\n          <div d-flex align-self-center>&nbsp; Fetching Orders...</div>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n    <ion-infinite-scroll\n      threshold=\"100px\"\n      [disabled]=\"orders?.length >= options.page.totalCount\"\n      (ionInfinite)=\"loadMore($event)\"\n    >\n      <ion-infinite-scroll-content loadingText=\"Loading more orders...\">\n      </ion-infinite-scroll-content>\n    </ion-infinite-scroll>\n  </ng-template>\n</div>\n",
                    styles: [":host ion-button.table-action-btns{--padding-end:0;--padding-start:0;height:34px;width:34px;border-radius:6px}:host ion-button.table-action-btns ion-icon{font-size:13px}:host .status-display{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;line-height:15px;text-transform:capitalize}:host .status-display .status-dot{width:8px;height:8px;margin-right:7px;border-radius:50%}:host .status-display .status-dot.invoice_pending{background-color:#ffef8c}:host .status-display .status-dot.payment_pending{background-color:#fcd974}:host .status-display .status-dot.invoice_rejected{background-color:#ff7a5f}:host .status-display .status-dot.invoice_verification_pending{background-color:#fbc45b}:host .ui-widget.ui-table table{table-layout:fixed!important}:host .cursor-pointer{cursor:pointer}:host .view-btn{--background:transparent;--color:inherit;--padding-start:0;--background-hover:transparent}"]
                }] }
    ];
    /** @nocollapse */
    OrderListComponent.ctorParameters = function () { return [
        { type: RcylOrderConfigService },
        { type: OrderListService },
        { type: PopoverController },
        { type: Events },
        { type: ModalController },
        { type: Platform }
    ]; };
    OrderListComponent.propDecorators = {
        options: [{ type: Input }],
        rowClicked: [{ type: Output }],
        onOrderDataLoaded: [{ type: Output }]
    };
    return OrderListComponent;
}());
if (false) {
    /** @type {?} */
    OrderListComponent.prototype.orders;
    /** @type {?} */
    OrderListComponent.prototype.firstTimeLoad;
    /** @type {?} */
    OrderListComponent.prototype.loadingIndicator;
    /** @type {?} */
    OrderListComponent.prototype.selectedOrders;
    /** @type {?} */
    OrderListComponent.prototype.selectedPickupPerson;
    /** @type {?} */
    OrderListComponent.prototype.initialData;
    /** @type {?} */
    OrderListComponent.prototype.currentPage;
    /** @type {?} */
    OrderListComponent.prototype.activeView;
    /** @type {?} */
    OrderListComponent.prototype.options;
    /** @type {?} */
    OrderListComponent.prototype.rowClicked;
    /** @type {?} */
    OrderListComponent.prototype.onOrderDataLoaded;
    /** @type {?} */
    OrderListComponent.prototype.orderConfig;
    /**
     * @type {?}
     * @private
     */
    OrderListComponent.prototype.orderService;
    /**
     * @type {?}
     * @private
     */
    OrderListComponent.prototype.popoverController;
    /**
     * @type {?}
     * @private
     */
    OrderListComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    OrderListComponent.prototype.modalCtrl;
    /** @type {?} */
    OrderListComponent.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IFilterOptions() { }
if (false) {
    /** @type {?|undefined} */
    IFilterOptions.prototype.fieldType;
    /** @type {?|undefined} */
    IFilterOptions.prototype.key;
    /** @type {?|undefined} */
    IFilterOptions.prototype.options;
}
/**
 * @record
 */
function FieldOptions() { }
if (false) {
    /** @type {?|undefined} */
    FieldOptions.prototype.type;
    /** @type {?|undefined} */
    FieldOptions.prototype.value;
    /** @type {?|undefined} */
    FieldOptions.prototype.url;
    /** @type {?|undefined} */
    FieldOptions.prototype.template;
}
/** @enum {string} */
var DropDownType = {
    SINGLE: "SINGLE",
    MULTI_SELECT: "MULTI_SELECT",
    AUTO_COMPLETE: "AUTO_COMPLETE",
};
/** @enum {string} */
var FilterInputType = {
    TEXT: "TEXT",
    NUMBER: "NUMBER",
    SINGLE_SELECT: "SINGLE_SELECT",
    MULTI_SELECT: "MULTI_SELECT",
    AUTO_COMPLETE: "AUTO_COMPLETE",
    DATE_RANGE: "DATE_RANGE",
    SLIDER_RANGE: "SLIDER_RANGE",
    DELAY: "DELAY",
};
/** @enum {string} */
var OrderTemplateType = {
    GENERIC: "GENERIC",
    GENERIC_DATE: "GENERIC_DATE",
    QUANTITY: "QUANTITY",
    ADDRESS: "ADDRESS",
    FROM_LOCATION: "FROM_LOCATION",
    STATUS: "STATUS",
    EMAIL: "EMAIL",
    CONTACT: "CONTACT",
    CURRENCY: "CURRENCY",
    EXECUTIVE: "EXECUTIVE",
    DELAY: "DELAY",
    BUSINESS_TYPE: "BUSINESS_TYPE",
    RECEIVED_LOCATION: "RECEIVED_LOCATION",
    CITY_NAME: "CITY_NAME",
};
/**
 * @record
 */
function IOrderListColumn() { }
if (false) {
    /** @type {?|undefined} */
    IOrderListColumn.prototype.label;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.labelInfo;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.path;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.template;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.sort;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.display;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.fixed;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.width;
    /** @type {?|undefined} */
    IOrderListColumn.prototype.filterOptions;
}
var OrderListColumn = /** @class */ (function () {
    function OrderListColumn(label, labelInfo, path, template, sort, display, fixed, width, filterOptions) {
        this.label = label;
        this.labelInfo = labelInfo;
        this.path = path;
        this.template = template;
        this.sort = sort;
        this.display = display;
        this.fixed = fixed;
        this.width = width;
        this.filterOptions = filterOptions;
    }
    return OrderListColumn;
}());
if (false) {
    /** @type {?} */
    OrderListColumn.prototype.label;
    /** @type {?} */
    OrderListColumn.prototype.labelInfo;
    /** @type {?} */
    OrderListColumn.prototype.path;
    /** @type {?} */
    OrderListColumn.prototype.template;
    /** @type {?} */
    OrderListColumn.prototype.sort;
    /** @type {?} */
    OrderListColumn.prototype.display;
    /** @type {?} */
    OrderListColumn.prototype.fixed;
    /** @type {?} */
    OrderListColumn.prototype.width;
    /** @type {?} */
    OrderListColumn.prototype.filterOptions;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderListDataComponent = /** @class */ (function () {
    function OrderListDataComponent() {
        this.idClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    OrderListDataComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} object
     * @param {?} path
     * @return {?}
     */
    OrderListDataComponent.prototype.printData = /**
     * @param {?} object
     * @param {?} path
     * @return {?}
     */
    function (object, path) {
        /** @type {?} */
        var stack = path.split(">");
        while (stack.length > 1) {
            object = object[stack.shift()];
        }
        /** @type {?} */
        var data = object ? object[stack.shift()] : "";
        if (data) {
            return data;
        }
        else {
            return "";
        }
    };
    /**
     * @param {?} order
     * @return {?}
     */
    OrderListDataComponent.prototype.orderIdClicked = /**
     * @param {?} order
     * @return {?}
     */
    function (order) {
        this.idClicked.emit(order);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    OrderListDataComponent.prototype.printAsAbs = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return Math.abs(value);
    };
    OrderListDataComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-order-list-data",
                    template: "<!--dynamic data START-->\n<div [ngSwitch]=\"column.template.id\">\n  <ng-template [ngSwitchCase]=\"'GENERIC'\">\n    <div\n      *ngIf=\"column.path === 'formattedId'\"\n      class=\"cursor-pointer\"\n      (click)=\"orderIdClicked(order)\"\n    >\n      {{ printData(order, column.path) ? printData(order, column.path) : \"-\" }}\n    </div>\n    <div *ngIf=\"column.path != 'formattedId'\">\n      {{ printData(order, column.path) ? printData(order, column.path) : \"-\" }}\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'GENERIC_DATE'\">\n    <div>\n      {{\n        printData(order, column.path)\n          ? (printData(order, column.path) | date: \"dd MMM, yyyy\")\n          : \"-\"\n      }}\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'ADDRESS'\">\n    <div class=\"address-box line-2\">\n      <div *ngIf=\"!order.saleOrder && order.orderType === 'DROP'\">-</div>\n      <div\n        *ngIf=\"!order.saleOrder && order.orderType === 'PICKUP'\"\n        [pTooltip]=\"order?.fromLocation?.addressInfo | address\"\n        tooltipStyleClass=\"tooltip-bg-white\"\n      >\n        {{ order?.fromLocation?.name }} <br />{{\n          order?.fromLocation?.addressInfo\n            ? (order?.fromLocation?.addressInfo | address)\n            : \"-\"\n        }}\n      </div>\n      <div\n        *ngIf=\"order.saleOrder\"\n        [pTooltip]=\"order?.toLocation?.addressInfo | address\"\n        tooltipStyleClass=\"tooltip-bg-white\"\n      >\n        {{ order?.toLocation?.name }}<br />{{\n          order?.toLocation?.addressInfo\n            ? (order?.toLocation?.addressInfo | address)\n            : \"-\"\n        }}\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'CITY_NAME'\">\n    <div class=\"address-box line-2\">\n      <div *ngIf=\"!order.saleOrder && order.orderType === 'DROP'\">-</div>\n      <div\n        *ngIf=\"!order.saleOrder && order.orderType === 'PICKUP'\"\n        [pTooltip]=\"order?.fromLocation && order?.fromLocation?.addressInfo | address\"\n        tooltipStyleClass=\"tooltip-bg-white\"\n      >\n        {{\n          order?.fromLocation && order?.fromLocation?.addressInfo\n            ? order?.fromLocation?.addressInfo?.city?.name\n            : \"-\"\n        }}\n      </div>\n      <div\n        *ngIf=\"order.saleOrder\"\n        [pTooltip]=\"\n          order?.toLocation && order?.toLocation?.addressInfo | address\n        \"\n        tooltipStyleClass=\"tooltip-bg-white\"\n      >\n        {{\n          order?.toLocation && order?.toLocation?.addressInfo\n            ? order?.toLocation?.addressInfo?.city?.name\n            : \"-\"\n        }}\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'FROM_LOCATION'\">\n    <div class=\"address-box line-2\">\n      <div\n        *ngIf=\"order?.fromLocation?.addressInfo\"\n        [pTooltip]=\"order?.fromLocation?.addressInfo | address\"\n        tooltipStyleClass=\"tooltip-bg-white\"\n      >\n        {{ order?.fromLocation?.name }}<br />{{\n          order?.fromLocation?.addressInfo\n            ? (order?.fromLocation?.addressInfo | address)\n            : \"-\"\n        }}\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'RECEIVED_LOCATION'\">\n    <div class=\"address-box line-2\">\n      <div\n        [pTooltip]=\"order?.toLocation?.addressInfo | address\"\n        tooltipStyleClass=\"tooltip-bg-white\"\n      >\n        {{ order?.toLocation?.name }}<br />{{\n          order?.toLocation?.addressInfo\n            ? (order?.toLocation?.addressInfo | address)\n            : \"-\"\n        }}\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'QUANTITY'\">\n    <div>\n      {{\n        printData(order, column.path)\n          ? printData(order, column.path) + \" Kgs\"\n          : \"-\"\n      }}\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'EMAIL'\">\n    <div *ngIf=\"!order.saleOrder && order.orderType === 'DROP'\">\n      {{ order.seller?.email || \"-\" }}\n    </div>\n    <div *ngIf=\"!order.saleOrder && order.orderType === 'PICKUP'\">\n      {{ order.fromLocation?.email || \"-\" }}\n    </div>\n    <div *ngIf=\"order.saleOrder\">{{ order.buyer?.email || \"-\" }}</div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'STATUS'\">\n    <div class=\"status-display\">\n      <div\n        class=\"status-dot {{\n          order.displayStatusTitle === 'Completed'\n            ? order.paymentStatus\n              ? order.paymentStatus.toLowerCase()\n              : '-'\n            : order.displayStatusTitle.replace(' ', '_').toLowerCase()\n        }}\"\n      ></div>\n      <div>\n        {{\n          order.displayStatusTitle === \"Completed\"\n            ? order.paymentStatus\n              ? order.paymentStatus.split(\"_\").join(\" \").toLowerCase()\n              : \"-\"\n            : order.displayStatusTitle\n        }}\n      </div>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'CONTACT'\">\n    <div *ngIf=\"!order.saleOrder && order.orderType === 'DROP'\">\n      {{ order.seller?.mobile || \"-\" }}\n    </div>\n    <div *ngIf=\"!order.saleOrder && order.orderType === 'PICKUP'\">\n      {{ order.fromLocation?.contactNumber || \"-\" }}\n    </div>\n    <div *ngIf=\"order.saleOrder\">{{ order.buyer?.mobile || \"-\" }}</div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'EXECUTIVE'\">\n    <div>\n      <div *ngIf=\"order.pickupPerson\">\n        <div *ngIf=\"order.pickupPerson\">\n          {{ order.pickupPerson?.userName || \"-\" }}\n        </div>\n        <div *ngIf=\"order.pickupPerson\">\n          {{ order.pickupPerson?.mobileNumber || \"-\" }}\n        </div>\n      </div>\n      <div *ngIf=\"!order.pickupPerson\">-</div>\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'DELAY'\">\n    <div class=\"delay-column\">\n      {{\n        order.delay ? order.delay + (order.delay === 1 ? \" Day\" : \" Days\") : \"-\"\n      }}\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'CURRENCY'\">\n    <div>\n      {{\n        printData(order, column.path)\n          ? (printAsAbs(printData(order, column.path)) | currency: \"INR\")\n          : 0\n      }}\n    </div>\n  </ng-template>\n\n  <ng-template [ngSwitchCase]=\"'BUSINESS_TYPE'\">\n    <div class=\"bgtype\">\n      <span\n        *ngIf=\"!order.saleOrder\"\n        class=\"{{ order.seller?.businessType?.code || '' }}\"\n        >{{ order.seller?.businessType?.title || \"-\" }}</span\n      >\n      <span\n        *ngIf=\"order.saleOrder\"\n        class=\"{{ order.buyer?.businessType?.code || '' }}\"\n        >{{ order.buyer?.businessType?.title || \"-\" }}</span\n      >\n    </div>\n  </ng-template>\n</div>\n",
                    styles: [":host .cursor-pointer{cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    OrderListDataComponent.ctorParameters = function () { return []; };
    OrderListDataComponent.propDecorators = {
        column: [{ type: Input }],
        order: [{ type: Input }],
        idClicked: [{ type: Output }]
    };
    return OrderListDataComponent;
}());
if (false) {
    /** @type {?} */
    OrderListDataComponent.prototype.column;
    /** @type {?} */
    OrderListDataComponent.prototype.order;
    /** @type {?} */
    OrderListDataComponent.prototype.idClicked;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropLocationsService = /** @class */ (function () {
    function DropLocationsService(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    DropLocationsService.prototype.loadDropLocations = /**
     * @return {?}
     */
    function () {
        return this.http.get("/core/locations");
    };
    DropLocationsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    DropLocationsService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ DropLocationsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DropLocationsService_Factory() { return new DropLocationsService(ɵɵinject(HttpClient)); }, token: DropLocationsService, providedIn: "root" });
    return DropLocationsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DropLocationsService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DropLocationsComponent = /** @class */ (function () {
    function DropLocationsComponent(modalCtrl, dropLocationsService) {
        this.modalCtrl = modalCtrl;
        this.dropLocationsService = dropLocationsService;
        this.locations = [];
    }
    /**
     * @return {?}
     */
    DropLocationsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getLocations();
    };
    /**
     * @return {?}
     */
    DropLocationsComponent.prototype.getLocations = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.dropLocationsService.loadDropLocations().subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.locations = res;
        }));
    };
    /**
     * @param {?} location
     * @return {?}
     */
    DropLocationsComponent.prototype.onLocationChange = /**
     * @param {?} location
     * @return {?}
     */
    function (location) {
        this.changedLocationId = location.id;
    };
    /**
     * @return {?}
     */
    DropLocationsComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss(null);
    };
    /**
     * @return {?}
     */
    DropLocationsComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var loc = find(this.locations, { id: this.selectLocationId });
        this.modalCtrl.dismiss(loc);
    };
    DropLocationsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-drop-locations",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-buttons slot=\"start\">\n      <ion-back-button></ion-back-button>\n    </ion-buttons>\n    <ion-title class=\"ion-text-center\">{{ \"Select Drop Location\" }}</ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"close()\">\n        <ion-icon slot=\"icon-only\" name=\"close-circle\"></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-grid no-padding>\n    <ion-row>\n      <ion-col\n        class=\"ion-no-padding\"\n        size=\"12\"\n        *ngIf=\"locations?.length > 0; else noItems\"\n      >\n        <ion-radio-group name=\"locationsGroup\" [(ngModel)]=\"selectLocationId\">\n          <rcyl-location-item\n            *ngFor=\"let location of locations\"\n            (locationChanged)=\"onLocationChange($event)\"\n            [selectedLocationId]=\"selectLocationId\"\n            [locationItem]=\"location\"\n          >\n          </rcyl-location-item>\n        </ion-radio-group>\n      </ion-col>\n      <ng-template #noItems>\n        <div\n          style=\"\n            height: 60vh;\n            display: flex;\n            width: 100%;\n            flex-direction: column;\n          \"\n          class=\"ion-align-items-center ion-justify-content-center\"\n        >\n          <div class=\"ion-text-center\" *ngIf=\"locations === null\">\n            <ion-spinner></ion-spinner><br />\n            <div font-medium>Fetching locations...</div>\n          </div>\n          <div class=\"ion-text-center\" *ngIf=\"locations?.length === 0\">\n            <ion-title font-medium>No Locations</ion-title>\n            <ion-text\n              >There are no location. Please contact your admin.</ion-text\n            >\n          </div>\n        </div>\n      </ng-template>\n    </ion-row>\n  </ion-grid>\n</ion-content>\n<ion-footer class=\"no-box-shadow\" *ngIf=\"changedLocationId > 0\">\n  <ion-col size=\"12\">\n    <ion-button\n      centered=\"\"\n      (click)=\"submit()\"\n      recykal-button\n      size=\"large\"\n      expand=\"block\"\n      color=\"primary\"\n    >\n      Proceed\n    </ion-button>\n  </ion-col>\n</ion-footer>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    DropLocationsComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: DropLocationsService }
    ]; };
    DropLocationsComponent.propDecorators = {
        selectLocationId: [{ type: Input }]
    };
    return DropLocationsComponent;
}());
if (false) {
    /** @type {?} */
    DropLocationsComponent.prototype.locations;
    /** @type {?} */
    DropLocationsComponent.prototype.changedLocationId;
    /** @type {?} */
    DropLocationsComponent.prototype.selectLocationId;
    /**
     * @type {?}
     * @private
     */
    DropLocationsComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    DropLocationsComponent.prototype.dropLocationsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var LocationItemComponent = /** @class */ (function () {
    function LocationItemComponent() {
        this.locationChanged = new EventEmitter();
    }
    /**
     * @return {?}
     */
    LocationItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} location
     * @return {?}
     */
    LocationItemComponent.prototype.onItemSelect = /**
     * @param {?} location
     * @return {?}
     */
    function (location) {
        this.locationChanged.emit(location);
    };
    LocationItemComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-location-item",
                    template: "<ion-item my-item=\"\" text-center lines=\"none\">\n  <ion-grid no-padding>\n    <ion-row no-padding>\n      <ion-col no-padding size=\"12\">\n        <ion-icon\n          [color]=\"selectedLocationId === locationItem.id ? 'light' : 'none'\"\n          text-center\n          [src]=\"'./assets/store.svg'\"\n          style=\"font-size: 36px\"\n        ></ion-icon>\n      </ion-col>\n      <ion-col size=\"12\" class=\"location-name\" text-center no-padding>\n        <ion-text\n          [ngClass]=\"\n            selectedLocationId === locationItem.id\n              ? 'after-selection-color'\n              : 'before-selection-title'\n          \"\n          text-center\n        >\n          {{ locationItem.name }}\n        </ion-text>\n      </ion-col>\n      <ion-col size=\"12\" class=\"location-addr\" no-padding padding-horizontal>\n        <ion-text\n          text-center\n          [ngClass]=\"\n            selectedLocationId === locationItem.id\n              ? 'after-selection-color'\n              : 'before-selection-street'\n          \"\n        >\n          <span\n            >{{ locationItem?.addressInfo?.flatBuilding }},\n            {{ locationItem?.addressInfo?.street }}</span\n          >\n        </ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n  <ion-radio\n    (ionSelect)=\"onItemSelect(locationItem)\"\n    [value]=\"locationItem.id\"\n  ></ion-radio>\n  <ion-icon\n    class=\"check-mark-position\"\n    color=\"primary\"\n    [name]=\"'checkmark-circle'\"\n    slot=\"end\"\n  ></ion-icon>\n</ion-item>\n",
                    styles: [":host ion-item[my-item]{--background:#f4f9fa;--border-radius:6px;padding:0;height:113px;--min-height:113px;max-width:529px;margin:13px auto;overflow:initial}:host ion-item[my-item] .check-mark-position{position:absolute;visibility:hidden;top:-25px;right:-14px;background:#fff;border-radius:50%;padding:.5px;font-size:24px}:host ion-item[my-item].item-radio-checked{--background:#27353c;--background-hover:var(--background)}:host ion-item[my-item].item-radio-checked .check-mark-position{visibility:visible}:host ion-item[my-item] ion-radio{opacity:0;width:0}:host .location-name{font-size:.8571rem;font-family:font-bold;line-height:11px;margin-top:5px}:host .location-addr{line-height:15px;padding-top:3px;text-align:center;font-size:.8571rem}:host .after-selection-color{color:#fff}:host .before-selection-street{color:#27353c}"]
                }] }
    ];
    /** @nocollapse */
    LocationItemComponent.ctorParameters = function () { return []; };
    LocationItemComponent.propDecorators = {
        locationItem: [{ type: Input }],
        selectedLocationId: [{ type: Input }],
        locationChanged: [{ type: Output }]
    };
    return LocationItemComponent;
}());
if (false) {
    /** @type {?} */
    LocationItemComponent.prototype.locationItem;
    /** @type {?} */
    LocationItemComponent.prototype.selectedLocationId;
    /** @type {?} */
    LocationItemComponent.prototype.locationChanged;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CancelOrderModalService = /** @class */ (function () {
    function CancelOrderModalService(http, toast, rcylOrdersService) {
        this.http = http;
        this.toast = toast;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @param {?} orderId
     * @param {?=} reason
     * @return {?}
     */
    CancelOrderModalService.prototype.markAsRejected = /**
     * @param {?} orderId
     * @param {?=} reason
     * @return {?}
     */
    function (orderId, reason) {
        return this.http.put("/core/orders/" + orderId + "/mark-as-cancelled", reason);
    };
    /**
     * @param {?} orderId
     * @param {?=} reason
     * @return {?}
     */
    CancelOrderModalService.prototype.markAsHold = /**
     * @param {?} orderId
     * @param {?=} reason
     * @return {?}
     */
    function (orderId, reason) {
        return this.http.put("/core/orders/" + orderId + "/mark-as-hold", reason);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    CancelOrderModalService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg).then();
    };
    CancelOrderModalService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    CancelOrderModalService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ToastController },
        { type: RcylOrdersService }
    ]; };
    /** @nocollapse */ CancelOrderModalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CancelOrderModalService_Factory() { return new CancelOrderModalService(ɵɵinject(HttpClient), ɵɵinject(ToastController), ɵɵinject(RcylOrdersService)); }, token: CancelOrderModalService, providedIn: "root" });
    return CancelOrderModalService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    CancelOrderModalService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    CancelOrderModalService.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    CancelOrderModalService.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CancelOrderModalComponent = /** @class */ (function () {
    function CancelOrderModalComponent(modalCtrl, cancelOrderService, rcylOrdersService) {
        this.modalCtrl = modalCtrl;
        this.cancelOrderService = cancelOrderService;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @return {?}
     */
    CancelOrderModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    CancelOrderModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss(null);
    };
    /**
     * @param {?} reason
     * @return {?}
     */
    CancelOrderModalComponent.prototype.selectReason = /**
     * @param {?} reason
     * @return {?}
     */
    function (reason) {
        this.selectedReasonId = reason.id;
        this.cancelReason = reason.title;
        if (this.cancelReason === "Others") {
            this.cancelReason = "";
        }
    };
    /**
     * @return {?}
     */
    CancelOrderModalComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.buttonClicked === "HOLD") {
            this.cancelOrderService.markAsHold(this.id, this.cancelReason).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                _this.rcylOrdersService.presentToast("You have successfully placed the order on hold");
                _this.modalCtrl.dismiss(res);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                // this.cancelOrderService.onFailed(error);
            }));
        }
        else if (this.buttonClicked === "REJECT") {
            this.cancelOrderService
                .markAsRejected(this.id, this.cancelReason)
                .subscribe((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                _this.rcylOrdersService.presentToast("Order has been cancelled successfully");
                _this.modalCtrl.dismiss(res);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                // this.cancelOrderService.onFailed(error);
            }));
        }
    };
    CancelOrderModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-cancel-order-modal",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title text-center>\n      Select a reason for changing the order to {{ buttonClicked | lowercase }}\n    </ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon\n          class=\"position-rule\"\n          slot=\"icon-only\"\n          name=\"close-circle\"\n        ></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-grid *ngIf=\"reasons?.length > 0\">\n    <ion-row *ngFor=\"let rsn of reasons\" (click)=\"selectReason(rsn)\">\n      <ion-col size=\"12\">\n        <ion-item lines=\"none\" class=\"card-background\">\n          <ion-text text-regular class=\"txt-color\">\n            {{ rsn?.title }}\n          </ion-text>\n          <ion-icon\n            class=\"icon-color\"\n            name=\"radio-button-off\"\n            slot=\"end\"\n            [hidden]=\"selectedReasonId === rsn.id\"\n          ></ion-icon>\n          <ion-icon\n            name=\"checkmark-circle\"\n            slot=\"end\"\n            color=\"primary\"\n            [hidden]=\"selectedReasonId != rsn.id\"\n          ></ion-icon>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-item lines=\"none\">\n          <ion-textarea\n            class=\"txt-area-brdr\"\n            text-regular\n            [rows]=\"1\"\n            [(ngModel)]=\"cancelReason\"\n            [placeholder]=\"'write your reasons...'\"\n          ></ion-textarea>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-content>\n<ion-footer>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-button\n          centered=\"\"\n          [disabled]=\"!selectedReasonId || !cancelReason\"\n          (click)=\"submit()\"\n          recykal-button=\"\"\n          size=\"large\"\n          expand=\"block\"\n          color=\"primary\"\n        >\n          Done\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [".card-background{--background:var(--ion-color-light);--border-radius:6px;padding:0 15px}.txt-color{color:#5b7583!important}.txt-area-brdr{border:1px solid #eff1f2;border-radius:5px}"]
                }] }
    ];
    /** @nocollapse */
    CancelOrderModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: CancelOrderModalService },
        { type: RcylOrdersService }
    ]; };
    CancelOrderModalComponent.propDecorators = {
        reasons: [{ type: Input }],
        type: [{ type: Input }],
        buttonClicked: [{ type: Input }],
        id: [{ type: Input }]
    };
    return CancelOrderModalComponent;
}());
if (false) {
    /** @type {?} */
    CancelOrderModalComponent.prototype.reasons;
    /** @type {?} */
    CancelOrderModalComponent.prototype.type;
    /** @type {?} */
    CancelOrderModalComponent.prototype.buttonClicked;
    /** @type {?} */
    CancelOrderModalComponent.prototype.id;
    /** @type {?} */
    CancelOrderModalComponent.prototype.selectedReasonId;
    /** @type {?} */
    CancelOrderModalComponent.prototype.cancelReason;
    /**
     * @type {?}
     * @private
     */
    CancelOrderModalComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    CancelOrderModalComponent.prototype.cancelOrderService;
    /**
     * @type {?}
     * @private
     */
    CancelOrderModalComponent.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeSlotModalService = /** @class */ (function () {
    function TimeSlotModalService(http, toast, rcylOrdersService) {
        this.http = http;
        this.toast = toast;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @param {?} id
     * @return {?}
     */
    TimeSlotModalService.prototype.getTimeSlots = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return this.http.get("/core/time-slots?zip=" + id);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    TimeSlotModalService.prototype.updateTimeSlots = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/change-time-slot", data);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    TimeSlotModalService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg).then();
    };
    TimeSlotModalService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    TimeSlotModalService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ToastController },
        { type: RcylOrdersService }
    ]; };
    /** @nocollapse */ TimeSlotModalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function TimeSlotModalService_Factory() { return new TimeSlotModalService(ɵɵinject(HttpClient), ɵɵinject(ToastController), ɵɵinject(RcylOrdersService)); }, token: TimeSlotModalService, providedIn: "root" });
    return TimeSlotModalService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    TimeSlotModalService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    TimeSlotModalService.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    TimeSlotModalService.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeSlotModalComponent = /** @class */ (function () {
    function TimeSlotModalComponent(timeSlotService, rcylOrdersService, modalCtrl) {
        this.timeSlotService = timeSlotService;
        this.rcylOrdersService = rcylOrdersService;
        this.modalCtrl = modalCtrl;
    }
    /**
     * @return {?}
     */
    TimeSlotModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getTimeSlots();
        this.timeSlotObj = {
            pickupOrderId: this.order.id,
            timeSlotId: this.selectedTimeSlotId,
        };
    };
    /**
     * @return {?}
     */
    TimeSlotModalComponent.prototype.getTimeSlots = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.timeSlotService
            .getTimeSlots(this.order.addressInfo.zipcode)
            .subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.timeSlots = res;
            if (_this.order.timeSlot) {
                _this.selectedTimeSlotId = _this.order.timeSlot.id;
            }
        }));
    };
    /**
     * @param {?} time
     * @return {?}
     */
    TimeSlotModalComponent.prototype.selectTimeSlot = /**
     * @param {?} time
     * @return {?}
     */
    function (time) {
        this.selectedTimeSlotId = time.id;
    };
    /**
     * @return {?}
     */
    TimeSlotModalComponent.prototype.updateTimeSlot = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.timeSlotObj.timeSlotId = this.selectedTimeSlotId;
        this.timeSlotService.updateTimeSlots(this.timeSlotObj).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.modalCtrl.dismiss(res);
            _this.rcylOrdersService.presentToast("Order rescheduled successfully");
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // this.timeSlotService.onFailed(error);
        }));
    };
    /**
     * @return {?}
     */
    TimeSlotModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss();
    };
    TimeSlotModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-time-slot-modal",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title text-center> Select a date to reschedule </ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon\n          class=\"position-rule\"\n          slot=\"icon-only\"\n          name=\"close-circle\"\n        ></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <div class=\"inner-content\" padding=\"\">\n    <ion-grid>\n      <ion-row *ngIf=\"timeSlots?.length > 0; else noTimeSlotes\">\n        <ion-col size=\"12\">\n          <ion-radio-group [(ngModel)]=\"selectedTimeSlotId\">\n            <ion-grid no-padding>\n              <ion-row>\n                <ion-col\n                  *ngFor=\"let time of timeSlots\"\n                  size=\"3\"\n                  (click)=\"time?.available ? selectTimeSlot(time) : ''\"\n                >\n                  <div\n                    [ngClass]=\"time?.available ? 'date' : 'date-disabled'\"\n                    card-like=\"\"\n                  >\n                    <div\n                      class=\"item-radio-selectable\"\n                      [ngClass]=\"{\n                        'item-radio-selected': time?.id === selectedTimeSlotId\n                      }\"\n                    >\n                      <div style=\"padding-top: 8px; padding-bottom: 8px\">\n                        <ion-radio\n                          mode=\"ios\"\n                          [disabled]=\"!time.available\"\n                          [value]=\"time.id\"\n                        ></ion-radio>\n                        <ion-text\n                          [ngClass]=\"{ 'text-color': !time?.available }\"\n                          [color]=\"\n                            time?.id === selectedTimeSlotId ? 'light' : 'medium'\n                          \"\n                          text-small\n                          *ngIf=\"time?.isToday\"\n                          >Today</ion-text\n                        >\n                        <ion-text\n                          [ngClass]=\"{ 'text-color': !time?.available }\"\n                          [color]=\"\n                            time?.id === selectedTimeSlotId ? 'light' : 'medium'\n                          \"\n                          text-small\n                          *ngIf=\"time?.isTomorrow\"\n                          >Tomorrow</ion-text\n                        >\n                        <ion-text\n                          [ngClass]=\"{ 'text-color': !time?.available }\"\n                          [color]=\"\n                            time?.id === selectedTimeSlotId ? 'light' : 'medium'\n                          \"\n                          text-small\n                          *ngIf=\"!time?.isToday && !time?.isTomorrow\"\n                        >\n                          {{ time?.startTime | date: \"dd MMM\" }}\n                        </ion-text>\n                      </div>\n                    </div>\n                  </div>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-radio-group>\n        </ion-col>\n      </ion-row>\n      <ng-template #noTimeSlotes>\n        <div\n          style=\"\n            height: 60vh;\n            display: flex;\n            width: 100%;\n            flex-direction: column;\n          \"\n          align-items-center\n          justify-content-center\n        >\n          <div text-center *ngIf=\"timeSlots === null\">\n            <ion-spinner></ion-spinner><br />\n            <div font-medium>Fetching time slots...</div>\n          </div>\n          <div text-center *ngIf=\"timeSlots?.length === 0\">\n            <h2 font-medium>No Time slots</h2>\n            <p>There are no Time slots. Please contact your admin.</p>\n          </div>\n        </div>\n      </ng-template>\n    </ion-grid>\n  </div>\n</ion-content>\n\n<ion-footer no-box-shadow=\"\" *ngIf=\"timeSlots?.length > 0\">\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"4\" class=\"ion-text-center\">\n        <div class=\"input-color\">\n          <ion-text class=\"text-position\" color=\"medium\"\n            >Slot Available</ion-text\n          >\n          <div class=\"color-box active\"></div>\n        </div>\n      </ion-col>\n      <ion-col size=\"4\">\n        <div class=\"input-color\">\n          <ion-text class=\"text-position\" color=\"medium\"\n            >Slot Disabled</ion-text\n          >\n          <div class=\"color-box disabled\"></div>\n        </div>\n      </ion-col>\n      <ion-col size=\"4\">\n        <div class=\"input-color\">\n          <ion-text class=\"text-position\" color=\"medium\"\n            >Slot Selected</ion-text\n          >\n          <div class=\"color-box selected\"></div>\n        </div>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-button\n          [color]=\"'primary'\"\n          recykal-button=\"\"\n          centered=\"\"\n          expand=\"block\"\n          size=\"large\"\n          [disabled]=\"!selectedTimeSlotId\"\n          (click)=\"updateTimeSlot()\"\n          >Reschedule</ion-button\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [".date{line-height:19px;border:1px solid #a9a9a9;text-align:center;border-radius:5px;margin-bottom:8px}.date .item-radio-selectable ion-radio{float:right;margin-right:-15px;margin-top:-12px}.date .item-radio-selected{background:var(--ion-color-dark)!important;--background:var(--ion-color-dark)!important;border-radius:5px;--border-radius:5px;color:var(--ion-color-primary-contrast)!important;--color:var(--ion-color-primary-contrast)!important;--box-shadow:2px 15px 14px -9px var(--ion-color-dark-shade);height:100%}.date .item-radio-selected .radio-checked{position:absolute;right:9px;top:6px;width:20px;padding:1.8px;border-radius:12px;margin-top:-8px;height:20px;margin-right:-11px;background:#63ad85;--color-checked:var(--ion-color-primary-contrast);float:right}.date-disabled{line-height:19px;border:1px solid #f0f0f0;text-align:center;border-radius:5px;margin-bottom:8px}.date-disabled .item-radio-selectable ion-radio{float:right;margin-right:-15px;margin-top:-12px}.text-color{color:#f0f0f0!important}.disabled{border:1px solid #f0f0f0}.active{border:1px solid #a9a9a9;left:35px!important}.selected{background:var(--ion-color-dark)}.input-color{position:relative}.input-color .color-box{width:20px;height:20px;display:inline-block;position:absolute;border-radius:5px;left:5px}.input-color .text-position{padding-left:30px}"]
                }] }
    ];
    /** @nocollapse */
    TimeSlotModalComponent.ctorParameters = function () { return [
        { type: TimeSlotModalService },
        { type: RcylOrdersService },
        { type: ModalController }
    ]; };
    TimeSlotModalComponent.propDecorators = {
        order: [{ type: Input }]
    };
    return TimeSlotModalComponent;
}());
if (false) {
    /** @type {?} */
    TimeSlotModalComponent.prototype.timeSlots;
    /** @type {?} */
    TimeSlotModalComponent.prototype.selectedTimeSlotId;
    /** @type {?} */
    TimeSlotModalComponent.prototype.order;
    /** @type {?} */
    TimeSlotModalComponent.prototype.timeSlotObj;
    /**
     * @type {?}
     * @private
     */
    TimeSlotModalComponent.prototype.timeSlotService;
    /**
     * @type {?}
     * @private
     */
    TimeSlotModalComponent.prototype.rcylOrdersService;
    /**
     * @type {?}
     * @private
     */
    TimeSlotModalComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InvoiceVerifyService = /** @class */ (function () {
    function InvoiceVerifyService(http, rcylOrdersService) {
        this.http = http;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @param {?=} data
     * @return {?}
     */
    InvoiceVerifyService.prototype.verifyInvoice = /**
     * @param {?=} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/order-payments/change-status", data);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    InvoiceVerifyService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg);
    };
    /**
     * @param {?} orderId
     * @return {?}
     */
    InvoiceVerifyService.prototype.getOrder = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        return this.http.get("/core/orders/" + orderId);
    };
    InvoiceVerifyService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    InvoiceVerifyService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: RcylOrdersService }
    ]; };
    /** @nocollapse */ InvoiceVerifyService.ngInjectableDef = ɵɵdefineInjectable({ factory: function InvoiceVerifyService_Factory() { return new InvoiceVerifyService(ɵɵinject(HttpClient), ɵɵinject(RcylOrdersService)); }, token: InvoiceVerifyService, providedIn: "root" });
    return InvoiceVerifyService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    InvoiceVerifyService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    InvoiceVerifyService.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var InvoiceVerifyModalComponent = /** @class */ (function () {
    function InvoiceVerifyModalComponent(modalCtrl, verifyService) {
        this.modalCtrl = modalCtrl;
        this.verifyService = verifyService;
        this.invoiceDetails = {
            id: null,
            orderPaymentStatus: "",
            comment: "",
        };
        this.comments = "";
    }
    /**
     * @return {?}
     */
    InvoiceVerifyModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getOrderDetails();
    };
    /**
     * @return {?}
     */
    InvoiceVerifyModalComponent.prototype.getOrderDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.verifyService.getOrder(this.orderId).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.paymentId = data.payment.id;
        }));
    };
    /**
     * @return {?}
     */
    InvoiceVerifyModalComponent.prototype.verifyInvoice = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.invoiceDetails.id = this.paymentId;
        this.invoiceDetails.orderPaymentStatus = "PAYMENT_PENDING";
        this.invoiceDetails.comment = this.comments;
        this.verifyService.verifyInvoice(this.invoiceDetails).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.modalCtrl.dismiss(res);
        }), (/**
         * @param {?} error1
         * @return {?}
         */
        function (error1) {
            // this.verifyService.onFailed(error1);
        }));
    };
    /**
     * @return {?}
     */
    InvoiceVerifyModalComponent.prototype.rejectInvoice = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.invoiceDetails.id = this.paymentId;
        this.invoiceDetails.comment = this.comments;
        this.invoiceDetails.orderPaymentStatus = "INVOICE_REJECTED";
        this.verifyService.verifyInvoice(this.invoiceDetails).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.modalCtrl.dismiss(res);
        }), (/**
         * @param {?} error1
         * @return {?}
         */
        function (error1) {
            // this.verifyService.onFailed(error1);
        }));
    };
    /**
     * @return {?}
     */
    InvoiceVerifyModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss(null);
    };
    InvoiceVerifyModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-invoice-verify-modal",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title\n      text-medium\n      class=\"ion-text-center\"\n      font-bold=\"\"\n      *ngIf=\"buttonClicked === 'VerifyInvoice'\"\n    >\n      Verify Invoice\n    </ion-title>\n    <ion-title\n      text-medium\n      class=\"ion-text-center\"\n      font-bold=\"\"\n      *ngIf=\"buttonClicked === 'RejectInvoice'\"\n    >\n      Reject Invoice\n    </ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon slot=\"icon-only\" name=\"close-circle\"></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"3\">\n        <ion-item input-item lines=\"none\">\n          <ion-label text-small class=\"ion-text-center\">PickupId</ion-label>\n        </ion-item>\n      </ion-col>\n      <ion-col size=\"6\">\n        <ion-item input-item lines=\"none\">\n          <ion-text text-regular=\"\">{{ formattedId }}</ion-text>\n        </ion-item>\n      </ion-col>\n      <ion-col size=\"12\">\n        <ion-item\n          input-item=\"\"\n          centered=\"\"\n          style=\"width: 95% !important\"\n          lines=\"none\"\n        >\n          <ion-textarea\n            centered=\"\"\n            font-medium=\"\"\n            [(ngModel)]=\"comments\"\n            placeholder=\"Write your comment\"\n          ></ion-textarea>\n        </ion-item>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-content>\n<ion-footer no-box-shadow=\"\" centered=\"\">\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"6\">\n        <ion-button\n          recykal-button=\"\"\n          centered=\"\"\n          color=\"primary\"\n          expand=\"block\"\n          (click)=\"verifyInvoice()\"\n          >Verify Invoice\n        </ion-button>\n      </ion-col>\n      <ion-col size=\"6\">\n        <ion-button\n          recykal-button=\"\"\n          centered=\"\"\n          color=\"danger\"\n          expand=\"block\"\n          (click)=\"rejectInvoice()\"\n          >Reject Invoice\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: ["::ng-deep .verify-invoice-modal .modal-wrapper{--max-height:270px!important}"]
                }] }
    ];
    /** @nocollapse */
    InvoiceVerifyModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: InvoiceVerifyService }
    ]; };
    InvoiceVerifyModalComponent.propDecorators = {
        orderId: [{ type: Input }],
        formattedId: [{ type: Input }],
        buttonClicked: [{ type: Input }]
    };
    return InvoiceVerifyModalComponent;
}());
if (false) {
    /** @type {?} */
    InvoiceVerifyModalComponent.prototype.orderId;
    /** @type {?} */
    InvoiceVerifyModalComponent.prototype.formattedId;
    /** @type {?} */
    InvoiceVerifyModalComponent.prototype.buttonClicked;
    /** @type {?} */
    InvoiceVerifyModalComponent.prototype.paymentId;
    /** @type {?} */
    InvoiceVerifyModalComponent.prototype.invoiceDetails;
    /** @type {?} */
    InvoiceVerifyModalComponent.prototype.comments;
    /**
     * @type {?}
     * @private
     */
    InvoiceVerifyModalComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    InvoiceVerifyModalComponent.prototype.verifyService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MakePaymentService = /** @class */ (function () {
    function MakePaymentService(http, rcylOrdersService) {
        this.http = http;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @param {?=} data
     * @return {?}
     */
    MakePaymentService.prototype.makePayment = /**
     * @param {?=} data
     * @return {?}
     */
    function (data) {
        return this.http.post("/core/order-payments/make-payment", data);
    };
    /**
     * @param {?} orderId
     * @return {?}
     */
    MakePaymentService.prototype.getOrder = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        return this.http.get("/core/orders/" + orderId);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    MakePaymentService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg);
    };
    MakePaymentService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    MakePaymentService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: RcylOrdersService }
    ]; };
    /** @nocollapse */ MakePaymentService.ngInjectableDef = ɵɵdefineInjectable({ factory: function MakePaymentService_Factory() { return new MakePaymentService(ɵɵinject(HttpClient), ɵɵinject(RcylOrdersService)); }, token: MakePaymentService, providedIn: "root" });
    return MakePaymentService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    MakePaymentService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    MakePaymentService.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MakePaymentModalComponent = /** @class */ (function () {
    function MakePaymentModalComponent(modalCtrl, formBuilder, paymentService, modalController, rcylOrdersService) {
        this.modalCtrl = modalCtrl;
        this.formBuilder = formBuilder;
        this.paymentService = paymentService;
        this.modalController = modalController;
        this.rcylOrdersService = rcylOrdersService;
        this.paymentOptions = [
            { name: "Select Mode", value: null },
            { name: "Net Banking", value: "ONLINE_TRANSFER" },
            { name: "Cheque", value: "CHEQUE" },
            { name: "Cash", value: "CASH" },
            { name: "UPI/Wallet", value: "UPI" },
        ];
        this.paymentObj = {
            paymentIds: [],
            orderPaymentMode: "",
            referenceNumber: "",
            paymentDate: "",
            amountPaid: "",
            comment: "",
        };
    }
    /**
     * @return {?}
     */
    MakePaymentModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log("payment", { a: this.selectedOrders, b: this.selectOrder });
        this.getOrderDetails();
        this.sDate = new Date().toISOString();
        this.newDate = this.sDate;
    };
    /**
     * @return {?}
     */
    MakePaymentModalComponent.prototype.getOrderDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.selectedOrders) {
            /** @type {?} */
            var payments = this.selectedOrders
                .map((/**
             * @param {?} od
             * @return {?}
             */
            function (od) { return od.payment; }))
                .filter(Boolean);
            this.paymentObj.paymentIds = payments.map((/**
             * @param {?} p
             * @return {?}
             */
            function (p) { return p.id; }));
            this.systemPaymentAmount = sumBy(payments, "amount");
            this.createPaymentForm();
        }
        else {
            this.paymentService.getOrder(this.orderId).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _this.paymentObj.paymentIds = [data.payment.id];
                _this.selectOrder = data;
                _this.systemPaymentAmount = data.payment.amount;
                _this.createPaymentForm();
            }));
        }
    };
    /**
     * @return {?}
     */
    MakePaymentModalComponent.prototype.createPaymentForm = /**
     * @return {?}
     */
    function () {
        this.paymentForm = this.formBuilder.group({
            amountPaid: [this.systemPaymentAmount || "", Validators.required],
            paymentMode: ["", Validators.required],
            refNo: ["", Validators.required],
            comment: [""],
        });
    };
    /**
     * @return {?}
     */
    MakePaymentModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss(null);
    };
    /**
     * @return {?}
     */
    MakePaymentModalComponent.prototype.savePayment = /**
     * @return {?}
     */
    function () {
        var _this = this;
        // this.paymentObj.paymentIds.push(this.selectOrder.payment.id);
        this.paymentObj.orderPaymentMode = this.paymentForm.value.paymentMode.value;
        this.paymentObj.referenceNumber = this.paymentForm.value.refNo;
        this.paymentObj.paymentDate = this.sDate;
        this.paymentObj.amountPaid = this.paymentForm.value.amountPaid;
        this.paymentObj.comment = this.paymentForm.value.comment;
        this.paymentService.makePayment(this.paymentObj).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.rcylOrdersService.presentToast(" Payment completed successfully");
            _this.modalCtrl.dismiss(res);
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // this.paymentService.onFailed(error);
        }));
    };
    MakePaymentModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-make-payment-modal",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title text-center>\n      {{ selectOrder?.tradeType === \"S\" ? \"Receive\" : \"Make\" }} Payment\n    </ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon\n          class=\"position-rule\"\n          slot=\"icon-only\"\n          name=\"close-circle\"\n        ></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content *ngIf=\"selectOrder || selectedOrders\">\n  <ion-card\n    class=\"background-card no-box-shadow\"\n    *ngIf=\"selectedOrders?.length > 1\"\n  >\n    <ion-grid no-padding=\"\" class=\"d-flex order-details\">\n      <ion-row class=\"ion-nowrap\" style=\"overflow-x: scroll\">\n        <div\n          style=\"background-color: #ffffff; margin: 10px\"\n          *ngFor=\"let order of selectedOrders\"\n        >\n          <ion-item class=\"background-style\" input-item lines=\"none\">\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Order Id</ion-label\n            >\n            <ion-text text-regular style=\"width: 100%\" class=\"ion-float-left\"\n              >#{{ order?.formattedId }}</ion-text\n            >\n          </ion-item>\n          <ion-item class=\"background-style\" input-item lines=\"none\">\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Bulk Generator Name</ion-label\n            >\n            <ion-text text-regular style=\"width: 100%\">{{\n              order?.seller?.firstName\n            }}</ion-text>\n          </ion-item>\n          <ion-item class=\"background-style\" input-item lines=\"none\">\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Account Holder</ion-label\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType !== 'DROP'\"\n              >{{\n                order?.payment?.location?.customerPaymentAccount\n                  ?.accountHolderName || \"Not Available\"\n              }}</ion-text\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType === 'DROP'\"\n              >{{\n                order?.seller?.paymentAccountDTO?.accountHolderName ||\n                  \"Not Available\"\n              }}</ion-text\n            >\n          </ion-item>\n          <div style=\"margin-bottom: 10px\"></div>\n        </div>\n      </ion-row>\n    </ion-grid>\n  </ion-card>\n  <ion-card\n    class=\"background-card no-box-shadow\"\n    *ngIf=\"selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING'\"\n  >\n    <ion-grid no-padding=\"\">\n      <ion-row>\n        <ion-col size=\"6\">\n          <ion-item class=\"background-style\" input-item lines=\"none\">\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >PickupId</ion-label\n            >\n            <ion-text text-regular style=\"width: 100%\" class=\"ion-float-left\"\n              >#{{ selectOrder?.formattedId }}</ion-text\n            >\n          </ion-item>\n          <ion-item\n            class=\"background-style\"\n            input-item\n            lines=\"none\"\n            *ngIf=\"selectOrder?.tradeType === 'B'\"\n          >\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Account Number</ion-label\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType !== 'DROP'\"\n              >{{\n                selectOrder?.payment?.location?.customerPaymentAccount\n                  ?.accountNumber || \"Not Available\"\n              }}</ion-text\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType === 'DROP'\"\n              >{{\n                selectOrder?.seller?.paymentAccountDTO?.accountNumber ||\n                  \"Not Available\"\n              }}</ion-text\n            >\n          </ion-item>\n          <ion-item\n            class=\"background-style\"\n            input-item\n            lines=\"none\"\n            *ngIf=\"selectOrder?.tradeType === 'B'\"\n          >\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Account Holder</ion-label\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType !== 'DROP'\"\n              >{{\n                selectOrder?.payment?.location?.customerPaymentAccount\n                  ?.accountHolderName || \"Not Available\"\n              }}</ion-text\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType === 'DROP'\"\n              >{{\n                selectOrder?.seller?.paymentAccountDTO?.accountHolderName ||\n                  \"Not Available\"\n              }}</ion-text\n            >\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"6\">\n          <ion-item class=\"background-style\" input-item lines=\"none\">\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Bulk Generator Name</ion-label\n            >\n            <ion-text text-regular style=\"width: 100%\">{{\n              selectOrder?.seller?.firstName\n            }}</ion-text>\n          </ion-item>\n          <ion-item\n            class=\"background-style\"\n            input-item\n            lines=\"none\"\n            *ngIf=\"selectOrder?.tradeType === 'B'\"\n          >\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >Bank/Branch</ion-label\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType !== 'DROP'\"\n              >{{\n                selectOrder?.payment?.location?.customerPaymentAccount?.bank ||\n                  \"Not Available\"\n              }}\n              /\n              {{\n                selectOrder?.payment?.location?.customerPaymentAccount\n                  ?.branch || \"Not Available\"\n              }}\n            </ion-text>\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType === 'DROP'\"\n            >\n              {{\n                selectOrder?.seller?.paymentAccountDTO?.bank || \"Not Available\"\n              }}\n              /\n              {{\n                selectOrder?.seller?.paymentAccountDTO?.branch ||\n                  \"Not Available\"\n              }}</ion-text\n            >\n          </ion-item>\n\n          <ion-item\n            class=\"background-style\"\n            input-item\n            lines=\"none\"\n            *ngIf=\"selectOrder?.tradeType === 'B'\"\n          >\n            <ion-label class=\"ion-text-uppercase\" position=\"stacked\"\n              >IFSC</ion-label\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType !== 'DROP'\"\n              >{{\n                selectOrder?.payment?.location?.customerPaymentAccount?.ifsc ||\n                  \"Not Available\"\n              }}</ion-text\n            >\n            <ion-text\n              text-regular\n              style=\"width: 100%\"\n              *ngIf=\"selectOrder?.orderType === 'DROP'\"\n              >{{ selectOrder?.seller?.paymentAccountDTO?.ifsc }}</ion-text\n            >\n          </ion-item>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </ion-card>\n  <ion-grid>\n    <form [formGroup]=\"paymentForm\" name=\"paymentForm\">\n      <ion-row>\n        <ion-col size=\"6\">\n          <ion-item input-item lines=\"none\">\n            <ion-label position=\"stacked\" font-medium=\"\"\n              >Amount\n              {{\n                selectOrder?.tradeType === \"S\" ? \"Received\" : \"Paid\"\n              }}*</ion-label\n            >\n            <ion-input\n              type=\"number\"\n              inputmode=\"text\"\n              formControlName=\"amountPaid\"\n              name=\"amountPaid\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n\n        <ion-col size=\"6\">\n          <ion-label position=\"stacked\" font-medium=\"\" class=\"label-position\"\n            >Payment Mode*</ion-label\n          >\n          <div>\n            <p-dropdown\n              [options]=\"paymentOptions\"\n              optionLabel=\"name\"\n              formControlName=\"paymentMode\"\n              name=\"paymentMode\"\n            ></p-dropdown>\n          </div>\n        </ion-col>\n\n        <ion-col size=\"6\">\n          <ion-item input-item=\"\" lines=\"none\">\n            <ion-label position=\"stacked\" font-medium=\"\">Ref.No*</ion-label>\n            <ion-input\n              inputmode=\"text\"\n              type=\"text\"\n              formControlName=\"refNo\"\n              name=\"refNo\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n\n        <ion-col size=\"6\">\n          <ion-item input-item=\"\" lines=\"none\">\n            <ion-label position=\"stacked\" font-medium=\"\"\n              >Payment Date*</ion-label\n            >\n            <ion-input readonly=\"\" (click)=\"datepicker.open()\"\n              >&nbsp; {{ sDate | date: \"dd/MM/yyyy\" }}\n              <ion-icon\n                name=\"calendar\"\n                slot=\"end\"\n                float-right=\"\"\n                style=\"position: absolute; right: 5px\"\n              ></ion-icon>\n            </ion-input>\n            <ion-datetime\n              displayFormat=\"YYYY-MM-DD\"\n              hidden=\"true\"\n              mode=\"ios\"\n              placeholder=\"Select Date\"\n              value=\"sDate\"\n              [(ngModel)]=\"sDate\"\n              #datepicker\n              [ngModelOptions]=\"{ standalone: true }\"\n            ></ion-datetime>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\">\n          <ion-item input-item=\"\" lines=\"none\">\n            <ion-textarea\n              font-medium=\"\"\n              type=\"text\"\n              placeholder=\"Comments\"\n              formControlName=\"comment\"\n              name=\"comment\"\n            ></ion-textarea>\n          </ion-item>\n        </ion-col>\n      </ion-row>\n    </form>\n  </ion-grid>\n</ion-content>\n<ion-footer no-box-shadow=\"\" text-center>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-button\n          size=\"large\"\n          recykal-button=\"\"\n          style=\"width: 90%\"\n          [disabled]=\"!paymentForm?.valid\"\n          color=\"primary\"\n          class=\"ion-margin-bottom\"\n          (click)=\"savePayment()\"\n          >Confirm Payment\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [":host ::ng-deep .order-details ion-item{--background:transparent}:host ::ng-deep .ui-dropdown{display:-webkit-box;display:flex;margin-top:15px;height:32px;border-radius:4px;margin-left:15px;margin-right:15px;border:1px solid #c7d2d8}:host ::ng-deep .ui-dropdown .ui-inputtext{font-size:12px!important}.no-box-shadow{box-shadow:none}.label-position{font-size:1rem;text-align:left;padding-right:15px;padding-left:15px;display:block;font-family:font-regular;--color:var(--ion-color-dark)!important;color:var(--ion-color-dark)!important}.label-position.label-stacked.sc-ion-label-md-h{-webkit-transform:translate3d(0,50%,0) scale(1);transform:translate3d(0,50%,0) scale(1)}.background-style{--background:var(--ion-color-light)}.background-card{background:var(--ion-color-light)}"]
                }] }
    ];
    /** @nocollapse */
    MakePaymentModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: FormBuilder },
        { type: MakePaymentService },
        { type: ModalController },
        { type: RcylOrdersService }
    ]; };
    MakePaymentModalComponent.propDecorators = {
        orderId: [{ type: Input }],
        selectedOrders: [{ type: Input }]
    };
    return MakePaymentModalComponent;
}());
if (false) {
    /** @type {?} */
    MakePaymentModalComponent.prototype.orderId;
    /** @type {?} */
    MakePaymentModalComponent.prototype.selectedOrders;
    /** @type {?} */
    MakePaymentModalComponent.prototype.selectOrder;
    /** @type {?} */
    MakePaymentModalComponent.prototype.paymentOptions;
    /** @type {?} */
    MakePaymentModalComponent.prototype.newDate;
    /** @type {?} */
    MakePaymentModalComponent.prototype.paymentForm;
    /** @type {?} */
    MakePaymentModalComponent.prototype.sDate;
    /** @type {?} */
    MakePaymentModalComponent.prototype.paymentObj;
    /** @type {?} */
    MakePaymentModalComponent.prototype.systemPaymentAmount;
    /**
     * @type {?}
     * @private
     */
    MakePaymentModalComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    MakePaymentModalComponent.prototype.formBuilder;
    /**
     * @type {?}
     * @private
     */
    MakePaymentModalComponent.prototype.paymentService;
    /**
     * @type {?}
     * @private
     */
    MakePaymentModalComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    MakePaymentModalComponent.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IDocument() { }
if (false) {
    /** @type {?} */
    IDocument.prototype.active;
    /** @type {?} */
    IDocument.prototype.entity;
    /** @type {?} */
    IDocument.prototype.entityId;
    /** @type {?} */
    IDocument.prototype.fileName;
    /** @type {?} */
    IDocument.prototype.fileSize;
    /** @type {?} */
    IDocument.prototype.id;
    /** @type {?} */
    IDocument.prototype.modifiedAt;
    /** @type {?} */
    IDocument.prototype.signedUrl;
    /** @type {?} */
    IDocument.prototype.type;
    /** @type {?} */
    IDocument.prototype.url;
    /** @type {?|undefined} */
    IDocument.prototype.contentType;
}
var OrderDocument = /** @class */ (function () {
    function OrderDocument(active, entity, entityId, fileName, fileSize, id, modifiedAt, signedUrl, type, url, contentType) {
        this.active = active;
        this.entity = entity;
        this.entityId = entityId;
        this.fileName = fileName;
        this.fileSize = fileSize;
        this.id = id;
        this.modifiedAt = modifiedAt;
        this.signedUrl = signedUrl;
        this.type = type;
        this.url = url;
        this.contentType = contentType;
    }
    return OrderDocument;
}());
if (false) {
    /** @type {?} */
    OrderDocument.prototype.active;
    /** @type {?} */
    OrderDocument.prototype.entity;
    /** @type {?} */
    OrderDocument.prototype.entityId;
    /** @type {?} */
    OrderDocument.prototype.fileName;
    /** @type {?} */
    OrderDocument.prototype.fileSize;
    /** @type {?} */
    OrderDocument.prototype.id;
    /** @type {?} */
    OrderDocument.prototype.modifiedAt;
    /** @type {?} */
    OrderDocument.prototype.signedUrl;
    /** @type {?} */
    OrderDocument.prototype.type;
    /** @type {?} */
    OrderDocument.prototype.url;
    /** @type {?} */
    OrderDocument.prototype.contentType;
}
/**
 * @record
 */
function IDocumentMap() { }
if (false) {
    /** @type {?} */
    IDocumentMap.prototype.SELLER_WEIGH_BRIDGE;
    /** @type {?} */
    IDocumentMap.prototype.BUYER_WEIGH_BRIDGE;
    /** @type {?} */
    IDocumentMap.prototype.LORRY_RECEIPT;
    /** @type {?} */
    IDocumentMap.prototype.EWAY_BILL;
    /** @type {?} */
    IDocumentMap.prototype.INVOICE;
    /** @type {?} */
    IDocumentMap.prototype.DC;
    /** @type {?} */
    IDocumentMap.prototype.LAB_REPORT;
    /** @type {?} */
    IDocumentMap.prototype.OTHER;
    /** @type {?} */
    IDocumentMap.prototype.ITEM_IMAGE;
    /** @type {?} */
    IDocumentMap.prototype.PROOF_OF_SIGNATURE;
    /** @type {?} */
    IDocumentMap.prototype.FINAL_PAYMENT_ADVICE;
}
/**
 * @record
 */
function IDocumentMapItem() { }
if (false) {
    /** @type {?} */
    IDocumentMapItem.prototype.displayText;
    /** @type {?} */
    IDocumentMapItem.prototype.sampleImg;
    /** @type {?} */
    IDocumentMapItem.prototype.icon;
    /** @type {?} */
    IDocumentMapItem.prototype.iconChecked;
    /** @type {?} */
    IDocumentMapItem.prototype.beforeUploadText;
    /** @type {?} */
    IDocumentMapItem.prototype.afterUploadText;
    /** @type {?} */
    IDocumentMapItem.prototype.showInList;
    /** @type {?} */
    IDocumentMapItem.prototype.documents;
}
/** @enum {string} */
var OrderDocumentTypes = {
    ITEM_IMAGE: "ITEM_IMAGE",
    SELLER_WEIGH_BRIDGE: "SELLER_WEIGH_BRIDGE",
    BUYER_WEIGH_BRIDGE: "BUYER_WEIGH_BRIDGE",
    LORRY_RECEIPT: "LORRY_RECEIPT",
    EWAY_BILL: "EWAY_BILL",
    INVOICE: "INVOICE",
    ORDER_INVOICE: "ORDER_INVOICE",
    DC: "DC",
    LAB_REPORT: "LAB_REPORT",
    OTHER: "OTHER",
    PROOF_OF_SIGNATURE: "PROOF_OF_SIGNATURE",
    FINAL_PAYMENT_ADVICE: "FINAL_PAYMENT_ADVICE",
};
/**
 * @record
 */
function OrderSelectImgEvent() { }
if (false) {
    /** @type {?} */
    OrderSelectImgEvent.prototype.order;
    /** @type {?} */
    OrderSelectImgEvent.prototype.documentType;
    /** @type {?} */
    OrderSelectImgEvent.prototype.selectFrom;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ImgViewerComponent = /** @class */ (function () {
    function ImgViewerComponent(modalController, alertController, events, renderer) {
        this.modalController = modalController;
        this.alertController = alertController;
        this.events = events;
        this.renderer = renderer;
        this.zoomLevel = 100;
        this.docDeleteSubscription = new Subscription();
    }
    /**
     * @return {?}
     */
    ImgViewerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.VIEW_BG, '#27353C');
        this.pinchZoom();
    };
    /**
     * @return {?}
     */
    ImgViewerComponent.prototype.pinchZoom = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var oldDist = undefined;
        this.renderer.listen(this.img.nativeElement, "touchstart", (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (e.touches.length === 2) {
                _this.scaling = true;
            }
        }));
        this.renderer.listen(this.img.nativeElement, "touchmove", (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (_this.scaling) {
                /** @type {?} */
                var newDist = Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY);
                _this.zoomBy(_this.img.nativeElement, newDist > oldDist);
                oldDist = newDist;
            }
        }));
        this.renderer.listen(this.img.nativeElement, "touchend", (/**
         * @param {?} e
         * @return {?}
         */
        function (e) {
            if (_this.scaling) {
                _this.scaling = false;
            }
            oldDist = undefined;
        }));
    };
    /**
     * @return {?}
     */
    ImgViewerComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalController.dismiss().then();
    };
    /**
     * @param {?} img
     * @return {?}
     */
    ImgViewerComponent.prototype.zoomIn = /**
     * @param {?} img
     * @return {?}
     */
    function (img) {
        /*this.zoomLevel = this.zoomLevel + 50;
            img.style.width = this.zoomLevel + 'px';
            img.style.height = this.zoomLevel + 'px';*/
        this.zoomLevel = this.zoomLevel + 20;
        img.style.zoom = this.zoomLevel + "%";
    };
    /**
     * @param {?} img
     * @param {?} zoomInOrOut
     * @return {?}
     */
    ImgViewerComponent.prototype.zoomBy = /**
     * @param {?} img
     * @param {?} zoomInOrOut
     * @return {?}
     */
    function (img, zoomInOrOut) {
        if (zoomInOrOut) {
            this.zoomLevel = this.zoomLevel + 4;
        }
        else {
            if (this.zoomLevel > 40) {
                this.zoomLevel = this.zoomLevel - 4;
            }
        }
        img.style.zoom = this.zoomLevel + "%";
    };
    /**
     * @param {?} img
     * @return {?}
     */
    ImgViewerComponent.prototype.zoomOut = /**
     * @param {?} img
     * @return {?}
     */
    function (img) {
        if (this.zoomLevel > 40) {
            /*this.zoomLevel = this.zoomLevel - 50;
                  img.style.width = this.zoomLevel + 'px';
                  img.style.height = this.zoomLevel + 'px';*/
            this.zoomLevel = this.zoomLevel - 20;
            img.style.zoom = this.zoomLevel + "%";
        }
    };
    /**
     * @return {?}
     */
    ImgViewerComponent.prototype.downloadClicked = /**
     * @return {?}
     */
    function () {
        if (this.downloadCallback) {
            this.downloadCallback(this.document);
        }
    };
    /**
     * @return {?}
     */
    ImgViewerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.docDeleteSubscription.unsubscribe();
    };
    ImgViewerComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-img-viewer",
                    template: "<ion-header no-shodow>\n  <ion-toolbar no-border>\n    <ion-buttons slot=\"start\">\n      <ion-back-button\n        onclick=\"event.stopImmediatePropagation();\"\n        (mouseup)=\"closeModal()\"\n        defaultHref=\"\"\n        color=\"light\"\n        [icon]=\"'ios-arrow-back'\"\n        [text]=\"''\"\n      ></ion-back-button>\n    </ion-buttons>\n    <ion-title text-left no-padding>\n      <div class=\"modal-title-text\" text-wrap>\n        <ion-text font-bold=\"\" color=\"light\">{{ document?.fileName }}</ion-text>\n      </div>\n    </ion-title>\n    <ion-buttons slot=\"end\" *ngIf=\"componentOptions?.showDownload\">\n      <ion-button (click)=\"downloadClicked()\" fill=\"clear\" color=\"light\">\n        <ion-icon name=\"download\"></ion-icon>\n        <span>DOWNLOAD</span>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-grid>\n    <ion-row>\n      <ion-col text-center size=\"12\" class=\"img-col\">\n        <div>\n          <img [src]=\"document?.url\" alt=\"\" #img />\n        </div>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-content>\n<ion-footer>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\" text-center class=\"zoom-buttons\" margin-bottom>\n        <ion-button (click)=\"zoomIn(img)\">\n          <ion-icon slot=\"icon-only\" name=\"add-circle-outline\"></ion-icon>\n        </ion-button>\n        <ion-button (click)=\"zoomOut(img)\">\n          <ion-icon slot=\"icon-only\" name=\"remove-circle-outline\"></ion-icon>\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n<!--\n<ion-grid>\n    <ion-row>\n        <ion-col size=\"12\" >\n            <ion-text color=\"light\" float-start>Invoice No. 6456</ion-text>\n            <ion-icon name=\"trash\" float-end></ion-icon>\n        </ion-col>\n    </ion-row>\n    <ion-row>\n        <ion-col size=\"12\">\n            <ion-button  (click)=\"closeModal()\"></ion-button>\n        </ion-col>\n        <ion-col size=\"12\">\n            <img [src]=\"imageUrl\" alt=\"\" />\n        </ion-col>\n    </ion-row>\n</ion-grid>\n-->\n",
                    styles: ["ion-content,ion-header,ion-header ion-toolbar{--background:#27353c 0% 0% no-repeat padding-box;opacity:.96}ion-header ion-toolbar ion-buttons[slot=end] ion-button{font-size:.9231rem;line-height:1.077rem;letter-spacing:2.4px;color:#fff;text-transform:uppercase;opacity:1;--box-shadow:none}ion-header ion-toolbar ion-buttons[slot=end] ion-button ion-icon{padding-right:5px}@media only screen and (max-width:34.375em){ion-header ion-toolbar ion-buttons[slot=end] ion-button span{display:none}ion-header ion-toolbar ion-buttons[slot=end] ion-button ion-icon{font-size:25px}}@media only screen and (max-width:20em){ion-header ion-toolbar ion-buttons[slot=end] ion-button span{display:none}ion-header ion-toolbar ion-buttons[slot=end] ion-button ion-icon{font-size:20px;padding:0}}ion-content .img-col div{overflow:auto;height:78vh}@media only screen and (max-width:75em){ion-content .img-col div{scrollbar-width:none}ion-content .img-col div::-webkit-scrollbar{width:0;height:0}}ion-content .img-col div img{width:80vw;margin:0 auto;max-width:none}ion-footer{background:no-repeat padding-box #27353c;opacity:.96}ion-footer .zoom-buttons ion-button{--background:#ffffff24 0% 0% no-repeat padding-box;--background-hover:#ffffff24 0% 0% no-repeat padding-box;--border-width:1px;--border-style:solid;--border-color:#f4f5f7;--border-radius:4px;--box-shadow:none;margin-right:5px;width:auto;height:auto;--padding-top:4px;--padding-bottom:4px}ion-footer .zoom-buttons ion-button ion-icon{font-size:25px}"]
                }] }
    ];
    /** @nocollapse */
    ImgViewerComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: AlertController },
        { type: Events },
        { type: Renderer2 }
    ]; };
    ImgViewerComponent.propDecorators = {
        document: [{ type: Input }],
        downloadCallback: [{ type: Input }],
        componentOptions: [{ type: Input }],
        img: [{ type: ViewChild, args: ["img", { static: true },] }]
    };
    return ImgViewerComponent;
}());
if (false) {
    /** @type {?} */
    ImgViewerComponent.prototype.document;
    /** @type {?} */
    ImgViewerComponent.prototype.downloadCallback;
    /** @type {?} */
    ImgViewerComponent.prototype.componentOptions;
    /** @type {?} */
    ImgViewerComponent.prototype.img;
    /** @type {?} */
    ImgViewerComponent.prototype.zoomLevel;
    /** @type {?} */
    ImgViewerComponent.prototype.docDeleteSubscription;
    /** @type {?} */
    ImgViewerComponent.prototype.scaling;
    /**
     * @type {?}
     * @private
     */
    ImgViewerComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    ImgViewerComponent.prototype.alertController;
    /**
     * @type {?}
     * @private
     */
    ImgViewerComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    ImgViewerComponent.prototype.renderer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylImgListComponent = /** @class */ (function () {
    function RcylImgListComponent(modalController, events) {
        this.modalController = modalController;
        this.events = events;
        this.onCapture = new EventEmitter();
    }
    /**
     * @return {?}
     */
    RcylImgListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_DOCUMENTS_UPDATED, (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data[_this.docType] && _this.docType) {
                _this.docList = data[_this.docType].documents;
            }
        }));
    };
    /**
     * @param {?} doc
     * @return {?}
     */
    RcylImgListComponent.prototype.deleteImg = /**
     * @param {?} doc
     * @return {?}
     */
    function (doc) {
        var _this = this;
        this.deleteDocumentCallback(doc).then((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data != "cancel") {
                _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "DOCUMENT_DELETE", data);
            }
        }));
    };
    /**
     * @return {?}
     */
    RcylImgListComponent.prototype.onCaptureClick = /**
     * @return {?}
     */
    function () {
        this.onCapture.emit();
    };
    /**
     * @param {?} doc
     * @return {?}
     */
    RcylImgListComponent.prototype.onImageClick = /**
     * @param {?} doc
     * @return {?}
     */
    function (doc) {
        this.showImg(doc).then();
    };
    /**
     * @param {?} document
     * @return {?}
     */
    RcylImgListComponent.prototype.showImg = /**
     * @param {?} document
     * @return {?}
     */
    function (document) {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(document && document.url)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.modalController.create({
                                component: ImgViewerComponent,
                                componentProps: {
                                    document: document,
                                    componentOptions: {
                                        showDownload: true,
                                    },
                                    downloadCallback: this.downloadDocumentCallback,
                                },
                                cssClass: "full-width-modal",
                            })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RcylImgListComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-img-list",
                    template: "<div no-padding class=\"uploaded-imgs\">\n  <div class=\"img-node\" (click)=\"onCaptureClick()\" *ngIf=\"showCapture\">\n    <div class=\"camera-icon\">\n      <ion-icon color=\"dark\" size=\"small\" name=\"camera\"></ion-icon>\n    </div>\n  </div>\n\n  <div class=\"img-node\" *ngFor=\"let img of docList\">\n    <ion-button\n      *ngIf=\"showDelete\"\n      (click)=\"deleteImg(img)\"\n      size=\"small\"\n      fill=\"clear\"\n      no-box-shadow\n    >\n      <ion-icon size=\"small\" name=\"close-circle\" color=\"medium\"></ion-icon>\n    </ion-button>\n    <img (click)=\"onImageClick(img)\" [src]=\"img?.url\" />\n  </div>\n</div>\n",
                    styles: [".uploaded-imgs{overflow:auto;white-space:nowrap;padding-top:10px;padding-bottom:10px}.uploaded-imgs .img-node{display:inline-block;color:#fff;text-align:center;margin-right:10px;position:relative}.uploaded-imgs .img-node ion-button{position:absolute;top:-10px;right:-7px;--background-activated:transparent!important;--background-focused:transparent!important;--background-hover:transparent!important;--background:transparent!important}.uploaded-imgs .img-node ion-button ion-icon[name=close-circle]{position:absolute;top:-2px;right:-2px;border-radius:15px;background:#fff;border:1px solid var(--ion-color-primary-contrast)}.uploaded-imgs .img-node img{height:80px;width:80px;border-radius:10px;border:solid 1px var(--page-bg);-o-object-fit:cover;object-fit:cover}.uploaded-imgs .camera-icon{height:80px;width:80px;border-radius:10px;border:solid 1px var(--page-bg);background:var(--ion-color-light);display:table-cell}.uploaded-imgs .camera-icon ion-icon{margin-top:33%}"]
                }] }
    ];
    /** @nocollapse */
    RcylImgListComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: Events }
    ]; };
    RcylImgListComponent.propDecorators = {
        docList: [{ type: Input }],
        docType: [{ type: Input }],
        showDelete: [{ type: Input }],
        showCapture: [{ type: Input }],
        deleteDocumentCallback: [{ type: Input }],
        downloadDocumentCallback: [{ type: Input }],
        onCapture: [{ type: Output }]
    };
    return RcylImgListComponent;
}());
if (false) {
    /** @type {?} */
    RcylImgListComponent.prototype.docList;
    /** @type {?} */
    RcylImgListComponent.prototype.docType;
    /** @type {?} */
    RcylImgListComponent.prototype.showDelete;
    /** @type {?} */
    RcylImgListComponent.prototype.showCapture;
    /** @type {?} */
    RcylImgListComponent.prototype.deleteDocumentCallback;
    /** @type {?} */
    RcylImgListComponent.prototype.downloadDocumentCallback;
    /** @type {?} */
    RcylImgListComponent.prototype.onCapture;
    /**
     * @type {?}
     * @private
     */
    RcylImgListComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    RcylImgListComponent.prototype.events;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ImgViewerComponentModule = /** @class */ (function () {
    function ImgViewerComponentModule() {
    }
    ImgViewerComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ImgViewerComponent],
                    imports: [CommonModule, IonicModule, FileUploadModule, TooltipModule],
                    exports: [ImgViewerComponent],
                    entryComponents: [ImgViewerComponent],
                },] }
    ];
    return ImgViewerComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylImgListModule = /** @class */ (function () {
    function RcylImgListModule() {
    }
    RcylImgListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RcylImgListComponent],
                    imports: [CommonModule, IonicModule, FormsModule, ImgViewerComponentModule],
                    exports: [RcylImgListComponent],
                    entryComponents: [],
                    providers: [],
                },] }
    ];
    return RcylImgListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddressPipe = /** @class */ (function () {
    function AddressPipe() {
    }
    /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    AddressPipe.prototype.transform = /**
     * @param {?} value
     * @param {...?} args
     * @return {?}
     */
    function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (value) {
            /** @type {?} */
            var addr = value.street
                .substring(0, value.street.indexOf(value.city.name))
                .trim();
            if (addr.length <= 0) {
                addr = value.street
                    .substring(0, value.street.indexOf(value.city.state))
                    .trim();
            }
            return join(__spread([
                value.flatBuilding,
                value.landmark
            ], addr.split(","), [
                value.city.name,
                value.city.state,
                value.zipcode,
            ]).filter(Boolean), ", ");
        }
        return value;
    };
    AddressPipe.decorators = [
        { type: Pipe, args: [{
                    name: "address",
                },] }
    ];
    return AddressPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylKeysPipe = /** @class */ (function () {
    function RcylKeysPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    RcylKeysPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        if (args === void 0) { args = null; }
        return Object.keys(value).map((/**
         * @param {?} key
         * @return {?}
         */
        function (key) {
            return { key: key, val: value[key] };
        }));
    };
    RcylKeysPipe.decorators = [
        { type: Pipe, args: [{ name: "rcylKeys" },] }
    ];
    return RcylKeysPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylFilterPipe = /** @class */ (function () {
    function RcylFilterPipe() {
    }
    /**
     * @param {?} items
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    RcylFilterPipe.prototype.transform = /**
     * @param {?} items
     * @param {?} field
     * @param {?} value
     * @return {?}
     */
    function (items, field, value) {
        if (!items) {
            return [];
        }
        if (!value || value.length === 0) {
            return items;
        }
        if (isArray(items)) {
            return items.filter((/**
             * @param {?} it
             * @return {?}
             */
            function (it) { return it[field] === value; }));
        }
        else if (isObject(items)) {
            /** @type {?} */
            var newMapToReturn_1 = {};
            Object.keys(items).forEach((/**
             * @param {?} key
             * @return {?}
             */
            function (key) {
                if (items[key][field] === value) {
                    newMapToReturn_1[key] = items[key];
                }
            }));
            return newMapToReturn_1;
        }
        else {
            return items;
        }
    };
    RcylFilterPipe.decorators = [
        { type: Pipe, args: [{ name: "rcylFilter" },] }
    ];
    return RcylFilterPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderByPipe = /** @class */ (function () {
    function OrderByPipe() {
    }
    /**
     * @param {?} items
     * @param {?=} args
     * @param {?=} orders
     * @return {?}
     */
    OrderByPipe.prototype.transform = /**
     * @param {?} items
     * @param {?=} args
     * @param {?=} orders
     * @return {?}
     */
    function (items, args, orders) {
        if (args && args.length > 0) {
            if (orders) {
                return orderBy(items, args, orders);
            }
            else {
                return orderBy(items, args, "asc");
            }
        }
        else {
            return items;
        }
    };
    OrderByPipe.decorators = [
        { type: Pipe, args: [{
                    name: "orderBy",
                    pure: false,
                },] }
    ];
    return OrderByPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylSharedModule = /** @class */ (function () {
    function RcylSharedModule() {
    }
    RcylSharedModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        SelectPickupExecutiveComponent,
                        DropLocationsComponent,
                        MakePaymentModalComponent,
                        LocationItemComponent,
                        CancelOrderModalComponent,
                        TimeSlotModalComponent,
                        InvoiceVerifyModalComponent,
                        AddressPipe,
                        RcylKeysPipe,
                        RcylFilterPipe,
                        OrderByPipe,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FormsModule,
                        ReactiveFormsModule,
                        DropdownModule,
                        RcylImgListModule,
                    ],
                    providers: [FormBuilder],
                    exports: [
                        RcylImgListModule,
                        AddressPipe,
                        RcylKeysPipe,
                        RcylFilterPipe,
                        OrderByPipe,
                    ],
                    entryComponents: [
                        SelectPickupExecutiveComponent,
                        MakePaymentModalComponent,
                        DropLocationsComponent,
                        LocationItemComponent,
                        CancelOrderModalComponent,
                        TimeSlotModalComponent,
                        InvoiceVerifyModalComponent,
                    ],
                },] }
    ];
    return RcylSharedModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderListDataModule = /** @class */ (function () {
    function OrderListDataModule() {
    }
    OrderListDataModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [OrderListDataComponent],
                    exports: [OrderListDataComponent],
                    imports: [IonicModule, CommonModule, RcylSharedModule, TooltipModule$1],
                },] }
    ];
    return OrderListDataModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ManageColumnsModule = /** @class */ (function () {
    function ManageColumnsModule() {
    }
    ManageColumnsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ManageColumnsComponent],
                    imports: [CommonModule, IonicModule, FormsModule],
                    exports: [ManageColumnsComponent],
                    entryComponents: [ManageColumnsComponent],
                },] }
    ];
    return ManageColumnsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MakePaymentButtonComponent = /** @class */ (function () {
    function MakePaymentButtonComponent(modalCtrl, rcylOrdersService) {
        this.modalCtrl = modalCtrl;
        this.rcylOrdersService = rcylOrdersService;
        this.paymentStatus = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MakePaymentButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log("this.selectOrder", this.selectOrder);
    };
    /**
     * @return {?}
     */
    MakePaymentButtonComponent.prototype.makePayment = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var hasInvoice, modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.order && this.order.saleOrder) {
                            hasInvoice = some(this.order.documents, (/**
                             * @param {?} d
                             * @return {?}
                             */
                            function (d) { return d.type === "INVOICE"; }));
                            if (!hasInvoice) {
                                this.rcylOrdersService
                                    .presentToast("Please upload invoice to make payment")
                                    .then();
                                return [2 /*return*/];
                            }
                        }
                        return [4 /*yield*/, this.modalCtrl.create({
                                component: MakePaymentModalComponent,
                                componentProps: {
                                    orderId: this.selectOrder,
                                    selectedOrders: this.selectedOrders,
                                },
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.paymentStatus.emit(data);
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MakePaymentButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-make-payment-button",
                    template: "<ion-button (click)=\"makePayment()\" class=\"ion-text-uppercase status-btn\">\n  <ion-icon\n    name=\"checkmark\"\n    class=\"ion-float-left icon-padding\"\n    color=\"light\"\n  ></ion-icon>\n  {{ tradeType === \"S\" ? \"RECEIVE PAYMENT\" : \"MAKE PAYMENT\" }}</ion-button\n>\n",
                    styles: [".icon-padding{padding-right:2px}"]
                }] }
    ];
    /** @nocollapse */
    MakePaymentButtonComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: RcylOrdersService }
    ]; };
    MakePaymentButtonComponent.propDecorators = {
        selectOrder: [{ type: Input }],
        order: [{ type: Input }],
        selectedOrders: [{ type: Input }],
        tradeType: [{ type: Input }],
        paymentStatus: [{ type: Output }]
    };
    return MakePaymentButtonComponent;
}());
if (false) {
    /** @type {?} */
    MakePaymentButtonComponent.prototype.selectOrder;
    /** @type {?} */
    MakePaymentButtonComponent.prototype.order;
    /** @type {?} */
    MakePaymentButtonComponent.prototype.selectedOrders;
    /** @type {?} */
    MakePaymentButtonComponent.prototype.tradeType;
    /** @type {?} */
    MakePaymentButtonComponent.prototype.paymentStatus;
    /**
     * @type {?}
     * @private
     */
    MakePaymentButtonComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    MakePaymentButtonComponent.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MakePaymentButtonModule = /** @class */ (function () {
    function MakePaymentButtonModule() {
    }
    MakePaymentButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MakePaymentButtonComponent],
                    imports: [CommonModule, IonicModule],
                    providers: [FormBuilder],
                    exports: [MakePaymentButtonComponent],
                },] }
    ];
    return MakePaymentButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VerifyInvoiceButtonComponent = /** @class */ (function () {
    function VerifyInvoiceButtonComponent(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.verifiedStatus = new EventEmitter();
    }
    /**
     * @return {?}
     */
    VerifyInvoiceButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    VerifyInvoiceButtonComponent.prototype.verifyInvoice = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: InvoiceVerifyModalComponent,
                            cssClass: "verify-invoice-modal",
                            componentProps: {
                                orderId: this.id,
                                formattedId: this.formattedId,
                                buttonClicked: "VerifyInvoice",
                            },
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.verifiedStatus.emit(data);
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    VerifyInvoiceButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-verify-invoice-button",
                    template: "<ion-button\n  [color]=\"'primary'\"\n  (click)=\"verifyInvoice()\"\n  class=\"status-btn ion-text-uppercase\"\n>\n  <ion-icon\n    name=\"checkmark\"\n    class=\"ion-float-left icon-padding\"\n    color=\"light\"\n  ></ion-icon>\n  Verify Invoice</ion-button\n>\n",
                    styles: [".icon-padding{padding-right:2px}"]
                }] }
    ];
    /** @nocollapse */
    VerifyInvoiceButtonComponent.ctorParameters = function () { return [
        { type: ModalController }
    ]; };
    VerifyInvoiceButtonComponent.propDecorators = {
        id: [{ type: Input }],
        formattedId: [{ type: Input }],
        verifiedStatus: [{ type: Output }]
    };
    return VerifyInvoiceButtonComponent;
}());
if (false) {
    /** @type {?} */
    VerifyInvoiceButtonComponent.prototype.id;
    /** @type {?} */
    VerifyInvoiceButtonComponent.prototype.formattedId;
    /** @type {?} */
    VerifyInvoiceButtonComponent.prototype.verifiedStatus;
    /**
     * @type {?}
     * @private
     */
    VerifyInvoiceButtonComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var VerifyInvoiceButtonModule = /** @class */ (function () {
    function VerifyInvoiceButtonModule() {
    }
    VerifyInvoiceButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [VerifyInvoiceButtonComponent],
                    imports: [CommonModule, IonicModule],
                    exports: [VerifyInvoiceButtonComponent],
                },] }
    ];
    return VerifyInvoiceButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DataFilterInputsService = /** @class */ (function () {
    function DataFilterInputsService(http) {
        this.http = http;
    }
    /**
     * @param {?=} apiUrl
     * @param {?=} reqParams
     * @return {?}
     */
    DataFilterInputsService.prototype.getDataFromServer = /**
     * @param {?=} apiUrl
     * @param {?=} reqParams
     * @return {?}
     */
    function (apiUrl, reqParams) {
        /** @type {?} */
        var params = new HttpParams({ fromObject: reqParams });
        return this.http.get(apiUrl, { params: params });
    };
    DataFilterInputsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    DataFilterInputsService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ DataFilterInputsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function DataFilterInputsService_Factory() { return new DataFilterInputsService(ɵɵinject(HttpClient)); }, token: DataFilterInputsService, providedIn: "root" });
    return DataFilterInputsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    DataFilterInputsService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DataFilterInputsComponent = /** @class */ (function () {
    function DataFilterInputsComponent(filterService) {
        this.filterService = filterService;
        // @Output() filterOptionsChange = new EventEmitter();
        this.applyFilters = new EventEmitter();
        this.autoCompleteValues = [];
        this.multiSelectValues = [];
        this.rangeValues = [0, 10];
        this.delayRangeType = "";
    }
    /**
     * @return {?}
     */
    DataFilterInputsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // console.log(this.filterOptions);
        if (this.inputData.fieldType === "DELAY") {
            this.delayRangeType = this.inputData.additionalData
                ? this.inputData.additionalData.listData[0].value
                : "";
        }
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    DataFilterInputsComponent.prototype.onFilter = /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        this.filterOptions[key] = value;
        // console.log(this.filterOptions);
        // this.filterOptionsChange.emit(this.filterOptions);
        this.applyFilters.emit(this.filterOptions);
    };
    /**
     * @param {?} key
     * @param {?} name
     * @param {?} selectedData
     * @return {?}
     */
    DataFilterInputsComponent.prototype.selectedValue = /**
     * @param {?} key
     * @param {?} name
     * @param {?} selectedData
     * @return {?}
     */
    function (key, name, selectedData) {
        if (selectedData.value) {
            this.filterOptions[key] = selectedData.value[name];
            this.applyFilters.emit(this.filterOptions);
        }
        else {
            this.filterOptions[key] = "";
            this.applyFilters.emit(this.filterOptions);
        }
    };
    /**
     * @param {?} event
     * @param {?} url
     * @param {?} urlParamKey
     * @param {?} listData
     * @return {?}
     */
    DataFilterInputsComponent.prototype.getDataBySearch = /**
     * @param {?} event
     * @param {?} url
     * @param {?} urlParamKey
     * @param {?} listData
     * @return {?}
     */
    function (event, url, urlParamKey, listData) {
        var _this = this;
        /** @type {?} */
        var obj = {};
        obj[urlParamKey] = event.query;
        if (event.query.length > 0) {
            this.filterService.getDataFromServer(url, obj).subscribe((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _this.inputData.additionalData.listData = data;
            }));
        }
    };
    /**
     * @param {?=} selectedValue
     * @param {?=} key
     * @param {?=} selectedKey
     * @return {?}
     */
    DataFilterInputsComponent.prototype.getSelectedValues = /**
     * @param {?=} selectedValue
     * @param {?=} key
     * @param {?=} selectedKey
     * @return {?}
     */
    function (selectedValue, key, selectedKey) {
        if (selectedKey) {
            this.filterOptions[key] = map(this.autoCompleteValues, selectedKey);
            this.applyFilters.emit(this.filterOptions);
        }
        else {
            this.filterOptions[key] = this.autoCompleteValues;
            this.applyFilters.emit(this.filterOptions);
        }
    };
    /**
     * @param {?} event
     * @param {?} key
     * @param {?=} selectedKey
     * @return {?}
     */
    DataFilterInputsComponent.prototype.getMultiSelectValues = /**
     * @param {?} event
     * @param {?} key
     * @param {?=} selectedKey
     * @return {?}
     */
    function (event, key, selectedKey) {
        if (selectedKey) {
            this.filterOptions[key] = map(this.multiSelectValues, selectedKey);
            this.applyFilters.emit(this.filterOptions);
        }
        else {
            this.filterOptions[key] = this.multiSelectValues;
            this.applyFilters.emit(this.filterOptions);
        }
    };
    /**
     * @param {?} event
     * @param {?} fromKey
     * @param {?} toKey
     * @return {?}
     */
    DataFilterInputsComponent.prototype.applyDateRangeValues = /**
     * @param {?} event
     * @param {?} fromKey
     * @param {?} toKey
     * @return {?}
     */
    function (event, fromKey, toKey) {
        console.log(this.rangeDates);
        if (this.rangeDates.length === 2 && this.rangeDates[1] != null) {
            this.filterOptions[fromKey] = new Date(this.rangeDates[0]).toISOString();
            this.filterOptions[toKey] = new Date(this.rangeDates[1]).toISOString();
            this.applyFilters.emit(this.filterOptions);
        }
    };
    /*applySliderRangeValues(event, fromKey, toKey) {
          console.log(this.rangeValues);
          this.filterOptions[fromKey] =  this.rangeValues[0].toString(10);
          this.filterOptions[toKey] = this.rangeValues[1].toString(10);
          this.applyFilters.emit(this.filterOptions);
      }*/
    /*applySliderRangeValues(event, fromKey, toKey) {
            console.log(this.rangeValues);
            this.filterOptions[fromKey] =  this.rangeValues[0].toString(10);
            this.filterOptions[toKey] = this.rangeValues[1].toString(10);
            this.applyFilters.emit(this.filterOptions);
        }*/
    /**
     * @return {?}
     */
    DataFilterInputsComponent.prototype.onFilterByDelay = /*applySliderRangeValues(event, fromKey, toKey) {
            console.log(this.rangeValues);
            this.filterOptions[fromKey] =  this.rangeValues[0].toString(10);
            this.filterOptions[toKey] = this.rangeValues[1].toString(10);
            this.applyFilters.emit(this.filterOptions);
        }*/
    /**
     * @return {?}
     */
    function () {
        var e_1, _a;
        try {
            for (var _b = __values(this.inputData.additionalData.listData), _c = _b.next(); !_c.done; _c = _b.next()) {
                var i = _c.value;
                this.filterOptions[i.value] = "";
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.filterOptions[this.delayRangeType] = this.delayRangeValue;
        this.applyFilters.emit(this.filterOptions);
    };
    DataFilterInputsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-data-filter-inputs",
                    template: "<div [ngSwitch]=\"inputData.fieldType\">\n  <!-- TEXT -->\n  <input\n    *ngSwitchCase=\"'TEXT'\"\n    pInputText\n    ngModel\n    [attr.id]=\"inputData.key\"\n    [attr.name]=\"inputData.key\"\n    name=\"{{ inputData.key }}\"\n    type=\"search\"\n    (keyup.enter)=\"onFilter(inputData.key, $event.target.value)\"\n    placeholder=\"{{ inputData?.additionalData?.placeholder || '' }}\"\n  />\n  <!-- SINGLE_SELECT -->\n  <p-dropdown\n    *ngSwitchCase=\"'SINGLE_SELECT'\"\n    [options]=\"inputData.additionalData.listData\"\n    (onChange)=\"\n      selectedValue(inputData.key, inputData.additionalData.optionLabel, $event)\n    \"\n    placeholder=\"{{ inputData.additionalData.placeholder }}\"\n    optionLabel=\"{{ inputData.additionalData.optionLabel }}\"\n    showClear=\"true\"\n  ></p-dropdown>\n  <!--MULTI SELECT -->\n  <p-multiSelect\n    *ngSwitchCase=\"'MULTI_SELECT'\"\n    defaultLabel=\"{{ inputData.additionalData.placeholder }}\"\n    [attr.id]=\"inputData.key\"\n    [attr.name]=\"inputData.key\"\n    [options]=\"inputData.additionalData.listData\"\n    [(ngModel)]=\"multiSelectValues\"\n    tooltipPosition=\"bottom\"\n    appendTo=\"body\"\n    optionLabel=\"{{ inputData.additionalData.optionLabel }}\"\n    (onChange)=\"\n      getMultiSelectValues(\n        $event,\n        inputData.key,\n        inputData.additionalData.selectedKey\n      )\n    \"\n  ></p-multiSelect>\n  <!--    AUTO_COMPLETE-->\n  <p-autoComplete\n    *ngSwitchCase=\"'AUTO_COMPLETE'\"\n    [(ngModel)]=\"autoCompleteValues\"\n    name=\"{{ inputData.key }}\"\n    id=\"{{ inputData.key }}\"\n    [suggestions]=\"inputData.additionalData.listData\"\n    (completeMethod)=\"\n      getDataBySearch(\n        $event,\n        inputData.additionalData.url,\n        inputData.additionalData.urlParamKey,\n        inputData.additionalData.listData\n      )\n    \"\n    (onSelect)=\"\n      getSelectedValues(\n        $event,\n        inputData.key,\n        inputData.additionalData.selectedKey\n      )\n    \"\n    (onUnselect)=\"\n      getSelectedValues(\n        $event,\n        inputData.key,\n        inputData.additionalData.selectedKey\n      )\n    \"\n    placeholder=\"{{ inputData.additionalData.placeholder }}\"\n    [multiple]=\"true\"\n    field=\"{{ inputData.additionalData.optionLabel }}\"\n  ></p-autoComplete>\n  <!-- DATE_RANGE -->\n  <p-calendar\n    *ngSwitchCase=\"'DATE_RANGE'\"\n    [(ngModel)]=\"rangeDates\"\n    placeholder=\"{{ inputData?.additionalData?.placeholder }}\"\n    (onSelect)=\"\n      applyDateRangeValues(\n        $event,\n        inputData.additionalData.fromKey,\n        inputData.additionalData.toKey\n      )\n    \"\n    selectionMode=\"range\"\n    [readonlyInput]=\"true\"\n    [showIcon]\n    [dateFormat]=\"'dd M'\"\n    [hideOnDateTimeSelect]=\"true\"\n  ></p-calendar>\n\n  <div class=\"ui-g-12 ui-md-4\" *ngSwitchCase=\"'DELAY'\" class=\"delay-section\">\n    <div class=\"ui-inputgroup delay-group-box\">\n      <p-dropdown\n        class=\"delay-dropdown\"\n        [options]=\"inputData.additionalData.listData\"\n        [(ngModel)]=\"delayRangeType\"\n        placeholder=\"Select\"\n      ></p-dropdown>\n      <input\n        type=\"search\"\n        class=\"delay-text\"\n        pInputText\n        [(ngModel)]=\"delayRangeValue\"\n        (keyup.enter)=\"onFilterByDelay()\"\n      />\n    </div>\n  </div>\n</div>\n",
                    styles: [":host .ui-dropdown .ui-dropdown-item,:host .ui-multiselect .ui-dropdown-item{font-size:var(--ion-regular-font-size)}:host .ui-dropdown .ui-dropdown-trigger-icon,:host .ui-multiselect .ui-dropdown-trigger-icon{font-size:.8rem}:host .ui-dropdown label.ui-dropdown-label,:host .ui-multiselect label.ui-dropdown-label{font-size:var(--ion-regular-font-size);padding:4px 10px!important}"]
                }] }
    ];
    /** @nocollapse */
    DataFilterInputsComponent.ctorParameters = function () { return [
        { type: DataFilterInputsService }
    ]; };
    DataFilterInputsComponent.propDecorators = {
        filterOptions: [{ type: Input }],
        inputData: [{ type: Input }],
        applyFilters: [{ type: Output }]
    };
    return DataFilterInputsComponent;
}());
if (false) {
    /** @type {?} */
    DataFilterInputsComponent.prototype.filterOptions;
    /** @type {?} */
    DataFilterInputsComponent.prototype.inputData;
    /** @type {?} */
    DataFilterInputsComponent.prototype.applyFilters;
    /** @type {?} */
    DataFilterInputsComponent.prototype.autoCompleteValues;
    /** @type {?} */
    DataFilterInputsComponent.prototype.multiSelectValues;
    /** @type {?} */
    DataFilterInputsComponent.prototype.rangeDates;
    /** @type {?} */
    DataFilterInputsComponent.prototype.rangeValues;
    /** @type {?} */
    DataFilterInputsComponent.prototype.delayRangeValue;
    /** @type {?} */
    DataFilterInputsComponent.prototype.delayRangeType;
    /**
     * @type {?}
     * @private
     */
    DataFilterInputsComponent.prototype.filterService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DataFilterInputsModule = /** @class */ (function () {
    function DataFilterInputsModule() {
    }
    DataFilterInputsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [DataFilterInputsComponent],
                    imports: [
                        CommonModule,
                        DropdownModule,
                        MultiSelectModule,
                        AutoCompleteModule,
                        FormsModule,
                        CalendarModule,
                        SliderModule,
                    ],
                    exports: [DataFilterInputsComponent],
                    providers: [DataFilterInputsService],
                },] }
    ];
    return DataFilterInputsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarketOrderCardComponent = /** @class */ (function () {
    function MarketOrderCardComponent() {
        this.onOrderClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    MarketOrderCardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    MarketOrderCardComponent.prototype.orderClicked = /**
     * @return {?}
     */
    function () {
        this.onOrderClicked.emit(this.order);
    };
    MarketOrderCardComponent.decorators = [
        { type: Component, args: [{
                    selector: "market-order-card",
                    template: "<ion-card\n  no-margin\n  margin-top\n  no-box-shadow\n  class=\"mobile-view\"\n  (click)=\"orderClicked()\"\n>\n  <!--<ion-grid no-padding >\n    <ion-row align-items-end>\n      <ion-col>\n        <ion-text class=\"item-name\">{{order?.orderItems[0]?.item?.name}}</ion-text>\n      </ion-col>\n      <ion-col text-end d-flex align-self-end justify-content-end class=\"display-status\">\n        <ion-badge color=\"medium\" >{{order?.displayStatusTitle}}</ion-badge>\n      </ion-col>\n    </ion-row>\n  </ion-grid>-->\n  <ion-grid no-padding class=\"market-order\">\n    <ion-row align-items-end>\n      <ion-col\n        class=\"item-name\"\n        size=\"8\"\n        no-padding-bottom=\"\"\n        no-padding-top=\"\"\n        no-padding-left=\"\"\n      >\n        <ion-text font-bold color=\"dark\">{{\n          order?.orderItems[0]?.item?.name\n        }}</ion-text>\n      </ion-col>\n      <ion-col\n        no-padding-bottom=\"\"\n        no-padding-top=\"\"\n        no-padding-right=\"\"\n        size=\"4\"\n        class=\"display-status\"\n        text-end\n        d-flex\n        align-self-end\n        justify-content-end\n      >\n        <ion-badge\n          font-bold\n          [OrderStatus]=\"\n            order?.status === 'ORDER_COMPLETED'\n              ? order?.payment?.orderPaymentStatus\n              : order?.status\n          \"\n          font-bold\n        >\n          {{\n            (order.status === \"ORDER_COMPLETED\"\n              ? order?.payment?.statusTitle\n              : order?.displayStatusTitle\n            ) | uppercase\n          }}\n        </ion-badge>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col size=\"12\" class=\"order-id\" no-padding=\"\">\n        <ion-text color=\"primary\" font-regular=\"\">Order Id \u2022 </ion-text>\n        <ion-text color=\"primary\" font-bold>{{ order?.formattedId }}</ion-text>\n      </ion-col>\n      <ion-col size=\"12\" class=\"created-date\" no-padding=\"\">\n        <ion-text color=\"medium\">Created Date \u2022 </ion-text>\n        <ion-text color=\"medium\" font-bold>{{\n          order?.createdDate | date: \"dd-MMM-yyyy\"\n        }}</ion-text>\n      </ion-col>\n    </ion-row>\n    <ion-row align-items-end>\n      <ion-col class=\"rate\" no-padding=\"\">\n        <ion-text color=\"dark\"\n          ><span font-bold>{{\n            order?.orderItems[0]?.itemPrice | currency: \"INR\"\n          }}</span\n          ><span>/{{ order?.orderItems[0]?.item?.unitType }}</span></ion-text\n        >\n      </ion-col>\n      <ion-col\n        text-end\n        align-self-end\n        justify-content-end\n        class=\"allocated-qty\"\n        no-padding=\"\"\n      >\n        <ion-text font-regular=\"\">Allocated Quantity</ion-text>\n        <br />\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          order?.formattedTotalQty || \"-\"\n        }}</ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n  <!--<ion-item my-item margin-bottom lines=\"none\" no-padding class=\"offer-bid-box\" >\n    <ion-icon class=\"icon-background ion-hide-md-up\" style=\"position: absolute;right:0\" name=\"ios-arrow-forward\"></ion-icon>\n\n  </ion-item>-->\n</ion-card>\n",
                    styles: [".rcyl-order-status-created{background-color:#72abea;--background:#72abea}.rcyl-order-status-scheduled{background-color:#ffa25f;--background:#ffa25f}.rcyl-order-status-on-hold{background-color:#ffd378;--background:#ffd378}.rcyl-order-status-picked{background-color:#bee2c6;--background:#bee2c6;color:rgba(0,0,0,.8);--color:rgba(0, 0, 0, 0.8)}.rcyl-order-status-received{background-color:#89cb97;--background:#89cb97}.rcyl-order-status-completed{background-color:#54b468;--background:#54b468}.rcyl-order-status-invoice-pending{background-color:#ffef8c;--background:#ffef8c;color:rgba(0,0,0,.7);--color:rgba(0, 0, 0, 0.7)}.rcyl-order-status-payment-pending{background-color:#fcd974;--background:#fcd974}.rcyl-order-status-invoice-verification-pending{background-color:#fbc45b;--background:#fbc45b}.rcyl-order-status-invoice-rejected{background-color:#ff7a5f;--background:#ff7a5f}.rcyl-order-status-rejected{background-color:#ff5545;--background:#ff5545}.rcyl-order-status-cancelled{background-color:#f2503b;--background:#f2503b}::ng-deep .full-width-modal .modal-wrapper{--width:100vw;width:100vw;--height:100vh;height:100vh;--max-width:100vw;max-width:100vw;max-height:100vh;--max-height:100vh;--background:transparent}.mobile-view .market-order{padding:10px}.mobile-view .market-order .item-name ion-text{text-align:left;font-size:1.385rem;line-height:.7692rem;letter-spacing:0;opacity:1}.mobile-view .market-order .display-status ion-badge{text-align:left;font-size:.9231rem;line-height:15px;letter-spacing:2px;opacity:1;border-radius:5px;--padding-start:5px;--padding-end:5px;--padding-top:5px;--padding-bottom:4px;white-space:normal}.mobile-view .market-order .order-id ion-text[font-bold],.mobile-view .market-order .order-id ion-text[font-regular]{text-align:left;font-size:1.077rem;line-height:.7692rem;letter-spacing:0}.mobile-view .market-order .created-date ion-text{font-size:.9231rem;line-height:.7692rem;text-align:left;letter-spacing:0}.mobile-view .market-order .rate{text-align:left}.mobile-view .market-order .rate ion-text{font-size:1.231rem;line-height:.7692rem;letter-spacing:0}.mobile-view .market-order .allocated-qty ion-text[font-regular]{text-align:right;font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1;color:#a3b4be}.mobile-view .market-order .allocated-qty ion-text[font-bold]{text-align:right;font-size:1.077rem;line-height:.7692rem;letter-spacing:0;opacity:1}.mobile-view [font-size-18]{font-size:18px!important}.mobile-view [font-bold]{font-weight:700!important}"]
                }] }
    ];
    /** @nocollapse */
    MarketOrderCardComponent.ctorParameters = function () { return []; };
    MarketOrderCardComponent.propDecorators = {
        order: [{ type: Input }],
        onOrderClicked: [{ type: Output }]
    };
    return MarketOrderCardComponent;
}());
if (false) {
    /** @type {?} */
    MarketOrderCardComponent.prototype.order;
    /** @type {?} */
    MarketOrderCardComponent.prototype.onOrderClicked;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderStatusDirective = /** @class */ (function () {
    function OrderStatusDirective(el) {
    }
    /**
     * @return {?}
     */
    OrderStatusDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.getColor();
    };
    /**
     * @return {?}
     */
    OrderStatusDirective.prototype.getColor = /**
     * @return {?}
     */
    function () {
        switch (this.orderStatus) {
            case "CREATED":
                this.colorClass = "rcyl-order-status-created";
                break;
            case "PICKUP_SCHEDULED":
                this.colorClass = "rcyl-order-status-scheduled";
                break;
            case "HOLD":
                this.colorClass = "rcyl-order-status-on-hold";
                break;
            case "MATERIAL_PICKED":
                this.colorClass = "rcyl-order-status-picked";
                break;
            case "MATERIAL_RECEIVED":
                this.colorClass = "rcyl-order-status-received";
                break;
            case "COMPLETED" || "ORDER_COMPLETED":
                this.colorClass = "rcyl-order-status-completed";
                break;
            case "INVOICE_PENDING":
                this.colorClass = "rcyl-order-status-invoice-pending";
                break;
            case "PAYMENT_PENDING":
                this.colorClass = "rcyl-order-status-payment-pending";
                break;
            case "INVOICE_VERIFICATION_PENDING":
                this.colorClass = "rcyl-order-status-invoice-verification-pending";
                break;
            case "INVOICE_REJECTED":
                this.colorClass = "rcyl-order-status-invoice-rejected";
                break;
            case "REJECTED":
                this.colorClass = "rcyl-order-status-rejected";
                break;
            case "CANCELLED":
                this.colorClass = "rcyl-order-status-cancelled";
                break;
            case "DENIED":
                break;
        }
    };
    OrderStatusDirective.decorators = [
        { type: Directive, args: [{
                    selector: "[OrderStatus]",
                },] }
    ];
    /** @nocollapse */
    OrderStatusDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    OrderStatusDirective.propDecorators = {
        colorClass: [{ type: HostBinding, args: ["class",] }],
        orderStatus: [{ type: Input, args: ["OrderStatus",] }]
    };
    return OrderStatusDirective;
}());
if (false) {
    /** @type {?} */
    OrderStatusDirective.prototype.colorClass;
    /** @type {?} */
    OrderStatusDirective.prototype.orderStatus;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderStatusModule = /** @class */ (function () {
    function OrderStatusModule() {
    }
    OrderStatusModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [OrderStatusDirective],
                    imports: [CommonModule, IonicModule],
                    exports: [OrderStatusDirective],
                },] }
    ];
    return OrderStatusModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarketOrderCardModule = /** @class */ (function () {
    function MarketOrderCardModule() {
    }
    MarketOrderCardModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MarketOrderCardComponent],
                    exports: [MarketOrderCardComponent],
                    imports: [CommonModule, IonicModule, OrderStatusModule],
                },] }
    ];
    return MarketOrderCardModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderCardComponent = /** @class */ (function () {
    function OrderCardComponent() {
        this.onOrderClicked = new EventEmitter();
    }
    /**
     * @return {?}
     */
    OrderCardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    OrderCardComponent.prototype.orderClicked = /**
     * @return {?}
     */
    function () {
        this.onOrderClicked.emit(this.order);
    };
    /**
     * @param {?} x
     * @return {?}
     */
    OrderCardComponent.prototype.getAbs = /**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        return Math.abs(x);
    };
    /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    OrderCardComponent.prototype.status = /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    function (statuses, In) {
        /** @type {?} */
        var isPresent = indexOf(statuses, this.order.status) >= 0;
        return In ? isPresent : !isPresent;
    };
    OrderCardComponent.decorators = [
        { type: Component, args: [{
                    selector: "order-card",
                    template: "<ion-card\n  no-margin\n  margin-top\n  no-box-shadow\n  class=\"mobile-view\"\n  (click)=\"orderClicked()\"\n>\n  <ion-grid>\n    <ion-row>\n      <ion-col text-left=\"\">\n        <ion-text>\n          <div font-medium text-black font-size-14>{{ order.formattedId }}</div>\n          <div font-size-10>\n            Pick up Date \u2022\n            <span font-medium font-size-10>{{\n              order.orderDate | date: \"dd-MMM-yyyy\"\n            }}</span>\n          </div>\n          <div font-size-12 font-medium *ngIf=\"order.addressInfo.city\">\n            <ion-text color=\"primary\">{{ order.fromLocation?.name }}</ion-text>\n          </div>\n        </ion-text>\n      </ion-col>\n      <ion-col size=\"auto\" text-right=\"\">\n        <ion-text\n          *ngIf=\"!status(['ORDER_COMPLETED'], true)\"\n          [color]=\"order?.totalAmountOfExclTax > 0 ? 'primary' : 'danger'\"\n        >\n          <div font-medium font-size-14>\n            {{ getAbs(order?.totalAmountOfExclTax) | currency: \"INR\" }}*\n          </div>\n        </ion-text>\n        <ion-text\n          *ngIf=\"status(['ORDER_COMPLETED'], true)\"\n          [color]=\"order?.tradeType === 'B' ? 'primary' : 'danger'\"\n        >\n          <div font-medium font-size-14>\n            {{ order?.netAmount | currency: \"INR\" }}*\n          </div>\n        </ion-text>\n\n        <div *ngIf=\"!status(['ORDER_COMPLETED'], true)\" font-size-10>\n          <i>*All rates exclusive of GST</i>\n        </div>\n        <div *ngIf=\"status(['ORDER_COMPLETED'], true)\" font-size-10>\n          <i>*All rates inclusive of GST</i>\n        </div>\n      </ion-col>\n    </ion-row>\n    <ion-row align-items-end margin-top>\n      <ion-col size=\"7\" text-left=\"\" class=\"statusLabel\">\n        <ion-badge\n          font-size-12\n          text-wrap\n          [OrderStatus]=\"\n            order?.status === 'ORDER_COMPLETED'\n              ? order?.payment?.orderPaymentStatus\n              : order?.status\n          \"\n        >\n          {{\n            (order?.status === \"ORDER_COMPLETED\"\n              ? order?.payment?.statusTitle\n              : order?.displayStatusTitle\n            ) | uppercase\n          }}\n        </ion-badge>\n      </ion-col>\n      <ion-col size=\"5\" text-right=\"\">\n        <ion-text color=\"medium\" font-size-10=\"\"> Qty \u2022</ion-text>\n        <ion-text font-size-14=\"\">\n          {{ order?.formattedTotalQty || \"-\" }}</ion-text\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-card>\n",
                    styles: [".rcyl-order-status-created{background-color:#72abea;--background:#72abea}.rcyl-order-status-scheduled{background-color:#ffa25f;--background:#ffa25f}.rcyl-order-status-on-hold{background-color:#ffd378;--background:#ffd378}.rcyl-order-status-picked{background-color:#bee2c6;--background:#bee2c6;color:rgba(0,0,0,.8);--color:rgba(0, 0, 0, 0.8)}.rcyl-order-status-received{background-color:#89cb97;--background:#89cb97}.rcyl-order-status-completed{background-color:#54b468;--background:#54b468}.rcyl-order-status-invoice-pending{background-color:#ffef8c;--background:#ffef8c;color:rgba(0,0,0,.7);--color:rgba(0, 0, 0, 0.7)}.rcyl-order-status-payment-pending{background-color:#fcd974;--background:#fcd974}.rcyl-order-status-invoice-verification-pending{background-color:#fbc45b;--background:#fbc45b}.rcyl-order-status-invoice-rejected{background-color:#ff7a5f;--background:#ff7a5f}.rcyl-order-status-rejected{background-color:#ff5545;--background:#ff5545}.rcyl-order-status-cancelled{background-color:#f2503b;--background:#f2503b}::ng-deep .full-width-modal .modal-wrapper{--width:100vw;width:100vw;--height:100vh;height:100vh;--max-width:100vw;max-width:100vw;max-height:100vh;--max-height:100vh;--background:transparent}.mobile-view [font-size-9]{font-size:9px!important}.mobile-view [font-size-10]{font-size:10px!important}.mobile-view [font-size-12]{font-size:12px!important}.mobile-view [font-size-13]{font-size:13px!important}.mobile-view [font-size-14]{font-size:14px!important}.mobile-view [font-size-16]{font-size:16px!important}.mobile-view [text-bold]{font-weight:700!important}.mobile-view [text-black]{color:#27353c!important}.mobile-view .statusLabel ion-badge{padding:0 10px;line-height:22px;display:-webkit-inline-box;min-height:20px}"]
                }] }
    ];
    /** @nocollapse */
    OrderCardComponent.ctorParameters = function () { return []; };
    OrderCardComponent.propDecorators = {
        order: [{ type: Input }],
        onOrderClicked: [{ type: Output }]
    };
    return OrderCardComponent;
}());
if (false) {
    /** @type {?} */
    OrderCardComponent.prototype.order;
    /** @type {?} */
    OrderCardComponent.prototype.onOrderClicked;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderCardModule = /** @class */ (function () {
    function OrderCardModule() {
    }
    OrderCardModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [OrderCardComponent],
                    exports: [OrderCardComponent],
                    imports: [CommonModule, IonicModule, OrderStatusModule],
                },] }
    ];
    return OrderCardModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var OrderListModule = /** @class */ (function () {
    function OrderListModule() {
    }
    OrderListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [OrderListComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        TableModule,
                        OrderListDataModule,
                        ManageColumnsModule,
                        MakePaymentButtonModule,
                        VerifyInvoiceButtonModule,
                        DataFilterInputsModule,
                        TooltipModule,
                        MarketOrderCardModule,
                        OrderCardModule,
                    ],
                    exports: [OrderListComponent],
                },] }
    ];
    return OrderListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylFileManagerService = /** @class */ (function () {
    function RcylFileManagerService(http, toast, events, alertController) {
        var _this = this;
        this.http = http;
        this.toast = toast;
        this.events = events;
        this.alertController = alertController;
        this.dataSource = new Subject();
        this.onUploadSuccess = this.dataSource.asObservable();
        this.documentMap = new BehaviorSubject({
            ITEM_IMAGE: {
                displayText: "Item Image",
                sampleImg: "",
                icon: "",
                iconChecked: "",
                beforeUploadText: "",
                afterUploadText: "",
                showInList: false,
                documents: [],
            },
            SELLER_WEIGH_BRIDGE: {
                displayText: "Seller Weighbridge",
                sampleImg: "assets/rcyl-orders/weigh-bridge-sample.jpg",
                icon: "assets/rcyl-orders/seller-weighbridge.svg",
                iconChecked: "assets/rcyl-orders/seller-weighbridge-checked.svg",
                beforeUploadText: "Upload new seller weigh-bridge document",
                afterUploadText: "Weigh-bridge was successfully added",
                showInList: true,
                documents: [],
            },
            LORRY_RECEIPT: {
                displayText: "Lorry Receipt",
                sampleImg: "assets/rcyl-orders/lorry-receipt-sample.jpg",
                icon: "assets/rcyl-orders/lorry-receipt.svg",
                iconChecked: "assets/rcyl-orders/lorry-receipt-checked.svg",
                beforeUploadText: "Upload new lorry receipts document",
                afterUploadText: "Lorry receipts was successfully added",
                showInList: true,
                documents: [],
            },
            EWAY_BILL: {
                displayText: "E-Way Bill",
                sampleImg: "assets/rcyl-orders/e-way-bill-sample.jpg",
                icon: "assets/rcyl-orders/e-way-bill.svg",
                iconChecked: "assets/rcyl-orders/e-way-bill-checked.svg",
                beforeUploadText: "Upload new E-way bill",
                afterUploadText: "E-way bill was successfully added",
                showInList: true,
                documents: [],
            },
            INVOICE: {
                displayText: "Invoice",
                sampleImg: "assets/rcyl-orders/tax-invoice-sample.jpg",
                icon: "assets/rcyl-orders/invoice.svg",
                iconChecked: "assets/rcyl-orders/invoice-checked.svg",
                beforeUploadText: "Upload new Invoice document",
                afterUploadText: "Invoice was successfully added",
                showInList: true,
                documents: [],
            },
            DC: {
                displayText: "Delivery Challan",
                sampleImg: "assets/rcyl-orders/delivery-challan-sample.jpg",
                icon: "assets/rcyl-orders/delivery-challan.svg",
                iconChecked: "assets/rcyl-orders/delivery-challan-checked.svg",
                beforeUploadText: "Upload new delivery challan",
                afterUploadText: "Delivery challan was successfully added",
                showInList: true,
                documents: [],
            },
            BUYER_WEIGH_BRIDGE: {
                displayText: "Buyer Weighbridge",
                sampleImg: "assets/rcyl-orders/weigh-bridge-sample.jpg",
                icon: "assets/rcyl-orders/buyer-weighbridge.svg",
                iconChecked: "assets/rcyl-orders/buyer-weighbridge-checked.svg",
                beforeUploadText: "Upload new buyer weigh-bridge",
                afterUploadText: "Weigh-bridge was successfully added",
                showInList: true,
                documents: [],
            },
            LAB_REPORT: {
                displayText: "Lab Report",
                sampleImg: "assets/rcyl-orders/lab-report-sample.jpg",
                icon: "assets/rcyl-orders/lab-report.svg",
                iconChecked: "assets/rcyl-orders/lab-report-checked.svg",
                beforeUploadText: "Upload new lab report",
                afterUploadText: "Lab report was successfully added",
                showInList: true,
                documents: [],
            },
            PROOF_OF_SIGNATURE: {
                displayText: "Proof of Signature",
                sampleImg: "assets/rcyl-orders/lab-report-sample.jpg",
                icon: "assets/rcyl-orders/gallery-icon.svg",
                iconChecked: "assets/rcyl-orders/gallery-icon-checked.svg",
                beforeUploadText: "Upload new proof of signature",
                afterUploadText: "Proof of signature was successfully added",
                showInList: true,
                documents: [],
            },
            FINAL_PAYMENT_ADVICE: {
                displayText: "Payment Advice",
                sampleImg: "assets/rcyl-orders/item-img-sample.jpg",
                icon: "assets/rcyl-orders/gallery-icon.svg",
                iconChecked: "assets/rcyl-orders/gallery-icon-checked.svg",
                beforeUploadText: "Upload Payment advice",
                afterUploadText: "Payment advice was successfully added",
                showInList: true,
                documents: [],
            },
            OTHER: {
                displayText: "Other Images/Documents",
                sampleImg: "assets/rcyl-orders/item-img-sample.jpg",
                icon: "assets/rcyl-orders/gallery-icon.svg",
                iconChecked: "assets/rcyl-orders/gallery-icon-checked.svg",
                beforeUploadText: "Upload new images/documents",
                afterUploadText: "Upload new images/documents",
                showInList: true,
                documents: [],
            },
        });
        this.confirmAndDeleteDocument = (/**
         * @param {?} document
         * @return {?}
         */
        function (document) {
            return new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) {
                _this.alertController
                    .create({
                    header: "Are you sure you want to delete document ?",
                    buttons: [
                        {
                            text: "No",
                            role: "cancel",
                            cssClass: "secondary",
                            handler: (/**
                             * @return {?}
                             */
                            function () {
                                resolve("cancel");
                            }),
                        },
                        {
                            text: "Yes",
                            handler: (/**
                             * @return {?}
                             */
                            function () {
                                _this.deleteDocument(document.id).subscribe((/**
                                 * @param {?} data
                                 * @return {?}
                                 */
                                function (data) {
                                    resolve(data);
                                }), (/**
                                 * @param {?} err
                                 * @return {?}
                                 */
                                function (err) {
                                    reject(err);
                                }));
                            }),
                        },
                    ],
                })
                    .then((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    /** @type {?} */
                    var alert = data;
                    alert.present().then();
                }));
            }));
        });
    }
    /**
     * @param {?} orderDocs
     * @return {?}
     */
    RcylFileManagerService.prototype.prepareOrderDocumentsMap = /**
     * @param {?} orderDocs
     * @return {?}
     */
    function (orderDocs) {
        /** @type {?} */
        var documentTypes = OrderDocumentTypes;
        if (isArray(orderDocs)) {
            this.documentMap.value.BUYER_WEIGH_BRIDGE.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.BUYER_WEIGH_BRIDGE) {
                    return item;
                }
            }));
            this.documentMap.value.SELLER_WEIGH_BRIDGE.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.SELLER_WEIGH_BRIDGE) {
                    return item;
                }
            }));
            this.documentMap.value.LORRY_RECEIPT.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.LORRY_RECEIPT) {
                    return item;
                }
            }));
            this.documentMap.value.EWAY_BILL.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.EWAY_BILL) {
                    return item;
                }
            }));
            this.documentMap.value.INVOICE.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.INVOICE ||
                    item.type === documentTypes.ORDER_INVOICE) {
                    return item;
                }
            }));
            this.documentMap.value.DC.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.DC) {
                    return item;
                }
            }));
            this.documentMap.value.LAB_REPORT.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.LAB_REPORT) {
                    return item;
                }
            }));
            this.documentMap.value.OTHER.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.OTHER) {
                    return item;
                }
            }));
            this.documentMap.value.PROOF_OF_SIGNATURE.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.PROOF_OF_SIGNATURE) {
                    return item;
                }
            }));
            this.documentMap.value.FINAL_PAYMENT_ADVICE.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.FINAL_PAYMENT_ADVICE) {
                    return item;
                }
            }));
            this.documentMap.value.ITEM_IMAGE.documents = orderDocs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                if (item.type === documentTypes.ITEM_IMAGE) {
                    return item;
                }
            }));
        }
        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_DOCUMENTS_UPDATED, this.documentMap.value);
        this.documentMap.next(this.documentMap.value);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylFileManagerService.prototype.signedUrl = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        /** @type {?} */
        var promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            /** @type {?} */
            var apiURL = "/core/documents/signed-url";
            _this.http
                .post(apiURL, data)
                .toPromise()
                .then((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                console.log(res);
                resolve(res);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                reject(error);
            }));
        }));
        return promise;
    };
    /**
     * @param {?} data
     * @param {?} file
     * @return {?}
     */
    RcylFileManagerService.prototype.upload = /**
     * @param {?} data
     * @param {?} file
     * @return {?}
     */
    function (data, file) {
        var _this = this;
        console.log("upload-called");
        return this.signedUrl(data).then((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            return _this.uploadToS3(file, result).then((/**
             * @param {?} response
             * @return {?}
             */
            function (response) {
                return _this.attachUploadedFileToEntity((/** @type {?} */ (result)), "CORE").then((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    _this.document = data;
                    _this.dataSource.next(_this.document);
                    return data;
                }));
            }));
        }));
    };
    /**
     * @param {?} file
     * @param {?} result
     * @return {?}
     */
    RcylFileManagerService.prototype.uploadToS3 = /**
     * @param {?} file
     * @param {?} result
     * @return {?}
     */
    function (file, result) {
        var _this = this;
        if (file) {
            /** @type {?} */
            var headersValues_1 = new HttpHeaders();
            headersValues_1.append("Content-Type", file.type);
            /** @type {?} */
            var promise = new Promise((/**
             * @param {?} resolve
             * @param {?} reject
             * @return {?}
             */
            function (resolve, reject) {
                _this.http
                    .put(result.signedUrl, file, { headers: headersValues_1 })
                    .toPromise()
                    .then((/**
                 * @param {?} res
                 * @return {?}
                 */
                function (res) {
                    console.log(res);
                    resolve(res);
                }), (/**
                 * @param {?} error
                 * @return {?}
                 */
                function (error) {
                    reject(error);
                }));
            }));
            return promise;
        }
    };
    /**
     * @param {?=} id
     * @param {?=} data
     * @return {?}
     */
    RcylFileManagerService.prototype.deleteDocument = /**
     * @param {?=} id
     * @param {?=} data
     * @return {?}
     */
    function (id, data) {
        return this.http.put("/core/documents/remove?id=" + id, data);
    };
    /**
     * @param {?} orderDoc
     * @return {?}
     */
    RcylFileManagerService.prototype.downloadDocumentInBrowser = /**
     * @param {?} orderDoc
     * @return {?}
     */
    function (orderDoc) {
        if (orderDoc && orderDoc.url) {
            try {
                /** @type {?} */
                var link = document.createElement("a");
                link.href = orderDoc.url;
                link.download = orderDoc.fileName;
                link.target = "_blank";
                link.click();
            }
            catch (e) {
                window.open(orderDoc.url, "_blank");
            }
        }
    };
    /**
     * @param {?} request
     * @param {?} uploadAgainst
     * @return {?}
     */
    RcylFileManagerService.prototype.attachUploadedFileToEntity = /**
     * @param {?} request
     * @param {?} uploadAgainst
     * @return {?}
     */
    function (request, uploadAgainst) {
        var _this = this;
        // adding case because in platform different urls for attach.
        if (request && request.signedUrl && !request.url) {
            /** @type {?} */
            var splittedString = request.signedUrl.split("?X-Amz-");
            if (splittedString && splittedString[0]) {
                request.url = splittedString[0];
            }
        }
        return new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            switch (uploadAgainst) {
                case "CORE":
                    _this.http
                        .post("/core/documents/attach", request)
                        .toPromise()
                        .then((/**
                     * @param {?} res
                     * @return {?}
                     */
                    function (res) {
                        resolve(res);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject(error);
                    }));
                    break;
                case "STACKHOLDER":
                    reject("Not supported");
                    break;
                case "CATALOG":
                    _this.http
                        .post("/catalog/documents/attach", request)
                        .toPromise()
                        .then((/**
                     * @param {?} res
                     * @return {?}
                     */
                    function (res) {
                        resolve(res);
                    }), (/**
                     * @param {?} error
                     * @return {?}
                     */
                    function (error) {
                        reject(error);
                    }));
                    break;
                default:
                    reject("Not supported");
            }
        }));
    };
    RcylFileManagerService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    RcylFileManagerService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ToastController },
        { type: Events },
        { type: AlertController }
    ]; };
    /** @nocollapse */ RcylFileManagerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RcylFileManagerService_Factory() { return new RcylFileManagerService(ɵɵinject(HttpClient), ɵɵinject(ToastController), ɵɵinject(Events), ɵɵinject(AlertController)); }, token: RcylFileManagerService, providedIn: "root" });
    return RcylFileManagerService;
}());
if (false) {
    /** @type {?} */
    RcylFileManagerService.prototype.document;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerService.prototype.dataSource;
    /** @type {?} */
    RcylFileManagerService.prototype.onUploadSuccess;
    /** @type {?} */
    RcylFileManagerService.prototype.documentMap;
    /** @type {?} */
    RcylFileManagerService.prototype.confirmAndDeleteDocument;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerService.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerService.prototype.events;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerService.prototype.alertController;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylFileManagerComponent = /** @class */ (function () {
    function RcylFileManagerComponent(modalController, fileManager, toastCtrl, events, rcylOrdersService) {
        this.modalController = modalController;
        this.fileManager = fileManager;
        this.toastCtrl = toastCtrl;
        this.events = events;
        this.rcylOrdersService = rcylOrdersService;
        // It is for file upload
        this.uploader = new FileUploader({
            disableMultipart: false,
            itemAlias: "attachment",
            allowedFileType: ["pdf", "image"],
            allowedMimeType: [
                "image/jpeg",
                "image/jpg",
                "application/pdf",
                "image/png",
            ],
        });
        this.isOrderChanged = false;
    }
    /**
     * @return {?}
     */
    RcylFileManagerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        console.log(this.docType);
        this.modalTitle = startCase(this.docType);
    };
    // file upload code
    // file upload code
    /**
     * @param {?} event
     * @return {?}
     */
    RcylFileManagerComponent.prototype.onFileSelected = 
    // file upload code
    /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        if (event && event.length > 0) {
            this.isLoading = true;
            /** @type {?} */
            var file = event[0];
            /** @type {?} */
            var data = {
                type: this.docType,
                fileName: file.name,
                fileSize: file.size,
                entityId: this.order.id,
                entity: "ORDER",
            };
            this.fileManager
                .upload(data, file)
                .then((/**
             * @param {?} result
             * @return {?}
             */
            function (result) {
                if (result) {
                    _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "INVOICE_VERIFICATION_PENDING", result);
                    // console.log(JSON.stringify(result));
                    _this.docs = __spread(_this.docs, [result]);
                    _this.isLoading = false;
                    if (_this.docType === "WEIGH_BRIDGE") {
                        _this.rcylOrdersService
                            .presentToast("Weighbridge Uploaded Successfully.")
                            .then();
                    }
                    else if (_this.docType === "INVOICE") {
                        _this.rcylOrdersService
                            .presentToast("Invoice Uploaded Successfully.")
                            .then();
                    }
                }
            }))
                .catch((/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                _this.isLoading = false;
            }));
        }
    };
    /**
     * @param {?} url
     * @return {?}
     */
    RcylFileManagerComponent.prototype.openFile = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        this.openFileUrl(url);
        /*if(window.cordova) {
                const openbrowser = this.iab.create(url,"_system");
            } else {
                const openInNew = document.createElement('a');
                openInNew.target="_blank";
                openInNew.href=url;
                openInNew.click();
            }*/
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylFileManagerComponent.prototype.closeModal = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.modalController.dismiss({ data: data }, "FILE_UPLOAD_SUCCESS");
    };
    /**
     * @return {?}
     */
    RcylFileManagerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () { };
    RcylFileManagerComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-file-manager",
                    template: "<div class=\"inner-content\" padding=\"\">\n  <div text-center margin>\n    <div font-medium style=\"font-size: 16px !important\">\n      {{ modalTitle | titlecase }}\n    </div>\n    <div\n      style=\"font-size: 12px; color: #5b7583\"\n      *ngIf=\"modalTitle === 'INVOICE'\"\n    >\n      Payments will be made based on the Invoice Value\n    </div>\n  </div>\n  <ion-card no-box-shadow>\n    <ion-list no-margin no-padding *ngIf=\"docs?.length > 0\">\n      <ion-item\n        [lines]=\"'none'\"\n        class=\"uploaded_file\"\n        *ngFor=\"let document of docs\"\n      >\n        <ion-label> {{ document.fileName }} </ion-label>\n        <ion-button\n          (click)=\"openFile(document.url)\"\n          class=\"view_btn\"\n          color=\"primary\"\n          text-regular\n        >\n          <ion-icon name=\"ios-eye\" slot=\"start\"></ion-icon> VIEW\n        </ion-button>\n        <!--<ion-button href=\"#\" text-center color=\"dark\"><ion-icon slot=\"start\" name=\"star\"></ion-icon></ion-button>-->\n      </ion-item>\n    </ion-list>\n    <ion-row *ngIf=\"docs?.length === 0\">\n      <ion-col text-center padding margin>\n        <ion-text>There are no documents.</ion-text>\n      </ion-col>\n    </ion-row>\n    <ion-row\n      (click)=\"fileInput.click()\"\n      [hidden]=\"\n        order.status === 'ORDER_COMPLETED' &&\n        order.payment.orderPaymentStatus === 'COMPLETED'\n      \"\n    >\n      <ion-col no-padding>\n        <input\n          type=\"file\"\n          #fileInput\n          ng2FileSelect\n          hidden=\"true\"\n          [uploader]=\"uploader\"\n          (onFileSelected)=\"onFileSelected($event)\"\n        />\n        <ion-button\n          size=\"large\"\n          class=\"uploadBtn\"\n          no-margin-left\n          expand=\"block\"\n          color=\"light\"\n          text-regular\n        >\n          <ion-icon name=\"folder\" slot=\"start\"></ion-icon>&nbsp;Attach File\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-card>\n  <div text-center *ngIf=\"isLoading\">\n    <ion-spinner></ion-spinner>\n  </div>\n</div>\n",
                    styles: [":host .upload-box{border:2px dashed #46d6e8;min-height:100px;background:#fff;box-shadow:none;border-radius:0;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center}:host .upload-box ion-icon{font-size:26px}:host .uploadBtn{border:1px dashed #5b7583;border-radius:5px;font-size:14px!important;height:50px;--ion-color-base:#ffffff!important;--box-shadow:none!important;margin-left:0!important}:host .uploadBtn ion-icon{font-size:22px}:host .uploaded_file{--background:#f4f4f4;--border-radius:5px;margin-bottom:10px}:host .view_btn{font-size:12px!important;font-weight:600}:host .view_btn ion-icon{font-size:14px!important}"]
                }] }
    ];
    /** @nocollapse */
    RcylFileManagerComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: RcylFileManagerService },
        { type: ToastController },
        { type: Events },
        { type: RcylOrdersService }
    ]; };
    RcylFileManagerComponent.propDecorators = {
        docs: [{ type: Input }],
        docType: [{ type: Input }],
        order: [{ type: Input }],
        openFileUrl: [{ type: Input }]
    };
    return RcylFileManagerComponent;
}());
if (false) {
    /** @type {?} */
    RcylFileManagerComponent.prototype.docs;
    /** @type {?} */
    RcylFileManagerComponent.prototype.docType;
    /** @type {?} */
    RcylFileManagerComponent.prototype.order;
    /** @type {?} */
    RcylFileManagerComponent.prototype.openFileUrl;
    /** @type {?} */
    RcylFileManagerComponent.prototype.uploader;
    /** @type {?} */
    RcylFileManagerComponent.prototype.modalTitle;
    /** @type {?} */
    RcylFileManagerComponent.prototype.isOrderChanged;
    /** @type {?} */
    RcylFileManagerComponent.prototype.isLoading;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerComponent.prototype.fileManager;
    /** @type {?} */
    RcylFileManagerComponent.prototype.toastCtrl;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    RcylFileManagerComponent.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var OrderStatus = {
    CREATED: "CREATED",
    VERIFIED: "VERIFIED",
    PICKED: "PICKED",
    MATERIAL_RECEIVED: "MATERIAL_RECEIVED",
    PICKUP_SCHEDULED: "PICKUP_SCHEDULED",
    MATERIAL_PICKED: "MATERIAL_PICKED",
    HOLD: "HOLD",
    CANCELLED: "CANCELLED",
    REJECTED: "REJECTED",
    PAYMENT_PENDING: "PAYMENT_PENDING",
    PAYMENT_COMPLETED: "COMPLETED",
    ORDER_COMPLETED: "ORDER_COMPLETED",
    INVOICE_PENDING: "INVOICE_PENDING",
    INVOICE_VERIFICATION_PENDING: "INVOICE_VERIFICATION_PENDING",
};
/**
 * @record
 */
function IOrder() { }
if (false) {
    /** @type {?|undefined} */
    IOrder.prototype.id;
    /** @type {?|undefined} */
    IOrder.prototype.active;
    /** @type {?|undefined} */
    IOrder.prototype.alert;
    /** @type {?|undefined} */
    IOrder.prototype.allowEdit;
    /** @type {?|undefined} */
    IOrder.prototype.alternateMobile1;
    /** @type {?|undefined} */
    IOrder.prototype.alternateMobile2;
    /** @type {?|undefined} */
    IOrder.prototype.contactDetails;
    /** @type {?|undefined} */
    IOrder.prototype.createdDate;
    /** @type {?|undefined} */
    IOrder.prototype.currency;
    /** @type {?|undefined} */
    IOrder.prototype.customer;
    /** @type {?|undefined} */
    IOrder.prototype.seller;
    /** @type {?|undefined} */
    IOrder.prototype.buyer;
    /** @type {?|undefined} */
    IOrder.prototype.customerId;
    /** @type {?|undefined} */
    IOrder.prototype.customerStore;
    /** @type {?|undefined} */
    IOrder.prototype.documents;
    /** @type {?|undefined} */
    IOrder.prototype.location;
    /** @type {?|undefined} */
    IOrder.prototype.fromLocation;
    /** @type {?|undefined} */
    IOrder.prototype.toLocation;
    /** @type {?|undefined} */
    IOrder.prototype.executedTime;
    /** @type {?|undefined} */
    IOrder.prototype.executiveRate;
    /** @type {?|undefined} */
    IOrder.prototype.formattedId;
    /** @type {?|undefined} */
    IOrder.prototype.gstOrder;
    /** @type {?|undefined} */
    IOrder.prototype.gstin;
    /** @type {?|undefined} */
    IOrder.prototype.lastNote;
    /** @type {?|undefined} */
    IOrder.prototype.logisticsCharges;
    /** @type {?|undefined} */
    IOrder.prototype.netAmount;
    /** @type {?|undefined} */
    IOrder.prototype.orderItems;
    /** @type {?|undefined} */
    IOrder.prototype.orderType;
    /** @type {?|undefined} */
    IOrder.prototype.payment;
    /** @type {?|undefined} */
    IOrder.prototype.pickupExecutiveRate;
    /** @type {?|undefined} */
    IOrder.prototype.pickupPerson;
    /** @type {?|undefined} */
    IOrder.prototype.pickupTime;
    /** @type {?|undefined} */
    IOrder.prototype.receivedByUserName;
    /** @type {?|undefined} */
    IOrder.prototype.rejectionReason;
    /** @type {?|undefined} */
    IOrder.prototype.seqNo;
    /** @type {?|undefined} */
    IOrder.prototype.status;
    /** @type {?|undefined} */
    IOrder.prototype.statusText;
    /** @type {?|undefined} */
    IOrder.prototype.statusTime;
    /** @type {?|undefined} */
    IOrder.prototype.statusTitle;
    /** @type {?|undefined} */
    IOrder.prototype.storeId;
    /** @type {?|undefined} */
    IOrder.prototype.timeSlot;
    /** @type {?|undefined} */
    IOrder.prototype.franchise;
    /** @type {?|undefined} */
    IOrder.prototype.totalAmount;
    /** @type {?|undefined} */
    IOrder.prototype.totalQty;
    /** @type {?|undefined} */
    IOrder.prototype.totalTax;
    /** @type {?|undefined} */
    IOrder.prototype.warehouse;
    /** @type {?|undefined} */
    IOrder.prototype.warehouseReceivedDate;
    /** @type {?|undefined} */
    IOrder.prototype.weightOfOrder;
    /** @type {?|undefined} */
    IOrder.prototype.displayStatusTitle;
    /** @type {?|undefined} */
    IOrder.prototype.paymentMode;
    /** @type {?|undefined} */
    IOrder.prototype.orderDate;
    /** @type {?|undefined} */
    IOrder.prototype.saleOrder;
    /** @type {?|undefined} */
    IOrder.prototype.delay;
    /** @type {?|undefined} */
    IOrder.prototype.paymentStatus;
    /** @type {?|undefined} */
    IOrder.prototype.paymentStatusTitle;
    /** @type {?|undefined} */
    IOrder.prototype.addressInfo;
    /** @type {?|undefined} */
    IOrder.prototype.bidId;
    /** @type {?|undefined} */
    IOrder.prototype.offerId;
    /** @type {?|undefined} */
    IOrder.prototype.formattedTotalQty;
    /** @type {?|undefined} */
    IOrder.prototype.channelType;
    /** @type {?|undefined} */
    IOrder.prototype.totalEarnAmount;
    /** @type {?|undefined} */
    IOrder.prototype.tradeType;
    /** @type {?|undefined} */
    IOrder.prototype.totalReceivedQty;
    /** @type {?|undefined} */
    IOrder.prototype.totalInitialQty;
    /** @type {?|undefined} */
    IOrder.prototype.totalPickedQty;
    /** @type {?|undefined} */
    IOrder.prototype.earnTax;
    /** @type {?|undefined} */
    IOrder.prototype.totalAmountOfExclTax;
    /** @type {?|undefined} */
    IOrder.prototype.totalOfAllTaxes;
}
var Order = /** @class */ (function () {
    function Order(id, active, alert, allowEdit, alternateMobile1, alternateMobile2, contactDetails, createdDate, currency, customer, customerId, customerStore, documents, location, fromLocation, toLocation, executedTime, executiveRate, formattedId, gstOrder, gstin, logisticsCharges, netAmount, orderItems, orderType, payment, pickupPerson, pickupTime, receivedByUserName, rejectionReason, seqNo, status, statusText, statusTime, statusTitle, storeId, totalAmount, totalQty, totalTax, warehouseReceivedDate, weightOfOrder, lastNote, pickupExecutiveRate, timeSlot, franchise, warehouse, displayStatusTitle, paymentMode, orderDate, saleOrder, delay, paymentStatus, paymentStatusTitle, bidId, offerId, formattedTotalQty, channelType, totalEarnAmount, tradeType, totalReceivedQty, totalInitialQty, totalPickedQty, earnTax, totalAmountOfExclTax, totalOfAllTaxes) {
        this.id = id;
        this.active = active;
        this.alert = alert;
        this.allowEdit = allowEdit;
        this.alternateMobile1 = alternateMobile1;
        this.alternateMobile2 = alternateMobile2;
        this.contactDetails = contactDetails;
        this.createdDate = createdDate;
        this.currency = currency;
        this.customer = customer;
        this.customerId = customerId;
        this.customerStore = customerStore;
        this.documents = documents;
        this.location = location;
        this.fromLocation = fromLocation;
        this.toLocation = toLocation;
        this.executedTime = executedTime;
        this.executiveRate = executiveRate;
        this.formattedId = formattedId;
        this.gstOrder = gstOrder;
        this.gstin = gstin;
        this.logisticsCharges = logisticsCharges;
        this.netAmount = netAmount;
        this.orderItems = orderItems;
        this.orderType = orderType;
        this.payment = payment;
        this.pickupPerson = pickupPerson;
        this.pickupTime = pickupTime;
        this.receivedByUserName = receivedByUserName;
        this.rejectionReason = rejectionReason;
        this.seqNo = seqNo;
        this.status = status;
        this.statusText = statusText;
        this.statusTime = statusTime;
        this.statusTitle = statusTitle;
        this.storeId = storeId;
        this.totalAmount = totalAmount;
        this.totalQty = totalQty;
        this.totalTax = totalTax;
        this.warehouseReceivedDate = warehouseReceivedDate;
        this.weightOfOrder = weightOfOrder;
        this.lastNote = lastNote;
        this.pickupExecutiveRate = pickupExecutiveRate;
        this.timeSlot = timeSlot;
        this.franchise = franchise;
        this.warehouse = warehouse;
        this.displayStatusTitle = displayStatusTitle;
        this.paymentMode = paymentMode;
        this.orderDate = orderDate;
        this.saleOrder = saleOrder;
        this.delay = delay;
        this.paymentStatus = paymentStatus;
        this.paymentStatusTitle = paymentStatusTitle;
        this.bidId = bidId;
        this.offerId = offerId;
        this.formattedTotalQty = formattedTotalQty;
        this.channelType = channelType;
        this.totalEarnAmount = totalEarnAmount;
        this.tradeType = tradeType;
        this.totalReceivedQty = totalReceivedQty;
        this.totalInitialQty = totalInitialQty;
        this.totalPickedQty = totalPickedQty;
        this.earnTax = earnTax;
        this.totalAmountOfExclTax = totalAmountOfExclTax;
        this.totalOfAllTaxes = totalOfAllTaxes;
    }
    return Order;
}());
if (false) {
    /** @type {?} */
    Order.prototype.id;
    /** @type {?} */
    Order.prototype.active;
    /** @type {?} */
    Order.prototype.alert;
    /** @type {?} */
    Order.prototype.allowEdit;
    /** @type {?} */
    Order.prototype.alternateMobile1;
    /** @type {?} */
    Order.prototype.alternateMobile2;
    /** @type {?} */
    Order.prototype.contactDetails;
    /** @type {?} */
    Order.prototype.createdDate;
    /** @type {?} */
    Order.prototype.currency;
    /** @type {?} */
    Order.prototype.customer;
    /** @type {?} */
    Order.prototype.customerId;
    /** @type {?} */
    Order.prototype.customerStore;
    /** @type {?} */
    Order.prototype.documents;
    /** @type {?} */
    Order.prototype.location;
    /** @type {?} */
    Order.prototype.fromLocation;
    /** @type {?} */
    Order.prototype.toLocation;
    /** @type {?} */
    Order.prototype.executedTime;
    /** @type {?} */
    Order.prototype.executiveRate;
    /** @type {?} */
    Order.prototype.formattedId;
    /** @type {?} */
    Order.prototype.gstOrder;
    /** @type {?} */
    Order.prototype.gstin;
    /** @type {?} */
    Order.prototype.logisticsCharges;
    /** @type {?} */
    Order.prototype.netAmount;
    /** @type {?} */
    Order.prototype.orderItems;
    /** @type {?} */
    Order.prototype.orderType;
    /** @type {?} */
    Order.prototype.payment;
    /** @type {?} */
    Order.prototype.pickupPerson;
    /** @type {?} */
    Order.prototype.pickupTime;
    /** @type {?} */
    Order.prototype.receivedByUserName;
    /** @type {?} */
    Order.prototype.rejectionReason;
    /** @type {?} */
    Order.prototype.seqNo;
    /** @type {?} */
    Order.prototype.status;
    /** @type {?} */
    Order.prototype.statusText;
    /** @type {?} */
    Order.prototype.statusTime;
    /** @type {?} */
    Order.prototype.statusTitle;
    /** @type {?} */
    Order.prototype.storeId;
    /** @type {?} */
    Order.prototype.totalAmount;
    /** @type {?} */
    Order.prototype.totalQty;
    /** @type {?} */
    Order.prototype.totalTax;
    /** @type {?} */
    Order.prototype.warehouseReceivedDate;
    /** @type {?} */
    Order.prototype.weightOfOrder;
    /** @type {?} */
    Order.prototype.lastNote;
    /** @type {?} */
    Order.prototype.pickupExecutiveRate;
    /** @type {?} */
    Order.prototype.timeSlot;
    /** @type {?} */
    Order.prototype.franchise;
    /** @type {?} */
    Order.prototype.warehouse;
    /** @type {?} */
    Order.prototype.displayStatusTitle;
    /** @type {?} */
    Order.prototype.paymentMode;
    /** @type {?} */
    Order.prototype.orderDate;
    /** @type {?} */
    Order.prototype.saleOrder;
    /** @type {?} */
    Order.prototype.delay;
    /** @type {?} */
    Order.prototype.paymentStatus;
    /** @type {?} */
    Order.prototype.paymentStatusTitle;
    /** @type {?} */
    Order.prototype.bidId;
    /** @type {?} */
    Order.prototype.offerId;
    /** @type {?} */
    Order.prototype.formattedTotalQty;
    /** @type {?} */
    Order.prototype.channelType;
    /** @type {?} */
    Order.prototype.totalEarnAmount;
    /** @type {?} */
    Order.prototype.tradeType;
    /** @type {?} */
    Order.prototype.totalReceivedQty;
    /** @type {?} */
    Order.prototype.totalInitialQty;
    /** @type {?} */
    Order.prototype.totalPickedQty;
    /** @type {?} */
    Order.prototype.earnTax;
    /** @type {?} */
    Order.prototype.totalAmountOfExclTax;
    /** @type {?} */
    Order.prototype.totalOfAllTaxes;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var Channel = {
    STARGAZE: "STARGAZE",
    CENTER: "CENTER",
    GALAXY: "GALAXY",
    RECYKAL: "RECYKAL",
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderDetailsService = /** @class */ (function () {
    function RcylOrderDetailsService(http, toast, orderConfig, events, rcylOrdersService, fileManagerService) {
        this.http = http;
        this.toast = toast;
        this.orderConfig = orderConfig;
        this.events = events;
        this.rcylOrdersService = rcylOrdersService;
        this.fileManagerService = fileManagerService;
        this.dataSource = new Subject();
        this.onUploadSuccess = this.dataSource.asObservable();
        this.appChannel = Channel;
    }
    /**
     * @param {?} orderId
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getOrder = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        var _this = this;
        return this.http.get("/core/orders/" + orderId).pipe(map$1((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data.documents) {
                _this.fileManagerService.prepareOrderDocumentsMap(data.documents);
            }
            return data;
        })));
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.signedUrl = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        /** @type {?} */
        var promise = new Promise((/**
         * @param {?} resolve
         * @param {?} reject
         * @return {?}
         */
        function (resolve, reject) {
            /** @type {?} */
            var apiURL = "/core/documents/signed-url";
            _this.http
                .post(apiURL, data)
                .toPromise()
                .then((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                console.log(res);
                resolve(res);
            }), (/**
             * @param {?} error
             * @return {?}
             */
            function (error) {
                reject(error);
                _this.rcylOrdersService.presentToast(error.title).then();
            }));
        }));
        return promise;
    };
    /**
     * @param {?} err
     * @return {?}
     */
    RcylOrderDetailsService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg).then();
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.markAsDelivered = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/mark-as-received", data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.markAsComplete = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/complete", data);
    };
    /**
     * @param {?} orderId
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.markAsScheduled = /**
     * @param {?} orderId
     * @param {?} data
     * @return {?}
     */
    function (orderId, data) {
        return this.http.put("/core/orders/" + orderId + "/mark-as-scheduled", data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.markAsPicked = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/mark-as-picked", data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.markQcDone = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/qc", data);
    };
    /**
     * @param {?} orderId
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getNotes = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        return this.http.get("/core/pickup-orders/" + orderId + "/notes");
    };
    /**
     * @param {?} reqParam
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getTimeSlots = /**
     * @param {?} reqParam
     * @return {?}
     */
    function (reqParam) {
        // return this.http.get<ITimeSlot[]>(`/core/time-slots`);
        /** @type {?} */
        var params = new HttpParams({ fromObject: reqParam });
        return this.http.get("/core/time-slots", {
            headers: new HttpHeaders({ ignoreLoadingBar: "" }),
            params: params,
        });
    };
    /**
     * @param {?=} id
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getDropLocation = /**
     * @param {?=} id
     * @return {?}
     */
    function (id) {
        return this.http.get("/core/locations");
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getPickupPersons = /**
     * @return {?}
     */
    function () {
        return this.http.get("/stakeholders/pickup-people", {
            headers: new HttpHeaders({ ignoreLoadingBar: "" }),
        });
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.changeTimeSlot = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/change-time-slot", data);
    };
    /**
     * @param {?} data
     * @param {?} orderId
     * @return {?}
     */
    RcylOrderDetailsService.prototype.updateTimeSlot = /**
     * @param {?} data
     * @param {?} orderId
     * @return {?}
     */
    function (data, orderId) {
        return this.http.put("/core/customer/orders/" + orderId, data);
    };
    /**
     * @param {?} orderId
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.addNoteToPickupOrder = /**
     * @param {?} orderId
     * @param {?} data
     * @return {?}
     */
    function (orderId, data) {
        return this.http.post("/core/pickup-orders/" + orderId + "/notes", data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.cancelOrder = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/" + data.orderId + "/mark-as-cancelled ", data.reason);
    };
    /**
     * @param {?} orderId
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getOrderChangeLogs = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        return this.http.get("/core/orders/" + orderId + "/change-logs", {
            headers: new HttpHeaders({ ignoreLoadingBar: "" }),
        });
    };
    /**
     * @param {?} bidOrOfferId
     * @return {?}
     */
    RcylOrderDetailsService.prototype.getAdditionalInfo = /**
     * @param {?} bidOrOfferId
     * @return {?}
     */
    function (bidOrOfferId) {
        return this.http.get("/catalog/listings/info/" + bidOrOfferId);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsService.prototype.updateOrder = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        return this.http.put("/core/orders/update-drop-order", data);
    };
    /**
     * @param {?} documentType
     * @param {?} order
     * @return {?}
     */
    RcylOrderDetailsService.prototype.canUploadDeleteDoc = /**
     * @param {?} documentType
     * @param {?} order
     * @return {?}
     */
    function (documentType, order) {
        if (documentType === OrderDocumentTypes.PROOF_OF_SIGNATURE) {
            return false;
        }
        if (this.orderConfig.channel === Channel.STARGAZE) {
            return true;
        }
        else {
            if (order) {
                if (order.saleOrder) {
                    switch (order.orderType) {
                        // non bulk generator
                        case "DROP":
                            return [
                                OrderDocumentTypes.SELLER_WEIGH_BRIDGE,
                                OrderDocumentTypes.EWAY_BILL,
                                OrderDocumentTypes.INVOICE,
                                OrderDocumentTypes.DC,
                                OrderDocumentTypes.LORRY_RECEIPT,
                                OrderDocumentTypes.OTHER,
                                OrderDocumentTypes.ITEM_IMAGE,
                            ].includes(documentType);
                            break;
                        case "PICKUP":
                            return [
                                OrderDocumentTypes.SELLER_WEIGH_BRIDGE,
                                OrderDocumentTypes.EWAY_BILL,
                                OrderDocumentTypes.INVOICE,
                                OrderDocumentTypes.DC,
                                OrderDocumentTypes.OTHER,
                                OrderDocumentTypes.ITEM_IMAGE,
                            ].includes(documentType);
                            break;
                        default:
                            return false;
                    }
                }
                else {
                    return [
                        OrderDocumentTypes.BUYER_WEIGH_BRIDGE,
                        OrderDocumentTypes.LAB_REPORT,
                        OrderDocumentTypes.OTHER,
                        OrderDocumentTypes.ITEM_IMAGE,
                    ].includes(documentType);
                }
            }
            return false;
        }
    };
    /**
     * @param {?} orderId
     * @return {?}
     */
    RcylOrderDetailsService.prototype.downloadProformaInvoice = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        /** @type {?} */
        var headerOptions = new HttpHeaders({
            "Content-Type": "application/pdf",
            Accept: "application/pdf",
        });
        /** @type {?} */
        var requestOptions = {
            headers: headerOptions,
            responseType: (/** @type {?} */ ("blob")),
        };
        return this.http
            .get("/core/orders/proforma-invoice/pdf/" + orderId, requestOptions)
            .pipe(map$1((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            /** @type {?} */
            var blob = new Blob([data], {
                type: "application/pdf",
            });
            // @ts-ignore
            /** @type {?} */
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = orderId + "-ProfomaInvoice.pdf";
            link.target = "_blank";
            link.click();
        })));
    };
    RcylOrderDetailsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    RcylOrderDetailsService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ToastController },
        { type: RcylOrderConfigService },
        { type: Events },
        { type: RcylOrdersService },
        { type: RcylFileManagerService }
    ]; };
    /** @nocollapse */ RcylOrderDetailsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RcylOrderDetailsService_Factory() { return new RcylOrderDetailsService(ɵɵinject(HttpClient), ɵɵinject(ToastController), ɵɵinject(RcylOrderConfigService), ɵɵinject(Events), ɵɵinject(RcylOrdersService), ɵɵinject(RcylFileManagerService)); }, token: RcylOrderDetailsService, providedIn: "root" });
    return RcylOrderDetailsService;
}());
if (false) {
    /** @type {?} */
    RcylOrderDetailsService.prototype.document;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.dataSource;
    /** @type {?} */
    RcylOrderDetailsService.prototype.onUploadSuccess;
    /** @type {?} */
    RcylOrderDetailsService.prototype.appChannel;
    /** @type {?} */
    RcylOrderDetailsService.prototype.documentMap;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.orderConfig;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.events;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.rcylOrdersService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsService.prototype.fileManagerService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderDocumentsManagerComponent = /** @class */ (function () {
    function RcylOrderDocumentsManagerComponent(modalController, alertController, events, platform, orderConfig, actionSheetController, fileManagerService, orderDetailsService, changeDetector) {
        var _this = this;
        this.modalController = modalController;
        this.alertController = alertController;
        this.events = events;
        this.platform = platform;
        this.orderConfig = orderConfig;
        this.actionSheetController = actionSheetController;
        this.fileManagerService = fileManagerService;
        this.orderDetailsService = orderDetailsService;
        this.changeDetector = changeDetector;
        this.selectAndUploadImgDocument = new EventEmitter();
        this.downloadDocument = new EventEmitter();
        this.downloadProformaInvoice = new EventEmitter();
        this.orderDocumentTypes = OrderDocumentTypes;
        this.orderStatuses = OrderStatus;
        this.uploadMaxLimit = RCYL_ORDERS_GLOBALS.ORDER_MAX_UPLOAD_FILES_LIMIT_PER_TYPE;
        this.backDrop = false;
        this.deleteImg = (/**
         * @param {?} document
         * @param {?=} event
         * @return {?}
         */
        function (document, event) { return __awaiter(_this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (event) {
                            event.stopPropagation();
                        }
                        return [4 /*yield*/, this.alertController.create({
                                header: "Are you sure you want to delete document ?",
                                buttons: [
                                    {
                                        text: "No",
                                        role: "cancel",
                                        cssClass: "secondary",
                                        handler: (/**
                                         * @return {?}
                                         */
                                        function () { }),
                                    },
                                    {
                                        text: "Yes",
                                        handler: (/**
                                         * @return {?}
                                         */
                                        function () {
                                            _this.deleteDocument(document).subscribe();
                                        }),
                                    },
                                ],
                            })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        this.deleteDocument = (/**
         * @param {?} document
         * @return {?}
         */
        function (document) {
            return _this.fileManagerService.deleteDocument(document.id).pipe(map$1((/**
             * @param {?} data
             * @return {?}
             */
            function (data) {
                _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "DOCUMENT_DELETED");
                _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.SHOW_TOAST, {
                    message: "Document deleted successfully.",
                    color: "dark",
                });
                return data;
            })), catchError((/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                return throwError(err);
            })));
        });
        this.downloadFile = (/**
         * @param {?} document
         * @return {?}
         */
        function (document) {
            if (_this.platform.is("cordova")) {
                _this.downloadDocument.emit(document);
            }
            else {
                _this.fileManagerService.downloadDocumentInBrowser(document);
            }
        });
    }
    /**
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.componentView) {
            this.componentView = "LIST";
        }
        // this.selectDocumentType(OrderDocumentTypes.LORRY_RECEIPT);
        // reason we need this event is we are using this component in modal.
        // and data bindings won't work in modals
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_DOCUMENTS_UPDATED, (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                _this.orderDocumentsMap = data;
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    if (_this.changeDetector &&
                        !((/** @type {?} */ (_this.changeDetector))).destroyed) {
                        _this.changeDetector.detectChanges();
                    }
                }));
            }
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.ionViewDidEnter = /**
     * @return {?}
     */
    function () {
        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.VIEW_BG, "#FFFFFF");
    };
    /**
     * @param {?} selectedDocType
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.selectDocumentType = /**
     * @param {?} selectedDocType
     * @return {?}
     */
    function (selectedDocType) {
        this.activeDocumentType = selectedDocType;
        this.componentView = "VIEW_UPLOAD";
    };
    /**
     * @param {?} documentType
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.handleUploadClick = /**
     * @param {?} documentType
     * @return {?}
     */
    function (documentType) {
        return __awaiter(this, void 0, void 0, function () {
            var actionSheet;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.platform.is("cordova")) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.actionSheetController.create({
                                header: "Choose an action",
                                mode: "md",
                                buttons: [
                                    {
                                        text: "Camera",
                                        role: "camera",
                                        icon: "custom-camera",
                                        handler: (/**
                                         * @return {?}
                                         */
                                        function () {
                                            _this.selectAndUploadImgDocument.emit({
                                                order: _this.orderDetails,
                                                documentType: documentType,
                                                selectFrom: "CAMERA",
                                            });
                                        }),
                                    },
                                    {
                                        text: "Gallery",
                                        icon: "custom-gallery",
                                        role: "gallery",
                                        handler: (/**
                                         * @return {?}
                                         */
                                        function () {
                                            _this.selectAndUploadImgDocument.emit({
                                                order: _this.orderDetails,
                                                documentType: documentType,
                                                selectFrom: "GALLERY",
                                            });
                                        }),
                                    },
                                    {
                                        text: "Files",
                                        icon: "custom-files",
                                        role: "files",
                                        handler: (/**
                                         * @return {?}
                                         */
                                        function () {
                                            _this.fileInput.nativeElement.click();
                                        }),
                                    },
                                ],
                            })];
                    case 1:
                        actionSheet = _a.sent();
                        return [4 /*yield*/, actionSheet.present()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.fileInput.nativeElement.click();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} files
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.handleBrowserFileUploads = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        var _this = this;
        if (!this.orderDocumentsMap[this.activeDocumentType] ||
            this.orderDocumentsMap[this.activeDocumentType].documents.length <
                RCYL_ORDERS_GLOBALS.ORDER_MAX_UPLOAD_FILES_LIMIT_PER_TYPE) {
            /** @type {?} */
            var file = files[0];
            /** @type {?} */
            var data = {
                entity: "ORDER",
                entityId: this.orderDetails.id,
                fileName: file.name,
                fileSize: file.size,
                type: this.activeDocumentType,
                contentType: file.type,
            };
            this.fileManagerService
                .upload(data, file)
                .then((/**
             * @param {?} result
             * @return {?}
             */
            function (result) {
                if (result) {
                    _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "DOCUMENT_UPLOAD", result);
                }
            }))
                .catch((/**
             * @param {?} err
             * @return {?}
             */
            function (err) { }));
        }
        else {
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.SHOW_TOAST, {
                message: "Maximum " +
                    RCYL_ORDERS_GLOBALS.ORDER_MAX_UPLOAD_FILES_LIMIT_PER_TYPE +
                    " documents can be uploaded.",
                color: "warning",
            });
        }
    };
    /**
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.canUploadDelete = /**
     * @return {?}
     */
    function () {
        return this.orderDetailsService.canUploadDeleteDoc(this.activeDocumentType, this.orderDetails);
    };
    /**
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalController.dismiss().then();
    };
    /**
     * @param {?=} event
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.switchView = /**
     * @param {?=} event
     * @return {?}
     */
    function (event) {
        if (event) {
            event.stopImmediatePropagation();
        }
        switch (this.componentView) {
            case "LIST":
                this.closeModal();
                break;
            case "VIEW_UPLOAD":
                this.componentView = "LIST";
                break;
        }
    };
    /**
     * @param {?} statusName
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.containsInStatusLog = /**
     * @param {?} statusName
     * @return {?}
     */
    function (statusName) {
        if (this.orderStatusLogs) {
            return this.orderStatusLogs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.id && item.toStatus === statusName ? item : false;
            })).length;
        }
        else {
            return 0;
        }
    };
    /**
     * @param {?} document
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.openViewFile = /**
     * @param {?} document
     * @return {?}
     */
    function (document) {
        if (document) {
            if (document.contentType && document.contentType.includes("image")) {
                this.showImg(document).then();
            }
            else {
                this.downloadFile(document);
            }
        }
    };
    /**
     * @param {?} document
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.showImg = /**
     * @param {?} document
     * @return {?}
     */
    function (document) {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(document && document.url)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.modalController.create({
                                component: ImgViewerComponent,
                                componentProps: {
                                    document: document,
                                    componentOptions: {
                                        showDownload: true,
                                    },
                                    downloadCallback: this.downloadFile,
                                },
                                cssClass: "full-width-modal",
                            })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.openProformaInvoice = /**
     * @return {?}
     */
    function () {
        if (this.platform.is("cordova")) {
            this.downloadProformaInvoice.emit(this.orderDetails);
        }
        else {
            this.orderDetailsService
                .downloadProformaInvoice(this.orderDetails.id)
                .subscribe((/**
             * @param {?} res
             * @return {?}
             */
            function (res) { }));
        }
    };
    /**
     * @param {?} documentType
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.typeContainsDocuments = /**
     * @param {?} documentType
     * @return {?}
     */
    function (documentType) {
        /* if (documentType === this.orderDocumentTypes.INVOICE) {
                if (this.containsInStatusLog(this.orderStatuses.ORDER_COMPLETED) ||
                    (this.orderDocumentsMap &&
                        this.orderDocumentsMap[documentType] && this.orderDocumentsMap[documentType].documents.length)) {
                    return true;
                }
            } else */
        if (this.orderDocumentsMap &&
            this.orderDocumentsMap[documentType] &&
            this.orderDocumentsMap[documentType].documents.length) {
            return true;
        }
        return false;
    };
    /**
     * @return {?}
     */
    RcylOrderDocumentsManagerComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.events.unsubscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_DOCUMENTS_UPDATED);
    };
    RcylOrderDocumentsManagerComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-order-documents-manager",
                    template: "<ion-header\n  no-shadow\n  [ngClass]=\"{\n    'colored-bg':\n      componentView === 'VIEW_UPLOAD' &&\n      !typeContainsDocuments(activeDocumentType)\n  }\"\n>\n  <ion-toolbar\n    no-border\n    [ngClass]=\"{\n      'colored-bg':\n        componentView === 'VIEW_UPLOAD' &&\n        !typeContainsDocuments(activeDocumentType)\n    }\"\n  >\n    <ion-buttons slot=\"start\" class=\"back-button-section\">\n      <ion-back-button\n        onclick=\"event.stopImmediatePropagation();\"\n        (mouseup)=\"switchView($event)\"\n        defaultHref=\"\"\n        color=\"dark\"\n      ></ion-back-button>\n    </ion-buttons>\n\n    <ion-title text-left *ngIf=\"componentView === 'LIST'\" no-padding-start>\n      <div class=\"modal-title-text\">\n        <ion-icon\n          [src]=\"'assets/rcyl-orders/upload-document.svg'\"\n          color=\"primary\"\n        ></ion-icon\n        >&nbsp;\n        <ion-text font-bold=\"\" color=\"dark\">Order Documents</ion-text>\n      </div>\n    </ion-title>\n    <ion-title\n      text-left\n      *ngIf=\"componentView === 'VIEW_UPLOAD'\"\n      no-padding-start\n    >\n      <div class=\"modal-title-text\">\n        <ion-icon\n          [src]=\"orderDocumentsMap[activeDocumentType]?.icon\"\n          color=\"primary\"\n        ></ion-icon\n        >&nbsp;\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          orderDocumentsMap[activeDocumentType]?.displayText\n        }}</ion-text>\n      </div>\n    </ion-title>\n    <ion-buttons slot=\"end\" class=\"close-button-section\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon\n          color=\"medium\"\n          slot=\"icon-only\"\n          name=\"close-circle\"\n        ></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content\n  class=\"ion-padding\"\n  [ngClass]=\"{\n    'colored-bg':\n      componentView === 'VIEW_UPLOAD' &&\n      !typeContainsDocuments(activeDocumentType)\n  }\"\n>\n  <ion-list *ngIf=\"componentView === 'LIST'\" padding class=\"list-view\">\n    <ion-item\n      lines=\"none\"\n      *ngFor=\"\n        let orderTypeData of orderDocumentsMap\n          | rcylFilter: 'showInList':true\n          | rcylKeys\n          | orderBy: ['val.documents.length']:'asc'\n      \"\n      (click)=\"selectDocumentType(orderTypeData?.key)\"\n    >\n      <ion-icon\n        [src]=\"\n          typeContainsDocuments(orderTypeData?.key)\n            ? orderTypeData?.val?.iconChecked\n            : orderTypeData?.val?.icon\n        \"\n        slot=\"start\"\n      >\n      </ion-icon>\n      <ion-label text-wrap>\n        <ion-text color=\"dark\" font-bold=\"\">\n          {{ orderTypeData?.val?.displayText }}\n        </ion-text>\n        <br />\n        <ion-text\n          font-regular=\"\"\n          *ngIf=\"!typeContainsDocuments(orderTypeData?.key)\"\n        >\n          {{ orderTypeData?.val?.beforeUploadText }}\n        </ion-text>\n        <ion-text\n          *ngIf=\"typeContainsDocuments(orderTypeData?.key)\"\n          font-regular=\"\"\n        >\n          {{ orderTypeData?.val?.afterUploadText }}\n        </ion-text>\n      </ion-label>\n      <ion-icon\n        [src]=\"'assets/rcyl-orders/right-arrow.svg'\"\n        slot=\"end\"\n      ></ion-icon>\n    </ion-item>\n  </ion-list>\n  <input\n    #fileInputElement\n    hidden=\"true\"\n    accept=\"image/*,.pdf,.doc,.txt\"\n    type=\"file\"\n    (change)=\"handleBrowserFileUploads($event?.target?.files)\"\n  />\n  <ion-grid *ngIf=\"componentView === 'VIEW_UPLOAD'\" class=\"view-upload\">\n    <!--<ion-row *ngIf=\"!typeContainsDocuments(activeDocumentType)\">\n            <ion-col size=\"12\" no-padding>\n                <rcyl-document-sample-for-upload [orderDocumentType]=\"activeDocumentType\"\n                                                 [orderDetails]=\"orderDetails\"\n                                                 (uploadClick)=\"handleUploadClick($event)\"></rcyl-document-sample-for-upload>\n            </ion-col>\n        </ion-row>-->\n    <ion-row\n      text-center\n      class=\"no-upload-img\"\n      *ngIf=\"!typeContainsDocuments(activeDocumentType)\"\n    >\n      <div margin padding>\n        <ion-icon name=\"document\" mode=\"ios\" color=\"medium\"></ion-icon>\n        <!--<ion-img src=\"assets/rcyl-orders/upload-document.svg\"></ion-img>-->\n      </div>\n    </ion-row>\n    <ion-row class=\"document-list\" no-padding>\n      <ion-col size=\"12\" no-padding>\n        <ion-list lines=\"none\">\n          <ion-item-sliding\n            class=\"proforma-invoice-item\"\n            *ngIf=\"\n              activeDocumentType === orderDocumentTypes.INVOICE &&\n              containsInStatusLog(orderStatuses.ORDER_COMPLETED) &&\n              orderDetails?.channelType !== 'Marketplace' &&\n              orderDetails?.orderType !== 'DROP'\n            \"\n          >\n            <ion-item (click)=\"openProformaInvoice()\" margin-bottom>\n              <ion-icon slot=\"start\" name=\"custom-files\" mode=\"md\"></ion-icon>\n              <ion-label text-wrap>\n                Proforma Invoice\n                <p>Refer this document to prepare the final invoice.</p>\n              </ion-label>\n            </ion-item>\n          </ion-item-sliding>\n\n          <ion-item-sliding\n            *ngFor=\"let doc of orderDocumentsMap[activeDocumentType].documents\"\n          >\n            <ion-item (click)=\"openViewFile(doc)\">\n              <ion-img\n                slot=\"start\"\n                *ngIf=\"doc?.contentType?.includes('image')\"\n                [src]=\"doc?.url\"\n              ></ion-img>\n              <ion-icon\n                slot=\"start\"\n                *ngIf=\"!doc?.contentType?.includes('image')\"\n                name=\"custom-files\"\n                mode=\"md\"\n              ></ion-icon>\n              <ion-label text-wrap>\n                {{ doc.fileName }}\n                <p *ngIf=\"doc?.fileSize\">\n                  Size {{ doc.fileSize / 1024 | number: \"1.2-2\" }} KB\n                </p>\n              </ion-label>\n              <ion-button\n                *ngIf=\"canUploadDelete()\"\n                (click)=\"deleteImg(doc, $event)\"\n                fill=\"clear\"\n                slot=\"end\"\n              >\n                <ion-icon\n                  name=\"trash\"\n                  slot=\"icon-only\"\n                  color=\"medium\"\n                ></ion-icon>\n              </ion-button>\n            </ion-item>\n            <ion-item-options side=\"end\" *ngIf=\"canUploadDelete()\">\n              <ion-item-option color=\"danger\" (click)=\"deleteImg(doc, $event)\"\n                >Delete</ion-item-option\n              >\n            </ion-item-options>\n          </ion-item-sliding>\n        </ion-list>\n        <ion-row>\n          <!--<ion-col size=\"12\"\n                             *ngFor=\"let doc of orderDocumentsMap[activeDocumentType].documents\">\n                        <ion-row>\n                            <ion-col size=\"4\">\n                                <ion-img *ngIf=\"doc?.contentType?.includes('image')\" [src]=\"doc?.url\"></ion-img>\n                            </ion-col>\n                            <ion-col size=\"8\">\n\n                            </ion-col>\n                        </ion-row>\n                        <div class=\"img-container\" (click)=\"openViewFile(doc)\">\n                            <ion-button *ngIf=\"canUploadDelete()\" (click)=\"deleteImg(doc, $event)\" size=\"small\" fill=\"clear\" no-box-shadow>\n                                <ion-icon size=\"small\" color=\"medium\" name=\"close-circle\"></ion-icon>\n                            </ion-button>\n                            <ion-img *ngIf=\"doc?.contentType?.includes('image')\" [src]=\"doc?.url\"></ion-img>\n                            <ion-icon *ngIf=\"!doc?.contentType?.includes('image')\" name=\"custom-files\" mode=\"md\"></ion-icon>\n                            <p *ngIf=\"!doc?.contentType?.includes('image')\">{{doc.fileName}}</p>\n                        </div>\n                    </ion-col>-->\n          <!--<ion-col size=\"6\" *ngIf=\"activeDocumentType === orderDocumentTypes.INVOICE && containsInStatusLog(orderStatuses.ORDER_COMPLETED)\" >\n                        <div class=\"img-container\" (click)=\"openProformaInvoice()\">\n                            <ion-icon name=\"custom-files\" mode=\"md\"></ion-icon>\n                            <p>Proforma Invoice</p>\n                        </div>\n                    </ion-col>-->\n        </ion-row>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-content>\n<ion-footer\n  no-border\n  *ngIf=\"componentView === 'VIEW_UPLOAD'\"\n  [ngClass]=\"{\n    'colored-bg':\n      componentView === 'VIEW_UPLOAD' &&\n      !typeContainsDocuments(activeDocumentType)\n  }\"\n>\n  <ion-row>\n    <ion-col size=\"12\" text-center>\n      <!--<ion-text color=\"medium\" class=\"note-text\">\n                <span font-bold>Note: </span>You can upload maximum {{uploadMaxLimit}} documents.\n            </ion-text>\n            <br/>-->\n      <ion-button\n        centered=\"\"\n        expand=\"block\"\n        recykal-button=\"\"\n        margin-top\n        size=\"large\"\n        [disabled]=\"!canUploadDelete()\"\n        (click)=\"handleUploadClick(activeDocumentType)\"\n      >\n        <ion-icon name=\"cloud-upload\"></ion-icon> &nbsp; Upload Document\n      </ion-button>\n    </ion-col>\n  </ion-row>\n</ion-footer>\n",
                    styles: ["ion-header ion-title{padding-left:2px}@media only screen and (min-width:40.625em){ion-header ion-title .modal-title-text{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}ion-header ion-title .modal-title-text ion-icon{font-size:2.538rem}.back-button-section{display:none}.close-button-section{display:-webkit-box;display:flex}}@media only screen and (max-width:40.625em){ion-header ion-title .modal-title-text{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}ion-header ion-title .modal-title-text ion-icon{font-size:3.538rem}}ion-header ion-title .modal-title-text ion-text{text-align:left;font-size:1.538rem;line-height:2.615rem;letter-spacing:0;text-transform:capitalize;opacity:1;font-weight:700}ion-content ion-list.list-view ion-item{--background:#ffffff 0% 0% no-repeat padding-box;--box-shadow:0 0 15px #96a5ad40;box-shadow:0 0 15px #96a5ad40;--border-width:1px;--border-color:#f4f5f7;--border-style:solid;--border-radius:6px;opacity:1;--padding-start:10px;margin-bottom:20px;--inner-padding-end:10px}ion-content ion-list.list-view ion-item ion-icon[slot=start]{font-size:4.308rem;margin-right:2px}ion-content ion-list.list-view ion-item ion-icon[slot=end]{font-size:2rem;margin-left:2px}ion-content ion-list.list-view ion-item ion-label{line-height:1.2rem}ion-content ion-list.list-view ion-item ion-label ion-text[font-bold]{text-align:left;font-size:1.231rem;line-height:1.077rem;letter-spacing:0;text-transform:capitalize;opacity:1}ion-content ion-list.list-view ion-item ion-label ion-text[font-regular]{text-align:left;font-size:.9231rem;line-height:1.077rem;letter-spacing:0;color:#96a5ad;opacity:1}ion-content ion-list.list-view ion-item ion-label ion-text[font-regular] ion-icon{font-size:18px}ion-content ion-list.list-view ion-item ion-label div ion-icon{margin-bottom:-2px}ion-content .view-upload .no-upload-img div{position:fixed;top:50%;left:48%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}ion-content .view-upload .no-upload-img div ion-icon{font-size:135px;margin:auto}ion-content .view-upload .no-upload-img div ion-img{margin:0 auto;height:200px;width:200px;padding:45px}ion-content .view-upload .document-list ion-list{background:0 0}ion-content .view-upload .document-list ion-list .proforma-invoice-item,ion-content .view-upload .document-list ion-list .proforma-invoice-item ion-item{--background:#f2f2f2 0 0 no-repeat padding-box}ion-content .view-upload .document-list ion-list ion-item-sliding ion-item{margin-bottom:0}ion-content .view-upload .document-list ion-list ion-item-sliding ion-item ion-img{height:35px;width:35px}ion-content .view-upload .document-list ion-list ion-item-sliding ion-item ion-icon[slot=start]{font-size:35px}ion-content .view-upload .document-list ion-list ion-item-sliding ion-item ion-button[slot=end] ion-icon[name=trash]{font-size:25px}@media only screen and (max-width:37.5em){ion-content .view-upload .document-list ion-list ion-item-sliding ion-item ion-button[slot=end]{display:none}}ion-content .view-upload .document-list .img-container{height:128px;width:100%;overflow:hidden;border:1px solid var(--ion-color-light);border-radius:4px;text-align:center;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}ion-content .view-upload .document-list .img-container ion-button{position:absolute;top:-3px;right:-1px;--background-activated:transparent!important;--background-focused:transparent!important;--background-hover:transparent!important;--background:transparent!important}ion-content .view-upload .document-list .img-container ion-button ion-icon[name=close-circle]{position:absolute;top:-2px;right:-2px;border-radius:15px;background:#fff;border:1px solid var(--ion-color-primary-contrast)}ion-content .view-upload .document-list .img-container ion-img{height:100%;width:100%;-o-object-fit:cover;object-fit:cover}ion-content .view-upload .document-list .img-container ion-icon[name=custom-files]{font-size:6.154rem;margin:auto}ion-content .view-upload .document-list .img-container p{color:var(--ion-color-medium);margin-top:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-left:5px;padding-right:5px}ion-content .view-upload .document-list .note-text{font-size:.9231rem;line-height:1.077rem}.colored-bg{--background:#f2f2f2 0 0 no-repeat padding-box;background:no-repeat padding-box #f2f2f2}.colored-bg .proforma-invoice-item,.colored-bg .proforma-invoice-item ion-item{--background:white 0 0 no-repeat padding-box!important}ion-header[no-shadow]:after{background:0 0}@media only screen and (max-width:40.625em){.back-button-section{display:block}.close-button-section{display:none}}"]
                }] }
    ];
    /** @nocollapse */
    RcylOrderDocumentsManagerComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: AlertController },
        { type: Events },
        { type: Platform },
        { type: RcylOrderConfigService },
        { type: ActionSheetController },
        { type: RcylFileManagerService },
        { type: RcylOrderDetailsService },
        { type: ChangeDetectorRef }
    ]; };
    RcylOrderDocumentsManagerComponent.propDecorators = {
        orderDetails: [{ type: Input }],
        orderDocumentsMap: [{ type: Input }],
        orderStatusLogs: [{ type: Input }],
        selectAndUploadImgDocument: [{ type: Output }],
        downloadDocument: [{ type: Output }],
        downloadProformaInvoice: [{ type: Output }],
        fileInput: [{ type: ViewChild, args: ["fileInputElement", { static: true },] }],
        componentView: [{ type: Input }],
        activeDocumentType: [{ type: Input }]
    };
    return RcylOrderDocumentsManagerComponent;
}());
if (false) {
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.orderDetails;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.orderDocumentsMap;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.orderStatusLogs;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.selectAndUploadImgDocument;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.downloadDocument;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.downloadProformaInvoice;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.fileInput;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.componentView;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.activeDocumentType;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.orderDocumentTypes;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.orderStatuses;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.selectedFiles;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.uploadMaxLimit;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.backDrop;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.deleteImg;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.deleteDocument;
    /** @type {?} */
    RcylOrderDocumentsManagerComponent.prototype.downloadFile;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.alertController;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.platform;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.orderConfig;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.actionSheetController;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.fileManagerService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.orderDetailsService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDocumentsManagerComponent.prototype.changeDetector;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderLogisticsService = /** @class */ (function () {
    function RcylOrderLogisticsService(httpClient) {
        this.httpClient = httpClient;
        this.idProofTypes = [
            {
                label: "Aadhar Card",
                value: "AADHAR_CARD",
            },
            {
                label: "Pan Card",
                value: "PAN_CARD",
            },
            {
                label: "Passport",
                value: "PASSPORT",
            },
            {
                label: "Voter ID",
                value: "VOTER_ID",
            },
        ];
    }
    /**
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.getIdProofTypes = /**
     * @return {?}
     */
    function () {
        return this.idProofTypes;
    };
    /**
     * @param {?} val
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.getIdProofDisplayNameByVal = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        /** @type {?} */
        var result = this.idProofTypes.filter((/**
         * @param {?} item
         * @return {?}
         */
        function (item) {
            return item.value === val;
        }));
        if (result && result[0]) {
            return result[0].label;
        }
        else {
            return "";
        }
    };
    /**
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.getAllVehicleTypes = /**
     * @return {?}
     */
    function () {
        return this.httpClient.get("/core/logistics-vehicle").pipe(map$1((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data;
        })));
    };
    /**
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.getAllTransporters = /**
     * @return {?}
     */
    function () {
        return this.httpClient
            .get("/core/logistics-transporters")
            .pipe(map$1((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data;
        })));
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.saveLogisticDetails = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data && data.logisticsTransporters && !data.logisticsTransporters.id) {
            data.logisticsTransporters = null;
        }
        if (data && data.logisticsVehicle && !data.logisticsVehicle.id) {
            data.logisticsVehicle = null;
        }
        return this.httpClient.post("/core/orders/order-logistics", data);
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.updateLogisticDetails = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (data && data.logisticsTransporters && !data.logisticsTransporters.id) {
            data.logisticsTransporters = null;
        }
        if (data && data.logisticsVehicle && !data.logisticsVehicle.id) {
            data.logisticsVehicle = null;
        }
        return this.httpClient.put("/core/orders/order-logistics", data);
    };
    /**
     * @param {?} orderId
     * @return {?}
     */
    RcylOrderLogisticsService.prototype.getOrderLogisticsDetails = /**
     * @param {?} orderId
     * @return {?}
     */
    function (orderId) {
        return this.httpClient
            .get("/core/orders/" + orderId + "/order-logistics")
            .pipe(map$1((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            return data;
        })));
    };
    RcylOrderLogisticsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    RcylOrderLogisticsService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ RcylOrderLogisticsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RcylOrderLogisticsService_Factory() { return new RcylOrderLogisticsService(ɵɵinject(HttpClient)); }, token: RcylOrderLogisticsService, providedIn: "root" });
    return RcylOrderLogisticsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    RcylOrderLogisticsService.prototype.idProofTypes;
    /**
     * @type {?}
     * @private
     */
    RcylOrderLogisticsService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TransportationDetailsModalComponent = /** @class */ (function () {
    function TransportationDetailsModalComponent(modalController, formBuilder, orderConfigService, orderLogisticsService, events) {
        this.modalController = modalController;
        this.formBuilder = formBuilder;
        this.orderConfigService = orderConfigService;
        this.orderLogisticsService = orderLogisticsService;
        this.events = events;
        this.getAllTransportersSubscription = new Subscription();
        this.getAllVehicleTypesSubscription = new Subscription();
    }
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.channelType = this.orderConfigService.channel;
        this.idProofTypes = this.orderLogisticsService.getIdProofTypes();
        this.getAllTransportersSubscription = this.orderLogisticsService
            .getAllTransporters()
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data.length > 0) {
                _this.transporters = map(data, (/**
                 * @param {?} i
                 * @return {?}
                 */
                function (i) {
                    return merge(i, { label: i.name, value: i.id });
                }));
            }
        }));
        this.getAllVehicleTypesSubscription = this.orderLogisticsService
            .getAllVehicleTypes()
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data.length > 0) {
                _this.vehicleTypes = map(data, (/**
                 * @param {?} i
                 * @return {?}
                 */
                function (i) {
                    return merge(i, { label: i.vehicleType, value: i.id });
                }));
            }
        }));
        this.createTransportationDetailsForm();
        if (this.orderLogisticsDetails) {
            this.updateFormValues(this.orderLogisticsDetails);
        }
    };
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.ionViewDidEnter = /**
     * @return {?}
     */
    function () {
        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.VIEW_BG, "#FFFFFF");
    };
    /**
     * @param {?=} event
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.closeModal = /**
     * @param {?=} event
     * @return {?}
     */
    function (event) {
        if (event) {
            event.stopPropagation();
        }
        this.modalController.dismiss().then();
    };
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.createTransportationDetailsForm = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.transportationDetailsForm = this.formBuilder.group({
            logisticsTransporters: this.formBuilder.group({
                id: ["", Validators.compose([])],
            }),
            logisticsVehicle: this.formBuilder.group({
                id: ["", Validators.compose([])],
            }),
            vehicleCapacity: ["", Validators.compose([])],
            vehicleNumber: [
                "",
                Validators.compose([
                    Validators.pattern(RCYL_ORDERS_GLOBALS.REGEX.VEHICLE_NUMBER),
                ]),
            ],
            vehiclePermit: ["", Validators.compose([])],
            vehicleInsurance: ["", Validators.compose([])],
            driverName: [
                "",
                Validators.compose([
                    Validators.pattern(RCYL_ORDERS_GLOBALS.REGEX.NUMBER_STRING_AND_SPACES_ONLY),
                ]),
            ],
            driverContact: [
                "",
                Validators.compose([
                    Validators.pattern(RCYL_ORDERS_GLOBALS.REGEX.MOBILE_NO),
                ]),
            ],
            idProof: ["", Validators.compose([])],
            idProofNo: [
                "",
                Validators.compose([
                    Validators.pattern(RCYL_ORDERS_GLOBALS.REGEX.NUMBER_STRING_AND_SPACES_ONLY),
                ]),
            ],
            driverLicenceNo: [
                "",
                Validators.compose([
                    Validators.pattern(RCYL_ORDERS_GLOBALS.REGEX.NUMBER_STRING_AND_SPACES_ONLY),
                ]),
            ],
        });
        this.transportationDetailsForm.valueChanges.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.logMe();
        }));
    };
    /**
     * @param {?} orderLogisticsDetails
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.updateFormValues = /**
     * @param {?} orderLogisticsDetails
     * @return {?}
     */
    function (orderLogisticsDetails) {
        this.transportationDetailsForm.patchValue(orderLogisticsDetails);
    };
    /**
     * @param {?} selectedVehicleTypeId
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.updateVehicleCapacity = /**
     * @param {?} selectedVehicleTypeId
     * @return {?}
     */
    function (selectedVehicleTypeId) {
        if (selectedVehicleTypeId) {
            /** @type {?} */
            var selectedVehicleType = this.vehicleTypes.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.id === selectedVehicleTypeId;
            }));
            if (selectedVehicleType && selectedVehicleType[0]) {
                this.transportationDetailsForm.patchValue({
                    vehicleCapacity: selectedVehicleType[0].capacity,
                });
            }
        }
    };
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.updateLogisticDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderLogisticsDetails = merge(this.orderLogisticsDetails, this.transportationDetailsForm.value);
        /*const data: IOrderLogistics = this.transportationDetailsForm.value;
            data.orderId = this.orderDetails.id;*/
        this.orderLogisticsService
            .updateLogisticDetails(this.orderLogisticsDetails)
            .subscribe((/**
         * @return {?}
         */
        function () {
            _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.SHOW_TOAST, {
                message: "Transportation and driver details updated successfully.",
                color: "dark",
            });
            _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_LOGISTIC_DETAILS_UPDATED);
            _this.closeModal();
        }));
    };
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.saveLogisticDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var data = this.transportationDetailsForm.value;
        data.orderId = this.orderDetails.id;
        this.orderLogisticsService.saveLogisticDetails(data).subscribe((/**
         * @return {?}
         */
        function () {
            _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.SHOW_TOAST, {
                message: "Transportation and driver details saved successfully.",
                color: "dark",
            });
            _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_LOGISTIC_DETAILS_UPDATED);
            _this.closeModal();
        }));
    };
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.logMe = /**
     * @return {?}
     */
    function () {
        console.log(this.transportationDetailsForm.value);
    };
    /**
     * @return {?}
     */
    TransportationDetailsModalComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.getAllTransportersSubscription.unsubscribe();
        this.getAllVehicleTypesSubscription.unsubscribe();
    };
    TransportationDetailsModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-transportation-details",
                    template: "<ion-header no-border=\"\" no-shadow>\n  <ion-toolbar no-border>\n    <ion-buttons slot=\"start\" class=\"back-button-section\">\n      <ion-back-button\n        onclick=\"event.stopImmediatePropagation();\"\n        (mouseup)=\"closeModal($event)\"\n        defaultHref=\"\"\n        color=\"dark\"\n        [icon]=\"'ios-arrow-back'\"\n        [text]=\"''\"\n      ></ion-back-button>\n    </ion-buttons>\n    <ion-buttons slot=\"end\" class=\"close-button-section\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon\n          color=\"medium\"\n          slot=\"icon-only\"\n          name=\"close-circle\"\n        ></ion-icon>\n      </ion-button>\n    </ion-buttons>\n    <ion-title text-left no-padding-start>\n      <div class=\"modal-title-text\">\n        <ion-icon\n          [src]=\"'assets/rcyl-orders/lorry-receipt.svg'\"\n          color=\"primary\"\n        ></ion-icon\n        >&nbsp;\n        <ion-text font-bold=\"\" color=\"dark\">Transportation Details</ion-text>\n      </div>\n    </ion-title>\n    <!--<ion-title text-left no-padding-start *ngIf=\"componentView ==='VIEW_UPLOAD'\">\n          <div class=\"modal-title-text\">\n            <ion-icon [src]=\"orderDocumentsMap[activeDocumentType]?.icon\" color=\"primary\"></ion-icon>&nbsp;\n            <ion-text font-bold=\"\" color=\"dark\">{{orderDocumentsMap[activeDocumentType]?.displayText}}</ion-text>\n          </div>\n        </ion-title>-->\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <form\n    [formGroup]=\"transportationDetailsForm\"\n    [ngClass]=\"channelType === 'STARGAZE' ? 'custom-input-fields' : ''\"\n  >\n    <ion-grid>\n      <ion-row>\n        <ion-col size=\"12\" *ngIf=\"channelType != 'STARGAZE'\">\n          <ion-item\n            lines=\"none\"\n            input-item=\"\"\n            formGroupName=\"logisticsTransporters\"\n          >\n            <ion-label position=\"stacked\">Transporter Name</ion-label>\n            <ion-select\n              formControlName=\"id\"\n              *ngIf=\"transporters\"\n              interface=\"action-sheet\"\n              placeholder=\"Select transporter name\"\n            >\n              <ion-select-option\n                *ngFor=\"let transporter of transporters\"\n                [value]=\"transporter?.value\"\n                >{{ transporter?.label }}</ion-select-option\n              >\n            </ion-select>\n          </ion-item>\n        </ion-col>\n        <ion-col\n          size=\"6\"\n          *ngIf=\"channelType === 'STARGAZE'\"\n          formGroupName=\"logisticsTransporters\"\n        >\n          <ion-label position=\"stacked\" class=\"label-position\"\n            >Transporter Name</ion-label\n          >\n          <div *ngIf=\"transporters\">\n            <p-dropdown\n              placeholder=\"Select transporter name\"\n              [options]=\"transporters\"\n              name=\"id\"\n              formControlName=\"id\"\n            ></p-dropdown>\n          </div>\n        </ion-col>\n        <ion-col size=\"12\" *ngIf=\"channelType != 'STARGAZE'\">\n          <ion-item lines=\"none\" input-item=\"\" formGroupName=\"logisticsVehicle\">\n            <ion-label position=\"stacked\">Vehicle Type</ion-label>\n            <ion-select\n              formControlName=\"id\"\n              *ngIf=\"vehicleTypes\"\n              interface=\"action-sheet\"\n              placeholder=\"Select the vehicle type\"\n              (ionChange)=\"\n                updateVehicleCapacity(\n                  transportationDetailsForm?.value?.logisticsVehicle?.id\n                )\n              \"\n            >\n              <ion-select-option\n                *ngFor=\"let vehicleType of vehicleTypes\"\n                [value]=\"vehicleType?.id\"\n                >{{ vehicleType?.vehicleType }}</ion-select-option\n              >\n            </ion-select>\n          </ion-item>\n        </ion-col>\n        <ion-col\n          size=\"6\"\n          *ngIf=\"channelType === 'STARGAZE'\"\n          formGroupName=\"logisticsVehicle\"\n        >\n          <ion-label position=\"stacked\" class=\"label-position\"\n            >Vehicle Type</ion-label\n          >\n          <div>\n            <p-dropdown\n              placeholder=\"Select the vehicle type\"\n              *ngIf=\"vehicleTypes\"\n              [options]=\"vehicleTypes\"\n              (onChange)=\"\n                updateVehicleCapacity(\n                  transportationDetailsForm?.value?.logisticsVehicle?.id\n                )\n              \"\n              formControlName=\"id\"\n            ></p-dropdown>\n          </div>\n        </ion-col>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">Vehicle Capacity</ion-label>\n            <ion-input\n              formControlName=\"vehicleCapacity\"\n              type=\"number\"\n              placeholder=\"Enter the capacity in tonnes\"\n            >\n              <ion-text class=\"text-right\" color=\"medium\">Tonnes</ion-text>\n            </ion-input>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">Vehicle Number</ion-label>\n            <ion-input\n              formControlName=\"vehicleNumber\"\n              type=\"text\"\n              placeholder=\"Enter the number\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\"\n              >Validity of National Permit/State Permit</ion-label\n            >\n          </ion-item>\n          <ion-radio-group formControlName=\"vehiclePermit\">\n            <ion-row no-padding>\n              <ion-col size=\"4\" no-padding>\n                <ion-item lines=\"none\" input-item=\"\">\n                  <ion-label>Yes</ion-label>\n                  <ion-radio slot=\"start\" [value]=\"true\"></ion-radio>\n                </ion-item>\n              </ion-col>\n              <ion-col size=\"4\" no-padding>\n                <ion-item lines=\"none\" input-item=\"\">\n                  <ion-label>No</ion-label>\n                  <ion-radio slot=\"start\" [value]=\"false\"></ion-radio>\n                </ion-item>\n              </ion-col>\n            </ion-row>\n          </ion-radio-group>\n        </ion-col>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">Insurance Available</ion-label>\n          </ion-item>\n\n          <ion-radio-group formControlName=\"vehicleInsurance\">\n            <ion-row no-padding>\n              <ion-col size=\"4\" no-padding>\n                <ion-item lines=\"none\" input-item=\"\">\n                  <ion-label>Yes</ion-label>\n                  <ion-radio slot=\"start\" [value]=\"true\"></ion-radio>\n                </ion-item>\n              </ion-col>\n              <ion-col size=\"4\" no-padding>\n                <ion-item lines=\"none\" input-item=\"\">\n                  <ion-label>No</ion-label>\n                  <ion-radio slot=\"start\" [value]=\"false\"></ion-radio>\n                </ion-item>\n              </ion-col>\n            </ion-row>\n          </ion-radio-group>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          class=\"section-separator\"\n          margin-top\n          text-center\n          padding-start\n          padding-top\n          padding-end\n        >\n          <ion-label>Driver information</ion-label>\n          <!--<p class=\"section-separator\"><span></span></p>-->\n        </ion-col>\n        <div></div>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">Driver Name</ion-label>\n            <ion-input\n              formControlName=\"driverName\"\n              placeholder=\"Enter the driver\u2019s name\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">Driver Mobile Number</ion-label>\n            <ion-input\n              type=\"phone\"\n              placeholder=\"Enter the driver\u2019s mobile number\"\n              formControlName=\"driverContact\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" *ngIf=\"channelType != 'STARGAZE'\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">ID Proof</ion-label>\n            <ion-select\n              interface=\"action-sheet\"\n              placeholder=\"Select the ID proof type\"\n              formControlName=\"idProof\"\n            >\n              <ion-select-option\n                *ngFor=\"let idType of idProofTypes\"\n                [value]=\"idType?.value\"\n              >\n                {{ idType?.label }}\n              </ion-select-option>\n            </ion-select>\n            <ion-input\n              [hidden]=\"!transportationDetailsForm?.value?.idProof\"\n              type=\"text\"\n              placeholder=\"Enter the ID proof number\"\n              formControlName=\"idProofNo\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" *ngIf=\"channelType === 'STARGAZE'\">\n          <ion-row>\n            <ion-col size=\"6\" style=\"margin-top: 6px\">\n              <ion-label class=\"label-position\">ID Proof</ion-label>\n              <div>\n                <p-dropdown\n                  placeholder=\"Select the ID proof type\"\n                  *ngIf=\"idProofTypes\"\n                  [options]=\"idProofTypes\"\n                  formControlName=\"idProof\"\n                ></p-dropdown>\n              </div>\n            </ion-col>\n            <ion-col size=\"6\">\n              <ion-item\n                lines=\"none\"\n                input-item\n                [hidden]=\"!transportationDetailsForm?.value?.idProof\"\n              >\n                <ion-label position=\"stacked\">ID Number</ion-label>\n                <ion-input\n                  type=\"text\"\n                  placeholder=\"Enter the ID proof number\"\n                  formControlName=\"idProofNo\"\n                ></ion-input>\n              </ion-item>\n            </ion-col>\n          </ion-row>\n        </ion-col>\n        <ion-col size=\"12\" size-lg=\"6\">\n          <ion-item lines=\"none\" input-item=\"\">\n            <ion-label position=\"stacked\">Driving License</ion-label>\n            <ion-input\n              formControlName=\"driverLicenceNo\"\n              placeholder=\"Enter the driving license number\"\n              type=\"text\"\n            ></ion-input>\n          </ion-item>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </form>\n  <!--<ion-grid no-padding>\n      <ion-row no-padding>\n        <ion-col size=\"12\" no-padding-left=\"\" no-padding-right=\"\" no-padding-bottom=\"\" padding-top=\"\">\n          <ion-row219027\n          >\n            <ion-col size=\"10\" text-left=\"\">\n              <ion-text color=\"medium\" class=\"to-from-location\" font-bold>Dispatched From\n              </ion-text>\n              <br/>\n              <ion-text color=\"dark\"\n                        class=\"location-name\">{{orderDetails?.fromLocation?.name | uppercase}}</ion-text>\n              <br/>\n              <ion-text color=\"dark\" font-bold\n                        class=\"street\">{{orderDetails?.fromLocation?.addressInfo?.landmark ? orderDetails?.fromLocation?.addressInfo?.landmark + ',' : '' }} {{orderDetails?.fromLocation?.addressInfo?.street}}</ion-text>\n            </ion-col>\n          </ion-row>\n        </ion-col>\n        <ion-col size=\"12\" no-padding=\"\" *ngIf=\"orderDetails?.status === 'SETTLED'\">\n          <ion-row>\n            <ion-col size=\"10\" text-left=\"\">\n              <ion-label color=\"medium\" class=\"to-from-location\" font-bold>Delivered At\n              </ion-label>\n              <br/>\n              <ion-text color=\"dark\"\n                        class=\"location-name\">{{orderDetails?.toLocation?.name | uppercase}}</ion-text>\n              <br/>\n              <ion-text color=\"dark\" font-bold\n                        class=\"street\">{{orderDetails?.toLocation?.addressInfo?.landmark ? orderDetails?.toLocation?.addressInfo?.landmark + ',' : '' }} {{orderDetails?.toLocation?.addressInfo?.street}}</ion-text>\n            </ion-col>\n            &lt;!&ndash;<ion-col size=\"2\" *ngIf=\"order?.status === 'CREATED'\">\n                <ion-button float-end=\"\" color=\"light\" size=\"small\" fill=\"outline\">EDIT</ion-button>\n            </ion-col>&ndash;&gt;\n          </ion-row>\n        </ion-col>\n      </ion-row>\n    </ion-grid>-->\n</ion-content>\n<ion-footer>\n  <ion-row>\n    <ion-col size=\"12\" text-center>\n      <ion-button\n        [disabled]=\"\n          !transportationDetailsForm.touched ||\n          transportationDetailsForm.invalid\n        \"\n        (click)=\"saveLogisticDetails()\"\n        size=\"large\"\n        *ngIf=\"!orderLogisticsDetails?.id\"\n      >\n        Save\n      </ion-button>\n      <ion-button\n        [disabled]=\"transportationDetailsForm.invalid\"\n        (click)=\"updateLogisticDetails()\"\n        size=\"large\"\n        *ngIf=\"orderLogisticsDetails?.id\"\n      >\n        Update\n      </ion-button>\n    </ion-col>\n  </ion-row>\n</ion-footer>\n",
                    styles: ["ion-header ion-title{padding-left:2px}ion-header ion-title .modal-title-text{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}ion-header ion-title .modal-title-text ion-icon{font-size:3.538rem}ion-header ion-title .modal-title-text ion-text{text-align:left;font-size:1.538rem;line-height:2.615rem;letter-spacing:0;text-transform:capitalize;opacity:1;font-weight:700}ion-content form ion-item ion-radio{margin-right:8px}ion-content form .section-separator{font-size:1.231rem;letter-spacing:2px}ion-header[no-shadow]:after{background:0 0}ion-text.text-right{right:0;position:absolute;padding:0 5px 0 8px}ion-input{--padding-end:75px!important}ion-input ion-text{line-height:22px}@media only screen and (min-width:40.625em){.back-button-section{display:none}.close-button-section{display:-webkit-box;display:flex}ion-header{padding-left:unset}ion-header ion-title .modal-title-text{-webkit-box-pack:center;justify-content:center}ion-header ion-title .modal-title-text ion-icon{font-size:2.538rem}}@media only screen and (max-width:40.625em){.back-button-section{display:block}.close-button-section{display:none}}.label-position{text-align:left;padding-right:15px;padding-left:15px;font-family:font-regular;color:#5b7583}.label-position.label-stacked.sc-ion-label-md-h{-webkit-transform:translate3d(0,50%,0) scale(1);transform:translate3d(0,50%,0) scale(1)}:host ::ng-deep .ui-dropdown{display:-webkit-box;display:flex;margin-top:6px;min-height:42px;border-radius:6px;margin-left:10px;margin-right:10px;border:none!important;background:#f4f9fa}:host ::ng-deep .ui-dropdown.ui-dropdown-open{border-radius:6px 6px 0 0}:host ::ng-deep label.ui-dropdown-label{padding:10px!important;background:#f4f9fa!important}:host ::ng-deep .ui-dropdown-panel{border:none;box-shadow:none}:host ::ng-deep .ui-dropdown-panel .ui-dropdown-items-wrapper{background:#f4f9fa}:host ::ng-deep .ui-dropdown-trigger{background:#f4f9fa!important}"]
                }] }
    ];
    /** @nocollapse */
    TransportationDetailsModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: FormBuilder },
        { type: RcylOrderConfigService },
        { type: RcylOrderLogisticsService },
        { type: Events }
    ]; };
    TransportationDetailsModalComponent.propDecorators = {
        orderDetails: [{ type: Input }],
        orderLogisticsDetails: [{ type: Input }]
    };
    return TransportationDetailsModalComponent;
}());
if (false) {
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.orderDetails;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.orderLogisticsDetails;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.transportationDetailsForm;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.transporters;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.vehicleTypes;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.getAllTransportersSubscription;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.getAllVehicleTypesSubscription;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.idProofTypes;
    /** @type {?} */
    TransportationDetailsModalComponent.prototype.channelType;
    /**
     * @type {?}
     * @private
     */
    TransportationDetailsModalComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    TransportationDetailsModalComponent.prototype.formBuilder;
    /**
     * @type {?}
     * @private
     */
    TransportationDetailsModalComponent.prototype.orderConfigService;
    /**
     * @type {?}
     * @private
     */
    TransportationDetailsModalComponent.prototype.orderLogisticsService;
    /**
     * @type {?}
     * @private
     */
    TransportationDetailsModalComponent.prototype.events;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CancelReasonModalComponent = /** @class */ (function () {
    function CancelReasonModalComponent(modelCtrl, platform) {
        this.modelCtrl = modelCtrl;
        this.platform = platform;
        this.otherReason = false;
    }
    /**
     * @return {?}
     */
    CancelReasonModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.title =
            this.type === "DROP_REJECTION" ||
                "PICKUP_REJECTION" ||
                "PICKUP_CANCEL" ||
                "ORDER_CANCEL"
                ? "Cancel Order"
                : "Hold Order";
    };
    /**
     * @param {?} reason
     * @return {?}
     */
    CancelReasonModalComponent.prototype.doCancel = /**
     * @param {?} reason
     * @return {?}
     */
    function (reason) {
        this.modelCtrl.dismiss(reason);
    };
    /**
     * @return {?}
     */
    CancelReasonModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modelCtrl.dismiss(undefined, null);
    };
    CancelReasonModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-cancel-reason-modal",
                    template: "<!-- <ion-toolbar [color]=\"'none'\">\n    <ion-title>\n        {{title | titlecase }}\n    </ion-title>\n    <ion-buttons slot=\"end\">\n        <ion-button  [fill]=\"'clear'\" (click)=\"doCancel(null)\">\n            <ion-icon name=\"close\"  ></ion-icon>\n        </ion-button>\n    </ion-buttons>\n</ion-toolbar> -->\n<div class=\"inner-content\" padding=\"\">\n  <div *ngIf=\"!platform.is('mobile')\" class=\"modal-close-btn\">\n    <ion-icon name=\"close\" (click)=\"closeModal()\"></ion-icon>\n  </div>\n  <div text-center class=\"ion-margin-top\">\n    <div>\n      {{ title | titlecase }} <strong>#{{ formattedId }}</strong>\n    </div>\n    <div style=\"font-size: 12px; color: #5b7583\">Please select a reason</div>\n  </div>\n  <ion-list class=\"cancel-reasons-section\">\n    <ion-radio-group>\n      <ion-item\n        [lines]=\"'none'\"\n        *ngFor=\"let reason of reasons; let i = index\"\n        (click)=\"\n          cancelReason = reason?.title === 'Other' ? '' : reason.title;\n          otherReason = reason?.title === 'Other'\n        \"\n      >\n        <ion-label font-size-12>{{ reason?.title }}</ion-label>\n        <ion-radio\n          mode=\"ios\"\n          color=\"light\"\n          slot=\"end\"\n          value=\"{{ reason?.title }}\"\n        ></ion-radio>\n      </ion-item>\n      <!--<ion-item [lines]=\"'none'\" (click)=\"(otherReason = true ) && (cancelReason = '')\" >\n                <ion-label font-size-12 >Others</ion-label> \n                <ion-radio mode=\"ios\" color=\"light\" slot=\"end\" value=''></ion-radio>\n            </ion-item>-->\n      <ion-item *ngIf=\"otherReason\">\n        <ion-textarea\n          [rows]=\"1\"\n          [(ngModel)]=\"cancelReason\"\n          [placeholder]=\"'Specify reason...'\"\n        ></ion-textarea>\n      </ion-item>\n    </ion-radio-group>\n  </ion-list>\n</div>\n<ion-footer>\n  <ion-grid>\n    <ion-row>\n      <ion-col>\n        <ion-button\n          [color]=\"'primary'\"\n          size=\"large\"\n          expand=\"block\"\n          [disabled]=\"cancelReason?.length <= 0\"\n          (click)=\"doCancel(cancelReason)\"\n          >Done</ion-button\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [":host ion-textarea{font-size:14px!important}:host ul{line-height:1.3}:host ul li{cursor:pointer;line-height:1.5}:host .cancel-reasons-section ion-label{white-space:inherit;overflow:inherit;font-size:14px;color:#5b7583}:host .cancel-reasons-section ion-radio{width:20px;height:20px;border-radius:50%;background:#e6ebed}:host .cancel-reasons-section ion-radio.radio-checked{background:#37916c}:host .modal-close-btn{width:100%;display:block;float:left}:host .modal-close-btn ion-icon{background-color:#bac4c9;font-size:16px;float:right;padding:2px;color:#fff;margin-top:20px;border-radius:50%;margin-right:10px;cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    CancelReasonModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: Platform }
    ]; };
    return CancelReasonModalComponent;
}());
if (false) {
    /** @type {?} */
    CancelReasonModalComponent.prototype.reasons;
    /** @type {?} */
    CancelReasonModalComponent.prototype.orderId;
    /** @type {?} */
    CancelReasonModalComponent.prototype.cancelReason;
    /** @type {?} */
    CancelReasonModalComponent.prototype.type;
    /** @type {?} */
    CancelReasonModalComponent.prototype.title;
    /** @type {?} */
    CancelReasonModalComponent.prototype.otherReason;
    /** @type {?} */
    CancelReasonModalComponent.prototype.formattedId;
    /**
     * @type {?}
     * @private
     */
    CancelReasonModalComponent.prototype.modelCtrl;
    /** @type {?} */
    CancelReasonModalComponent.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylSelectTimeslotModalComponent = /** @class */ (function () {
    function RcylSelectTimeslotModalComponent(modelCtrl, platform) {
        this.modelCtrl = modelCtrl;
        this.platform = platform;
    }
    /**
     * @return {?}
     */
    RcylSelectTimeslotModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // console.log(this.timeSlots);
        // this.selectedTimeSlotId = null;
    };
    /**
     * @param {?} time
     * @return {?}
     */
    RcylSelectTimeslotModalComponent.prototype.selectTimeSlot = /**
     * @param {?} time
     * @return {?}
     */
    function (time) {
        this.selectedTimeSlotId = time.id;
    };
    /**
     * @return {?}
     */
    RcylSelectTimeslotModalComponent.prototype.updateTimeSlot = /**
     * @return {?}
     */
    function () {
        this.modelCtrl.dismiss(this.selectedTimeSlotId);
    };
    /**
     * @return {?}
     */
    RcylSelectTimeslotModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modelCtrl.dismiss(undefined, null);
    };
    RcylSelectTimeslotModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-select-timeslot-modal",
                    template: "<div class=\"inner-content\" padding=\"\">\n  <div *ngIf=\"!platform.is('mobile')\" class=\"modal-close-btn\">\n    <ion-icon name=\"close\" (click)=\"closeModal()\"></ion-icon>\n  </div>\n  <div text-center>\n    <div font-medium style=\"font-size: 16px !important\">\n      Set up your pick up time\n    </div>\n    <div style=\"font-size: 12px; color: #5b7583\">\n      You can book a date between tomorrow & the next 30 days\n    </div>\n  </div>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\" text-center>\n        <ion-text font-bold text-small> PICKUP DATE </ion-text>\n      </ion-col>\n      <ion-col size=\"12\">\n        <ion-radio-group [(ngModel)]=\"selectedTimeSlotId\">\n          <ion-grid no-padding>\n            <ion-row>\n              <ion-col\n                (click)=\"selectTimeSlot(time)\"\n                *ngFor=\"let time of timeSlots\"\n                size=\"3\"\n              >\n                <div class=\"date\" card-like=\"\">\n                  <div\n                    class=\"item-radio-selectable\"\n                    [ngClass]=\"{\n                      'item-radio-selected': time?.id == selectedTimeSlotId\n                    }\"\n                  >\n                    <div style=\"padding-top: 8px\">\n                      <ion-radio\n                        mode=\"ios\"\n                        class=\"\"\n                        [value]=\"time.id\"\n                      ></ion-radio>\n                      <ion-text color=\"medium\" text-small *ngIf=\"time?.isToday\"\n                        >Today</ion-text\n                      >\n                      <ion-text\n                        color=\"medium\"\n                        text-small\n                        *ngIf=\"time?.isTomorrow\"\n                        >Tomorrow</ion-text\n                      >\n                      <ion-text\n                        color=\"medium\"\n                        text-small\n                        *ngIf=\"!time?.isToday && !time?.isTomorrow\"\n                      >\n                        {{ time?.startTime | date: \"d MMM\" }}\n                      </ion-text>\n                    </div>\n                  </div>\n                </div>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </ion-radio-group>\n      </ion-col>\n      <ion-col font-bold=\"\" size=\"12\" text-small text-center>\n        <ion-text color=\"primary\" style=\"font-size: 12px\"\n          >The pickup will be done between 8AM - 6PM</ion-text\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</div>\n<ion-footer>\n  <ion-grid>\n    <ion-row>\n      <ion-col>\n        <ion-button\n          [color]=\"'primary'\"\n          size=\"large\"\n          expand=\"block\"\n          [disabled]=\"!selectedTimeSlotId\"\n          (click)=\"updateTimeSlot()\"\n          >Save</ion-button\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [".date{line-height:19px;border:1px solid #f0f0f0;text-align:center;border-radius:5px;margin-bottom:8px}.date .item-radio-selectable ion-radio{float:right;margin-right:-15px;margin-top:-12px}.date .item-radio-selected{background:var(--ion-color-dark)!important;--background:var(--ion-color-dark)!important;border-radius:5px;--border-radius:5px;color:var(--ion-color-primary-contrast)!important;--color:var(--ion-color-primary-contrast)!important;--box-shadow:2px 15px 14px -9px var(--ion-color-dark-shade);height:100%}.date .item-radio-selected .radio-checked{position:absolute;right:9px;top:6px;width:20px;padding:1.8px;border-radius:12px;margin-top:-8px;height:20px;margin-right:-11px;background:#63ad85;--color-checked:var(--ion-color-primary-contrast);float:right}.modal-close-btn{width:100%;display:block;float:left}.modal-close-btn ion-icon{background-color:#bac4c9;font-size:16px;float:right;padding:2px;color:#fff;margin-top:20px;border-radius:50%;margin-right:10px;cursor:pointer}"]
                }] }
    ];
    /** @nocollapse */
    RcylSelectTimeslotModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: Platform }
    ]; };
    return RcylSelectTimeslotModalComponent;
}());
if (false) {
    /** @type {?} */
    RcylSelectTimeslotModalComponent.prototype.timeSlots;
    /** @type {?} */
    RcylSelectTimeslotModalComponent.prototype.selectedTimeSlotId;
    /**
     * @type {?}
     * @private
     */
    RcylSelectTimeslotModalComponent.prototype.modelCtrl;
    /** @type {?} */
    RcylSelectTimeslotModalComponent.prototype.platform;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function RcylOrderDetailsComponentConfig() { }
if (false) {
    /** @type {?} */
    RcylOrderDetailsComponentConfig.prototype.channelName;
}
var RcylOrderDetailsComponent = /** @class */ (function () {
    function RcylOrderDetailsComponent(orderService, rcylOrdersService, http, events, orderConfig, modalController, loadingCtrl, fileManagerService, orderLogisticsService, platform, alertController, orderListService, location, toast) {
        var _this = this;
        this.orderService = orderService;
        this.rcylOrdersService = rcylOrdersService;
        this.http = http;
        this.events = events;
        this.orderConfig = orderConfig;
        this.modalController = modalController;
        this.loadingCtrl = loadingCtrl;
        this.fileManagerService = fileManagerService;
        this.orderLogisticsService = orderLogisticsService;
        this.platform = platform;
        this.alertController = alertController;
        this.orderListService = orderListService;
        this.location = location;
        this.toast = toast;
        this.showStatusFlow = true;
        this.transportFlowToggle = true;
        this.driverFlowToggle = true;
        this.statusFlow = [];
        this.getNotes = [];
        this.ifPickedState = true;
        this.orderDocumentTypes = OrderDocumentTypes;
        // @deprecate this event can be removed will be handled by downloadProformaInvoice
        this.showInvoice = new EventEmitter();
        // @deprecate this event can be removed will be handled by downloadDocument
        this.openFileUrl = new EventEmitter();
        // new file manager events
        this.selectAndUploadImgDocument = new EventEmitter();
        this.downloadDocument = new EventEmitter();
        this.downloadProformaInvoice = new EventEmitter();
        this.orderLogisticsDetailsSubscription = new Subscription();
        this.openFileUrlCallback = (/**
         * @param {?} url
         * @return {?}
         */
        function (url) {
            _this.openFileUrl.emit(url);
        });
    }
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fileManagerService.onUploadSuccess.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            console.log("onFIleUp", data);
            _this.getOrderDetails();
        }));
        this.getOrderDetails();
        this.getConfigDetails(this.config);
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, (/**
         * @param {?} action
         * @param {?} data
         * @return {?}
         */
        function (action, data) {
            _this.getOrderDetails();
        }));
        this.fileManagerService.documentMap.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.orderDocumentsMap = data;
        }));
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_LOGISTIC_DETAILS_UPDATED, (/**
         * @return {?}
         */
        function () {
            _this.getOrderLogisticsDetails();
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.getOrderDetails();
        this.getOrderLogisticsDetails();
    };
    /**
     * @param {?} configData
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.getConfigDetails = /**
     * @param {?} configData
     * @return {?}
     */
    function (configData) {
        this.configData = configData;
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.toggleStatusFlow = /**
     * @return {?}
     */
    function () {
        this.showStatusFlow = !this.showStatusFlow;
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.transportDetailsFlow = /**
     * @return {?}
     */
    function () {
        this.transportFlowToggle = !this.transportFlowToggle;
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.driverDetailsFlow = /**
     * @return {?}
     */
    function () {
        this.driverFlowToggle = !this.driverFlowToggle;
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.getOrderDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.selectedOrder = this.orderService.getOrder(this.orderId).subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            var e_1, _a, e_2, _b;
            _this.order = data;
            if (_this.order.status === "MATERIAL_RECEIVED") {
                try {
                    for (var _c = __values(_this.order.orderItems), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var i = _d.value;
                        i.receivedQty = i.verifyQty;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (_this.status(["CREATED", "PICKUP_SCHEDULED"], true)) {
                try {
                    for (var _e = __values(_this.order.orderItems), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var i = _f.value;
                        if (!i.receivedQty) {
                            i.receivedQty = i.verifyQty;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            _this.orderService.getNotes(_this.orderId).subscribe((/**
             * @param {?} res
             * @return {?}
             */
            function (res) {
                _this.getNotes = res;
            }));
            _this.totalInitialQty = sumBy(_this.order.orderItems, "qty");
            _this.totalPickedQty = sumBy(_this.order.orderItems, "verifyQty");
            _this.totalReceivedQty = sumBy(_this.order.orderItems, "receivedQty");
            _this.orderDocuments = {
                invoice: filter(_this.order.documents, { type: "INVOICE" }),
                dc: filter(_this.order.documents, { type: "DC" }),
                weigh_bridge: filter(_this.order.documents, {
                    type: "WEIGH_BRIDGE",
                }),
            };
            _this.loadStatuses();
            if (_this.order.payment &&
                _this.order.payment.orderPaymentStatus === "INVOICE_REJECTED") {
                /** @type {?} */
                var sortedPaymentStatusLogs = sortBy(_this.order.payment.paymentStatusChangeLogs, ["id"]);
                _this.invoiceRejectedObj =
                    sortedPaymentStatusLogs[sortedPaymentStatusLogs.length - 1];
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            // this.orderService.onFailed(err);
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.getOrderLogisticsDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderLogisticsDetailsSubscription = this.orderLogisticsService
            .getOrderLogisticsDetails(this.orderId)
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                _this.orderLogisticsDetails = (/** @type {?} */ (data));
            }
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.picked = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderService
            .markAsPicked({
            id: toNumber(this.orderId),
            orderItems: this.order.orderItems,
        })
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.order = result;
            _this.getOrderDetails();
            _this.rcylOrdersService.presentToast("Order has been marked as picked successfully");
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            // this.orderService.onFailed(err);
        }));
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.receivedData = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value.buttonClicked === "MarkAsReceived") {
            this.getOrderDetails();
            this.markAsDelivered(value);
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
        }
        else if (value.buttonClicked === "OrderComplete") {
            this.markAsCompleted();
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
        }
        else if (value.buttonClicked === "dispatched") {
            this.dispatched(value);
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
        }
        else if (value.buttonClicked === "picked") {
            this.picked();
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
        }
        else if (value.buttonClicked === "assignExecutive" ||
            value.buttonClicked === "hold" ||
            value.buttonClicked === "Reject" ||
            value.buttonClicked === "verify" ||
            value.buttonClicked === "makePayment" ||
            value.buttonClicked === "reschedule") {
            this.getOrderDetails();
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
        }
        else if (value.buttonClicked === "AddNotes") {
            this.getOrderDetails();
            this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.markAsDelivered = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        delete data.buttonClicked;
        this.orderService.markAsDelivered(data).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.rcylOrdersService.presentToast(res.saleOrder
                ? "Order delivered to the buyer successfully."
                : "Order received at the warehouse successfully");
            _this.getOrderDetails();
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // this.orderService.onFailed(error);
        }));
    };
    /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.status = /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    function (statuses, In) {
        /** @type {?} */
        var isPresent = indexOf(statuses, this.order.status) >= 0;
        return In ? isPresent : !isPresent;
    };
    /**
     * @param {?} orderItems
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.onItemChanged = /**
     * @param {?} orderItems
     * @return {?}
     */
    function (orderItems) {
        if (orderItems) {
            this.order.orderItems.splice(findIndex(this.order.orderItems, { id: orderItems.id }), orderItems);
            this.updateOrderItems();
        }
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.dispatched = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        delete data.buttonClicked;
        this.orderService
            .markAsScheduled(toNumber(this.orderId), data.order)
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.order = result;
            _this.getOrderDetails();
            _this.rcylOrdersService.presentToast("Order dispatched to buyer successfully");
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            // this.orderService.onFailed(err);
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.markAsCompleted = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderService
            .markAsComplete({
            id: toNumber(this.orderId),
            orderItems: this.order.orderItems,
        })
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.order = result;
            _this.getOrderDetails();
            _this.rcylOrdersService.presentToast("Order completed successfully");
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            // this.orderService.onFailed(err);
        }));
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.fileUploaded = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.getOrderDetails();
        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
    };
    /**
     * @param {?} orderItem
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.onItemAdded = /**
     * @param {?} orderItem
     * @return {?}
     */
    function (orderItem) {
        var _a;
        orderItem.receivedQty = orderItem.itemQty;
        orderItem.tradeType = orderItem.item.tradeType;
        orderItem.isEdit = false;
        (_a = this.order.orderItems).push.apply(_a, __spread([orderItem]));
        this.updateOrderItems();
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.loadStatuses = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderService.getOrderChangeLogs(toNumber(this.orderId)).subscribe((/**
         * @param {?} logs
         * @return {?}
         */
        function (logs) {
            _this.statusFlow = logs;
            /** @type {?} */
            var data = filter(_this.statusFlow, { toStatus: "MATERIAL_PICKED" });
            if (data.length > 0) {
                _this.ifPickedState = !!data[0].id;
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            // this.orderService.onFailed(err);
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.updateOrderItems = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderService.updateOrder(this.order).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.loadingCtrl.dismiss().then();
            _this.order = __assign({}, result);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            // this.orderService.onFailed(err);
            _this.loadingCtrl.dismiss().then();
        }));
    };
    /**
     * @param {?} data
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.viewProformaInvoice = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        if (this.order.id === data) {
            this.showInvoice.emit({ order: this.order });
        }
    };
    /**
     * Stargaze Specific
     */
    /**
     * Stargaze Specific
     * @param {?} docType
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.addDocuments = /**
     * Stargaze Specific
     * @param {?} docType
     * @return {?}
     */
    function (docType) {
        return __awaiter(this, void 0, void 0, function () {
            var docsModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: RcylOrderDocumentsManagerComponent,
                            componentProps: {
                                orderDetails: this.order,
                                orderDocumentsMap: this.orderDocumentsMap,
                                orderStatusLogs: this.statusFlow,
                                selectAndUploadImgDocument: this.selectAndUploadImgDocument,
                                downloadDocument: this.downloadDocument,
                                downloadProformaInvoice: this.downloadProformaInvoice,
                                componentView: "VIEW_UPLOAD",
                                activeDocumentType: docType,
                            },
                        })];
                    case 1:
                        docsModal = _a.sent();
                        docsModal.present().then();
                        docsModal.onDidDismiss().then();
                        return [2 /*return*/, docsModal];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.addTransportDetailsModal = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var transportDetailModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: TransportationDetailsModalComponent,
                            componentProps: {
                                orderDetails: this.order,
                                orderLogisticsDetails: this.orderLogisticsDetails,
                            },
                        })];
                    case 1:
                        transportDetailModal = _a.sent();
                        transportDetailModal.present().then();
                        transportDetailModal.onDidDismiss().then();
                        return [2 /*return*/, transportDetailModal];
                }
            });
        });
    };
    /**
     * Recykal App Specific
     */
    /**
     * Recykal App Specific
     * @param {?} docs
     * @param {?} type
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.openFileManager = /**
     * Recykal App Specific
     * @param {?} docs
     * @param {?} type
     * @return {?}
     */
    function (docs, type) {
        return __awaiter(this, void 0, void 0, function () {
            var modalFM;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: RcylFileManagerComponent,
                            cssClass: "custom-bottom-sheet",
                            componentProps: {
                                docs: docs,
                                docType: type,
                                order: this.order,
                                openFileUrl: this.openFileUrlCallback,
                            },
                        })];
                    case 1:
                        modalFM = _a.sent();
                        modalFM.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) { }));
                        return [4 /*yield*/, modalFM.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @param {?} mobile
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.callPickUpPerson = /**
     * @param {?} mobile
     * @return {?}
     */
    function (mobile) {
        if (mobile) {
            window.location.href = "tel:" + mobile;
        }
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.loadTimeSlot = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.timeSlots) {
            this.presentTimeslotAlert().then();
        }
        else {
            /** @type {?} */
            var data_1 = {};
            if (this.orderConfig.channel === "RECYKAL") {
                // customer
                data_1 = {
                    zip: this.order.addressInfo.zipcode,
                    lat: this.order.addressInfo.latLng
                        ? this.order.addressInfo.latLng.lat
                        : "",
                    lng: this.order.addressInfo.latLng
                        ? this.order.addressInfo.latLng.lng
                        : "",
                    franchiseId: this.order.fromLocation.franchiseId,
                };
            }
            else {
                data_1 = { isDropLocation: this.order.orderType === "DROP" };
            }
            this.presentLoading("Loading TimeSlots...").then((/**
             * @param {?} loader
             * @return {?}
             */
            function (loader) {
                _this.orderService.getTimeSlots(data_1).subscribe((/**
                 * @param {?} timeslots
                 * @return {?}
                 */
                function (timeslots) {
                    _this.timeSlots = timeslots;
                    _this.loadingCtrl.dismiss();
                    setTimeout((/**
                     * @return {?}
                     */
                    function () {
                        _this.presentTimeslotAlert().then();
                    }), 200);
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) {
                    // this.orderService.onFailed(err);
                    _this.loadingCtrl.dismiss().then();
                }));
            }));
        }
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.presentTimeslotAlert = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeSlotModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // let options: any[] = [];
                        this.timeSlots = filter(this.timeSlots, "available");
                        // _.forEach(_.filter(this.timeSlots, 'available'), (p) => {
                        //     options = [...options, {name: p.id, type: 'radio',
                        //         label: this.datePipe.transform(p.startTime, 'EEE, dd-MMM-yy') + ', ' + p.regionName,
                        //         value: p,
                        //         checked: this.order.timeSlot && (p.id === this.order.timeSlot.id)}];
                        // });
                        return [4 /*yield*/, this.modalController.create({
                                component: RcylSelectTimeslotModalComponent,
                                cssClass: "custom-bottom-sheet",
                                componentProps: {
                                    timeSlots: this.timeSlots,
                                    selectedTimeSlotId: this.order.timeSlot && this.order.timeSlot.available
                                        ? this.order.timeSlot.id
                                        : null,
                                },
                            })];
                    case 1:
                        timeSlotModal = _a.sent();
                        timeSlotModal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result.data) {
                                /** @type {?} */
                                var newTimeSlot = find(_this.timeSlots, { id: result.data });
                                _this.changeTimeSlot(newTimeSlot);
                            }
                        }));
                        return [4 /*yield*/, timeSlotModal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.openCancelPickupOrderDailog = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.config.subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    _this.showCancelReasonsDialog(data, "PICKUP_CANCEL");
                }));
                return [2 /*return*/];
            });
        });
    };
    /**
     * @param {?} data
     * @param {?} type
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.showCancelReasonsDialog = /**
     * @param {?} data
     * @param {?} type
     * @return {?}
     */
    function (data, type) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: CancelReasonModalComponent,
                            cssClass: "custom-bottom-sheet",
                            componentProps: {
                                reasons: data.language.reasons[type],
                                type: type,
                                formattedId: this.order.formattedId,
                            },
                        })];
                    case 1:
                        cancelModal = _a.sent();
                        cancelModal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result.data) {
                                _this.cancelPickupOrder({ orderId: _this.order.id, reason: result.data });
                            }
                        }));
                        return [4 /*yield*/, cancelModal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @param {?} cancelData
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.cancelPickupOrder = /**
     * @param {?} cancelData
     * @return {?}
     */
    function (cancelData) {
        var _this = this;
        this.presentLoading().then((/**
         * @return {?}
         */
        function () {
            _this.orderService.cancelOrder(cancelData).subscribe((/**
             * @param {?} result
             * @return {?}
             */
            function (result) {
                _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "CANCELLED", result);
                _this.loadingCtrl.dismiss().then();
                _this.rcylOrdersService.presentToast("Order cancelled").then();
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.getOrderDetails();
                }), 200);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                // this.orderService.onFailed(err);
                _this.loadingCtrl.dismiss().then();
            }));
        }));
    };
    /**
     * @param {?=} message
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.presentLoading = /**
     * @param {?=} message
     * @return {?}
     */
    function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var loading;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadingCtrl.create({
                            message: message || "Please wait...",
                            cssClass: "custom-class custom-loading",
                        })];
                    case 1:
                        loading = _a.sent();
                        return [4 /*yield*/, loading.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @param {?} timeslot
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.changeTimeSlot = /**
     * @param {?} timeslot
     * @return {?}
     */
    function (timeslot) {
        var _this = this;
        this.presentLoading().then((/**
         * @return {?}
         */
        function () {
            if (_this.orderConfig.channel === "RECYKAL") {
                // customer
                _this.order.timeSlot = timeslot;
                _this.order.storeId = _this.order.fromLocation.id;
                _this.orderService.updateTimeSlot(_this.order, _this.order.id).subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                function (result) {
                    _this.loadingCtrl.dismiss().then();
                    // this.order = result;
                    _this.getOrderDetails();
                    _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "PICKUP_SCHEDULED", result);
                    _this.rcylOrdersService
                        .presentToast("Timeslot changed for order.")
                        .then();
                    // this.loadOrderRelatedData();
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) {
                    // this.orderService.onFailed(err);
                    _this.loadingCtrl.dismiss().then();
                }));
            }
            else {
                _this.orderService
                    .changeTimeSlot({
                    pickupOrderId: toNumber(_this.orderId),
                    timeSlotId: timeslot.id,
                })
                    .subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                function (result) {
                    _this.loadingCtrl.dismiss();
                    _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "PICKUP_SCHEDULED", result);
                    _this.order = result;
                    _this.rcylOrdersService
                        .presentToast("Timeslot changed for order.")
                        .then();
                    _this.getOrderDetails();
                }), (/**
                 * @param {?} err
                 * @return {?}
                 */
                function (err) {
                    // this.orderService.onFailed(err);
                    _this.loadingCtrl.dismiss().then();
                }));
            }
        }));
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.openDocumentManager = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var documentMgrModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: RcylOrderDocumentsManagerComponent,
                            componentProps: {
                                orderDetails: this.order,
                                orderDocumentsMap: this.orderDocumentsMap,
                                orderStatusLogs: this.statusFlow,
                                selectAndUploadImgDocument: this.selectAndUploadImgDocument,
                                downloadDocument: this.downloadDocument,
                                downloadProformaInvoice: this.downloadProformaInvoice,
                            },
                        })];
                    case 1:
                        documentMgrModal = _a.sent();
                        documentMgrModal.present().then();
                        documentMgrModal.onDidDismiss().then();
                        return [2 /*return*/, documentMgrModal];
                }
            });
        });
    };
    /**
     * @param {?} x
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.getAbs = /**
     * @param {?} x
     * @return {?}
     */
    function (x) {
        return Math.abs(x);
    };
    /**
     * @param {?} id
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.onClickRemoveOrder = /**
     * @param {?} id
     * @return {?}
     */
    function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: "Delete Order!",
                            message: "Would you like to delete this Order?",
                            buttons: [
                                {
                                    text: "No",
                                    role: "cancel",
                                    // cssClass: 'secondary',
                                    cssClass: "custom-alert",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () { }),
                                },
                                {
                                    text: "Yes",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () {
                                        console.log("OK");
                                        _this.orderListService.removeOrder(id).subscribe((/**
                                         * @param {?} res
                                         * @return {?}
                                         */
                                        function (res) {
                                            _this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
                                            _this.toast
                                                .create({
                                                message: "Order deleted successfully.",
                                                duration: 2000,
                                            })
                                                .then((/**
                                             * @param {?} toast
                                             * @return {?}
                                             */
                                            function (toast) { return toast.present(); }));
                                            setTimeout((/**
                                             * @return {?}
                                             */
                                            function () {
                                                _this.location.back(); // <-- go back to previous location on click Okay
                                            }), 800);
                                        }));
                                    }),
                                },
                            ],
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    RcylOrderDetailsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.events.unsubscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED);
    };
    RcylOrderDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-order-details",
                    template: "<div [ngSwitch]=\"orderConfig?.channel\">\n  <ng-template [ngSwitchCase]=\"'STARGAZE'\">\n    <ion-grid *ngIf=\"order\">\n      <ion-row>\n        <ion-col size=\"12\">\n          <ion-icon [src]=\"'./assets/paper.svg'\"></ion-icon>\n          <ion-text font-bold=\"\" text-large=\"\">{{\n            order?.formattedId\n          }}</ion-text>\n          <ion-text *ngIf=\"!order?.saleOrder\" font-regular=\"\" text-large>\n            &nbsp;\u2022 {{ order?.orderType === \"DROP\" ? \"Drop\" : \"Pickup\" }}\n          </ion-text>\n          <ion-icon\n            *ngIf=\"\n              order.orderType === 'DROP' &&\n              order?.payment?.orderPaymentStatus !== 'COMPLETED'\n            \"\n            (click)=\"onClickRemoveOrder(order?.id)\"\n            class=\"ion-float-right pi cursor-pointer\"\n            name=\"trash\"\n          ></ion-icon>\n        </ion-col>\n        <ion-col style=\"max-width: 28%\">\n          <rcyl-customer-details\n            [orderType]=\"order.orderType\"\n            [saleOrder]=\"order.saleOrder\"\n            [location]=\"\n              order?.saleOrder\n                ? order?.toLocation\n                : order.orderType === 'PICKUP'\n                ? order?.fromLocation\n                : ''\n            \"\n            [customer]=\"\n              order?.saleOrder\n                ? order?.buyer\n                : order.orderType === 'PICKUP'\n                ? order?.fromLocation\n                : order?.seller\n            \"\n          ></rcyl-customer-details>\n        </ion-col>\n        <ion-col size=\"3\">\n          <rcyl-pickup-details\n            [selectOrder]=\"order\"\n            (changeExecutive)=\"getOrderDetails()\"\n          ></rcyl-pickup-details>\n        </ion-col>\n        <ion-col>\n          <rcyl-status-details\n            [getConfig]=\"configData\"\n            [selectOrder]=\"order\"\n            (actionTriggered)=\"receivedData($event)\"\n          ></rcyl-status-details>\n        </ion-col>\n      </ion-row>\n      <ion-row>\n        <ion-col size=\"12\">\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title ion-margin-end\"\n              >Item Details</ion-text\n            >\n            <div\n              *ngIf=\"\n                (order.orderType === 'PICKUP' &&\n                  status(['PICKUP_SCHEDULED'], true) &&\n                  !order.saleOrder &&\n                  status(\n                    [\n                      'MATERIAL_RECEIVED',\n                      'ORDER_COMPLETED',\n                      'MATERIAL_PICKED',\n                      'CREATED',\n                      'CANCELLED',\n                      'REJECTED',\n                      'HOLD'\n                    ],\n                    false\n                  )) ||\n                (order.orderType === 'DROP' &&\n                  order?.payment?.orderPaymentStatus !== 'COMPLETED')\n              \"\n            >\n              <rcyl-add-item-button\n                (itemSelect)=\"onItemAdded($event)\"\n                [params]=\"{\n                  orderItems: order?.orderItems,\n                  locationId: order?.toLocation?.id,\n                  customerId: order?.seller.id\n                }\"\n              >\n              </rcyl-add-item-button>\n            </div>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\">\n          <rcyl-item-details\n            [selectOrder]=\"order\"\n            (itemUpdated)=\"onItemChanged($event)\"\n          ></rcyl-item-details>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          *ngIf=\"\n            (order?.orderType === 'DROP' &&\n              order?.status === 'PICKUP_SCHEDULED') ||\n            order?.status === 'ORDER_COMPLETED' ||\n            order?.documents?.length > 0\n          \"\n        >\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title\"\n              >View/Upload Supporting Documents</ion-text\n            >\n            <!--<ion-button class=\"status-btn ion-margin-start\" fill=\"outline\" size=\"large\" color=\"medium\"  (click)=\"addDocuments()\">\n                            <ion-text text-regular>View Upload Files</ion-text>\n                        </ion-button>-->\n          </ion-item>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          class=\"col-position\"\n          *ngIf=\"\n            (order?.orderType === 'DROP' &&\n              order?.status === 'PICKUP_SCHEDULED') ||\n            order?.status === 'ORDER_COMPLETED' ||\n            order?.documents?.length > 0\n          \"\n        >\n          <ion-grid>\n            <ion-row>\n              <ion-col\n                size=\"auto\"\n                *ngFor=\"\n                  let orderTypeData of orderDocumentsMap\n                    | rcylFilter: 'showInList':true\n                    | rcylKeys\n                \"\n              >\n                <ion-chip\n                  [outline]=\"true\"\n                  [ngClass]=\"\n                    orderTypeData?.val?.documents?.length > 0\n                      ? 'docs-chip'\n                      : 'no-docs-chip'\n                  \"\n                  (click)=\"addDocuments(orderTypeData?.key)\"\n                >\n                  <ion-icon [src]=\"orderTypeData?.val?.icon\"></ion-icon>\n                  <ion-text\n                    text-wrap\n                    [color]=\"\n                      orderTypeData?.val?.documents?.length > 0\n                        ? 'primary'\n                        : 'medium'\n                    \"\n                    class=\"text-regular text-flex\"\n                  >\n                    {{ orderTypeData?.val?.displayText }}\n                  </ion-text>\n                  <div\n                    color=\"primary\"\n                    *ngIf=\"orderTypeData?.val?.documents?.length > 0\"\n                  >\n                    <ion-text class=\"text-regular\" color=\"light\">{{\n                      orderTypeData?.val?.documents?.length\n                    }}</ion-text>\n                  </div>\n                </ion-chip>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n          <!-- <rcyl-view-upload-docs [selectOrderDocuments]=\"this.order?.documents\" [selectOrderStatus]=\"order?.status\"\n                                           [selectOrderId]=\"order?.id\" [selectOrderType]=\"order?.orderType\"\n                                           (fileUploadEvent)=\"fileUploaded($event)\"\n                                           (proformaInvoiceDownload)=\"viewProformaInvoice($event)\"></rcyl-view-upload-docs>-->\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          *ngIf=\"\n            order?.payment?.orderPaymentStatus === 'COMPLETED' &&\n            order?.status === 'ORDER_COMPLETED'\n          \"\n        >\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title ion-margin-end\"\n              >Payment Summary</ion-text\n            >\n          </ion-item>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          *ngIf=\"\n            order?.payment?.orderPaymentStatus === 'COMPLETED' &&\n            order?.status === 'ORDER_COMPLETED'\n          \"\n        >\n          <rcyl-payment-summary [selectOrder]=\"order\"></rcyl-payment-summary>\n        </ion-col>\n      </ion-row>\n      <ion-row>\n        <ion-col size=\"12\">\n          <ion-item\n            color=\"medium\"\n            lines=\"none\"\n            (click)=\"toggleStatusFlow()\"\n            class=\"status-section\"\n          >\n            <ion-text color=\"light\" class=\"section-title\">Status Flow</ion-text>\n            <ion-icon\n              color=\"light\"\n              class=\"ion-no-margin\"\n              [name]=\"showStatusFlow == true ? 'remove' : 'add'\"\n              slot=\"end\"\n            ></ion-icon>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" *ngIf=\"showStatusFlow\" style=\"overflow: scroll\">\n          <ion-grid>\n            <ion-row>\n              <ion-col size=\"11\" class=\"ion-margin-start\">\n                <rcyl-status-flow\n                  [isSaleOrder]=\"this.order?.saleOrder\"\n                  [statusFlow]=\"statusFlow\"\n                ></rcyl-status-flow>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </ion-col>\n      </ion-row>\n\n      <ion-row *ngIf=\"order?.orderType !== 'DROP'\" class=\"ion-padding-top\">\n        <ion-col size=\"12\">\n          <ion-item color=\"medium\" lines=\"none\" class=\"status-section\">\n            <ion-text color=\"light\" class=\"section-title\"\n              >Transporter and Vehicle Details</ion-text\n            >\n            <ion-button\n              *ngIf=\"!orderLogisticsDetails && !ifPickedState\"\n              fill=\"clear\"\n              color=\"light\"\n              class=\"status-btn ion-margin-start\"\n              (click)=\"addTransportDetailsModal()\"\n            >\n              <ion-icon name=\"add\" color=\"light\"></ion-icon>\n              <ion-text class=\"text-medium\" color=\"light\">Add</ion-text>\n            </ion-button>\n            <ion-icon\n              *ngIf=\"orderLogisticsDetails && !ifPickedState\"\n              name=\"create\"\n              class=\"ion-margin-start icon-size\"\n              color=\"light\"\n              (click)=\"addTransportDetailsModal()\"\n            ></ion-icon>\n            <ion-icon\n              color=\"light\"\n              (click)=\"transportDetailsFlow()\"\n              class=\"ion-no-margin\"\n              [name]=\"transportFlowToggle == true ? 'remove' : 'add'\"\n              slot=\"end\"\n            ></ion-icon>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" no-padding *ngIf=\"transportFlowToggle\">\n          <rcyl-transporter-vehicle-details\n            [enableEdit]=\"false\"\n            [orderLogisticsDetails]=\"orderLogisticsDetails\"\n          ></rcyl-transporter-vehicle-details>\n        </ion-col>\n      </ion-row>\n      <ion-row *ngIf=\"order?.orderType !== 'DROP'\">\n        <ion-col size=\"12\">\n          <ion-item color=\"medium\" lines=\"none\" class=\"status-section\">\n            <ion-text color=\"light\" class=\"section-title\"\n              >Driver Information\n            </ion-text>\n            <ion-button\n              *ngIf=\"!orderLogisticsDetails && !ifPickedState\"\n              fill=\"clear\"\n              color=\"light\"\n              class=\"status-btn ion-margin-start\"\n              (click)=\"addTransportDetailsModal()\"\n            >\n              <ion-icon name=\"add\" color=\"light\"></ion-icon>\n              <ion-text class=\"text-medium\" color=\"light\">Add</ion-text>\n            </ion-button>\n\n            <ion-icon\n              *ngIf=\"orderLogisticsDetails && !ifPickedState\"\n              name=\"create\"\n              class=\"ion-margin-start icon-size\"\n              color=\"light\"\n              (click)=\"addTransportDetailsModal()\"\n            ></ion-icon>\n            <ion-icon\n              color=\"light\"\n              (click)=\"driverDetailsFlow()\"\n              class=\"ion-no-margin\"\n              [name]=\"driverFlowToggle == true ? 'remove' : 'add'\"\n              slot=\"end\"\n            ></ion-icon>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\" no-padding *ngIf=\"driverFlowToggle\">\n          <rcyl-driver-details\n            [enableEdit]=\"false\"\n            [orderLogisticsDetails]=\"orderLogisticsDetails\"\n          ></rcyl-driver-details>\n        </ion-col>\n      </ion-row>\n\n      <ion-row>\n        <ion-col size=\"12\">\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title ion-margin-end\">Notes</ion-text>\n            <br />\n            <rcyl-add-notes-button\n              [orderId]=\"this.orderId\"\n              (noteOutput)=\"receivedData($event)\"\n            ></rcyl-add-notes-button>\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\">\n          <rcyl-notes-details [notes]=\"getNotes\"></rcyl-notes-details>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </ng-template>\n  <ng-template [ngSwitchCase]=\"'RECYKAL'\">\n    <div class=\"recykal-app\" *ngIf=\"platform.is('mobile')\">\n      <div\n        *ngIf=\"componentConfig.channelName == 'B2B'\"\n        class=\"non-market-order\"\n      >\n        <!-- generator mobile view start -->\n        <div *ngIf=\"order && order.id\" class=\"mobile-view\">\n          <div text-center margin class=\"statusLabel\">\n            <ion-badge\n              font-size-12\n              font-bold\n              text-wrap\n              (click)=\"getOrderDetails()\"\n              [OrderStatus]=\"\n                order?.status === 'ORDER_COMPLETED'\n                  ? order?.payment?.orderPaymentStatus\n                  : order?.status\n              \"\n            >\n              <!-- {{  | uppercase}}-->\n              {{\n                (order.status === \"ORDER_COMPLETED\"\n                  ? order?.payment?.statusTitle\n                  : order?.displayStatusTitle\n                ) | uppercase\n              }}\n            </ion-badge>\n          </div>\n          <div text-center=\"\">\n            <ion-text font-regular=\"\" color=\"medium\">\n              <span font-size-12=\"\" *ngIf=\"order.status === 'CREATED'\"\n                >Your request is being processed</span\n              >\n              <span font-size-12=\"\" *ngIf=\"order.status === 'PICKUP_SCHEDULED'\"\n                >Pickup executive assigned</span\n              >\n              <span font-size-12=\"\" *ngIf=\"order.status === 'MATERIAL_PICKED'\"\n                >Materials have been picked by our executive.</span\n              >\n              <span\n                font-size-12=\"\"\n                *ngIf=\"\n                  order.status === 'ORDER_COMPLETED' &&\n                  order?.payment?.orderPaymentStatus === 'INVOICE_PENDING'\n                \"\n                >Upload your invoice to get the payment processed</span\n              >\n            </ion-text>\n          </div>\n          <ion-grid no-padding=\"\">\n            <div\n              text-center=\"\"\n              *ngIf=\"\n                status(['ORDER_COMPLETED'], true) &&\n                order?.payment?.orderPaymentStatus != 'COMPLETED'\n              \"\n            >\n              <ion-text font-regular=\"\" color=\"medium\">\n                <span font-size-10=\"\"\n                  >Please refer to the Proforma Invoice for the net receivable\n                  amount.</span\n                >\n              </ion-text>\n            </div>\n          </ion-grid>\n\n          <ion-card no-padding no-box-shadow>\n            <ion-grid>\n              <ion-row>\n                <ion-col>\n                  <div font-medium=\"\">\n                    <ion-text font-size-12=\"\">Pickup Date</ion-text>\n                  </div>\n                  <div font-size-14 font-medium text-black no-margin>\n                    <ion-text>\n                      {{ order?.orderDate | date: \"dd MMM yyyy\" }}\n                    </ion-text>\n                  </div>\n                  <div margin-top-5 font-medium=\"\">\n                    <ion-text font-size-12=\"\">Pickup Location</ion-text>\n                  </div>\n                  <div font-size-14 font-medium text-black no-margin>\n                    <ion-text\n                      >{{ order?.seller?.name }},\n                      {{ order?.fromLocation?.addressInfo | address }}</ion-text\n                    >\n                  </div>\n                  <div class=\"partner-name\">\n                    <span>Partner</span>\n                    <ion-text text-regular=\"\">\n                      \u2022 {{ order?.buyer?.name || \"-\" }}</ion-text\n                    >\n                  </div>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-card>\n          <ion-card\n            no-padding\n            no-box-shadow\n            *ngIf=\"\n              order?.pickupPerson?.id && status(['ORDER_COMPLETED'], false)\n            \"\n          >\n            <ion-grid>\n              <ion-row>\n                <ion-col>\n                  <div>\n                    <ion-text font-medium font-size-12>Pickup Person</ion-text>\n                  </div>\n                  <div>\n                    <ion-text text-right=\"\" text-black=\"\" font-medium>{{\n                      order?.pickupPerson?.userName\n                    }}</ion-text>\n                  </div>\n                </ion-col>\n                <ion-col\n                  text-end=\"\"\n                  align-items-end=\"\"\n                  d-flex=\"\"\n                  justify-content-end=\"\"\n                >\n                  <div\n                    *ngIf=\"order?.pickupPerson?.mobileNumber\"\n                    (click)=\"callPickUpPerson(order.pickupPerson.mobileNumber)\"\n                  >\n                    <ion-text text-right=\"\" text-black=\"\" font-medium>\n                      <ion-icon name=\"call\" font-size-12></ion-icon>\n                      + {{ order?.pickupPerson?.mobileNumber }}\n                    </ion-text>\n                  </div>\n                  <div *ngIf=\"!order?.pickupPerson?.mobileNumber\">-</div>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-card>\n          <ion-card\n            no-padding\n            no-box-shadow\n            *ngIf=\"order.payment && order.payment?.paymentSettlement\"\n          >\n            <ion-grid>\n              <ion-row>\n                <ion-col no-padding-bottom>\n                  <div>\n                    <ion-text font-medium font-size-12\n                      >Payment Details</ion-text\n                    >\n                  </div>\n                </ion-col>\n              </ion-row>\n              <ion-row>\n                <ion-col>\n                  <div>\n                    <ion-text font-size-12 color=\"medium\">\n                      Reference No.\n                    </ion-text>\n                  </div>\n                  <div>\n                    <ion-text text-right=\"\" text-black=\"\" font-medium>\n                      {{\n                        order.payment?.paymentSettlement?.referenceNumber || \"-\"\n                      }}\n                    </ion-text>\n                  </div>\n                </ion-col>\n                <ion-col text-end=\"\">\n                  <div>\n                    <ion-text font-size-12 color=\"medium\">\n                      Payment Date\n                    </ion-text>\n                  </div>\n                  <div>\n                    <ion-text text-right=\"\" text-black=\"\" font-medium>\n                      {{\n                        order.payment?.paymentSettlement?.paymentDate\n                          | date: \"dd MMM yyyy\"\n                      }}\n                    </ion-text>\n                  </div>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-card>\n\n          <ion-card\n            no-padding\n            no-box-shadow\n            *ngIf=\"\n              (order?.orderType === 'DROP' &&\n                order?.status === 'PICKUP_SCHEDULED') ||\n              order?.status === 'ORDER_COMPLETED' ||\n              order?.documents?.length > 0\n            \"\n          >\n            <ion-item\n              lines=\"none\"\n              detail=\"true\"\n              (click)=\"openDocumentManager()\"\n            >\n              <ion-label color=\"dark\" font-bold=\"\">\n                Invoices & Documents\n              </ion-label>\n            </ion-item>\n          </ion-card>\n          <ion-grid\n            no-padding\n            *ngIf=\"orderLogisticsDetails\"\n            class=\"transportation-and-vehicle-details\"\n          >\n            <ion-row no-padding>\n              <ion-col size=\"12\" no-padding>\n                <rcyl-transporter-vehicle-details\n                  [enableEdit]=\"false\"\n                  [orderStatusLogs]=\"statusFlow\"\n                  [orderLogisticsDetails]=\"orderLogisticsDetails\"\n                ></rcyl-transporter-vehicle-details>\n              </ion-col>\n              <ion-col size=\"12\" no-padding>\n                <rcyl-driver-details\n                  [enableEdit]=\"false\"\n                  [orderStatusLogs]=\"statusFlow\"\n                  [orderLogisticsDetails]=\"orderLogisticsDetails\"\n                ></rcyl-driver-details>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n\n          <div\n            *ngIf=\"\n              (order?.orderItems | rcylFilter: 'tradeType':'S')?.length > 0\n            \"\n          >\n            <div margin-top>\n              <p class=\"summary-title\">\n                <span>ITEMS SUMMARY</span>\n              </p>\n            </div>\n            <ion-card\n              no-padding\n              no-box-shadow\n              *ngFor=\"\n                let oItem of order?.orderItems | rcylFilter: 'tradeType':'B'\n              \"\n            >\n              <ion-grid no-padding=\"\">\n                <ion-row no-padding=\"\">\n                  <ion-col size=\"4\" align-self-center>\n                    <div d-flex justify-content-center align-items-center>\n                      <ion-img\n                        style=\"width: 30px; margin-right: 10px\"\n                        [src]=\"oItem.item.icon\"\n                      ></ion-img>\n                    </div>\n                    <div text-center line-height-12>\n                      <ion-text text-black font-size-12 font-medium>{{\n                        oItem?.item.name\n                      }}</ion-text>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center class=\"item-left-border\">\n                    <div>\n                      <div line-height-10>\n                        <ion-text color=\"medium\" font-size-12\n                          >Initial Weight</ion-text\n                        >\n                      </div>\n                      <div>\n                        <ion-text text-black font-medium font-size-12\n                          >{{ oItem?.qty }}\n                          {{ oItem.item.unitType | titlecase }}</ion-text\n                        >\n                      </div>\n                    </div>\n                    <div\n                      *ngIf=\"\n                        status(\n                          [\n                            'MATERIAL_PICKED',\n                            'MATERIAL_RECEIVED',\n                            'ORDER_COMPLETED'\n                          ],\n                          true\n                        )\n                      \"\n                    >\n                      <div>\n                        <ion-text color=\"medium\" font-size-12\n                          >Picked Weight</ion-text\n                        >\n                      </div>\n                      <div line-height-10>\n                        <ion-text\n                          text-black\n                          color=\"primary\"\n                          font-medium\n                          font-size-12\n                          >{{ oItem?.formattedVerifyQty }}</ion-text\n                        >\n                      </div>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center>\n                    <div class=\"item-total-section\">\n                      <div>\n                        <div line-height-10 d-flex=\"\" align-items-center>\n                          <ion-text font-size-12 color=\"primary\"\n                            >You earn</ion-text\n                          >\n                        </div>\n                        <div>\n                          <ion-text text-black font-medium font-size-12\n                            >{{ oItem?.itemPrice | currency: \"INR\" }}/{{\n                              oItem.item.unitType | titlecase\n                            }}</ion-text\n                          >\n                        </div>\n                      </div>\n                      <div margin-top-5>\n                        <div>\n                          <ion-text font-size-12 color=\"primary\"\n                            >Total earning</ion-text\n                          >\n                        </div>\n                        <div line-height-10>\n                          <ion-text text-black font-medium font-size-12>{{\n                            oItem?.verifiedAmount | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                    </div>\n                  </ion-col>\n                </ion-row>\n              </ion-grid>\n            </ion-card>\n            <ion-card\n              no-padding\n              no-box-shadow\n              *ngFor=\"\n                let oItem of order?.orderItems | rcylFilter: 'tradeType':'S'\n              \"\n            >\n              <ion-grid no-padding=\"\">\n                <ion-row no-padding=\"\">\n                  <ion-col size=\"4\" align-self-center>\n                    <div d-flex justify-content-center align-items-center>\n                      <ion-img\n                        style=\"width: 30px; margin-right: 10px\"\n                        [src]=\"oItem.item.icon\"\n                      ></ion-img>\n                    </div>\n                    <div text-center line-height-12>\n                      <ion-text text-black font-size-12 font-medium>{{\n                        oItem?.item.name\n                      }}</ion-text>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center class=\"item-left-border\">\n                    <div>\n                      <div line-height-10>\n                        <ion-text color=\"medium\" font-size-12\n                          >Initial Weight</ion-text\n                        >\n                      </div>\n                      <div>\n                        <ion-text text-black font-medium font-size-12\n                          >{{ oItem?.qty }}\n                          {{ oItem.item.unitType | titlecase }}</ion-text\n                        >\n                      </div>\n                    </div>\n                    <div\n                      *ngIf=\"\n                        status(\n                          [\n                            'MATERIAL_PICKED',\n                            'MATERIAL_RECEIVED',\n                            'ORDER_COMPLETED'\n                          ],\n                          true\n                        )\n                      \"\n                    >\n                      <div>\n                        <ion-text color=\"medium\" font-size-12\n                          >Picked Weight</ion-text\n                        >\n                      </div>\n                      <div line-height-10>\n                        <ion-text\n                          text-black\n                          color=\"primary\"\n                          font-medium\n                          font-size-12\n                          >{{ oItem?.formattedVerifyQty }}</ion-text\n                        >\n                      </div>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center>\n                    <div class=\"item-total-section\">\n                      <div>\n                        <div line-height-10 d-flex=\"\" align-items-center>\n                          <ion-text font-size-12 color=\"danger\"\n                            >Service fee</ion-text\n                          >\n                        </div>\n                        <div>\n                          <ion-text text-black font-medium font-size-12\n                            >{{ oItem?.itemPrice | currency: \"INR\" }}/{{\n                              oItem.item.unitType | titlecase\n                            }}</ion-text\n                          >\n                        </div>\n                      </div>\n                      <div margin-top-5>\n                        <div>\n                          <ion-text font-size-12 color=\"danger\"\n                            >Total fee to pay</ion-text\n                          >\n                        </div>\n                        <div line-height-10>\n                          <ion-text text-black font-medium font-size-12>{{\n                            oItem?.verifiedAmount | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                    </div>\n                  </ion-col>\n                </ion-row>\n              </ion-grid>\n            </ion-card>\n            <div margin-top>\n              <p class=\"summary-title\"><span>TOTALS</span></p>\n            </div>\n            <ion-grid no-padding>\n              <ion-row no-padding>\n                <ion-col size=\"12\" no-padding>\n                  <ion-card no-padding no-box-shadow style=\"margin-bottom: 0\">\n                    <ion-grid>\n                      <ion-row>\n                        <ion-col size=\"8\" no-padding-bottom>\n                          <ion-text font-size-12 color=\"medium\"\n                            >Total Initial Weight</ion-text\n                          >\n                        </ion-col>\n                        <ion-col size=\"4\" text-end no-padding-bottom>\n                          <ion-text font-size-12 color=\"dark\">\n                            {{ order?.totalInitialQty }} Qty\n                          </ion-text>\n                        </ion-col>\n                      </ion-row>\n                      <ion-row\n                        *ngIf=\"\n                          status(\n                            [\n                              'MATERIAL_PICKED',\n                              'MATERIAL_RECEIVED',\n                              'ORDER_COMPLETED'\n                            ],\n                            true\n                          )\n                        \"\n                      >\n                        <ion-col size=\"8\">\n                          <ion-text font-size-12 color=\"medium\">\n                            Total Picked Weight\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"4\" text-end>\n                          <ion-text font-bold=\"\" font-size-12 color=\"dark\">\n                            {{ order?.totalPickedQty }} Qty\n                          </ion-text>\n                        </ion-col>\n                      </ion-row>\n                    </ion-grid>\n                  </ion-card>\n                </ion-col>\n\n                <ion-col size=\"12\" no-padding>\n                  <ion-card no-padding no-box-shadow>\n                    <ion-grid>\n                      <ion-row>\n                        <ion-col size=\"8\" no-padding-bottom>\n                          <ion-text font-size-12 color=\"medium\"\n                            >Amount you earn</ion-text\n                          >\n                        </ion-col>\n                        <ion-col size=\"4\" text-end no-padding-bottom>\n                          <ion-text font-size-12 color=\"primary\">\n                            {{ order.totalAmount | currency: \"INR\"\n                            }}<span *ngIf=\"!status(['ORDER_COMPLETED'], true)\"\n                              >*</span\n                            >\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"8\">\n                          <ion-text font-size-12 color=\"medium\"\n                            >Service fee you pay</ion-text\n                          >\n                        </ion-col>\n                        <ion-col size=\"4\" text-end>\n                          (-)\n                          <ion-text font-size-12 color=\"danger\">\n                            {{ order.totalEarnAmount | currency: \"INR\"\n                            }}<span *ngIf=\"!status(['ORDER_COMPLETED'], true)\"\n                              >*</span\n                            >\n                          </ion-text>\n                        </ion-col>\n                      </ion-row>\n                      <ion-row *ngIf=\"!status(['ORDER_COMPLETED'], true)\">\n                        <ion-col size=\"8\">\n                          <ion-text font-size-12 color=\"medium\">\n                            <span *ngIf=\"order.totalAmountOfExclTax >= 0\"\n                              >Estimated final amount that you earn</span\n                            >\n                            <span *ngIf=\"order.totalAmountOfExclTax < 0\"\n                              >Estimated final amount that you pay</span\n                            >\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"4\" text-end>\n                          <ion-text\n                            font-size-12\n                            [color]=\"\n                              order.totalAmountOfExclTax >= 0\n                                ? 'primary'\n                                : 'danger'\n                            \"\n                          >\n                            {{\n                              getAbs(order.totalAmountOfExclTax)\n                                | currency: \"INR\"\n                            }}*\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"12\">\n                          <ion-text font-size-12\n                            ><i>*All rates exclusive of GST</i></ion-text\n                          >\n                        </ion-col>\n                      </ion-row>\n\n                      <ion-row *ngIf=\"status(['ORDER_COMPLETED'], true)\">\n                        <ion-col size=\"8\">\n                          <ion-text font-size-12 color=\"medium\">\n                            GST Applicable\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"4\" text-end>\n                          <span *ngIf=\"order?.totalOfAllTaxes < 0\">(-) </span>\n                          <ion-text\n                            font-size-12\n                            [color]=\"\n                              order?.totalOfAllTaxes >= 0 ? 'primary' : 'danger'\n                            \"\n                          >\n                            {{\n                              getAbs(order?.totalOfAllTaxes) | currency: \"INR\"\n                            }}\n                          </ion-text>\n                        </ion-col>\n                      </ion-row>\n                      <ion-row *ngIf=\"status(['ORDER_COMPLETED'], true)\">\n                        <ion-col size=\"8\">\n                          <ion-text font-size-12 color=\"medium\">\n                            <span *ngIf=\"order?.tradeType === 'B'\"\n                              >Net amount that you earn</span\n                            >\n                            <span *ngIf=\"order?.tradeType === 'S'\"\n                              >Net amount that you pay</span\n                            >\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"4\" text-end>\n                          <ion-text\n                            font-size-12\n                            [color]=\"\n                              order?.tradeType === 'B' ? 'primary' : 'danger'\n                            \"\n                            font-bold=\"\"\n                          >\n                            {{ order.netAmount | currency: \"INR\" }}*\n                          </ion-text>\n                        </ion-col>\n                        <ion-col size=\"12\">\n                          <ion-text font-size-12\n                            ><i>*Net amount is inclusive of taxes</i></ion-text\n                          >\n                        </ion-col>\n                      </ion-row>\n                    </ion-grid>\n                  </ion-card>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </div>\n\n          <div\n            *ngIf=\"\n              (order?.orderItems | rcylFilter: 'tradeType':'S')?.length <= 0\n            \"\n          >\n            <div>\n              <p class=\"summary-title\"><span>YOUR SUMMARY</span></p>\n            </div>\n            <ion-card\n              no-padding\n              no-box-shadow\n              *ngFor=\"let oItem of order?.orderItems\"\n            >\n              <ion-grid no-padding=\"\">\n                <ion-row no-padding=\"\">\n                  <ion-col size=\"4\" align-self-center>\n                    <div d-flex justify-content-center align-items-center>\n                      <ion-img\n                        style=\"width: 30px; margin-right: 10px\"\n                        [src]=\"oItem.item.icon\"\n                      ></ion-img>\n                    </div>\n                    <div text-center line-height-12>\n                      <ion-text text-black font-size-12 font-medium>{{\n                        oItem?.item.name\n                      }}</ion-text>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center class=\"item-left-border\">\n                    <div>\n                      <div line-height-10>\n                        <ion-text color=\"medium\" font-size-12\n                          >Initial Weight</ion-text\n                        >\n                      </div>\n                      <div>\n                        <ion-text text-black font-medium font-size-12\n                          >{{ oItem?.qty }}\n                          {{ oItem.item.unitType | titlecase }}</ion-text\n                        >\n                      </div>\n                    </div>\n                    <div\n                      *ngIf=\"\n                        status(\n                          [\n                            'MATERIAL_PICKED',\n                            'MATERIAL_RECEIVED',\n                            'ORDER_COMPLETED'\n                          ],\n                          true\n                        )\n                      \"\n                    >\n                      <div>\n                        <ion-text color=\"medium\" font-size-12\n                          >Picked Weight</ion-text\n                        >\n                      </div>\n                      <div line-height-10>\n                        <ion-text\n                          text-black\n                          color=\"primary\"\n                          font-medium\n                          font-size-12\n                          >{{ oItem?.formattedVerifyQty }}</ion-text\n                        >\n                      </div>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center>\n                    <div class=\"item-total-section\">\n                      <div>\n                        <div line-height-10>\n                          <ion-text font-size-12\n                            >Price Per\n                            {{ oItem.item.unitType | titlecase }}</ion-text\n                          >\n                        </div>\n                        <div>\n                          <ion-text text-black font-medium font-size-12>{{\n                            oItem?.itemPrice | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                      <div margin-top-5>\n                        <div>\n                          <ion-text font-size-12>Total Value</ion-text>\n                        </div>\n                        <div line-height-10>\n                          <ion-text text-black font-medium font-size-12>{{\n                            oItem?.verifiedAmount | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                    </div>\n                  </ion-col>\n                </ion-row>\n              </ion-grid>\n            </ion-card>\n\n            <ion-card no-padding no-box-shadow>\n              <ion-grid no-padding=\"\">\n                <ion-row no-padding=\"\">\n                  <ion-col size=\"4\" align-self-center>\n                    <div text-center line-height-12>\n                      <ion-text text-black style=\"font-size: 18px\" text-bold\n                        >Totals</ion-text\n                      >\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center class=\"item-left-border\">\n                    <div>\n                      <div line-height-10>\n                        <ion-text color=\"medium\" font-size-12\n                          >Total Initial</ion-text\n                        >\n                      </div>\n                      <div>\n                        <ion-text text-black font-medium font-size-12\n                          >{{ order?.totalInitialQty }} Qty</ion-text\n                        >\n                      </div>\n                    </div>\n                    <div\n                      margin-top-5\n                      *ngIf=\"\n                        status(\n                          [\n                            'MATERIAL_PICKED',\n                            'MATERIAL_RECEIVED',\n                            'ORDER_COMPLETED'\n                          ],\n                          true\n                        )\n                      \"\n                    >\n                      <div line-height-10>\n                        <ion-text color=\"medium\" font-size-12\n                          >Total Picked</ion-text\n                        >\n                      </div>\n                      <div>\n                        <ion-text\n                          text-black\n                          color=\"primary\"\n                          font-medium\n                          font-size-12\n                          >{{ order?.totalPickedQty }} Qty</ion-text\n                        >\n                      </div>\n                    </div>\n                  </ion-col>\n                  <ion-col size=\"4\" align-self-center>\n                    <div class=\"order-total-section\">\n                      <div>\n                        <div line-height-10>\n                          <ion-text font-size-12 color=\"light\">Total</ion-text>\n                        </div>\n                        <div>\n                          <ion-text color=\"light\" font-medium font-size-12>{{\n                            order.totalAmount | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                      <div\n                        margin-top-5\n                        *ngIf=\"\n                          order?.gstOrder && status(['ORDER_COMPLETED'], true)\n                        \"\n                      >\n                        <div>\n                          <ion-text font-size-12 color=\"light\">GST</ion-text>\n                        </div>\n                        <div line-height-10>\n                          <ion-text color=\"light\" font-medium font-size-12>{{\n                            order.totalTax | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                      <div\n                        margin-top-5\n                        *ngIf=\"status(['ORDER_COMPLETED'], true)\"\n                      >\n                        <div>\n                          <ion-text font-size-12 color=\"light\"\n                            >Total Payable</ion-text\n                          >\n                        </div>\n                        <div line-height-10>\n                          <ion-text color=\"light\" font-medium font-size-12>{{\n                            order?.netAmount | currency: \"INR\"\n                          }}</ion-text>\n                        </div>\n                      </div>\n                    </div>\n                  </ion-col>\n                </ion-row>\n              </ion-grid>\n            </ion-card>\n            <div\n              text-center=\"\"\n              *ngIf=\"status(['ORDER_COMPLETED'], true) && order?.gstOrder\"\n            >\n              <ion-text\n                font-regular=\"\"\n                style=\"font-style: italic\"\n                [color]=\"'medium'\"\n                font-size-12=\"\"\n                >Note \u2022 Total Payable amount is inclusive of taxes\n              </ion-text>\n            </div>\n          </div>\n\n          <!--<ion-card no-padding no-box-shadow >\n                        <ion-grid no-padding=\"\">\n                            <ion-row no-padding=\"\" >\n                                <ion-col size=\"4\"  align-self-center >\n                                    <div text-center line-height-12 >\n                                        <ion-text text-black style=\"font-size:18px\" text-bold >Totals</ion-text>\n                                    </div>\n                                </ion-col>\n                                <ion-col size=\"4\" align-self-center class=\"item-left-border\">\n                                    <div>\n                                        <div line-height-10>\n                                            <ion-text color=\"medium\" font-size-12 >Total Initial</ion-text>\n                                        </div>\n                                        <div>\n                                            <ion-text text-black font-medium font-size-12>{{totalInitialQty}} Qty</ion-text>\n                                        </div>\n                                    </div>\n                                    <div margin-top-5 *ngIf=\"status(['MATERIAL_PICKED', 'MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true)\">\n                                        <div line-height-10>\n                                            <ion-text color=\"medium\" font-size-12 >Total Picked</ion-text>\n                                        </div>\n                                        <div>\n                                            <ion-text text-black color=\"primary\" font-medium font-size-12>{{  order.status === 'ORDER_COMPLETED' ? totalReceivedQty : totalPickedQty }} Qty</ion-text>\n                                        </div>\n                                    </div>\n                                </ion-col>\n                                <ion-col size=\"4\" align-self-center>\n                                    <div class=\"order-total-section\">\n                                        <div>\n                                            <div line-height-10>\n                                                <ion-text font-size-12 color=\"light\"  >Price to earn</ion-text>\n                                            </div>\n                                            <div>\n                                                <ion-text color=\"light\" font-medium font-size-12>{{ order.totalAmount | currency: 'INR'}}</ion-text>\n                                            </div>\n                                        </div>\n                                        <div margin-top-5=\"\">\n                                            <div line-height-10>\n                                                <ion-text font-size-12 color=\"light\"  >Price to pay</ion-text>\n                                            </div>\n                                            <div>\n                                                <ion-text color=\"light\" font-medium font-size-12>{{ order.totalEarnAmount | currency: 'INR'}}</ion-text>\n                                            </div>\n                                        </div>\n                                        <div margin-top-5 *ngIf=\"order?.gstOrder && status(['ORDER_COMPLETED'], true)\">\n                                            <div>\n                                                <ion-text font-size-12 color=\"light\" >GST</ion-text>\n                                            </div>\n                                            <div line-height-10>\n                                                <ion-text  color=\"light\" font-medium font-size-12>{{ order.totalTax | currency: 'INR'}}</ion-text>\n                                            </div>\n                                        </div>\n                                        <div margin-top-5 *ngIf=\"status(['ORDER_COMPLETED'], true)\">\n                                            <div>\n                                                <ion-text font-size-12 color=\"light\" >Total Payable</ion-text>\n                                            </div>\n                                            <div line-height-10>\n                                                <ion-text color=\"light\" font-medium font-size-12>{{ order?.netAmount | currency: 'INR'}}</ion-text>\n                                            </div>\n                                        </div>\n                                    </div>\n                                </ion-col>\n                            </ion-row>\n                        </ion-grid>\n                    </ion-card>-->\n\n          <ion-grid no-padding=\"\" *ngIf=\"order?.allowEdit\">\n            <ion-row>\n              <ion-col size=\"6\" no-padding-left>\n                <ion-button\n                  expand=\"block\"\n                  no-padding\n                  color=\"light\"\n                  (click)=\"loadTimeSlot()\"\n                  class=\"orderActionBtns\"\n                  font-medium\n                  text-black\n                >\n                  <ion-icon size=\"small\" name=\"time\"></ion-icon>&nbsp;Reschedule\n                </ion-button>\n              </ion-col>\n              <ion-col size=\"6\" no-padding-right>\n                <ion-button\n                  expand=\"block\"\n                  no-padding\n                  color=\"light\"\n                  (click)=\"openCancelPickupOrderDailog()\"\n                  class=\"orderActionBtns\"\n                  font-medium\n                  text-black\n                >\n                  <ion-icon name=\"close\" mode=\"ios\"></ion-icon>&nbsp;Cancel\n                  Order\n                </ion-button>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </div>\n\n        <a class=\"download-zip-link\" #downloadZipLink></a>\n        <!-- generator mobile view end -->\n      </div>\n    </div>\n    <div class=\"recykal-app\" *ngIf=\"!platform.is('mobile') && order\">\n      <ion-row>\n        <!--<ion-col size=\"12\">\n                    <ion-icon [src]=\"'./assets/paper.svg'\" style=\"font-size:18px;\" ></ion-icon>\n                    <ion-text font-bold=\"\" text-large=\"\">{{order?.formattedId}}</ion-text>\n                </ion-col>-->\n        <ion-col size=\"4\">\n          <ion-card\n            color=\"light\"\n            class=\"my-item ion-no-margin\"\n            style=\"height: 100%\"\n          >\n            <ion-grid class=\"ion-no-padding\">\n              <ion-row class=\"ion-padding-horizontal\">\n                <ion-col size=\"12\" style=\"padding-bottom: 0\">\n                  <ion-text color=\"medium\" class=\"label\"\n                    >Customer Details</ion-text\n                  >\n                </ion-col>\n                <ion-col size=\"12\">\n                  <ion-text\n                    class=\"text-medium font-bold\"\n                    font-bold\n                    color=\"dark\"\n                    >{{ order?.seller?.name }}</ion-text\n                  >\n                  <div style=\"line-height: 17px\" *ngIf=\"order?.fromLocation\">\n                    <ion-text\n                      [pTooltip]=\"order?.fromLocation?.addressInfo | address\"\n                      tooltipStyleClass=\"tooltip-bg-white\"\n                      color=\"medium\"\n                      class=\"text-regular address-box line-2\"\n                      margin-bottom\n                      >{{\n                        order?.fromLocation?.addressInfo | address\n                      }}</ion-text\n                    >\n                  </div>\n                </ion-col>\n                <ion-col size=\"12\">\n                  <ion-text color=\"dark\"\n                    >Partner name \u2022 {{ order?.buyer?.name }}</ion-text\n                  >\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-card>\n        </ion-col>\n        <ion-col size=\"4\">\n          <ion-card\n            color=\"light\"\n            class=\"my-item ion-no-margin\"\n            style=\"height: 100%\"\n          >\n            <ion-grid *ngIf=\"order\" class=\"ion-no-padding\">\n              <ion-row class=\"ion-padding-horizontal\">\n                <ion-col size=\"12\" *ngIf=\"order?.pickupPerson\">\n                  <ion-text color=\"medium\" class=\"label\">Pickup Person</ion-text\n                  ><br />\n                  <div class=\"person-details\">\n                    <ion-icon\n                      name=\"contact\"\n                      class=\"icon-padding\"\n                      color=\"dark\"\n                    ></ion-icon>\n                    <ion-text color=\"dark\" class=\"font-bold\" font-bold>{{\n                      order?.pickupPerson?.userName\n                    }}</ion-text>\n                  </div>\n                </ion-col>\n                <ion-col size=\"12\">\n                  <ion-text color=\"medium\" class=\"label\">Pickup Date</ion-text>\n                  <br />\n                  <ion-text color=\"dark\"\n                    >{{\n                      order?.timeSlot?.startTime\n                        | date: \"dd-MMM-yy hh:mm a\" || \"---\"\n                    }}\n                  </ion-text>\n                </ion-col>\n                <ion-col size=\"12\">\n                  <ion-text color=\"medium\" class=\"label\">Created on</ion-text>\n                  <br />\n                  <ion-text color=\"dark\">{{\n                    order?.createdDate | date: \"dd-MMM-yy hh:mm a\" || \"---\"\n                  }}</ion-text>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-card>\n        </ion-col>\n        <ion-col size=\"4\">\n          <ion-card\n            color=\"light\"\n            class=\"my-item ion-no-margin\"\n            style=\"height: 100%\"\n          >\n            <ion-grid *ngIf=\"order\" class=\"ion-no-padding\">\n              <ion-row class=\"ion-padding-horizontal parent-class\">\n                <ion-col>\n                  <ion-row\n                    [ngClass]=\"{ 'status-area': order?.status !== 'CANCELLED' }\"\n                  >\n                    <ion-col size=\"12\" class=\"ion-no-padding\">\n                      <ion-text color=\"medium\" class=\"label\">Status</ion-text>\n                    </ion-col>\n                    <ion-col size=\"12\" class=\"ion-no-padding status-icons\">\n                      <div>\n                        <ion-icon\n                          [src]=\"'./assets/MATERIAL_RECEIVED.svg'\"\n                          *ngIf=\"\n                            order?.saleOrder &&\n                            order?.status === 'PICKUP_SCHEDULED'\n                          \"\n                        ></ion-icon>\n                        <ion-icon\n                          [src]=\"'./assets/REJECTED.svg'\"\n                          *ngIf=\"\n                            order?.payment?.orderPaymentStatus ===\n                              'INVOICE_REJECTED' &&\n                            order?.status === 'ORDER_COMPLETED'\n                          \"\n                        ></ion-icon>\n                        <ion-icon\n                          [src]=\"'./assets/INVOICE_PENDING.svg'\"\n                          *ngIf=\"\n                            order?.payment?.orderPaymentStatus ===\n                              'INVOICE_VERIFICATION_PENDING' &&\n                            order?.status === 'ORDER_COMPLETED'\n                          \"\n                        ></ion-icon>\n                        <ion-icon\n                          [src]=\"'./assets/' + order?.status + '.svg'\"\n                          [ngClass]=\"{\n                            'reject-icon': order?.status === 'CANCELLED'\n                          }\"\n                          *ngIf=\"\n                            order?.status !== 'ORDER_COMPLETED' &&\n                            order?.status != 'HOLD' &&\n                            order?.status != 'AWAITING_PICKUP_CONFIRMATION'\n                          \"\n                        ></ion-icon>\n                        <ion-icon\n                          [src]=\"\n                            './assets/' +\n                            order?.payment?.orderPaymentStatus +\n                            '.svg'\n                          \"\n                          *ngIf=\"\n                            order?.payment?.orderPaymentStatus !==\n                              'INVOICE_REJECTED' &&\n                            order?.status === 'ORDER_COMPLETED' &&\n                            order?.payment?.orderPaymentStatus !==\n                              'INVOICE_VERIFICATION_PENDING'\n                          \"\n                        ></ion-icon>\n                        <ion-text\n                          class=\"status\"\n                          color=\"dark\"\n                          *ngIf=\"\n                            order?.status !== 'ORDER_COMPLETED' &&\n                            order?.status !== 'AWAITING_PICKUP_CONFIRMATION'\n                          \"\n                          >{{ order?.displayStatusTitle }}</ion-text\n                        >\n                        <ion-text\n                          class=\"status\"\n                          color=\"dark\"\n                          *ngIf=\"\n                            order?.status !== 'ORDER_COMPLETED' &&\n                            order?.status === 'AWAITING_PICKUP_CONFIRMATION'\n                          \"\n                          >{{ order?.statusTitle }}</ion-text\n                        >\n                        <ion-text\n                          class=\"status ion-text-capitalize\"\n                          color=\"dark\"\n                          *ngIf=\"order?.status === 'ORDER_COMPLETED'\"\n                          >{{ order?.payment?.statusTitle }}\n                        </ion-text>\n                      </div>\n                      <br />\n                      <ion-text\n                        color=\"medium\"\n                        text-regular=\"\"\n                        class=\"ion-text-capitalize\"\n                      >\n                        <span *ngIf=\"order.status === 'CREATED'\"\n                          >Your request is being processed</span\n                        >\n                        <span\n                          font-size-12=\"\"\n                          *ngIf=\"order.status === 'PICKUP_SCHEDULED'\"\n                          >Pickup executive assigned</span\n                        >\n                        <span\n                          font-size-12=\"\"\n                          *ngIf=\"order.status === 'MATERIAL_PICKED'\"\n                          >Materials have been picked by our executive.</span\n                        >\n                        <span\n                          font-size-12=\"\"\n                          *ngIf=\"\n                            order.status === 'ORDER_COMPLETED' &&\n                            order?.payment?.orderPaymentStatus ===\n                              'INVOICE_PENDING'\n                          \"\n                          >Upload your invoice to get the payment\n                          processed</span\n                        >\n                        <span\n                          font-size-12=\"\"\n                          color=\"medium\"\n                          text-small\n                          font-bold\n                          class=\"ion-text-uppercase label\"\n                          *ngIf=\"\n                            order?.status === 'ORDER_COMPLETED' &&\n                            order?.payment?.orderPaymentStatus ===\n                              'INVOICE_REJECTED'\n                          \"\n                          >Reason</span\n                        >\n                        <br />\n                        <span\n                          font-size-12=\"\"\n                          *ngIf=\"\n                            order?.status === 'ORDER_COMPLETED' &&\n                            order?.payment?.orderPaymentStatus ===\n                              'INVOICE_REJECTED'\n                          \"\n                          >{{ invoiceRejectedObj?.comment }}</span\n                        >\n                        <span\n                          font-size-12=\"\"\n                          color=\"medium\"\n                          text-small\n                          font-bold\n                          class=\"ion-text-uppercase label\"\n                          *ngIf=\"\n                            order?.status === 'CANCELLED' ||\n                            order?.status === 'HOLD'\n                          \"\n                          >Reason</span\n                        >\n                        <br />\n                        <span\n                          font-size-12=\"\"\n                          *ngIf=\"\n                            order?.status === 'CANCELLED' ||\n                            order?.status === 'HOLD'\n                          \"\n                          >{{ order?.rejectionReason }}</span\n                        >\n                      </ion-text>\n                    </ion-col>\n                  </ion-row>\n                  <ion-row margin-top *ngIf=\"order?.allowEdit\">\n                    <!--   Quick Actions   -->\n                    <ion-col size=\"12\" class=\"ion-no-padding quick-actions\">\n                      <ion-text color=\"medium\" class=\"label\"\n                        >Quick Actions</ion-text\n                      >\n                      <div>\n                        <ion-button\n                          class=\"ion-text-uppercase status-btn\"\n                          [color]=\"'medium'\"\n                          (click)=\"loadTimeSlot()\"\n                        >\n                          <ion-icon\n                            name=\"refresh\"\n                            color=\"light\"\n                            class=\"ion-float-left icon-padding\"\n                          ></ion-icon>\n                          Reschedule</ion-button\n                        >\n                        <ion-button\n                          [color]=\"'danger'\"\n                          (click)=\"openCancelPickupOrderDailog()\"\n                          class=\"status-btn ion-text-uppercase\"\n                        >\n                          <ion-icon\n                            name=\"close\"\n                            color=\"light\"\n                            class=\"ion-float-left icon-padding\"\n                          ></ion-icon>\n                          CANCEL\n                        </ion-button>\n                      </div>\n                    </ion-col>\n                  </ion-row>\n                </ion-col>\n              </ion-row>\n            </ion-grid>\n          </ion-card>\n        </ion-col>\n      </ion-row>\n      <ion-row>\n        <!--  desktop order items -->\n        <ion-col size=\"12\">\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title ion-margin-end\"\n              >Item Details</ion-text\n            >\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"12\">\n          <rcyl-item-details\n            [selectOrder]=\"order\"\n            [channel]=\"orderConfig?.channel\"\n            (itemUpdated)=\"onItemChanged($event)\"\n          ></rcyl-item-details>\n        </ion-col>\n        <!--  desktop order summary -->\n        <ion-col size=\"12\">\n          <ion-grid no-padding>\n            <ion-row no-padding>\n              <ion-col size=\"12\" no-padding>\n                <ion-card\n                  color=\"light\"\n                  class=\"ion-no-margin\"\n                  style=\"box-shadow: none; background: #f4f9fa\"\n                >\n                  <ion-grid>\n                    <ion-row>\n                      <ion-col\n                        size=\"8\"\n                        no-padding-bottom\n                        *ngIf=\"order?.totalEarnAmount > 0\"\n                      >\n                        <ion-text font-size-12 color=\"medium\"\n                          >Amount you earn</ion-text\n                        >\n                      </ion-col>\n                      <ion-col\n                        size=\"4\"\n                        text-end\n                        no-padding-bottom\n                        *ngIf=\"order?.totalEarnAmount > 0\"\n                      >\n                        <ion-text font-size-12 color=\"primary\">\n                          {{ order.totalAmount | currency: \"INR\"\n                          }}<span *ngIf=\"!status(['ORDER_COMPLETED'], true)\"\n                            >*</span\n                          >\n                        </ion-text>\n                      </ion-col>\n                      <ion-col size=\"8\" *ngIf=\"order?.totalEarnAmount > 0\">\n                        <ion-text font-size-12 color=\"medium\"\n                          >Service fee you pay</ion-text\n                        >\n                      </ion-col>\n                      <ion-col\n                        size=\"4\"\n                        text-end\n                        *ngIf=\"order?.totalEarnAmount > 0\"\n                      >\n                        (-)\n                        <ion-text font-size-12 color=\"danger\">\n                          {{ order.totalEarnAmount | currency: \"INR\"\n                          }}<span *ngIf=\"!status(['ORDER_COMPLETED'], true)\"\n                            >*</span\n                          >\n                        </ion-text>\n                      </ion-col>\n                    </ion-row>\n                    <ion-row *ngIf=\"!status(['ORDER_COMPLETED'], true)\">\n                      <ion-col size=\"8\">\n                        <ion-text font-size-12 color=\"medium\">\n                          <span *ngIf=\"order.totalAmountOfExclTax >= 0\"\n                            >Estimated final amount that you earn</span\n                          >\n                          <span *ngIf=\"order.totalAmountOfExclTax < 0\"\n                            >Estimated final amount that you pay</span\n                          >\n                        </ion-text>\n                      </ion-col>\n                      <ion-col size=\"4\" text-end>\n                        <ion-text\n                          font-size-12\n                          [color]=\"\n                            order.totalAmountOfExclTax >= 0\n                              ? 'primary'\n                              : 'danger'\n                          \"\n                        >\n                          {{\n                            getAbs(order.totalAmountOfExclTax)\n                              | currency: \"INR\"\n                          }}*\n                        </ion-text>\n                      </ion-col>\n                      <ion-col size=\"12\">\n                        <ion-text font-size-12\n                          ><i>*All rates exclusive of GST</i></ion-text\n                        >\n                      </ion-col>\n                    </ion-row>\n\n                    <ion-row *ngIf=\"status(['ORDER_COMPLETED'], true)\">\n                      <ion-col size=\"8\">\n                        <ion-text font-size-12 color=\"medium\">\n                          GST Applicable\n                        </ion-text>\n                      </ion-col>\n                      <ion-col size=\"4\" text-end>\n                        <span *ngIf=\"order?.totalOfAllTaxes < 0\">(-) </span>\n                        <ion-text\n                          font-size-12\n                          [color]=\"\n                            order?.totalOfAllTaxes >= 0 ? 'primary' : 'danger'\n                          \"\n                        >\n                          {{ getAbs(order?.totalOfAllTaxes) | currency: \"INR\" }}\n                        </ion-text>\n                      </ion-col>\n                    </ion-row>\n                    <ion-row *ngIf=\"status(['ORDER_COMPLETED'], true)\">\n                      <ion-col size=\"8\">\n                        <ion-text font-size-12 color=\"medium\">\n                          <span *ngIf=\"order?.tradeType === 'B'\"\n                            >Net amount that you earn</span\n                          >\n                          <span *ngIf=\"order?.tradeType === 'S'\"\n                            >Net amount that you pay</span\n                          >\n                        </ion-text>\n                      </ion-col>\n                      <ion-col size=\"4\" text-end>\n                        <ion-text\n                          font-size-12\n                          [color]=\"\n                            order?.tradeType === 'B' ? 'primary' : 'danger'\n                          \"\n                          font-bold=\"\"\n                        >\n                          {{ order.netAmount | currency: \"INR\" }}*\n                        </ion-text>\n                      </ion-col>\n                      <ion-col size=\"12\">\n                        <ion-text font-size-12\n                          ><i>*Net amount is inclusive of taxes</i></ion-text\n                        >\n                      </ion-col>\n                    </ion-row>\n                  </ion-grid>\n                </ion-card>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </ion-col>\n        <!--  desktop order documents  -->\n        <ion-col\n          size=\"12\"\n          *ngIf=\"\n            order?.status === 'ORDER_COMPLETED' || order?.documents?.length > 0\n          \"\n        >\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title\"\n              >View/Upload Supporting Documents</ion-text\n            >\n          </ion-item>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          class=\"col-position\"\n          *ngIf=\"\n            (order?.orderType === 'DROP' &&\n              order?.status === 'PICKUP_SCHEDULED') ||\n            order?.status === 'ORDER_COMPLETED' ||\n            order?.documents?.length > 0\n          \"\n        >\n          <ion-grid>\n            <ion-row>\n              <ion-col\n                size=\"auto\"\n                *ngFor=\"\n                  let orderTypeData of orderDocumentsMap\n                    | rcylFilter: 'showInList':true\n                    | rcylKeys\n                \"\n              >\n                <ion-chip\n                  [outline]=\"true\"\n                  [ngClass]=\"\n                    orderTypeData?.val?.documents?.length > 0\n                      ? 'docs-chip'\n                      : 'no-docs-chip'\n                  \"\n                  (click)=\"addDocuments(orderTypeData?.key)\"\n                >\n                  <ion-icon [src]=\"orderTypeData?.val?.icon\"></ion-icon>\n                  <ion-text\n                    text-wrap\n                    [color]=\"\n                      orderTypeData?.val?.documents?.length > 0\n                        ? 'primary'\n                        : 'medium'\n                    \"\n                    class=\"text-regular text-flex\"\n                  >\n                    {{ orderTypeData?.val?.displayText }}\n                  </ion-text>\n                  <div\n                    color=\"primary\"\n                    *ngIf=\"orderTypeData?.val?.documents?.length > 0\"\n                  >\n                    <ion-text class=\"text-regular\" color=\"light\">{{\n                      orderTypeData?.val?.documents?.length\n                    }}</ion-text>\n                  </div>\n                </ion-chip>\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </ion-col>\n\n        <!-- payment summary-->\n        <ion-col\n          size=\"12\"\n          *ngIf=\"\n            order?.payment?.orderPaymentStatus === 'COMPLETED' &&\n            order?.status === 'ORDER_COMPLETED'\n          \"\n        >\n          <ion-item lines=\"none\">\n            <ion-text class=\"section-title ion-margin-end\"\n              >Payment Summary</ion-text\n            >\n          </ion-item>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          *ngIf=\"\n            order?.payment?.orderPaymentStatus === 'COMPLETED' &&\n            order?.status === 'ORDER_COMPLETED'\n          \"\n        >\n          <rcyl-payment-summary\n            [channel]=\"orderConfig?.channel\"\n            [selectOrder]=\"order\"\n          ></rcyl-payment-summary>\n        </ion-col>\n      </ion-row>\n    </div>\n  </ng-template>\n</div>\n",
                    styles: [".rcyl-order-status-created{background-color:#72abea;--background:#72abea}.rcyl-order-status-scheduled{background-color:#ffa25f;--background:#ffa25f}.rcyl-order-status-on-hold{background-color:#ffd378;--background:#ffd378}.rcyl-order-status-picked{background-color:#bee2c6;--background:#bee2c6;color:rgba(0,0,0,.8);--color:rgba(0, 0, 0, 0.8)}.rcyl-order-status-received{background-color:#89cb97;--background:#89cb97}.rcyl-order-status-completed{background-color:#54b468;--background:#54b468}.rcyl-order-status-invoice-pending{background-color:#ffef8c;--background:#ffef8c;color:rgba(0,0,0,.7);--color:rgba(0, 0, 0, 0.7)}.rcyl-order-status-payment-pending{background-color:#fcd974;--background:#fcd974}.rcyl-order-status-invoice-verification-pending{background-color:#fbc45b;--background:#fbc45b}.rcyl-order-status-invoice-rejected{background-color:#ff7a5f;--background:#ff7a5f}.rcyl-order-status-rejected{background-color:#ff5545;--background:#ff5545}.rcyl-order-status-cancelled{background-color:#f2503b;--background:#f2503b}::ng-deep .full-width-modal .modal-wrapper{--width:100vw;width:100vw;--height:100vh;height:100vh;--max-width:100vw;max-width:100vw;max-height:100vh;--max-height:100vh;--background:transparent}:host .status-section{--border-radius:6px!important;--min-height:34px}:host .section-title{line-height:20px;font-family:font-medium;font-size:var(--ion-medium-font-size)}:host ion-text-center.sc-ion-label-md-h.sc-ion-label-md-s{margin:0!important;padding-top:15px!important}:host .item ion-button ion-text{font-size:.8571rem;padding-left:5px}:host .recykal-app .non-market-order ion-badge{letter-spacing:1.3px}:host .recykal-app .non-market-order .partner-name{color:var(--ion-color-primary);line-height:1.231rem;text-transform:uppercase;font-size:.9231rem;margin-top:6px}:host .recykal-app .non-market-order .partner-name span{font-family:\"Font Regular\";line-height:.7692rem;letter-spacing:2.4px;text-align:center}:host .recykal-app .non-market-order .partner-name ion-text{font-family:\"Font Bold\";color:var(--ion-color-primary)!important}:host .recykal-app .non-market-order .cancel-modal .modal-wrapper.sc-ion-modal-md{max-height:60%!important}:host .recykal-app .non-market-order .box{margin-top:20px;margin-bottom:20px}:host .recykal-app .non-market-order .box ion-item{--min-height:38px}:host .recykal-app .non-market-order .box.box-bordered{border:1px solid #dcdcdc}:host .recykal-app .non-market-order .box .box-header{padding:10px}:host .recykal-app .non-market-order .box .box-header.box-header-bordered{border-bottom:1px solid #dcdcdc}:host .recykal-app .non-market-order .mobile-view .transportation-and-vehicle-details ::ng-deep ion-card{border-radius:10px}:host .recykal-app .non-market-order .mobile-view .transportation-and-vehicle-details ::ng-deep ion-card .card-title ion-text[color=dark]{text-transform:capitalize;letter-spacing:0}:host .recykal-app .non-market-order .mobile-view .transportation-and-vehicle-details ::ng-deep ion-card .info-label{font-size:12px}:host .recykal-app .non-market-order .mobile-view .transportation-and-vehicle-details ::ng-deep ion-card .info{font-size:14px}:host .recykal-app .non-market-order .mobile-view ion-card{border-radius:10px;margin:10px 0}:host .recykal-app .non-market-order .mobile-view [font-size-9]{font-size:9px!important}:host .recykal-app .non-market-order .mobile-view [font-size-10]{font-size:10px!important}:host .recykal-app .non-market-order .mobile-view [font-size-12]{font-size:12px!important}:host .recykal-app .non-market-order .mobile-view [font-size-13]{font-size:13px!important}:host .recykal-app .non-market-order .mobile-view [font-size-14]{font-size:14px!important}:host .recykal-app .non-market-order .mobile-view [font-size-16]{font-size:16px!important}:host .recykal-app .non-market-order .mobile-view [text-bold]{font-weight:700!important}:host .recykal-app .non-market-order .mobile-view [text-black]{color:#27353c!important}:host .recykal-app .non-market-order .mobile-view [line-height-10]{line-height:10px!important}:host .recykal-app .non-market-order .mobile-view [line-height-12]{line-height:12px!important}:host .recykal-app .non-market-order .mobile-view [line-height-14]{line-height:14px!important}:host .recykal-app .non-market-order .mobile-view .statusLabel ion-badge{padding:0 10px;line-height:22px;display:-webkit-inline-box;height:20px}:host .recykal-app .non-market-order .mobile-view .orderActionBtns{--ion-color-base:#ffffff!important;font-size:1.077rem;--border-radius:10px!important}:host .recykal-app .non-market-order .mobile-view .summary-title{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;margin:5px 0}:host .recykal-app .non-market-order .mobile-view .summary-title:before{content:\"\";-webkit-box-flex:1;flex:1 1;border-bottom:1px solid #ddd;margin:auto 5px auto 0}:host .recykal-app .non-market-order .mobile-view .summary-title:after{content:\"\";-webkit-box-flex:1;flex:1 1;border-bottom:1px solid #ddd;margin:auto 0 auto 5px}:host .recykal-app .non-market-order .mobile-view .summary-title span{letter-spacing:1px;font-weight:700}:host .recykal-app .non-market-order .mobile-view .item-total-section{background:#f4f5f8;border-radius:5px;padding:5px}:host .recykal-app .non-market-order .mobile-view .order-total-section{background:#4e6771;border-radius:5px;padding:5px}:host .recykal-app .non-market-order .mobile-view .item-left-border{border-left:1px solid #ececec}:host .recykal-app .non-market-order .mobile-view [margin-top-5]{margin-top:5px}:host .recykal-app .non-market-order .bottom-sheet ion-modal.manager-sheet ion-backdrop{visibility:visible!important;z-index:0}:host .recykal-app .non-market-order .bottom-sheet .modal-wrapper{bottom:0;width:100%;max-width:500px;min-height:398px;position:absolute;border-radius:20px 20px 0 0!important;height:auto}:host .recykal-app .rotate-45{-webkit-transform:rotate(45deg);transform:rotate(45deg)}:host .recykal-app .col-position{margin-top:-10px}:host .recykal-app ion-card.my-item{min-height:150px}:host .recykal-app ion-card.my-item .label{font-size:var(--ion-small-font-size);font-family:Font Bold;letter-spacing:.5px;text-transform:uppercase}:host .recykal-app ion-card.my-item ion-row.add-class{border-left:1px solid #dcdcdc;padding-left:10px}:host .recykal-app ion-card.my-item ion-row.parent-class{align-content:baseline;-webkit-box-align:center;align-items:center}:host .recykal-app ion-card.my-item .text-medium ion-row{margin-bottom:10px}:host .recykal-app ion-card.my-item ion-card.my-item ion-row.add-class{border-left:2px solid rgba(199,210,216,.5)!important}:host .recykal-app ion-card.my-item .status-area{margin-bottom:20px!important}:host .recykal-app ion-card.my-item .status-area ion-text.status{font-size:1.357rem!important;font-family:Font Bold}:host .recykal-app ion-card.my-item .status-area .status-icons{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;padding-left:0}:host .recykal-app ion-card.my-item .status-area .status-icons ion-icon{margin-right:3px;font-size:1.629rem;vertical-align:sub}:host .recykal-app ion-card.my-item .status-btn{--padding-start:10px;--padding-end:10px}:host .recykal-app ion-card.my-item .status-btn ion-icon{padding-right:3px;font-size:1rem}:host .recykal-app ion-card.my-item .reject-icon{font-size:20px;margin-bottom:-4px}:host .recykal-app ion-card.my-item .icon-padding{padding-right:2px}:host .recykal-app .address-box{max-width:200px;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}:host .recykal-app .address-box.line-1{-webkit-line-clamp:1}:host .recykal-app .address-box.line-2{-webkit-line-clamp:2}:host .recykal-app .address-box.line-3{-webkit-line-clamp:3}:host .recykal-app .icon-padding{font-size:12px;padding-top:1px;padding-right:5px}:host .recykal-app .person-details{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}:host .recykal-app .person-details ion-button{height:18px;font-size:10px;letter-spacing:1px}:host .recykal-app .section-title{line-height:20px;font-family:Font Bold;font-size:var(--ion-medium-font-size)}:host .recykal-app .docs-chip{border:1px solid var(--ion-color-primary)}:host .recykal-app .docs-chip ion-icon{color:var(--ion-color-primary);font-size:24px}:host .recykal-app .docs-chip ion-text{font-family:Font Bold}:host .recykal-app .docs-chip div{margin-left:5px;position:relative;background-color:var(--ion-color-primary);width:18px;height:18px;border-radius:50%;line-height:18px;text-align:center}:host .recykal-app .text-flex{-webkit-box-flex:1;flex:1}:host .recykal-app .no-docs-chip{border:1px solid var(--ion-color-medium);opacity:.6}:host .recykal-app .no-docs-chip ion-icon{font-size:22px;-webkit-filter:grayscale(100%);filter:grayscale(100%)}:host .recykal-app .icon-size{font-size:18px}:host .cursor-pointer{cursor:pointer}.icon-size{font-size:18px}::ng-deep .custom-bottom-sheet{--height:auto}::ng-deep .custom-bottom-sheet.bottom{-webkit-box-align:end;align-items:flex-end}::ng-deep .custom-bottom-sheet .modal-wrapper{bottom:0;position:absolute;border-radius:10px 10px 0 0}::ng-deep .custom-bottom-sheet .ion-page{position:relative;display:block;contain:content}::ng-deep .custom-bottom-sheet .ion-page .inner-content{max-height:80vh;overflow:auto;padding:0 10px}.docs-chip{border:1px solid var(--ion-color-primary)}.docs-chip ion-icon{color:var(--ion-color-primary);font-size:24px}.docs-chip ion-text{font-family:font-bold}.docs-chip div{margin-left:5px;position:relative;background-color:var(--ion-color-primary);width:18px;height:18px;border-radius:50%;line-height:18px;text-align:center}.text-flex{-webkit-box-flex:1;flex:1}.no-docs-chip{border:1px solid var(--ion-color-medium);opacity:.6}.no-docs-chip ion-icon{font-size:22px;-webkit-filter:grayscale(100%);filter:grayscale(100%)}.col-position{margin-top:-10px}"]
                }] }
    ];
    /** @nocollapse */
    RcylOrderDetailsComponent.ctorParameters = function () { return [
        { type: RcylOrderDetailsService },
        { type: RcylOrdersService },
        { type: HttpClient },
        { type: Events },
        { type: RcylOrderConfigService },
        { type: ModalController },
        { type: LoadingController },
        { type: RcylFileManagerService },
        { type: RcylOrderLogisticsService },
        { type: Platform },
        { type: AlertController },
        { type: OrderListService },
        { type: Location },
        { type: ToastController }
    ]; };
    RcylOrderDetailsComponent.propDecorators = {
        orderId: [{ type: Input }],
        config: [{ type: Input }],
        componentConfig: [{ type: Input }],
        showInvoice: [{ type: Output }],
        openFileUrl: [{ type: Output }],
        selectAndUploadImgDocument: [{ type: Output }],
        downloadDocument: [{ type: Output }],
        downloadProformaInvoice: [{ type: Output }]
    };
    return RcylOrderDetailsComponent;
}());
if (false) {
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.itemDetails;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.selectedOrder;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.notesSubscription;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.showStatusFlow;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.transportFlowToggle;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.driverFlowToggle;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.order;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.statusFlow;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.invoiceRejectedObj;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.getNotes;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.totalInitialQty;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.totalReceivedQty;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.totalPickedQty;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.configData;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.displayAddNewNote;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.timeSlots;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.ifPickedState;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.orderDocuments;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.orderDocumentsMap;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.orderDocumentTypes;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.orderLogisticsDetails;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.orderId;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.config;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.componentConfig;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.showInvoice;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.openFileUrl;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.selectAndUploadImgDocument;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.downloadDocument;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.downloadProformaInvoice;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.orderLogisticsDetailsSubscription;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.openFileUrlCallback;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.orderService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.rcylOrdersService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.http;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.events;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.orderConfig;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.loadingCtrl;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.fileManagerService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.orderLogisticsService;
    /** @type {?} */
    RcylOrderDetailsComponent.prototype.platform;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.alertController;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.orderListService;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.location;
    /**
     * @type {?}
     * @private
     */
    RcylOrderDetailsComponent.prototype.toast;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CustomerDetailsComponent = /** @class */ (function () {
    function CustomerDetailsComponent() {
    }
    /**
     * @return {?}
     */
    CustomerDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    CustomerDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-customer-details",
                    template: "<ion-card color=\"light\" class=\"my-item ion-no-margin\">\n  <ion-grid class=\"ion-no-padding\">\n    <ion-row class=\"ion-padding-horizontal\">\n      <ion-col size=\"12\" style=\"padding-bottom: 0\">\n        <ion-text color=\"medium\" class=\"label\">Customer Details</ion-text>\n      </ion-col>\n      <ion-col size=\"12\">\n        <ion-text class=\"text-medium font-bold\" color=\"dark\">{{\n          customer?.name\n        }}</ion-text>\n        <div style=\"line-height: 17px\" *ngIf=\"location\">\n          <ion-text\n            [pTooltip]=\"location?.addressInfo | address\"\n            tooltipStyleClass=\"tooltip-bg-white\"\n            color=\"medium\"\n            class=\"text-regular address-box line-2\"\n            margin-bottom\n            >{{ location?.addressInfo | address }}</ion-text\n          >\n        </div>\n      </ion-col>\n      <ion-col size=\"12\" class=\"text-medium\">\n        <ion-row class=\"ion-align-items-center\">\n          <ion-icon\n            [src]=\"'./assets/call-icon.svg'\"\n            color=\"dark\"\n            class=\"ion-float-left icon-padding\"\n          ></ion-icon>\n          <ion-text color=\"dark\" text-medium=\"\">{{\n            saleOrder\n              ? customer?.mobile\n              : orderType === \"PICKUP\"\n              ? customer?.contactNumber\n              : customer?.mobile\n          }}</ion-text>\n        </ion-row>\n        <ion-row class=\"ion-align-items-center\" *ngIf=\"customer?.email\">\n          <ion-icon\n            [src]=\"'./assets/email_icon.svg'\"\n            color=\"dark\"\n            class=\"ion-float-left icon-padding\"\n          ></ion-icon>\n          <ion-text color=\"dark\" text-medium>{{ customer?.email }}</ion-text>\n        </ion-row>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-card>\n",
                    styles: [".icon-padding{font-size:12px;padding-top:1px;padding-right:5px}ion-card.my-item{min-height:150px}ion-card.my-item .label{font-size:var(--ion-small-font-size);font-family:font-bold;letter-spacing:.5px;text-transform:uppercase}.address-box{max-width:200px;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.address-box.line-1{-webkit-line-clamp:1}.address-box.line-2{-webkit-line-clamp:2}.address-box.line-3{-webkit-line-clamp:3}"]
                }] }
    ];
    /** @nocollapse */
    CustomerDetailsComponent.ctorParameters = function () { return []; };
    CustomerDetailsComponent.propDecorators = {
        orderType: [{ type: Input }],
        customer: [{ type: Input }],
        location: [{ type: Input }],
        saleOrder: [{ type: Input }]
    };
    return CustomerDetailsComponent;
}());
if (false) {
    /** @type {?} */
    CustomerDetailsComponent.prototype.orderType;
    /** @type {?} */
    CustomerDetailsComponent.prototype.customer;
    /** @type {?} */
    CustomerDetailsComponent.prototype.location;
    /** @type {?} */
    CustomerDetailsComponent.prototype.saleOrder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PickupDetailsComponent = /** @class */ (function () {
    function PickupDetailsComponent(modalCtrl, router, orderService) {
        this.modalCtrl = modalCtrl;
        this.router = router;
        this.orderService = orderService;
        this.changeExecutive = new EventEmitter();
    }
    /**
     * @return {?}
     */
    PickupDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    PickupDetailsComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.selectedOrderDate = new Date(this.selectOrder.orderDate);
        this.maxDateValue = new Date();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    PickupDetailsComponent.prototype.openCalendar = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        var _this = this;
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.calendar.showOverlay();
            event.stopPropagation();
        }), 50);
    };
    /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    PickupDetailsComponent.prototype.statusFilter = /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    function (statuses, In) {
        /** @type {?} */
        var isPresent = indexOf(statuses, this.selectOrder.status) >= 0;
        return In ? isPresent : !isPresent;
    };
    /**
     * @return {?}
     */
    PickupDetailsComponent.prototype.selectPickupExecutive = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.selectedPickupPerson = this.selectOrder.pickupPerson;
                        return [4 /*yield*/, this.modalCtrl.create({
                                component: SelectPickupExecutiveComponent,
                                componentProps: {
                                    orderId: this.selectOrder.id,
                                    selectedPickupPersonId: this.selectedPickupPerson.id,
                                },
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            if (data && data.data) {
                                _this.changeExecutive.emit(data.data);
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    PickupDetailsComponent.prototype.updateOrderDate = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderService.updateOrder(this.selectOrder).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.selectOrder = __assign({}, result);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) { }));
    };
    /**
     * @return {?}
     */
    PickupDetailsComponent.prototype.onSelectCal = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.selectOrder.isEdit = false;
        this.selectOrder.orderDate = this.selectedOrderDate.toISOString();
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.updateOrderDate();
        }), 500);
    };
    PickupDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-pickup-details",
                    template: "<ion-card color=\"light\" class=\"my-item ion-no-margin\">\n  <ion-grid *ngIf=\"selectOrder\" class=\"ion-no-padding\">\n    <ion-row class=\"ion-padding-horizontal\">\n      <ion-col size=\"12\" *ngIf=\"selectOrder?.pickupPerson\">\n        <ion-text color=\"medium\" class=\"label\">Pickup Person</ion-text><br />\n        <div class=\"person-details\">\n          <ion-icon name=\"contact\" class=\"icon-padding\" color=\"dark\"></ion-icon>\n          <ion-text color=\"dark\" class=\"font-bold\">{{\n            selectOrder?.pickupPerson?.userName\n          }}</ion-text>\n          <ion-button\n            size=\"small\"\n            color=\"medium\"\n            *ngIf=\"\n              selectOrder?.orderType !== 'DROP' &&\n              statusFilter(['CREATED', 'PICKUP_SCHEDULED'], true)\n            \"\n          >\n            <ion-text\n              class=\"ion-text-uppercase\"\n              color=\"light\"\n              (click)=\"selectPickupExecutive()\"\n              >Change</ion-text\n            >\n          </ion-button>\n        </div>\n      </ion-col>\n      <ion-col size=\"12\" *ngIf=\"!selectOrder?.saleOrder\">\n        <ion-text\n          color=\"medium\"\n          class=\"label\"\n          *ngIf=\"!selectOrder?.saleOrder && selectOrder?.orderType === 'PICKUP'\"\n          >pickup date</ion-text\n        >\n        <ion-text\n          color=\"medium\"\n          class=\"label\"\n          *ngIf=\"!selectOrder?.saleOrder && selectOrder?.orderType === 'DROP'\"\n          >drop date</ion-text\n        >\n        <br />\n        <ion-text\n          color=\"dark\"\n          *ngIf=\"!selectOrder?.saleOrder && selectOrder?.orderType === 'PICKUP'\"\n          >{{\n            selectOrder?.timeSlot?.startTime\n              | date: \"dd-MMM-yy hh:mm a\" || \"---\"\n          }}\n        </ion-text>\n        <ion-text\n          color=\"dark\"\n          *ngIf=\"\n            !selectOrder.isEdit &&\n            !selectOrder?.saleOrder &&\n            selectOrder?.orderType === 'DROP'\n          \"\n          >{{ selectOrder?.orderDate | date: \"dd-MMM-yy hh:mm a\" || \"---\" }}\n        </ion-text>\n        <ion-icon\n          *ngIf=\"\n            !selectOrder.isEdit &&\n            selectOrder.orderType === 'DROP' &&\n            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED'\n          \"\n          color=\"dark\"\n          name=\"create\"\n          class=\"icon-size cursor-pointer\"\n          (click)=\"selectOrder.isEdit = true; openCalendar($event)\"\n        ></ion-icon>\n        <p-calendar\n          #calendar\n          [hidden]=\"!selectOrder.isEdit\"\n          [(ngModel)]=\"selectedOrderDate\"\n          [maxDate]=\"maxDateValue\"\n          [readonlyInput]=\"true\"\n          (onSelect)=\"onSelectCal()\"\n          (onClose)=\"selectOrder.isEdit = false\"\n          appendTo=\"body\"\n        ></p-calendar>\n      </ion-col>\n      <ion-col size=\"12\">\n        <ion-text color=\"medium\" class=\"ion-text-uppercase text-small font-bold\"\n          >order created on</ion-text\n        >\n        <br />\n        <ion-text color=\"dark\">{{\n          selectOrder?.createdDate | date: \"dd-MMM-yy hh:mm a\" || \"---\"\n        }}</ion-text>\n      </ion-col>\n      <ion-col size=\"12\" *ngIf=\"selectOrder?.saleOrder\">\n        <ion-text color=\"medium\" class=\"ion-text-uppercase text-small font-bold\"\n          >dispatched location from</ion-text\n        >\n        <br />\n        <ion-text\n          color=\"dark\"\n          [title]=\"selectOrder?.fromLocation?.addressInfo | address\"\n          class=\"text-regular address-box line-2\"\n          >{{ selectOrder?.fromLocation?.addressInfo | address }}</ion-text\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-card>\n",
                    styles: [".icon-padding{font-size:17px;padding-top:1px;padding-right:5px}ion-card.my-item{min-height:150px}ion-card.my-item ion-col{padding:4px}ion-card.my-item .label{font-size:var(--ion-small-font-size);font-family:font-bold;letter-spacing:.5px;text-transform:uppercase}.person-details{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center}.person-details ion-button{height:18px;font-size:10px;letter-spacing:1px}:host .cursor-pointer{cursor:pointer!important}"]
                }] }
    ];
    /** @nocollapse */
    PickupDetailsComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: Router },
        { type: RcylOrderDetailsService }
    ]; };
    PickupDetailsComponent.propDecorators = {
        selectOrder: [{ type: Input }],
        changeExecutive: [{ type: Output }],
        calendar: [{ type: ViewChild, args: ["calendar", { static: false },] }]
    };
    return PickupDetailsComponent;
}());
if (false) {
    /** @type {?} */
    PickupDetailsComponent.prototype.selectOrder;
    /** @type {?} */
    PickupDetailsComponent.prototype.changeExecutive;
    /**
     * @type {?}
     * @private
     */
    PickupDetailsComponent.prototype.calendar;
    /**
     * @type {?}
     * @private
     */
    PickupDetailsComponent.prototype.selectedPickupPerson;
    /** @type {?} */
    PickupDetailsComponent.prototype.selectedOrderDate;
    /** @type {?} */
    PickupDetailsComponent.prototype.maxDateValue;
    /**
     * @type {?}
     * @private
     */
    PickupDetailsComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    PickupDetailsComponent.prototype.router;
    /**
     * @type {?}
     * @private
     */
    PickupDetailsComponent.prototype.orderService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StatusDetailsService = /** @class */ (function () {
    function StatusDetailsService(http) {
        this.http = http;
    }
    StatusDetailsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    StatusDetailsService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ StatusDetailsService.ngInjectableDef = ɵɵdefineInjectable({ factory: function StatusDetailsService_Factory() { return new StatusDetailsService(ɵɵinject(HttpClient)); }, token: StatusDetailsService, providedIn: "root" });
    return StatusDetailsService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    StatusDetailsService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StatusDetailsComponent = /** @class */ (function () {
    function StatusDetailsComponent(modalCtrl, statusDetailService, alertCtrl) {
        this.modalCtrl = modalCtrl;
        this.statusDetailService = statusDetailService;
        this.alertCtrl = alertCtrl;
        this.actionTriggered = new EventEmitter();
    }
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.selectOrder.payment &&
            this.selectOrder.payment.orderPaymentStatus === "INVOICE_REJECTED") {
            /** @type {?} */
            var sortedPaymentStatusLogs = sortBy(this.selectOrder.payment.paymentStatusChangeLogs, ["id"]);
            this.invoiceRejectedObj =
                sortedPaymentStatusLogs[sortedPaymentStatusLogs.length - 1];
        }
    };
    /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    StatusDetailsComponent.prototype.status = /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    function (statuses, In) {
        /** @type {?} */
        var isPresent = indexOf(statuses, this.selectOrder.status) >= 0;
        return In ? isPresent : !isPresent;
    };
    /**
     * @param {?} data
     * @return {?}
     */
    StatusDetailsComponent.prototype.loadTimeSlot = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.actionTriggered.emit({ buttonClicked: "reschedule" });
    };
    /**
     * @param {?} ev
     * @return {?}
     */
    StatusDetailsComponent.prototype.openHoldDialog = /**
     * @param {?} ev
     * @return {?}
     */
    function (ev) {
        this.actionTriggered.emit({ buttonClicked: "hold" });
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    StatusDetailsComponent.prototype.openCancelDialog = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        this.actionTriggered.emit({ buttonClicked: "Reject" });
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.pickedOrderAlert = /**
     * @return {?}
     */
    function () {
        this.actionTriggered.emit({ buttonClicked: "picked" });
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.dispatch = /**
     * @return {?}
     */
    function () {
        this.actionTriggered.emit({
            buttonClicked: "dispatched",
            order: this.selectOrder,
        });
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    StatusDetailsComponent.prototype.completeOrderAlert = /**
     * @param {?} $event
     * @return {?}
     */
    function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var orderCompletePrompt;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertCtrl.create({
                            header: "Confirm Order",
                            message: "Are you sure you want to complete this order?",
                            cssClass: "custom-alert",
                            buttons: [
                                {
                                    text: "",
                                    role: "no",
                                    cssClass: "custom-close-btn",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () { }),
                                },
                                {
                                    text: "Yes, Continue",
                                    cssClass: "success",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () {
                                        _this.completed();
                                    }),
                                },
                            ],
                        })];
                    case 1:
                        orderCompletePrompt = _a.sent();
                        return [4 /*yield*/, orderCompletePrompt.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.markDeliveredOrReceived = /**
     * @return {?}
     */
    function () {
        if (this.selectOrder.saleOrder) {
            this.markAsDelivered();
        }
        else {
            this.loadDropLocations();
        }
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.markAsDelivered = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var confirmCtrl;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertCtrl.create({
                            header: "Confirm",
                            message: "Are you sure you want to mark the sale order as delivered? ",
                            cssClass: "custom-alert",
                            buttons: [
                                {
                                    text: "",
                                    role: "no",
                                    cssClass: "custom-close-btn",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () { }),
                                },
                                {
                                    text: "Yes",
                                    cssClass: "success",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () {
                                        _this.markAsReceived(_this.selectOrder.toLocation);
                                    }),
                                },
                            ],
                        })];
                    case 1:
                        confirmCtrl = _a.sent();
                        return [4 /*yield*/, confirmCtrl.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.loadDropLocations = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.selectOrder.toLocation) {
                            this.selectLocationId = this.selectOrder.toLocation.id;
                        }
                        return [4 /*yield*/, this.modalCtrl.create({
                                component: DropLocationsComponent,
                                componentProps: {
                                    selectLocationId: this.selectLocationId,
                                },
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.markAsReceived(data.data);
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.selectPickupExecutive = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: SelectPickupExecutiveComponent,
                            componentProps: {
                                orderId: this.selectOrder.id,
                            },
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.actionTriggered.emit({ buttonClicked: "assignExecutive" });
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @param {?} location
     * @return {?}
     */
    StatusDetailsComponent.prototype.markAsReceived = /**
     * @param {?} location
     * @return {?}
     */
    function (location) {
        /** @type {?} */
        var data = {
            dropLocationId: location.id,
            id: this.selectOrder.id,
            buttonClicked: "MarkAsReceived",
        };
        this.actionTriggered.emit(data);
    };
    /**
     * @return {?}
     */
    StatusDetailsComponent.prototype.completed = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var data = { buttonClicked: "OrderComplete" };
        this.actionTriggered.emit(data);
    };
    /**
     * @param {?} ev
     * @return {?}
     */
    StatusDetailsComponent.prototype.verifyInvoice = /**
     * @param {?} ev
     * @return {?}
     */
    function (ev) {
        /** @type {?} */
        var data = { buttonClicked: "verify" };
        this.actionTriggered.emit(data);
    };
    /**
     * @param {?} ev
     * @return {?}
     */
    StatusDetailsComponent.prototype.makePayment = /**
     * @param {?} ev
     * @return {?}
     */
    function (ev) {
        /** @type {?} */
        var data = { buttonClicked: "makePayment" };
        this.actionTriggered.emit(data);
    };
    StatusDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-status-details",
                    template: "<ion-card color=\"light\" class=\"my-item ion-no-margin\">\n  <ion-grid *ngIf=\"selectOrder\" class=\"ion-no-padding\">\n    <ion-row class=\"ion-padding-horizontal parent-class\">\n      <ion-col>\n        <ion-row\n          [ngClass]=\"{ 'status-area': selectOrder?.status !== 'CANCELLED' }\"\n        >\n          <ion-col size=\"12\" class=\"ion-no-padding\">\n            <ion-text color=\"medium\" class=\"label\">status</ion-text>\n          </ion-col>\n          <ion-col size=\"12\" class=\"ion-no-padding\" class=\"status-icons\">\n            <ion-icon\n              [src]=\"'./assets/SALE_CREATED.svg'\"\n              *ngIf=\"\n                selectOrder?.saleOrder && selectOrder?.status === 'CREATED'\n              \"\n            ></ion-icon>\n            <ion-icon\n              [src]=\"'./assets/MATERIAL_RECEIVED.svg'\"\n              *ngIf=\"\n                selectOrder?.saleOrder &&\n                selectOrder?.status === 'PICKUP_SCHEDULED'\n              \"\n            ></ion-icon>\n            <ion-icon\n              [src]=\"'./assets/REJECTED.svg'\"\n              *ngIf=\"\n                selectOrder?.payment?.orderPaymentStatus ===\n                  'INVOICE_REJECTED' &&\n                selectOrder?.status === 'ORDER_COMPLETED'\n              \"\n            ></ion-icon>\n            <ion-icon\n              [src]=\"'./assets/INVOICE_PENDING.svg'\"\n              *ngIf=\"\n                selectOrder?.payment?.orderPaymentStatus ===\n                  'INVOICE_VERIFICATION_PENDING' &&\n                selectOrder?.status === 'ORDER_COMPLETED'\n              \"\n            ></ion-icon>\n            <ion-icon\n              [src]=\"'./assets/' + selectOrder?.status + '.svg'\"\n              [ngClass]=\"{ 'reject-icon': selectOrder?.status === 'CANCELLED' }\"\n              *ngIf=\"\n                !selectOrder?.saleOrder &&\n                selectOrder?.status !== 'ORDER_COMPLETED' &&\n                selectOrder?.status != 'HOLD' &&\n                selectOrder?.status != 'AWAITING_PICKUP_CONFIRMATION'\n              \"\n            ></ion-icon>\n            <ion-icon\n              [src]=\"\n                './assets/' + selectOrder?.payment?.orderPaymentStatus + '.svg'\n              \"\n              *ngIf=\"\n                selectOrder?.payment?.orderPaymentStatus !==\n                  'INVOICE_REJECTED' &&\n                selectOrder?.status === 'ORDER_COMPLETED' &&\n                selectOrder?.payment?.orderPaymentStatus !==\n                  'INVOICE_VERIFICATION_PENDING'\n              \"\n            ></ion-icon>\n            <ion-text\n              class=\"status\"\n              color=\"dark\"\n              *ngIf=\"\n                selectOrder?.status !== 'ORDER_COMPLETED' &&\n                selectOrder?.status !== 'AWAITING_PICKUP_CONFIRMATION'\n              \"\n              >{{ selectOrder?.displayStatusTitle }}</ion-text\n            >\n            <ion-text\n              class=\"status\"\n              color=\"dark\"\n              *ngIf=\"\n                selectOrder?.status !== 'ORDER_COMPLETED' &&\n                selectOrder?.status === 'AWAITING_PICKUP_CONFIRMATION'\n              \"\n              >{{ selectOrder?.statusTitle }}</ion-text\n            >\n            <ion-text\n              class=\"status ion-text-capitalize\"\n              color=\"dark\"\n              *ngIf=\"selectOrder?.status === 'ORDER_COMPLETED'\"\n              >{{\n                selectOrder.saleOrder\n                  ? selectOrder?.displayStatusTitle\n                  : selectOrder?.payment?.statusTitle\n              }}\n            </ion-text>\n          </ion-col>\n        </ion-row>\n        <ion-row margin-top *ngIf=\"status(['CANCELLED', 'REJECTED'], false)\">\n          <!--   Quick Actions   -->\n          <ion-col\n            size=\"12\"\n            class=\"ion-no-padding quick-actions\"\n            *ngIf=\"\n              !(\n                status(['CANCELLED', 'REJECTED'], true) ||\n                ['COMPLETED', 'INVOICE_REJECTED'].indexOf(\n                  selectOrder?.payment?.orderPaymentStatus\n                ) >= 0\n              )\n            \"\n          >\n            <ion-text color=\"medium\" class=\"label\">Quick Actions</ion-text>\n            <div>\n              <!-- CHANGE TIMELSOT BUTTON -->\n              <rcyl-timeslot-button\n                [order]=\"selectOrder\"\n                *ngIf=\"\n                  selectOrder?.orderType != 'DROP' &&\n                  status(\n                    ['VERIFIED', 'CREATED', 'PICKUP_SCHEDULED', 'HOLD'],\n                    true\n                  )\n                \"\n                (changeTimeSlot)=\"loadTimeSlot($event)\"\n              >\n              </rcyl-timeslot-button>\n\n              <rcyl-cancel-order-button\n                *ngIf=\"\n                  !selectOrder?.saleOrder &&\n                  status(\n                    [\n                      'ORDER_COMPLETED',\n                      'HOLD',\n                      'CANCELLED',\n                      'MATERIAL_RECEIVED',\n                      'MATERIAL_PICKED'\n                    ],\n                    false\n                  )\n                \"\n                [config]=\"getConfig\"\n                [buttonTriggered]=\"'HOLD'\"\n                [orderType]=\"selectOrder?.orderType\"\n                [orderId]=\"selectOrder.id\"\n                (getResult)=\"openHoldDialog($event)\"\n              >\n              </rcyl-cancel-order-button>\n\n              <rcyl-cancel-order-button\n                *ngIf=\"\n                  !selectOrder?.saleOrder &&\n                  status(\n                    ['CREATED', 'HOLD', 'PICKUP_SCHEDULED', 'VERIFIED'],\n                    true\n                  )\n                \"\n                [config]=\"getConfig\"\n                [buttonTriggered]=\"'REJECT'\"\n                [orderType]=\"selectOrder?.orderType\"\n                [orderId]=\"selectOrder.id\"\n                (getResult)=\"openCancelDialog($event)\"\n              >\n              </rcyl-cancel-order-button>\n              <ion-button\n                *ngIf=\"\n                  !selectOrder?.saleOrder &&\n                  selectOrder?.orderType !== 'DROP' &&\n                  status(\n                    ['PICKUP_SCHEDULED', 'AWAITING_PICKUP_CONFIRMATION'],\n                    true\n                  )\n                \"\n                (click)=\"pickedOrderAlert()\"\n                [color]=\"'primary'\"\n                class=\"ion-text-uppercase\"\n              >\n                <ion-icon\n                  name=\"checkmark\"\n                  class=\"ion-float-left icon-padding\"\n                  color=\"light\"\n                ></ion-icon>\n                MARK AS PICKED\n              </ion-button>\n              <ion-button\n                *ngIf=\"\n                  (selectOrder?.orderType === 'DROP' &&\n                    status(['PICKUP_SCHEDULED'], true)) ||\n                  (selectOrder?.orderType === 'PICKUP' &&\n                    status(['MATERIAL_PICKED'], true))\n                \"\n                (click)=\"markDeliveredOrReceived()\"\n                [color]=\"'primary'\"\n                class=\"ion-text-uppercase\"\n              >\n                <ion-icon\n                  name=\"checkmark\"\n                  class=\"ion-float-left icon-padding\"\n                  color=\"light\"\n                ></ion-icon>\n                {{\n                  selectOrder?.saleOrder\n                    ? \"Mark as Delivered\"\n                    : \"Mark as Received\"\n                }}\n              </ion-button>\n              <ion-button\n                *ngIf=\"selectOrder?.saleOrder && status(['CREATED'], true)\"\n                (click)=\"dispatch()\"\n                [color]=\"'primary'\"\n                class=\"ion-text-uppercase\"\n              >\n                <ion-icon\n                  name=\"checkmark\"\n                  class=\"ion-float-left icon-padding\"\n                  color=\"light\"\n                ></ion-icon>\n                Mark as Dispatched</ion-button\n              >\n              <ion-button\n                *ngIf=\"\n                  !selectOrder?.saleOrder && status(['MATERIAL_RECEIVED'], true)\n                \"\n                (click)=\"completeOrderAlert($event)\"\n                [color]=\"'primary'\"\n                class=\"ion-text-uppercase complete-btn\"\n              >\n                <ion-icon\n                  name=\"checkmark\"\n                  class=\"ion-float-left icon-padding\"\n                  color=\"light\"\n                ></ion-icon>\n                Complete Order\n              </ion-button>\n              <ion-button\n                *ngIf=\"\n                  !selectOrder?.saleOrder && status(['CREATED', 'HOLD'], true)\n                \"\n                (click)=\"selectPickupExecutive()\"\n                class=\"ion-text-uppercase\"\n              >\n                <ion-icon\n                  name=\"checkmark\"\n                  class=\"ion-float-left icon-padding\"\n                  color=\"light\"\n                ></ion-icon>\n                Assign Executive\n              </ion-button>\n\n              <rcyl-verify-invoice-button\n                *ngIf=\"\n                  selectOrder?.payment?.orderPaymentStatus ===\n                  'INVOICE_VERIFICATION_PENDING'\n                \"\n                [id]=\"selectOrder?.id\"\n                [formattedId]=\"selectOrder?.formattedId\"\n                (verifiedStatus)=\"verifyInvoice($event)\"\n              ></rcyl-verify-invoice-button>\n\n              <rcyl-make-payment-button\n                *ngIf=\"\n                  status(['MATERIAL_RECEIVED'], true) ||\n                  selectOrder?.payment?.orderPaymentStatus ===\n                    'INVOICE_PENDING' ||\n                  selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING'\n                \"\n                [selectOrder]=\"selectOrder?.id\"\n                [order]=\"selectOrder\"\n                [tradeType]=\"selectOrder?.tradeType\"\n                (paymentStatus)=\"makePayment($event)\"\n              >\n              </rcyl-make-payment-button>\n            </div>\n          </ion-col>\n        </ion-row>\n      </ion-col>\n      <ion-col\n        size=\"7\"\n        *ngIf=\"\n          selectOrder?.status === 'MATERIAL_RECEIVED' ||\n          selectOrder?.payment?.orderPaymentStatus ===\n            'INVOICE_VERIFICATION_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING'\n        \"\n      >\n        <ng-container *ngTemplateOutlet=\"received_at\"></ng-container>\n      </ion-col>\n\n      <!--      invoice rejection reason-->\n      <ion-col\n        size=\"12\"\n        *ngIf=\"\n          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' &&\n          invoiceRejectedObj?.status === 'INVOICE_REJECTED'\n        \"\n      >\n        <ng-container *ngTemplateOutlet=\"rejection_reason\"></ng-container>\n      </ion-col>\n\n      <!--Cancellation or On-hold reason-->\n      <ion-col size=\"12\" *ngIf=\"status(['CANCELLED', 'REJECTED'], true)\">\n        <ng-container *ngTemplateOutlet=\"OnHold_Reject\"></ng-container>\n      </ion-col>\n\n      <ion-col size=\"7\" *ngIf=\"status(['HOLD'], true)\">\n        <ng-container *ngTemplateOutlet=\"OnHold_Reject\"></ng-container>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-card>\n\n<ng-template #rejection_reason>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\" class=\"ion-no-padding\">\n        <ion-text\n          color=\"medium\"\n          text-small\n          font-bold\n          class=\"ion-text-uppercase label\"\n          >reason</ion-text\n        >\n        <br />\n        <ion-text color=\"medium\" text-medium=\"\" class=\"ion-text-capitalize\">{{\n          invoiceRejectedObj?.comment\n        }}</ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ng-template>\n\n<ng-template #OnHold_Reject>\n  <ion-grid>\n    <ion-row [ngClass]=\"{ 'add-class': selectOrder?.status === 'HOLD' }\">\n      <ion-col size=\"12\" class=\"ion-no-padding\">\n        <ion-text\n          color=\"medium\"\n          text-small\n          font-bold\n          class=\"ion-text-uppercase label\"\n          >reason</ion-text\n        >\n        <br />\n        <ion-text color=\"medium\" text-medium=\"\" class=\"ion-text-capitalize\">{{\n          selectOrder?.rejectionReason\n        }}</ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ng-template>\n\n<!--template Address-->\n<ng-template #received_at>\n  <ion-grid>\n    <ion-row\n      class=\"add-class\"\n      [ngClass]=\"{\n        'add-class':\n          selectOrder?.payment?.orderPaymentStatus != 'INVOICE_PENDING'\n      }\"\n    >\n      <ion-col size=\"12\">\n        <ion-text color=\"medium\" text-small font-bold class=\"ion-text-uppercase\"\n          >received at</ion-text\n        >\n      </ion-col>\n      <ion-col size=\"12\">\n        <ion-text color=\"medium\" text-regular=\"\" class=\"ion-text-uppercase\">{{\n          selectOrder?.toLocation?.name\n        }}</ion-text>\n        <br />\n        <ion-text\n          color=\"medium\"\n          text-regular=\"\"\n          class=\"ion-text-capitalize address-box line-3\"\n          [pTooltip]=\"selectOrder?.toLocation?.addressInfo | address\"\n          tooltipStyleClass=\"tooltip-bg-white\"\n          >{{ selectOrder?.toLocation?.addressInfo | address }}</ion-text\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ng-template>\n",
                    styles: ["::ng-deep ion-button.status-btn{--padding-start:10px;--padding-end:10px}::ng-deep ion-button.status-btn ion-icon{padding-right:3px}ion-card.my-item{min-height:150px}ion-card.my-item .label{font-size:var(--ion-small-font-size);font-family:font-bold;letter-spacing:.5px;text-transform:uppercase}ion-card.my-item ion-row.add-class{border-left:1px solid #dcdcdc;padding-left:10px}ion-card.my-item ion-row.parent-class{align-content:baseline;-webkit-box-align:center;align-items:center}ion-card.my-item .text-medium ion-row{margin-bottom:10px}ion-card.my-item ion-card.my-item ion-row.add-class{border-left:2px solid rgba(199,210,216,.5)!important}ion-card.my-item .status-area{margin-bottom:20px!important}ion-card.my-item .status-area ion-text.status{font-size:1.357rem!important;font-family:font-bold}ion-card.my-item .status-area .status-icons{display:-webkit-box;display:flex;padding-left:0;-webkit-box-align:center;align-items:center}ion-card.my-item .status-area .status-icons ion-icon{margin-right:3px;font-size:1.629rem}ion-card.my-item .reject-icon{font-size:20px;margin-bottom:-4px}"]
                }] }
    ];
    /** @nocollapse */
    StatusDetailsComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: StatusDetailsService },
        { type: AlertController }
    ]; };
    StatusDetailsComponent.propDecorators = {
        selectOrder: [{ type: Input }],
        getConfig: [{ type: Input }],
        actionTriggered: [{ type: Output }]
    };
    return StatusDetailsComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    StatusDetailsComponent.prototype.selectLocationId;
    /** @type {?} */
    StatusDetailsComponent.prototype.selectedPickupPerson;
    /** @type {?} */
    StatusDetailsComponent.prototype.invoiceRejectedObj;
    /** @type {?} */
    StatusDetailsComponent.prototype.selectOrder;
    /** @type {?} */
    StatusDetailsComponent.prototype.getConfig;
    /** @type {?} */
    StatusDetailsComponent.prototype.actionTriggered;
    /**
     * @type {?}
     * @private
     */
    StatusDetailsComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    StatusDetailsComponent.prototype.statusDetailService;
    /**
     * @type {?}
     * @private
     */
    StatusDetailsComponent.prototype.alertCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ItemDetailsComponent = /** @class */ (function () {
    function ItemDetailsComponent() {
        this.editFlags = [];
        this.isEdit = false;
        this.itemUpdated = new EventEmitter();
        this.totalPay = 0;
        this.totalEarn = 0;
        this.totalPayTax = 0;
        this.totalEarnTax = 0;
        this.totalLabelText = "Totals";
        this.totalAmount = 0;
    }
    /**
     * @return {?}
     */
    ItemDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.calculateTotal();
    };
    /**
     * @return {?}
     */
    ItemDetailsComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        // this.createData(this.selectOrder);
        this.calculateTotal();
        console.log("channel", this.channel);
    };
    /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    ItemDetailsComponent.prototype.status = /**
     * @param {?} statuses
     * @param {?=} In
     * @return {?}
     */
    function (statuses, In) {
        /** @type {?} */
        var isPresent = indexOf(statuses, this.selectOrder.status) >= 0;
        return In ? isPresent : !isPresent;
    };
    /**
     * @param {?} type
     * @param {?} item
     * @return {?}
     */
    ItemDetailsComponent.prototype.incr = /**
     * @param {?} type
     * @param {?} item
     * @return {?}
     */
    function (type, item) {
        console.log("total", item[type]);
        item[type]++;
    };
    /**
     * @param {?} type
     * @param {?} item
     * @return {?}
     */
    ItemDetailsComponent.prototype.decr = /**
     * @param {?} type
     * @param {?} item
     * @return {?}
     */
    function (type, item) {
        console.log("total", item[type]);
        item[type]--;
    };
    /**
     * @param {?} type
     * @param {?} item
     * @return {?}
     */
    ItemDetailsComponent.prototype.qtyChange = /**
     * @param {?} type
     * @param {?} item
     * @return {?}
     */
    function (type, item) {
        this.selectOrder.totalQty = sumBy(this.selectOrder.orderItems, (/**
         * @param {?} o
         * @return {?}
         */
        function (o) { return o[type]; }));
        item.itemTotal = item[type] * item.itemPrice;
        if (this.selectOrder.saleOrder) {
            this.totalAmount = sumBy(this.selectOrder.orderItems, (/**
             * @param {?} o
             * @return {?}
             */
            function (o) { return o.itemTotal; }));
        }
        else {
            this.calculateTotal();
        }
    };
    /**
     * @return {?}
     */
    ItemDetailsComponent.prototype.calculateTotal = /**
     * @return {?}
     */
    function () {
        if (this.selectOrder.saleOrder) {
            /** @type {?} */
            var totalBuyItems = this.selectOrder.orderItems;
            this.totalAmount = this.selectOrder.totalAmount;
            if (totalBuyItems.length > 0) {
                this.totalEarn = sumBy(totalBuyItems, "itemTotal");
                this.totalEarnTax = sumBy(totalBuyItems, (/**
                 * @param {?} o
                 * @return {?}
                 */
                function (o) {
                    return (o.itemTotal * ((o.itemSgstPercentage + o.itemSgstPercentage) / 100));
                }));
            }
            else {
                this.totalEarn = 0;
                this.totalEarnTax = 0;
            }
            this.setTotalAmount();
        }
        else {
            // total buy data
            console.log(this.selectOrder.orderItems);
            /** @type {?} */
            var totalBuyItems = filter(this.selectOrder.orderItems, [
                "tradeType",
                "B",
            ]);
            if (totalBuyItems.length > 0) {
                this.totalPay = sumBy(totalBuyItems, "itemTotal");
                this.totalPayTax = sumBy(totalBuyItems, (/**
                 * @param {?} o
                 * @return {?}
                 */
                function (o) {
                    if (o.tradeType === "B") {
                        return (o.itemTotal *
                            ((o.itemSgstPercentage + o.itemSgstPercentage) / 100));
                    }
                }));
            }
            else {
                this.totalPay = 0;
                this.totalPayTax = 0;
            }
            // total sale data
            /** @type {?} */
            var totalSaleItems = filter(this.selectOrder.orderItems, [
                "tradeType",
                "S",
            ]);
            if (totalSaleItems.length > 0) {
                this.totalEarn = sumBy(totalSaleItems, "itemTotal");
                this.totalEarnTax = sumBy(totalSaleItems, (/**
                 * @param {?} o
                 * @return {?}
                 */
                function (o) {
                    if (o.tradeType === "S") {
                        return (o.itemTotal *
                            ((o.itemSgstPercentage + o.itemSgstPercentage) / 100));
                    }
                }));
            }
            else {
                this.totalEarn = 0;
                this.totalEarnTax = 0;
            }
            this.setTotalAmount();
        }
    };
    /**
     * @return {?}
     */
    ItemDetailsComponent.prototype.setTotalAmount = /**
     * @return {?}
     */
    function () {
        if (!this.selectOrder.saleOrder) {
            /** @type {?} */
            var totalPayAmount = this.totalPay;
            /** @type {?} */
            var totalEarnAmount = this.totalEarn;
            if (totalPayAmount > totalEarnAmount) {
                this.totalLabelText = "Amount to Pay";
                this.totalAmount = totalPayAmount - totalEarnAmount;
            }
            else {
                this.totalLabelText = "Amount to Earn";
                this.totalAmount = totalEarnAmount - totalPayAmount;
            }
        }
    };
    /**
     * @param {?} orderItem
     * @return {?}
     */
    ItemDetailsComponent.prototype.savePrice = /**
     * @param {?} orderItem
     * @return {?}
     */
    function (orderItem) {
        orderItem.isEdit = false;
        this.itemUpdated.emit(orderItem);
    };
    ItemDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-item-details",
                    template: "<p-table *ngIf=\"selectOrder\" [value]=\"selectOrder?.orderItems\">\n  <ng-template pTemplate=\"header\">\n    <tr class=\"table-grey-bg\">\n      <th width=\"60px\"></th>\n      <th width=\"90px\">Item Name</th>\n      <th width=\"80px\">Trade Type</th>\n      <th width=\"100px\">Initial Qty</th>\n      <th width=\"100px\">Initial Amount</th>\n      <th\n        width=\"150px\"\n        *ngIf=\"\n          channel !== 'RECYKAL' &&\n          !selectOrder.saleOrder &&\n          selectOrder.orderType === 'PICKUP' &&\n          status(\n            [\n              'PICKUP_SCHEDULED',\n              'MATERIAL_PICKED',\n              'MATERIAL_RECEIVED',\n              'ORDER_COMPLETED'\n            ],\n            true\n          )\n        \"\n      >\n        Picked Qty\n      </th>\n      <th\n        width=\"100px\"\n        *ngIf=\"\n          channel === 'RECYKAL' &&\n          selectOrder.saleOrder &&\n          selectOrder.orderType === 'PICKUP' &&\n          status(\n            ['MATERIAL_PICKED', 'MATERIAL_RECEIVED', 'ORDER_COMPLETED'],\n            true\n          )\n        \"\n      >\n        Picked Qty\n      </th>\n      <th\n        width=\"85px\"\n        *ngIf=\"\n          !selectOrder.saleOrder &&\n          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true)\n        \"\n      >\n        Deductions\n      </th>\n      <th\n        width=\"150px\"\n        *ngIf=\"\n          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true) ||\n          (selectOrder.orderType === 'DROP' &&\n            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')\n        \"\n      >\n        {{ selectOrder?.saleOrder ? \"Final\" : \"Received\" }} Qty\n      </th>\n      <th\n        width=\"65px\"\n        *ngIf=\"\n          (!selectOrder.saleOrder &&\n            status(['PICKUP_SCHEDULED', 'MATERIAL_RECEIVED'], true)) ||\n          (selectOrder.orderType === 'DROP' &&\n            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')\n        \"\n      >\n        Actions\n      </th>\n      <th width=\"100px\">Amount</th>\n    </tr>\n  </ng-template>\n  <ng-template pTemplate=\"body\" let-order>\n    <tr class=\"custom-table-body\">\n      <td class=\"ion-text-center\">\n        <ion-img\n          slot=\"start\"\n          style=\"width: 30px; margin-right: 10px\"\n          [src]=\"order.item.icon\"\n        ></ion-img>\n      </td>\n      <td style=\"line-height: 18px\">\n        <ion-text class=\"ion-float-left\">{{ order?.item?.name }}</ion-text>\n        <ion-text class=\"text-regular\" color=\"medium\"\n          ><br />{{ order?.itemPrice | currency: \"INR\" }} /\n          {{ order?.item?.unitType }}</ion-text\n        >\n        <!-- price-log approval info -->\n        <ng-container *ngIf=\"order.priceLog\" #actualTarget>\n          <ion-icon\n            pTooltip=\"More info\"\n            name=\"information-circle-outline\"\n            (click)=\"op.toggle($event, actualTarget)\"\n            class=\"info-circle\"\n          ></ion-icon>\n          <p-overlayPanel #op [dismissable]=\"true\">\n            <div style=\"width: 300px\">\n              <ion-item lines=\"full\">\n                <ion-label\n                  position=\"stacked\"\n                  class=\"text-regular\"\n                  color=\"medium\"\n                  >Approval Raised On</ion-label\n                >\n                <ion-text class=\"ion-float-left\">{{\n                  order.priceLog?.createdOn | date: \"dd MMM yyyy, hh:mm a\"\n                }}</ion-text>\n              </ion-item>\n              <ion-item lines=\"full\">\n                <ion-label\n                  position=\"stacked\"\n                  class=\"text-regular\"\n                  color=\"medium\"\n                  >Centre Incharge</ion-label\n                >\n                <ion-text class=\"ion-float-left\">{{\n                  order.priceLog?.createdByName\n                }}</ion-text>\n              </ion-item>\n              <ion-item lines=\"full\">\n                <ion-label\n                  position=\"stacked\"\n                  class=\"text-regular\"\n                  color=\"medium\"\n                  >Centre Name</ion-label\n                >\n                <ion-text class=\"ion-float-left\">{{\n                  selectOrder.toLocation?.name\n                }}</ion-text>\n              </ion-item>\n              <ion-item lines=\"full\">\n                <ion-col slot=\"start\">\n                  <ion-label\n                    position=\"stacked\"\n                    class=\"text-regular\"\n                    color=\"medium\"\n                    >Original Price</ion-label\n                  >\n                  <ion-text class=\"ion-float-left\"\n                    >{{ order.priceLog?.initialPrice | currency: \"INR\" }} /\n                    {{ order?.item?.unitType }}</ion-text\n                  ></ion-col\n                >\n                <ion-col>\n                  <ion-label\n                    position=\"stacked\"\n                    class=\"text-regular\"\n                    color=\"medium\"\n                    >Requested Price</ion-label\n                  >\n                  <ion-text class=\"ion-float-left\"\n                    >{{ order.priceLog?.proposalPrice | currency: \"INR\" }} /\n                    {{ order?.item?.unitType }}</ion-text\n                  ></ion-col\n                >\n              </ion-item>\n              <ion-item lines=\"full\">\n                <ion-label\n                  position=\"stacked\"\n                  class=\"text-regular\"\n                  color=\"medium\"\n                  >Comments</ion-label\n                >\n                <ion-text class=\"ion-float-left\">{{\n                  order.priceLog?.reason\n                }}</ion-text>\n              </ion-item>\n\n              <ion-item\n                lines=\"full\"\n                *ngIf=\"order.priceStatus && order.priceStatus === 'APPROVED'\"\n              >\n                <ion-label\n                  position=\"stacked\"\n                  class=\"text-regular\"\n                  color=\"medium\"\n                  >Approved On</ion-label\n                >\n                <ion-text class=\"ion-float-left\">{{\n                  order.priceLog?.updatedOn | date: \"dd MMM yyyy, hh:mm a\"\n                }}</ion-text>\n              </ion-item>\n              <ion-item\n                lines=\"full\"\n                *ngIf=\"order.priceStatus && order.priceStatus === 'APPROVED'\"\n              >\n                <ion-col slot=\"start\">\n                  <ion-label\n                    position=\"stacked\"\n                    class=\"text-regular\"\n                    color=\"medium\"\n                    >Supervisor</ion-label\n                  >\n                  <ion-text class=\"ion-float-left\">{{\n                    order.priceLog?.updatedByName\n                  }}</ion-text></ion-col\n                >\n                <ion-col>\n                  <ion-label\n                    position=\"stacked\"\n                    class=\"text-regular\"\n                    color=\"medium\"\n                    >Modified price</ion-label\n                  >\n                  <ion-text class=\"ion-float-left\"\n                    >{{ order.priceLog?.approvedPrice | currency: \"INR\" }} /\n                    {{ order?.item?.unitType }}</ion-text\n                  ></ion-col\n                >\n              </ion-item>\n              <ion-item\n                lines=\"full\"\n                *ngIf=\"order.priceStatus && order.priceStatus === 'APPROVED'\"\n              >\n                <ion-label\n                  position=\"stacked\"\n                  class=\"text-regular\"\n                  color=\"medium\"\n                  >Comments</ion-label\n                >\n                <ion-text class=\"ion-float-left\">{{\n                  order.priceLog?.approvalReason\n                }}</ion-text>\n              </ion-item>\n            </div>\n          </p-overlayPanel>\n        </ng-container>\n      </td>\n      <td>\n        <ion-text class=\"ion-float-left\" *ngIf=\"order?.tradeType === 'B'\"\n          >Buy</ion-text\n        >\n        <ion-text class=\"ion-float-left\" *ngIf=\"order?.tradeType === 'S'\"\n          >Sale</ion-text\n        >\n      </td>\n      <td>\n        <ion-text>\n          {{ order?.qty }} {{ order.item.unitType | titlecase }}</ion-text\n        >\n      </td>\n      <td>\n        <ion-text class=\"ion-float-left\">{{\n          order?.qty * order.itemPrice | currency: \"INR\"\n        }}</ion-text>\n      </td>\n      <td\n        *ngIf=\"\n          !selectOrder.saleOrder &&\n          selectOrder.orderType === 'PICKUP' &&\n          status(\n            [\n              'PICKUP_SCHEDULED',\n              'MATERIAL_PICKED',\n              'MATERIAL_RECEIVED',\n              'ORDER_COMPLETED'\n            ],\n            true\n          )\n        \"\n      >\n        <ion-row>\n          <ion-col size=\"12\" class=\"ion-no-padding\" d-flex>\n            <ion-item\n              border-radius-10=\"\"\n              *ngIf=\"order.isEdit && status(['PICKUP_SCHEDULED'], true)\"\n              class=\"edit-quantity-item\"\n              lines=\"none\"\n            >\n              <ion-button\n                min=\"0\"\n                color=\"medium\"\n                class=\"qty-btn minus-button ion-float-left\"\n                [disabled]=\"order.verifyQty <= 0\"\n                (click)=\"decr('verifyQty', order)\"\n              >\n                <ion-icon name=\"remove\"></ion-icon>\n              </ion-button>\n              <ion-input\n                type=\"number\"\n                class=\"enter-quantity-input\"\n                (ionChange)=\"qtyChange('verifyQty', order)\"\n                min=\"0\"\n                [(ngModel)]=\"order.verifyQty\"\n              ></ion-input>\n              <ion-button\n                max=\"200\"\n                color=\"medium\"\n                class=\"qty-btn minus-button ion-float-right\"\n                (click)=\"incr('verifyQty', order)\"\n              >\n                <ion-icon name=\"add\"></ion-icon>\n              </ion-button>\n            </ion-item>\n            <p *ngIf=\"isEdit\">\n              <ion-text text-small color=\"medium\">{{\n                order?.item?.unitType\n              }}</ion-text>\n            </p>\n            <ion-text\n              *ngIf=\"\n                (!order.isEdit &&\n                  status(\n                    [\n                      'PICKUP_SCHEDULED',\n                      'MATERIAL_PICKED',\n                      'MATERIAL_RECEIVED',\n                      'ORDER_COMPLETED'\n                    ],\n                    true\n                  )) ||\n                (order.isEdit && status(['MATERIAL_RECEIVED'], true))\n              \"\n              class=\"ion-float-left\"\n            >\n              {{ order.verifyQty }} {{ order?.item?.unitType | titlecase }}\n            </ion-text>\n          </ion-col>\n        </ion-row>\n      </td>\n      <td\n        *ngIf=\"\n          channel === 'RECYKAL' &&\n          selectOrder.saleOrder &&\n          selectOrder.orderType === 'PICKUP' &&\n          status(\n            ['MATERIAL_PICKED', 'MATERIAL_RECEIVED', 'ORDER_COMPLETED'],\n            true\n          )\n        \"\n      >\n        <ion-text class=\"ion-float-left\">\n          {{ order.verifyQty }} {{ order?.item?.unitType | titlecase }}\n        </ion-text>\n      </td>\n      <td\n        *ngIf=\"\n          !selectOrder.saleOrder &&\n          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true)\n        \"\n      >\n        <ion-text class=\"ion-float-left\" *ngIf=\"!selectOrder.saleOrder\">\n          {{\n            order.verifyQty - order.receivedQty > 0\n              ? (order.verifyQty - order.receivedQty | number: \"1.2-2\")\n              : 0\n          }}\n          {{ order.item.unitType | titlecase }}\n        </ion-text>\n        <ion-text\n          class=\"ion-float-left\"\n          *ngIf=\"selectOrder.saleOrder && channel === 'RECYKAL'\"\n        >\n          {{\n            order.verifyQty - order.receivedQty > 0\n              ? (order.verifyQty - order.receivedQty | number: \"1.2-2\")\n              : 0\n          }}\n          {{ order.item.unitType | titlecase }}\n        </ion-text>\n      </td>\n      <td\n        *ngIf=\"\n          status(['MATERIAL_RECEIVED', 'ORDER_COMPLETED'], true) ||\n          (selectOrder.orderType === 'DROP' &&\n            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')\n        \"\n      >\n        <ion-row>\n          <ion-col size=\"12\" class=\"ion-no-padding\" d-flex>\n            <ion-item\n              border-radius-10=\"\"\n              *ngIf=\"\n                order?.isEdit &&\n                (status(['MATERIAL_RECEIVED'], true) ||\n                  selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')\n              \"\n              class=\"edit-quantity-item\"\n              lines=\"none\"\n            >\n              <ion-button\n                min=\"0\"\n                class=\"qty-btn minus-button ion-float-left\"\n                [disabled]=\"order.receivedQty <= 0\"\n                (click)=\"decr('receivedQty', order)\"\n              >\n                <ion-icon color=\"medium\" name=\"remove\"></ion-icon>\n              </ion-button>\n              <ion-input\n                type=\"number\"\n                class=\"enter-quantity-input\"\n                (ionChange)=\"qtyChange('receivedQty', order)\"\n                min=\"0\"\n                [(ngModel)]=\"order.receivedQty\"\n              ></ion-input>\n              <ion-button\n                max=\"200\"\n                class=\"qty-btn minus-button ion-float-right\"\n                (click)=\"incr('receivedQty', order)\"\n              >\n                <ion-icon color=\"medium\" name=\"add\"></ion-icon>\n              </ion-button>\n            </ion-item>\n            <p *ngIf=\"isEdit\">\n              <ion-text text-small color=\"medium\">{{\n                order?.item?.unitType\n              }}</ion-text>\n            </p>\n            <ion-text *ngIf=\"!order.isEdit\" class=\"ion-float-left\">\n              {{ order.receivedQty }} {{ order?.item?.unitType | titlecase }}\n            </ion-text>\n            <!--            <ion-text *ngIf='!valid' class='invalid-style' font-regular>Enter only positive number.</ion-text>-->\n          </ion-col>\n        </ion-row>\n      </td>\n      <td\n        *ngIf=\"\n          (!selectOrder.saleOrder &&\n            status(['PICKUP_SCHEDULED', 'MATERIAL_RECEIVED'], true)) ||\n          (selectOrder.orderType === 'DROP' &&\n            selectOrder?.payment?.orderPaymentStatus !== 'COMPLETED')\n        \"\n      >\n        <div>\n          <ion-icon\n            color=\"dark\"\n            *ngIf=\"!order.isEdit\"\n            name=\"create\"\n            class=\"icon-size\"\n            (click)=\"order.isEdit = true\"\n          ></ion-icon>\n          <ion-icon\n            color=\"dark\"\n            *ngIf=\"order.isEdit\"\n            name=\"checkmark\"\n            class=\"icon-size\"\n            (click)=\"savePrice(order)\"\n          ></ion-icon>\n        </div>\n      </td>\n      <td>\n        <ion-text class=\"ion-float-left\">{{\n          order?.itemTotal | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n  </ng-template>\n  <ng-template pTemplate=\"footer\" *ngIf=\"channel !== 'RECYKAL'\">\n    <tr\n      class=\"border-box\"\n      *ngIf=\"\n        selectOrder?.status === 'CREATED' ||\n        selectOrder?.status === 'CANCELLED' ||\n        selectOrder?.status === 'REJECTED' ||\n        selectOrder?.status === 'HOLD' ||\n        (selectOrder?.saleOrder && selectOrder?.status === 'PICKUP_SCHEDULED')\n      \"\n    >\n      <td class=\"no-border\" [colSpan]=\"2\"></td>\n      <td class=\"no-border-right\">\n        <ion-text class=\"ion-float-end\" color=\"dark\">{{\n          totalLabelText\n        }}</ion-text>\n      </td>\n      <td [colSpan]=\"2\" class=\"no-border-right no-border-left\">\n        <ion-text color=\"dark\">{{ selectOrder?.totalQty }}Kg</ion-text>\n      </td>\n      <td class=\"no-border-left\">\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          totalAmount | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n    <tr class=\"border-box\" *ngIf=\"selectOrder?.status === 'MATERIAL_PICKED'\">\n      <td [colSpan]=\"3\" class=\"no-border\"></td>\n      <td class=\"no-border-right\" [colSpan]=\"2\">\n        <ion-text class=\"ion-float-left\" color=\"dark\">{{\n          totalLabelText\n        }}</ion-text>\n      </td>\n      <td class=\"no-border-left no-border-right\">\n        <ion-text color=\"dark\">{{ selectOrder?.totalQty }}Kg</ion-text>\n      </td>\n      <td class=\"no-border-left\">\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          totalAmount | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n    <tr\n      class=\"border-box\"\n      *ngIf=\"\n        !selectOrder?.saleOrder && selectOrder?.status === 'PICKUP_SCHEDULED'\n      \"\n    >\n      <td [colSpan]=\"3\" class=\"no-border\"></td>\n      <td class=\"no-border-right\" [colSpan]=\"2\">\n        <ion-text color=\"dark\">{{ totalLabelText }}</ion-text>\n      </td>\n      <td [colSpan]=\"2\" class=\"no-border-left no-border-right\">\n        <ion-text color=\"dark\">{{ selectOrder?.totalQty }}Kg</ion-text>\n      </td>\n      <td class=\"no-border-left\">\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          totalAmount | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n    <tr class=\"border-box\" *ngIf=\"selectOrder?.status === 'MATERIAL_RECEIVED'\">\n      <td\n        [colSpan]=\"selectOrder.orderType === 'PICKUP' ? 5 : 3\"\n        class=\"no-border\"\n      ></td>\n\n      <td class=\"no-border-right\" [colSpan]=\"2\">\n        <ion-text class=\"ion-float-left\" color=\"dark\">{{\n          totalLabelText\n        }}</ion-text>\n      </td>\n      <td class=\"no-border-left no-border-right\">\n        <ion-text color=\"dark\">{{ selectOrder?.totalQty }}Kg</ion-text>\n      </td>\n      <td class=\"no-border-left no-border-right\"></td>\n      <td class=\"no-border-left\">\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          totalAmount | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n    <tr\n      class=\"border-box\"\n      *ngIf=\"\n        selectOrder?.status === 'ORDER_COMPLETED' &&\n        (selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus ===\n            'INVOICE_VERIFICATION_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' ||\n          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus === 'COMPLETED')\n      \"\n    >\n      <td\n        [colSpan]=\"selectOrder.orderType === 'PICKUP' ? 5 : 3\"\n        class=\"no-border\"\n      ></td>\n\n      <td class=\"no-border-right no-border-bottom\" [colSpan]=\"2\">\n        <ion-text class=\"ion-float-left\" color=\"dark\">{{\n          totalLabelText\n        }}</ion-text>\n      </td>\n      <td class=\"no-border-left no-border-right no-border-bottom\">\n        <ion-text *ngIf=\"selectOrder.orderType === 'DROP'\" color=\"dark\"\n          >{{ selectOrder?.totalQty }}Kg\n        </ion-text>\n        <ion-text\n          *ngIf=\"selectOrder.orderType === 'PICKUP'\"\n          tooltipPosition=\"top\"\n          pTooltip=\"Picked Qty / Received Qty\"\n          tooltipStyleClass=\"tooltip-bg-white\"\n          color=\"dark\"\n          >{{ selectOrder?.totalQty }}Kg / {{ selectOrder?.totalReceivedQty }}Kg\n        </ion-text>\n      </td>\n      <td class=\"no-border-left no-border-bottom\">\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          (totalPay > totalEarn ? totalPay - totalEarn : totalEarn - totalPay)\n            | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n    <tr\n      class=\"border-box-2\"\n      *ngIf=\"\n        selectOrder?.status === 'ORDER_COMPLETED' &&\n        (selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus ===\n            'INVOICE_VERIFICATION_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' ||\n          selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING' ||\n          selectOrder?.payment?.orderPaymentStatus === 'COMPLETED')\n      \"\n    >\n      <td\n        [colSpan]=\"selectOrder.orderType === 'PICKUP' ? 5 : 3\"\n        class=\"no-border\"\n      ></td>\n\n      <td class=\"no-border-right no-border-top no-border-bottom\">\n        <ion-text class=\"ion-float-left\" color=\"dark\">Total Tax</ion-text>\n      </td>\n      <td class=\"no-border\" [colSpan]=\"2\"></td>\n      <td class=\"no-border-left no-border-top no-border-bottom\">\n        <div\n          tooltipPosition=\"top\"\n          [escape]=\"false\"\n          pTooltip=\"<p>Goods Tax: <ion-text color='primary'>{{\n            selectOrder.gstOrder ? selectOrder.totalTax : 0\n          }}<ion-text></p> <p> Service Tax: <ion-text color='danger'>{{\n            selectOrder.earnTax ? selectOrder.earnTax : 0\n          }}<ion-text></p>\"\n          tooltipStyleClass=\"tooltip-bg-white\"\n        >\n          <ion-text font-bold=\"\" color=\"dark\" *ngIf=\"selectOrder.gstOrder\">{{\n            (totalPay > totalEarn\n              ? totalPayTax - totalEarnTax\n              : totalEarnTax - totalPayTax\n            ) | currency: \"INR\"\n          }}</ion-text>\n          <ion-text font-bold=\"\" color=\"dark\" *ngIf=\"!selectOrder.gstOrder\">{{\n            totalEarnTax | currency: \"INR\"\n          }}</ion-text>\n          <ion-icon\n            name=\"help-circle\"\n            mode=\"ios\"\n            size=\"small\"\n            color=\"grey\"\n            style=\"vertical-align: sub; margin-left: 2px\"\n          ></ion-icon>\n        </div>\n      </td>\n    </tr>\n    <tr\n      class=\"border-box-2\"\n      *ngIf=\"\n        (selectOrder?.status === 'ORDER_COMPLETED' && selectOrder?.gstOrder) ||\n        selectOrder?.payment?.orderPaymentStatus === 'PAYMENT_PENDING' ||\n        selectOrder?.payment?.orderPaymentStatus ===\n          'INVOICE_VERIFICATION_PENDING' ||\n        selectOrder?.payment?.orderPaymentStatus === 'INVOICE_REJECTED' ||\n        selectOrder?.payment?.orderPaymentStatus === 'INVOICE_PENDING' ||\n        selectOrder?.payment?.orderPaymentStatus === 'COMPLETED'\n      \"\n    >\n      <td\n        [colSpan]=\"selectOrder.orderType === 'PICKUP' ? 5 : 3\"\n        class=\"no-border\"\n      ></td>\n\n      <td class=\"no-border-right no-border-top\" [colSpan]=\"3\">\n        <ion-text font-bold=\"\" class=\"ion-float-left\" color=\"dark\"\n          >Net Amount</ion-text\n        >\n      </td>\n      <td class=\"no-border-left no-border-top\">\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          selectOrder.netAmount | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n  </ng-template>\n</p-table>\n",
                    styles: [".invalid-input{border-bottom:1px solid red}.invalid-style{color:red}.qty-btn{--padding-top:0px;height:28px;width:28px;margin:0!important;--background:#bac4c9}.qty-btn.minus-button,.qty-btn.plus-button{--border-radius:0}.icon-size{font-size:18px;color:#27353c}.edit-quantity-item{--background:#f2f2f2;--border-color:#fff;--border-width:1px;--padding-start:0px;--margin-top:0px;--padding-end:0px;--inner-padding-end:0;--min-height:26px;max-width:120px}.edit-quantity-item .enter-quantity-input{font-size:14px;text-align:center;--padding-top:0px;--padding-bottom:0px;--padding-start:8px;--padding-end:8px;color:#27353c;background:#f2f2f2}.edit-quantity-item .enter-quantity-input input{padding:0;background:#e5eaed;border-radius:0}.border-box{float:right;border-radius:5px;border-top:1px solid #c7d2d8;border-bottom:1px solid #c7d2d8;display:contents}.border-box-2{border-radius:5px;display:table-row}.no-border-left{border-left:none!important}.no-border-right{border-right:none!important}.no-border{border:none!important}.no-border-top{border-top:none!important}.no-border-bottom{border-bottom:none!important}.table-grey-bg th{background-color:var(--ion-color-medium)!important;color:#fff!important;font-size:.8571rem;font-weight:400!important;height:34px}.table-grey-bg th:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.table-grey-bg th:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}.custom-table-body td{border:none}.custom-table-body td ion-text{--color:#5b7583!important;font-size:.8571rem}.custom-table-body td ion-img{width:40px!important;margin:0 auto!important}.custom-table-body td:nth-child(2) ion-text{font-weight:600;--color:#27353c!important}.custom-table-body td:nth-child(2) ion-text:last-child{font-weight:400!important}.custom-table-body td:nth-child(4) ion-text{font-weight:600;--color:#27353c!important}.custom-table-body:nth-child(even) td{background-color:#f4f9fa!important}.custom-table-body:nth-child(even) td:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.custom-table-body:nth-child(even) td:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}:host ::ng-deep .ui-table .ui-table-tfoot>tr>td{font-weight:unset}:host ::ng-deep .ui-overlaypanel{left:12%!important}.info-circle{cursor:pointer!important;position:relative;top:3px;left:10px;color:#328e69}"]
                }] }
    ];
    /** @nocollapse */
    ItemDetailsComponent.ctorParameters = function () { return []; };
    ItemDetailsComponent.propDecorators = {
        selectOrder: [{ type: Input }],
        channel: [{ type: Input }],
        itemUpdated: [{ type: Output }]
    };
    return ItemDetailsComponent;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    ItemDetailsComponent.prototype.editFlags;
    /** @type {?} */
    ItemDetailsComponent.prototype.selectOrder;
    /** @type {?} */
    ItemDetailsComponent.prototype.channel;
    /** @type {?} */
    ItemDetailsComponent.prototype.isEdit;
    /** @type {?} */
    ItemDetailsComponent.prototype.itemUpdated;
    /** @type {?} */
    ItemDetailsComponent.prototype.totalPay;
    /** @type {?} */
    ItemDetailsComponent.prototype.totalEarn;
    /** @type {?} */
    ItemDetailsComponent.prototype.totalPayTax;
    /** @type {?} */
    ItemDetailsComponent.prototype.totalEarnTax;
    /** @type {?} */
    ItemDetailsComponent.prototype.totalLabelText;
    /** @type {?} */
    ItemDetailsComponent.prototype.totalAmount;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CancelOrderButtonComponent = /** @class */ (function () {
    function CancelOrderButtonComponent(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.getResult = new EventEmitter();
    }
    /**
     * @return {?}
     */
    CancelOrderButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} data
     * @param {?} typ
     * @return {?}
     */
    CancelOrderButtonComponent.prototype.openCancelDialog = /**
     * @param {?} data
     * @param {?} typ
     * @return {?}
     */
    function (data, typ) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: CancelOrderModalComponent,
                            componentProps: {
                                reasons: data.language.reasons[typ],
                                type: typ,
                                buttonClicked: this.buttonTriggered,
                                id: this.orderId,
                            },
                        })];
                    case 1:
                        cancelModal = _a.sent();
                        cancelModal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result.data) {
                                _this.getResult.emit(result.data);
                            }
                        }));
                        return [4 /*yield*/, cancelModal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    CancelOrderButtonComponent.prototype.getCancelReasons = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.config.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (_this.buttonTriggered === "HOLD") {
                _this.openCancelDialog(data, _this.orderType + "_HOLD");
            }
            else if (_this.buttonTriggered === "REJECT") {
                _this.openCancelDialog(data, _this.orderType + "_REJECTION");
            }
        }));
    };
    CancelOrderButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-cancel-order-button",
                    template: "<ion-button\n  *ngIf=\"buttonTriggered === 'REJECT'\"\n  [color]=\"'danger'\"\n  (click)=\"getCancelReasons()\"\n  class=\"status-btn ion-text-uppercase\"\n>\n  <ion-icon\n    name=\"close\"\n    color=\"light\"\n    class=\"ion-float-left icon-padding\"\n  ></ion-icon>\n  CANCEL\n</ion-button>\n<ion-button\n  *ngIf=\"buttonTriggered === 'HOLD'\"\n  (click)=\"getCancelReasons()\"\n  [color]=\"'medium'\"\n  class=\"ion-text-uppercase status-btn\"\n>\n  <ion-icon\n    name=\"pause\"\n    color=\"light\"\n    class=\"ion-float-left icon-padding\"\n  ></ion-icon>\n  HOLD\n</ion-button>\n",
                    styles: [".icon-padding{padding-right:2px}"]
                }] }
    ];
    /** @nocollapse */
    CancelOrderButtonComponent.ctorParameters = function () { return [
        { type: ModalController }
    ]; };
    CancelOrderButtonComponent.propDecorators = {
        config: [{ type: Input }],
        orderType: [{ type: Input }],
        buttonTriggered: [{ type: Input }],
        orderId: [{ type: Input }],
        getResult: [{ type: Output }]
    };
    return CancelOrderButtonComponent;
}());
if (false) {
    /** @type {?} */
    CancelOrderButtonComponent.prototype.config;
    /** @type {?} */
    CancelOrderButtonComponent.prototype.orderType;
    /** @type {?} */
    CancelOrderButtonComponent.prototype.buttonTriggered;
    /** @type {?} */
    CancelOrderButtonComponent.prototype.orderId;
    /** @type {?} */
    CancelOrderButtonComponent.prototype.getResult;
    /**
     * @type {?}
     * @private
     */
    CancelOrderButtonComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CancelOrderButtonModule = /** @class */ (function () {
    function CancelOrderButtonModule() {
    }
    CancelOrderButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [CancelOrderButtonComponent],
                    imports: [CommonModule, IonicModule],
                    exports: [CancelOrderButtonComponent],
                },] }
    ];
    return CancelOrderButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeslotButtonComponent = /** @class */ (function () {
    function TimeslotButtonComponent(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.changeTimeSlot = new EventEmitter();
    }
    /**
     * @return {?}
     */
    TimeslotButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    TimeslotButtonComponent.prototype.loadTimeSlot = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: TimeSlotModalComponent,
                            componentProps: {
                                order: this.order,
                            },
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.changeTimeSlot.emit(data);
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TimeslotButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-timeslot-button",
                    template: "<ion-button\n  class=\"ion-text-uppercase status-btn\"\n  [color]=\"'medium'\"\n  (click)=\"loadTimeSlot()\"\n  class=\"ion-text-uppercase\"\n>\n  <ion-icon\n    name=\"refresh\"\n    color=\"light\"\n    class=\"ion-float-left icon-padding\"\n  ></ion-icon>\n  RESCHEDULE</ion-button\n>\n",
                    styles: [".icon-padding{padding-right:2px}"]
                }] }
    ];
    /** @nocollapse */
    TimeslotButtonComponent.ctorParameters = function () { return [
        { type: ModalController }
    ]; };
    TimeslotButtonComponent.propDecorators = {
        order: [{ type: Input }],
        changeTimeSlot: [{ type: Output }]
    };
    return TimeslotButtonComponent;
}());
if (false) {
    /** @type {?} */
    TimeslotButtonComponent.prototype.order;
    /** @type {?} */
    TimeslotButtonComponent.prototype.changeTimeSlot;
    /**
     * @type {?}
     * @private
     */
    TimeslotButtonComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TimeslotButtonModule = /** @class */ (function () {
    function TimeslotButtonModule() {
    }
    TimeslotButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TimeslotButtonComponent],
                    imports: [CommonModule, IonicModule],
                    exports: [TimeslotButtonComponent],
                },] }
    ];
    return TimeslotButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StatusFlowComponent = /** @class */ (function () {
    function StatusFlowComponent(http) {
        this.http = http;
        this.defaultFlow = [];
    }
    /**
     * @return {?}
     */
    StatusFlowComponent.prototype.ngOnChanges = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /*this.statusFlow = _.filter(this.statusFlow, (status) => {
          if (!(status.fromStatus === null && status.id !== null)) {
            return status;
          }
        });*/
        if (this.isSaleOrder) {
            this.defaultFlow = [
                { text: "Created", status: [OrderStatus.CREATED], data: null },
                {
                    text: "Dispatched",
                    status: [OrderStatus.PICKUP_SCHEDULED],
                    data: null,
                },
                {
                    text: "Delivered",
                    status: [OrderStatus.MATERIAL_RECEIVED, OrderStatus.ORDER_COMPLETED],
                },
                { text: "Completed", status: [OrderStatus.PAYMENT_COMPLETED] },
            ];
        }
        else {
            this.defaultFlow = [
                { text: "Created", status: [OrderStatus.CREATED], data: null },
                { text: "Scheduled", status: [OrderStatus.PICKUP_SCHEDULED] },
                { text: "Picked", status: [OrderStatus.MATERIAL_PICKED] },
                { text: "Received", status: [OrderStatus.MATERIAL_RECEIVED] },
                { text: "Completed", status: [OrderStatus.ORDER_COMPLETED] },
                {
                    text: "Payment Pending",
                    status: [
                        OrderStatus.PAYMENT_PENDING,
                        OrderStatus.INVOICE_PENDING,
                        OrderStatus.INVOICE_VERIFICATION_PENDING,
                    ],
                },
                { text: "Payment Done", status: [OrderStatus.PAYMENT_COMPLETED] },
            ];
        }
        this.defaultFlow.forEach((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            data.data = find(_this.statusFlow, (/**
             * @param {?} status
             * @return {?}
             */
            function (status) {
                return data.status.includes(status.toStatus);
            }));
        }));
        //
        // const cancelLog = _.find(this.statusFlow, {toStatus: OrderStatus.CANCELLED});
        // const holdLog = _.find(this.statusFlow, {toStatus: OrderStatus.HOLD});
        // if (cancelLog) {
        //   const cancelFromStatusIndex = _.findIndex(this.defaultFlow, (status) => status.status.indexOf(cancelLog.fromStatus) >= 0);
        //   this.defaultFlow.splice(cancelFromStatusIndex + 1, 0,
        //     {text: 'Cancelled', status: [OrderStatus.CANCELLED], data: cancelLog}
        //     );
        // }
        //
        // if (holdLog) {
        //   const holdLogFromStatusIndex = _.findIndex(this.defaultFlow, (status) => status.status.indexOf(holdLog.fromStatus) >= 0);
        //   this.defaultFlow.splice(holdLogFromStatusIndex + 1, 0,
        //     {text: 'Hold', status: [OrderStatus.HOLD], data: holdLog});
        // }
        console.log("statusflow", this.statusFlow);
    };
    /**
     * @return {?}
     */
    StatusFlowComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    StatusFlowComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-status-flow",
                    template: "<div class=\"demo\">\n  <ul class=\"progress-tracker anim-ripple\">\n    <li\n      class=\"progress-step active\"\n      *ngFor=\"let status of defaultFlow; let i = index\"\n      [ngClass]=\"{\n        's-cancelled': status?.data?.toStatus === 'CANCELLED',\n        's-hold': status?.data?.toStatus === 'HOLD',\n        active: status?.data?.id != null\n      }\"\n    >\n      <span class=\"progress-marker\">\n        <h6>{{ status.text }}</h6>\n        <div class=\"additional-data\" *ngIf=\"status?.data?.id != null\">\n          {{ status?.data?.changedByName }}<br />\n          <div class=\"date-time\">\n            <ion-icon name=\"alarm\" mode=\"ios\"></ion-icon\n            >{{ status?.data?.changedDate | date: \"hh:mm a, dd-MMM\" }}\n          </div>\n        </div>\n      </span>\n    </li>\n  </ul>\n</div>\n",
                    changeDetection: ChangeDetectionStrategy.Default,
                    styles: ["@charset \"UTF-8\";:host .demo{margin-bottom:60px}:host .progress-tracker{display:-webkit-box;display:flex;margin:21px auto;padding:0;list-style:none}:host .progress-step{display:block;position:relative;-webkit-box-flex:1;flex:1 1 0%;margin:0;padding:0;min-width:160px}:host .progress-step:last-child{-webkit-box-flex:0;flex-grow:0}:host .progress-step:not(:last-child)::after{content:\"\";display:block;position:absolute;top:8px;bottom:8px;right:-14px;width:100%;height:0;-webkit-transition:background-color .3s;transition:background-color .3s}:host .progress-step.is-active .progress-title{font-weight:400}:host .progress-step>a{display:block}:host .progress-marker{font-size:14px;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;position:relative;z-index:20;width:18px;height:18px;padding-bottom:2px;color:#fff;font-weight:400;border:2px solid transparent;border-radius:50%;-webkit-transition:background-color .3s,border-color .3s;transition:background-color .3s,border-color .3s}:host .progress-text{display:block;padding:14px 9.33px 42px;overflow:hidden;text-overflow:ellipsis}:host .progress-title{margin-top:0}:host .progress-step .progress-marker{background-color:#c7d2d8}:host .progress-step::after{border:2.5px solid #c7d2d8}:host .progress-step .progress-step>a .progress-text,:host .progress-step .progress-text{color:#333}:host .progress-step.is-active .progress-marker{background-color:#d5d5d5}:host .progress-step.active .progress-marker{background-color:#2c8f68;border:2px solid #2c8f68;background-repeat:no-repeat;background-position:center;background-size:18px}:host .progress-step.active::after{border:2.5px solid #2c8f68;z-index:0}:host .progress-step.active .progress-marker::before{content:\"\u2713\";padding-top:2px}:host .progress-tracker--center .progress-step{text-align:center}:host .demo h6{color:#c7d2d8;position:absolute;top:12px;left:0;width:160px;font-size:1rem}:host .demo .additional-data{color:#c7d2d8;position:absolute;top:54px;left:0;line-height:15px;width:160px;font-size:.8571rem}:host .demo .additional-data .date-time{font-size:var(--ion-small-font-size);display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;color:#c7d2d8}:host .active h6{color:#27353c}:host .active .additional-data{color:#5b7583}:host .s-cancelled h6{color:var(--ion-color-danger)}:host .s-cancelled.progress-step .progress-marker{background-color:var(--ion-color-danger);border:2px solid var(--ion-color-danger)}:host .s-cancelled.progress-step .progress-marker::before{content:\"\u00D7\";color:var(--ion-color-white)}:host .s-hold h6{color:var(--ion-color-warning)}:host .s-hold.progress-step::after{border:2.5px solid var(--ion-color-warning)}:host .s-hold.progress-step .progress-marker{background-color:var(--ion-color-warning);border:2px solid var(--ion-color-warning)}:host .s-hold.progress-step .progress-marker::before{content:\"\u2161\";color:var(--ion-color-white)}"]
                }] }
    ];
    /** @nocollapse */
    StatusFlowComponent.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    StatusFlowComponent.propDecorators = {
        statusFlow: [{ type: Input }],
        orderId: [{ type: Input }],
        isSaleOrder: [{ type: Input }]
    };
    return StatusFlowComponent;
}());
if (false) {
    /** @type {?} */
    StatusFlowComponent.prototype.statusFlow;
    /** @type {?} */
    StatusFlowComponent.prototype.orderId;
    /** @type {?} */
    StatusFlowComponent.prototype.isSaleOrder;
    /** @type {?} */
    StatusFlowComponent.prototype.defaultFlow;
    /**
     * @type {?}
     * @private
     */
    StatusFlowComponent.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var StatusFlowModule = /** @class */ (function () {
    function StatusFlowModule() {
    }
    StatusFlowModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [StatusFlowComponent],
                    imports: [CommonModule, IonicModule],
                    exports: [StatusFlowComponent],
                },] }
    ];
    return StatusFlowModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IOrderItem() { }
if (false) {
    /** @type {?|undefined} */
    IOrderItem.prototype.id;
    /** @type {?|undefined} */
    IOrderItem.prototype.item;
    /** @type {?|undefined} */
    IOrderItem.prototype.itemCgstPercentage;
    /** @type {?|undefined} */
    IOrderItem.prototype.itemId;
    /** @type {?|undefined} */
    IOrderItem.prototype.itemPrice;
    /** @type {?|undefined} */
    IOrderItem.prototype.itemQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.itemSgstPercentage;
    /** @type {?|undefined} */
    IOrderItem.prototype.itemTotal;
    /** @type {?|undefined} */
    IOrderItem.prototype.pickupOrderId;
    /** @type {?|undefined} */
    IOrderItem.prototype.qty;
    /** @type {?|undefined} */
    IOrderItem.prototype.receivedQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.tags;
    /** @type {?|undefined} */
    IOrderItem.prototype.verifyQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.isEdit;
    /** @type {?|undefined} */
    IOrderItem.prototype.rejectedQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.deductedPercentage;
    /** @type {?|undefined} */
    IOrderItem.prototype.formattedQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.formattedVerifyQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.formattedReceivedQty;
    /** @type {?|undefined} */
    IOrderItem.prototype.initialAmount;
    /** @type {?|undefined} */
    IOrderItem.prototype.verifiedAmount;
    /** @type {?|undefined} */
    IOrderItem.prototype.receivedAmount;
    /** @type {?|undefined} */
    IOrderItem.prototype.tradeType;
}
var OrderItem = /** @class */ (function () {
    function OrderItem(id, item, itemCgstPercentage, itemId, itemPrice, itemQty, itemSgstPercentage, itemTotal, pickupOrderId, qty, receivedQty, tags, verifyQty, isEdit, formattedQty, formattedVerifyQty, formattedReceivedQty, initialAmount, verifiedAmount, receivedAmount) {
        this.id = id;
        this.item = item;
        this.itemCgstPercentage = itemCgstPercentage;
        this.itemId = itemId;
        this.itemPrice = itemPrice;
        this.itemQty = itemQty;
        this.itemSgstPercentage = itemSgstPercentage;
        this.itemTotal = itemTotal;
        this.pickupOrderId = pickupOrderId;
        this.qty = qty;
        this.receivedQty = receivedQty;
        this.tags = tags;
        this.verifyQty = verifyQty;
        this.isEdit = isEdit;
        this.formattedQty = formattedQty;
        this.formattedVerifyQty = formattedVerifyQty;
        this.formattedReceivedQty = formattedReceivedQty;
        this.initialAmount = initialAmount;
        this.verifiedAmount = verifiedAmount;
        this.receivedAmount = receivedAmount;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    OrderItem.prototype.setItem = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.itemId = item.id;
        this.item = item;
        this.qty = item.qty || 0;
        this.itemPrice = item.price || 0;
        this.itemTotal = item.qty * item.itemPrice || 0;
    };
    return OrderItem;
}());
if (false) {
    /** @type {?} */
    OrderItem.prototype.id;
    /** @type {?} */
    OrderItem.prototype.item;
    /** @type {?} */
    OrderItem.prototype.itemCgstPercentage;
    /** @type {?} */
    OrderItem.prototype.itemId;
    /** @type {?} */
    OrderItem.prototype.itemPrice;
    /** @type {?} */
    OrderItem.prototype.itemQty;
    /** @type {?} */
    OrderItem.prototype.itemSgstPercentage;
    /** @type {?} */
    OrderItem.prototype.itemTotal;
    /** @type {?} */
    OrderItem.prototype.pickupOrderId;
    /** @type {?} */
    OrderItem.prototype.qty;
    /** @type {?} */
    OrderItem.prototype.receivedQty;
    /** @type {?} */
    OrderItem.prototype.tags;
    /** @type {?} */
    OrderItem.prototype.verifyQty;
    /** @type {?} */
    OrderItem.prototype.isEdit;
    /** @type {?} */
    OrderItem.prototype.formattedQty;
    /** @type {?} */
    OrderItem.prototype.formattedVerifyQty;
    /** @type {?} */
    OrderItem.prototype.formattedReceivedQty;
    /** @type {?} */
    OrderItem.prototype.initialAmount;
    /** @type {?} */
    OrderItem.prototype.verifiedAmount;
    /** @type {?} */
    OrderItem.prototype.receivedAmount;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ItemListService = /** @class */ (function () {
    function ItemListService(http) {
        this.http = http;
        this.items = new BehaviorSubject(null);
    }
    /**
     * @param {?} url
     * @param {?} reqParams
     * @return {?}
     */
    ItemListService.prototype.query = /**
     * @param {?} url
     * @param {?} reqParams
     * @return {?}
     */
    function (url, reqParams) {
        var _this = this;
        /** @type {?} */
        var params = new HttpParams({ fromObject: reqParams });
        return this.http.get(url, { params: params }).subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.items.next(result);
        }));
    };
    /**
     * @param {?} url
     * @param {?} reqParams
     * @return {?}
     */
    ItemListService.prototype.search = /**
     * @param {?} url
     * @param {?} reqParams
     * @return {?}
     */
    function (url, reqParams) {
        /** @type {?} */
        var params = new HttpParams({ fromObject: reqParams });
        return this.http.get(url, { params: params });
    };
    ItemListService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    ItemListService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    /** @nocollapse */ ItemListService.ngInjectableDef = ɵɵdefineInjectable({ factory: function ItemListService_Factory() { return new ItemListService(ɵɵinject(HttpClient)); }, token: ItemListService, providedIn: "root" });
    return ItemListService;
}());
if (false) {
    /** @type {?} */
    ItemListService.prototype.items;
    /**
     * @type {?}
     * @private
     */
    ItemListService.prototype.http;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function IItemOption() { }
if (false) {
    /** @type {?} */
    IItemOption.prototype.hideSearch;
    /** @type {?} */
    IItemOption.prototype.headerTitle;
    /** @type {?} */
    IItemOption.prototype.submitBtnText;
    /** @type {?} */
    IItemOption.prototype.url;
    /** @type {?} */
    IItemOption.prototype.params;
}
var ItemListComponent = /** @class */ (function () {
    function ItemListComponent(itemService, modal) {
        var _this = this;
        this.itemService = itemService;
        this.modal = modal;
        this.itemSelected = new EventEmitter();
        this.query = "";
        this.itemService.items.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            console.log(data);
            if (data) {
                _this.items = _this.filterAddedProducts(data);
                _this.originalList = cloneDeep(_this.items);
            }
        }));
    }
    /**
     * @private
     * @param {?} data
     * @return {?}
     */
    ItemListComponent.prototype.filterAddedProducts = /**
     * @private
     * @param {?} data
     * @return {?}
     */
    function (data) {
        var _this = this;
        return sortBy(filter(data, (/**
         * @param {?} item
         * @return {?}
         */
        function (item) { return indexOf(_this.selectedItemIds, item.id) < 0; })), ["seq"]);
    };
    /**
     * @return {?}
     */
    ItemListComponent.prototype.onSearch = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (this.query && this.query.length < 2) {
            return;
        }
        else if (this.query && this.query.length <= 0) {
            this.items = cloneDeep(this.originalList);
            return;
        }
        this.searching = true;
        this.itemService
            .search(this.options.url, __assign({ query: this.query }, this.options.params))
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.searching = false;
            _this.items = _this.filterAddedProducts(result);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.searching = false;
        }));
    };
    /**
     * @param {?} item
     * @return {?}
     */
    ItemListComponent.prototype.itemClicked = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.selectedItemId = item.id;
    };
    /**
     * @return {?}
     */
    ItemListComponent.prototype.submit = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var item = find(this.items, { id: this.selectedItemId });
        if (this.modal) {
            this.modal.dismiss(item, "SUBMIT");
        }
        else {
            this.itemSelected.emit(item);
        }
    };
    /**
     * @return {?}
     */
    ItemListComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.itemService.query(this.options.url, this.options.params);
    };
    /**
     * @return {?}
     */
    ItemListComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.modal.dismiss(null);
    };
    ItemListComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-item-list",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title modal-title>{{\n      options?.headerTitle || \"Select Item\"\n    }}</ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"close()\">\n        <ion-icon slot=\"icon-only\" name=\"close-circle\"></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n  <ion-toolbar padding-horizontal mode=\"ios\" *ngIf=\"!options?.hideSearch\">\n    <ion-searchbar\n      (ionChange)=\"onSearch()\"\n      [(ngModel)]=\"query\"\n      mode=\"ios\"\n      placeholder=\"Search Item\"\n    ></ion-searchbar>\n    <ion-progress-bar type=\"indeterminate\" *ngIf=\"searching\"></ion-progress-bar>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-list *ngIf=\"items?.length > 0; else noItems\">\n    <ion-grid no-padding>\n      <ion-row>\n        <ion-col no-padding size=\"12\" *ngFor=\"let item of items\">\n          <rcyl-item\n            [item]=\"item\"\n            [isSelected]=\"item.id === selectedItemId\"\n            (select)=\"itemClicked($event)\"\n          ></rcyl-item>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </ion-list>\n\n  <ng-template #noItems>\n    <div\n      style=\"height: 60vh; display: flex; width: 100%; flex-direction: column\"\n      align-items-center\n      justify-content-center\n    >\n      <div text-center *ngIf=\"items === null\">\n        <ion-spinner></ion-spinner><br />\n        <div font-medium>Loading...</div>\n      </div>\n      <div padding-horizontal text-center *ngIf=\"items?.length === 0\">\n        <ion-text color=\"primary\" text-large font-bold\n          >No Items found!</ion-text\n        >\n      </div>\n    </div>\n  </ng-template>\n</ion-content>\n<ion-footer no-box-shadow=\"\" *ngIf=\"selectedItemId\">\n  <ion-col size=\"12\">\n    <ion-button\n      centered\n      (click)=\"submit()\"\n      class=\"ion-no-margin\"\n      recykal-button\n      size=\"large\"\n      expand=\"block\"\n      color=\"primary\"\n    >\n      {{ options?.submitBtnText || \"Proceed\" }}\n    </ion-button>\n  </ion-col>\n</ion-footer>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ItemListComponent.ctorParameters = function () { return [
        { type: ItemListService },
        { type: ModalController }
    ]; };
    ItemListComponent.propDecorators = {
        options: [{ type: Input }],
        selectedItemIds: [{ type: Input }],
        itemSelected: [{ type: Output }]
    };
    return ItemListComponent;
}());
if (false) {
    /** @type {?} */
    ItemListComponent.prototype.options;
    /** @type {?} */
    ItemListComponent.prototype.selectedItemIds;
    /** @type {?} */
    ItemListComponent.prototype.itemSelected;
    /** @type {?} */
    ItemListComponent.prototype.selectedItemId;
    /** @type {?} */
    ItemListComponent.prototype.searching;
    /** @type {?} */
    ItemListComponent.prototype.query;
    /** @type {?} */
    ItemListComponent.prototype.items;
    /** @type {?} */
    ItemListComponent.prototype.originalList;
    /** @type {?} */
    ItemListComponent.prototype.totalItemCount;
    /**
     * @type {?}
     * @private
     */
    ItemListComponent.prototype.itemService;
    /**
     * @type {?}
     * @private
     */
    ItemListComponent.prototype.modal;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function BaseEntity() { }
if (false) {
    /** @type {?|undefined} */
    BaseEntity.prototype.id;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var OrderType = {
    SALE: "SALE",
    PURCHASE: "PURCHASE",
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Account = /** @class */ (function () {
    function Account(activated, authorities, email, firstName, langKey, lastName, login, imageUrl) {
        this.activated = activated;
        this.authorities = authorities;
        this.email = email;
        this.firstName = firstName;
        this.langKey = langKey;
        this.lastName = lastName;
        this.login = login;
        this.imageUrl = imageUrl;
    }
    return Account;
}());
if (false) {
    /** @type {?} */
    Account.prototype.activated;
    /** @type {?} */
    Account.prototype.authorities;
    /** @type {?} */
    Account.prototype.email;
    /** @type {?} */
    Account.prototype.firstName;
    /** @type {?} */
    Account.prototype.langKey;
    /** @type {?} */
    Account.prototype.lastName;
    /** @type {?} */
    Account.prototype.login;
    /** @type {?} */
    Account.prototype.imageUrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var User = /** @class */ (function () {
    function User(id, login, firstName, lastName, email, activated, langKey, authorities, createdBy, createdDate, lastModifiedBy, lastModifiedDate, password) {
        this.id = id ? id : null;
        this.login = login ? login : null;
        this.firstName = firstName ? firstName : null;
        this.lastName = lastName ? lastName : null;
        this.email = email ? email : null;
        this.activated = activated ? activated : false;
        this.langKey = langKey ? langKey : null;
        this.authorities = authorities ? authorities : null;
        this.createdBy = createdBy ? createdBy : null;
        this.createdDate = createdDate ? createdDate : null;
        this.lastModifiedBy = lastModifiedBy ? lastModifiedBy : null;
        this.lastModifiedDate = lastModifiedDate ? lastModifiedDate : null;
        this.password = password ? password : null;
    }
    return User;
}());
if (false) {
    /** @type {?} */
    User.prototype.id;
    /** @type {?} */
    User.prototype.login;
    /** @type {?} */
    User.prototype.firstName;
    /** @type {?} */
    User.prototype.lastName;
    /** @type {?} */
    User.prototype.email;
    /** @type {?} */
    User.prototype.activated;
    /** @type {?} */
    User.prototype.langKey;
    /** @type {?} */
    User.prototype.authorities;
    /** @type {?} */
    User.prototype.createdBy;
    /** @type {?} */
    User.prototype.createdDate;
    /** @type {?} */
    User.prototype.lastModifiedBy;
    /** @type {?} */
    User.prototype.lastModifiedDate;
    /** @type {?} */
    User.prototype.password;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RateQuantityComponent = /** @class */ (function () {
    function RateQuantityComponent(modalController) {
        this.modalController = modalController;
        this.complete = new EventEmitter();
    }
    /**
     * @return {?}
     */
    RateQuantityComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.quantity = this.orderItem.itemQty || 0;
        this.price = this.orderItem.itemPrice || 0;
    };
    /**
     * @return {?}
     */
    RateQuantityComponent.prototype.onSubmit = /**
     * @return {?}
     */
    function () {
        if (this.priceEdit) {
            if (this.price <= 0) {
                return;
            }
            this.orderItem.itemPrice = this.price;
        }
        if (this.qtyEdit) {
            if (this.quantity <= 0) {
                return;
            }
            this.orderItem.itemQty = this.quantity;
        }
        this.orderItem.itemTotal =
            this.orderItem.itemPrice * this.orderItem.itemQty;
        this.modalController.dismiss(this.orderItem, "SUBMIT");
    };
    /**
     * @return {?}
     */
    RateQuantityComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalController.dismiss();
    };
    RateQuantityComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-rate-quantity",
                    template: "<ion-header>\n  <ion-toolbar class=\"no-box-shadow\" mode=\"ios\">\n    <ion-buttons\n      (click)=\"closeModal()\"\n      slot=\"start\"\n      style=\"cursor: pointer\"\n      padding\n    >\n      <ion-icon\n        color=\"medium\"\n        slot=\"icon-only\"\n        style=\"width: 20px; margin-right: 3px\"\n        [icon]=\"'./assets/back-arrow.svg'\"\n      ></ion-icon>\n      <span class=\"back-btn\">Back</span>\n    </ion-buttons>\n    <ion-title modal-title>{{ title || \"Add Quantity & Rate\" }}</ion-title>\n  </ion-toolbar>\n</ion-header>\n\n<ion-content text-center>\n  <img [src]=\"orderItem?.item.icon\" width=\"56px\" />\n  <form (ngSubmit)=\"onSubmit()\" #rateQuantityForm1=\"ngForm\" id=\"form\">\n    <ion-grid>\n      <ion-row text-center=\"\" input-white=\"\">\n        <ion-col\n          size=\"12\"\n          text-center=\"\"\n          no-padding-left=\"\"\n          no-padding-right=\"\"\n        >\n          <ion-text\n            [style.background]=\"orderItem?.item.colorCode\"\n            text-center\n            font-medium=\"\"\n            color=\"medium\"\n            class=\"title-label\"\n            >{{ orderItem?.item.name }}</ion-text\n          >\n        </ion-col>\n\n        <!--EDIT PRICE-->\n        <ion-col\n          size=\"12\"\n          class=\"enter-quantity-label\"\n          *ngIf=\"priceEdit || priceEdit === qtyEdit\"\n        >\n          <ion-label margin-top=\"\" text-center=\"\" font-regular=\"\"\n            >ENTER PRICE</ion-label\n          >\n        </ion-col>\n        <ion-col\n          size=\"6\"\n          offset=\"3\"\n          text-center\n          *ngIf=\"priceEdit || priceEdit === qtyEdit\"\n        >\n          <ion-item class=\"edit-quantity-item\" lines=\"none\">\n            <ion-button\n              class=\"qty-btn minus-button\"\n              float-left=\"\"\n              [disabled]=\"price <= 0\"\n              (click)=\"price = price - 1; priceInput.setFocus()\"\n            >\n              <ion-icon color=\"medium\" padding-5=\"\" name=\"remove\"></ion-icon>\n            </ion-button>\n            <ion-input\n              class=\"enter-quantity-input\"\n              tabindex=\"1\"\n              maxlength=\"10\"\n              [tabIndex]=\"1\"\n              #priceInput\n              type=\"number\"\n              min=\"0\"\n              max=\"200\"\n              [(ngModel)]=\"price\"\n              placeholder=\"0.00\"\n              name=\"price\"\n              id=\"price\"\n            ></ion-input>\n            <ion-button\n              class=\"qty-btn plus-button\"\n              tabindex=\"500\"\n              float-right=\"\"\n              (click)=\"price = price + 1; priceInput.setFocus()\"\n            >\n              <ion-icon color=\"medium\" padding-5=\"\" name=\"add\"></ion-icon>\n            </ion-button>\n          </ion-item>\n          <ion-label\n            no-margin\n            slot=\"end\"\n            class=\"item-quantity-label\"\n            color=\"medium\"\n            text-medium\n            >{{ orderItem?.item?.unitType | titlecase }}</ion-label\n          >\n        </ion-col>\n\n        <!--EDIT QUANTITY-->\n        <ion-col\n          size=\"12\"\n          class=\"enter-quantity-label\"\n          *ngIf=\"qtyEdit || priceEdit === qtyEdit\"\n        >\n          <ion-label margin-top=\"\" text-center=\"\" font-regular=\"\"\n            >ENTER QUANTITY</ion-label\n          >\n        </ion-col>\n        <ion-col\n          size=\"6\"\n          offset=\"3\"\n          text-center\n          *ngIf=\"qtyEdit || priceEdit === qtyEdit\"\n        >\n          <ion-item border-radius-10=\"\" class=\"edit-quantity-item\" lines=\"none\">\n            <ion-button\n              min=\"0\"\n              class=\"qty-btn minus-button\"\n              target=\"400\"\n              float-left=\"\"\n              [disabled]=\"quantity <= 0\"\n              (click)=\"quantity = quantity - 1; qtyInput.setFocus()\"\n            >\n              <ion-icon\n                color=\"medium\"\n                mode=\"ios\"\n                padding-5=\"\"\n                name=\"remove\"\n              ></ion-icon>\n            </ion-button>\n            <ion-input\n              class=\"enter-quantity-input\"\n              tabindex=\"2\"\n              maxlength=\"10\"\n              #qtyInput\n              [tabIndex]=\"2\"\n              type=\"number\"\n              min=\"0\"\n              max=\"200\"\n              [(ngModel)]=\"quantity\"\n              placeholder=\"0\"\n              name=\"qty\"\n              id=\"qty\"\n            ></ion-input>\n            <ion-button\n              max=\"200\"\n              class=\"qty-btn plus-button\"\n              float-right=\"\"\n              (click)=\"quantity = quantity + 1; qtyInput.setFocus()\"\n            >\n              <ion-icon\n                color=\"medium\"\n                mode=\"ios\"\n                padding-5=\"\"\n                name=\"add\"\n              ></ion-icon>\n            </ion-button>\n          </ion-item>\n          <ion-label\n            no-margin\n            slot=\"end\"\n            class=\"item-quantity-label\"\n            color=\"medium\"\n            text-medium\n            >{{ orderItem?.item?.unitType | titlecase }}</ion-label\n          >\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n    <button type=\"submit\" tabindex=\"600\" #submitBtn [hidden]=\"true\">\n      Submit\n    </button>\n  </form>\n</ion-content>\n<ion-footer no-box-shadow>\n  <ion-col size=\"12\">\n    <ion-button\n      centered\n      type=\"submit\"\n      (click)=\"submitBtn.click()\"\n      class=\"ion-no-margin\"\n      recykal-button\n      size=\"large\"\n      expand=\"block\"\n      color=\"primary\"\n    >\n      Proceed\n    </ion-button>\n  </ion-col>\n</ion-footer>\n",
                    styles: [":host ion-range{--knob-background:var(--primary);--knob-size:32px;--bar-height:3px}:host .back-btn{font-family:font-book,font-medium;font-size:.8571rem}:host .range-tick{height:9px!important;width:2px;top:29px;background:#dcdcdc}:host .enter-quantity-label{font-size:14px;letter-spacing:2.4px;color:#27353c;margin-top:31.75px}:host .button-changes{margin-top:36px}:host .button-changes .button-text{font-size:20px;text-transform:none;letter-spacing:0}:host .price{padding:0;font-weight:700;font-size:22px;text-align:center;--padding-bottom:0px;--padding-top:0px}:host .price input{margin-bottom:6px!important}:host .native-input::-webkit-input-placeholder{font-family:font-bold!important}:host .title-label{border-radius:6px;font-size:1.286rem;padding:5px 12px}:host .price-label{font-size:14px;margin-top:0}:host .edit-quantity-item{--background:#e5eaed;--min-height:39px;--border-radius:4px;--inner-padding-end:0;--padding-start:0px;--margin-top:0px;max-width:194px;margin:0 auto;--padding-end:0px}:host .edit-quantity-item .enter-quantity-input{font-size:1.286rem;text-align:center;--padding-top:0;--padding-bottom:0;--padding-start:8px;--padding-end:8px;color:#27353c}:host .edit-quantity-item .item-quantity-label{color:#5b7583;font-size:1.231rem}:host .qty-btn{--padding-top:0px;height:39px;width:38px;--box-shadow:none;margin:0;--background:#bac4c9}:host .qty-btn ion-icon{font-size:2rem}:host .qty-btn.plus-button{--border-radius:0px 4px 4px 0px}:host .qty-btn.minus-button{--border-radius:4px 0px 0px 4px}"]
                }] }
    ];
    /** @nocollapse */
    RateQuantityComponent.ctorParameters = function () { return [
        { type: ModalController }
    ]; };
    RateQuantityComponent.propDecorators = {
        orderItem: [{ type: Input }],
        orderType: [{ type: Input }],
        title: [{ type: Input }],
        priceEdit: [{ type: Input }],
        qtyEdit: [{ type: Input }],
        editQtyRate: [{ type: Input }],
        complete: [{ type: Output }]
    };
    return RateQuantityComponent;
}());
if (false) {
    /** @type {?} */
    RateQuantityComponent.prototype.quantity;
    /** @type {?} */
    RateQuantityComponent.prototype.price;
    /** @type {?} */
    RateQuantityComponent.prototype.active;
    /** @type {?} */
    RateQuantityComponent.prototype.orderItem;
    /** @type {?} */
    RateQuantityComponent.prototype.orderType;
    /** @type {?} */
    RateQuantityComponent.prototype.title;
    /** @type {?} */
    RateQuantityComponent.prototype.priceEdit;
    /** @type {?} */
    RateQuantityComponent.prototype.qtyEdit;
    /** @type {?} */
    RateQuantityComponent.prototype.editQtyRate;
    /** @type {?} */
    RateQuantityComponent.prototype.complete;
    /**
     * @type {?}
     * @private
     */
    RateQuantityComponent.prototype.modalController;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
var ItemActions = {
    ADD_ITEM: "ADD_ITEM",
    UPDATE_ITEM: "UPDATE_ITEM",
    REMOVE_ITEM: "REMOVE_ITEM",
};
/**
 * @record
 */
function IAddItemButtonParams() { }
if (false) {
    /** @type {?} */
    IAddItemButtonParams.prototype.orderItems;
    /** @type {?} */
    IAddItemButtonParams.prototype.orderType;
    /** @type {?} */
    IAddItemButtonParams.prototype.locationId;
    /** @type {?|undefined} */
    IAddItemButtonParams.prototype.customerId;
    /** @type {?} */
    IAddItemButtonParams.prototype.orderId;
}
var AddItemButtonComponent = /** @class */ (function () {
    function AddItemButtonComponent(modalController) {
        this.modalController = modalController;
        this.itemSelect = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AddItemButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.url =
            this.params.orderType === OrderType.SALE
                ? "/catalog/sale-order-items"
                : "/catalog/items";
    };
    /**
     * @async open item list component in modal
     * to select item
     * @input options
     * @output IOrderItem
     */
    /**
     * \@async open item list component in modal
     * to select item
     * \@input options
     * \@output IOrderItem
     * @return {?}
     */
    AddItemButtonComponent.prototype.addItem = /**
     * \@async open item list component in modal
     * to select item
     * \@input options
     * \@output IOrderItem
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.params.locationId) {
                            console.error("Location Not found!");
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.modalController.create({
                                component: ItemListComponent,
                                componentProps: {
                                    selectedItemIds: map(this.params.orderItems, "itemId"),
                                    options: {
                                        url: this.url,
                                        params: {
                                            channelName: "B2B",
                                            locationId: this.params.locationId,
                                            customerId: this.params.customerId,
                                        },
                                    },
                                },
                            })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result && result.role === "SUBMIT") {
                                /** @type {?} */
                                var oitem = new OrderItem();
                                oitem.setItem(result.data);
                                _this.setItemQuantityRate(oitem, ItemActions.ADD_ITEM, {
                                    qtyEdit: true,
                                    priceEdit: _this.params.orderType === OrderType.SALE,
                                });
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Open item rate component in modal
     * to give rate and quantity of item
     * @input item
     * @output item
     */
    /**
     * Open item rate component in modal
     * to give rate and quantity of item
     * \@input item
     * \@output item
     * @param {?} oitem
     * @param {?=} action
     * @param {?=} props
     * @return {?}
     */
    AddItemButtonComponent.prototype.setItemQuantityRate = /**
     * Open item rate component in modal
     * to give rate and quantity of item
     * \@input item
     * \@output item
     * @param {?} oitem
     * @param {?=} action
     * @param {?=} props
     * @return {?}
     */
    function (oitem, action, props) {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalController.create({
                            component: RateQuantityComponent,
                            componentProps: {
                                orderItem: oitem,
                                orderType: this.params.orderType,
                                priceEdit: props ? props.priceEdit : null,
                                qtyEdit: props ? props.qtyEdit : null,
                                title: props ? props.title : "Add Quantity",
                                active: true,
                            },
                        })];
                    case 1:
                        modal = _a.sent();
                        modal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result && result.role === "SUBMIT") {
                                _this.itemSelect.emit(result.data);
                                // this.stepChanged.emit({
                                //   type: SaleEvents.ORDER_ITEM,
                                //   action: action || ItemActions.UPDATE_ITEM,
                                //   body: result.data
                                // });
                            }
                        }));
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AddItemButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-add-item-button",
                    template: "<ion-button\n  class=\"status-btn\"\n  (click)=\"addItem()\"\n  fill=\"outline\"\n  size=\"large\"\n  color=\"medium\"\n>\n  <ion-icon name=\"add\" class=\"ion-float-left\"></ion-icon>\n  <ion-text>Add Item</ion-text>\n</ion-button>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    AddItemButtonComponent.ctorParameters = function () { return [
        { type: ModalController }
    ]; };
    AddItemButtonComponent.propDecorators = {
        params: [{ type: Input }],
        itemSelect: [{ type: Output }]
    };
    return AddItemButtonComponent;
}());
if (false) {
    /** @type {?} */
    AddItemButtonComponent.prototype.params;
    /** @type {?} */
    AddItemButtonComponent.prototype.itemSelect;
    /**
     * @type {?}
     * @private
     */
    AddItemButtonComponent.prototype.url;
    /**
     * @type {?}
     * @private
     */
    AddItemButtonComponent.prototype.modalController;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ItemComponent = /** @class */ (function () {
    function ItemComponent() {
        this.select = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ItemComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    ItemComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-item",
                    template: "<ion-item\n  my-item\n  lines=\"none\"\n  (click)=\"select.emit(item)\"\n  [style.background]=\"item.colorCode || '#F4F9FA'\"\n>\n  <ion-avatar slot=\"start\">\n    <ion-img [src]=\"item.icon\"></ion-img>\n  </ion-avatar>\n  <ion-label>\n    <div class=\"item-name\">{{ item.name }}</div>\n    <p>\n      <ion-text\n        color=\"dark\"\n        *ngFor=\"let cat of item.categoryNodes; let $index = index\"\n        [class.font-bold]=\"$index == 0 && item?.categoryNodes.length > 1\"\n      >\n        {{ cat.name }}\n        <span [hidden]=\"$index + 1 === item?.categoryNodes.length\"> \u2022 </span>\n      </ion-text>\n    </p>\n  </ion-label>\n  <ion-icon\n    style=\"font-size: 19px\"\n    color=\"medium\"\n    *ngIf=\"!isSelected\"\n    class=\"icon-border\"\n    [src]=\"'./assets/forward-arrow.svg'\"\n    slot=\"end\"\n  ></ion-icon>\n  <ion-icon\n    *ngIf=\"isSelected\"\n    color=\"primary\"\n    [name]=\"'checkmark-circle'\"\n    slot=\"end\"\n  ></ion-icon>\n</ion-item>\n",
                    styles: [":host ion-item[my-item]{border-radius:6px;max-width:529px;margin:0 auto 20px;--padding-start:10px}:host ion-item[my-item] ion-avatar{margin-right:5px}:host ion-item[my-item] ion-label{margin:7px 0}:host ion-item[my-item] .item-name{font-size:1rem;font-family:font-bold}:host ion-item[my-item] p{margin:0}:host .font-bold{font-family:font-bold;text-transform:uppercase}"]
                }] }
    ];
    /** @nocollapse */
    ItemComponent.ctorParameters = function () { return []; };
    ItemComponent.propDecorators = {
        item: [{ type: Input }],
        isSelected: [{ type: Input }],
        select: [{ type: Output }]
    };
    return ItemComponent;
}());
if (false) {
    /** @type {?} */
    ItemComponent.prototype.item;
    /** @type {?} */
    ItemComponent.prototype.isSelected;
    /** @type {?} */
    ItemComponent.prototype.select;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ItemListModule = /** @class */ (function () {
    function ItemListModule() {
    }
    ItemListModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [ItemListComponent, ItemComponent],
                    entryComponents: [ItemListComponent],
                    imports: [CommonModule, IonicModule, FormsModule],
                    exports: [ItemListComponent, ItemComponent],
                    providers: [ItemListService],
                },] }
    ];
    return ItemListModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RateQuantityModule = /** @class */ (function () {
    function RateQuantityModule() {
    }
    RateQuantityModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RateQuantityComponent],
                    imports: [CommonModule, IonicModule, FormsModule],
                    entryComponents: [RateQuantityComponent],
                    exports: [RateQuantityComponent],
                },] }
    ];
    return RateQuantityModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddItemButtonModule = /** @class */ (function () {
    function AddItemButtonModule() {
    }
    AddItemButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AddItemButtonComponent],
                    imports: [CommonModule, IonicModule, ItemListModule, RateQuantityModule],
                    exports: [AddItemButtonComponent],
                },] }
    ];
    return AddItemButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var UpdateNotesService = /** @class */ (function () {
    function UpdateNotesService(http, toast, rcylOrdersService) {
        this.http = http;
        this.toast = toast;
        this.rcylOrdersService = rcylOrdersService;
    }
    /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    UpdateNotesService.prototype.addNotes = /**
     * @param {?} id
     * @param {?} data
     * @return {?}
     */
    function (id, data) {
        return this.http.post("/core/pickup-orders/" + id + "/notes", data);
    };
    /**
     * @param {?} err
     * @return {?}
     */
    UpdateNotesService.prototype.onFailed = /**
     * @param {?} err
     * @return {?}
     */
    function (err) {
        /** @type {?} */
        var errMsg = err.headers.get("X-RecykalApp-error");
        this.rcylOrdersService.presentToast(errMsg);
    };
    UpdateNotesService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    UpdateNotesService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: ToastController },
        { type: RcylOrdersService }
    ]; };
    /** @nocollapse */ UpdateNotesService.ngInjectableDef = ɵɵdefineInjectable({ factory: function UpdateNotesService_Factory() { return new UpdateNotesService(ɵɵinject(HttpClient), ɵɵinject(ToastController), ɵɵinject(RcylOrdersService)); }, token: UpdateNotesService, providedIn: "root" });
    return UpdateNotesService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    UpdateNotesService.prototype.http;
    /**
     * @type {?}
     * @private
     */
    UpdateNotesService.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    UpdateNotesService.prototype.rcylOrdersService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddNewNotesModalComponent = /** @class */ (function () {
    function AddNewNotesModalComponent(modalCtrl, noteService, rcylOrdersService, formBuilder) {
        this.modalCtrl = modalCtrl;
        this.noteService = noteService;
        this.rcylOrdersService = rcylOrdersService;
        this.formBuilder = formBuilder;
        this.roles = [
            { label: "Select Role", value: "" },
            { label: "Order", value: 0 },
            { label: "Pickup Executive", value: 1 },
        ];
    }
    /**
     * @return {?}
     */
    AddNewNotesModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.createNotesForm();
    };
    /**
     * @return {?}
     */
    AddNewNotesModalComponent.prototype.createNotesForm = /**
     * @return {?}
     */
    function () {
        this.notesForm = this.formBuilder.group({
            selectedRole: ["", Validators.required],
            note: ["", Validators.required],
        });
    };
    /**
     * @return {?}
     */
    AddNewNotesModalComponent.prototype.closeModal = /**
     * @return {?}
     */
    function () {
        this.modalCtrl.dismiss(null);
    };
    /**
     * @return {?}
     */
    AddNewNotesModalComponent.prototype.addNotes = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var newNotesObj = {
            forExecutive: this.notesForm.value.selectedRole,
            text: this.notesForm.value.note,
        };
        this.noteService.addNotes(this.orderId, newNotesObj).subscribe((/**
         * @param {?} res
         * @return {?}
         */
        function (res) {
            _this.modalCtrl.dismiss({ buttonClicked: "AddNotes" });
            _this.rcylOrdersService.presentToast("Note added for this order successfully");
        }), (/**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            // this.noteService.onFailed(error);
        }));
    };
    AddNewNotesModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-add-new-notes-modal",
                    template: "<ion-header>\n  <ion-toolbar mode=\"ios\">\n    <ion-title text-center> Add Notes </ion-title>\n    <ion-buttons slot=\"end\">\n      <ion-button (click)=\"closeModal()\">\n        <ion-icon slot=\"icon-only\" name=\"close-circle\"></ion-icon>\n      </ion-button>\n    </ion-buttons>\n  </ion-toolbar>\n</ion-header>\n<ion-content>\n  <ion-grid>\n    <form [formGroup]=\"notesForm\" name=\"notesForm\">\n      <ion-row>\n        <ion-col size=\"3\">\n          <ion-item input-item lines=\"none\">\n            <ion-label\n              text-small\n              class=\"ion-text-center ion-no-margin select-role-txt\"\n              >Select Role</ion-label\n            >\n          </ion-item>\n        </ion-col>\n        <ion-col size=\"6\">\n          <div>\n            <p-dropdown\n              [options]=\"roles\"\n              formControlName=\"selectedRole\"\n              name=\"selectedRole\"\n            ></p-dropdown>\n          </div>\n        </ion-col>\n        <ion-col size=\"12\">\n          <ion-item\n            input-item=\"\"\n            class=\"ion-padding-top\"\n            centered=\"\"\n            style=\"width: 95% !important\"\n            lines=\"none\"\n          >\n            <ion-textarea\n              centered=\"\"\n              font-medium=\"\"\n              formControlName=\"note\"\n              name=\"note\"\n              placeholder=\"Write your notes here\"\n            ></ion-textarea>\n          </ion-item>\n        </ion-col>\n      </ion-row>\n    </form>\n  </ion-grid>\n</ion-content>\n<ion-footer no-box-shadow>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"6\" offset=\"3\">\n        <ion-button\n          size=\"large\"\n          expand=\"block\"\n          text-regular\n          [disabled]=\"!notesForm.valid\"\n          color=\"primary\"\n          (click)=\"addNotes()\"\n          >Save</ion-button\n        >\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: [":host ::ng-deep .ui-dropdown{display:-webkit-box;display:flex;margin-top:15px;height:32px;border-radius:4px;margin-left:15px;margin-right:15px;border:1px solid #c7d2d8}:host ::ng-deep .ui-dropdown .ui-inputtext{font-size:12px!important}:host ::ng-deep .select-role-txt{padding-top:15px}"]
                }] }
    ];
    /** @nocollapse */
    AddNewNotesModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: UpdateNotesService },
        { type: RcylOrdersService },
        { type: FormBuilder }
    ]; };
    AddNewNotesModalComponent.propDecorators = {
        orderId: [{ type: Input }]
    };
    return AddNewNotesModalComponent;
}());
if (false) {
    /** @type {?} */
    AddNewNotesModalComponent.prototype.roles;
    /** @type {?} */
    AddNewNotesModalComponent.prototype.orderId;
    /** @type {?} */
    AddNewNotesModalComponent.prototype.notesForm;
    /**
     * @type {?}
     * @private
     */
    AddNewNotesModalComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    AddNewNotesModalComponent.prototype.noteService;
    /**
     * @type {?}
     * @private
     */
    AddNewNotesModalComponent.prototype.rcylOrdersService;
    /**
     * @type {?}
     * @private
     */
    AddNewNotesModalComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddNotesButtonComponent = /** @class */ (function () {
    function AddNotesButtonComponent(modalCtrl) {
        this.modalCtrl = modalCtrl;
        this.noteOutput = new EventEmitter();
    }
    /**
     * @return {?}
     */
    AddNotesButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @return {?}
     */
    AddNotesButtonComponent.prototype.addNewNotes = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var notesModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: AddNewNotesModalComponent,
                            componentProps: {
                                orderId: this.orderId,
                            },
                        })];
                    case 1:
                        notesModal = _a.sent();
                        notesModal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            console.log(data);
                            if (data && data.data) {
                                _this.noteOutput.emit(data.data);
                            }
                        }));
                        return [4 /*yield*/, notesModal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AddNotesButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-add-notes-button",
                    template: "<ion-button\n  class=\"status-btn\"\n  fill=\"outline\"\n  size=\"large\"\n  color=\"medium\"\n  (click)=\"addNewNotes()\"\n>\n  <ion-icon name=\"add\" class=\"ion-float-left\"></ion-icon>\n  <ion-text text-regular class=\"mrg-5\">Add Note</ion-text>\n</ion-button>\n",
                    styles: [".mrg-5{margin-left:5px}"]
                }] }
    ];
    /** @nocollapse */
    AddNotesButtonComponent.ctorParameters = function () { return [
        { type: ModalController }
    ]; };
    AddNotesButtonComponent.propDecorators = {
        orderId: [{ type: Input }],
        noteOutput: [{ type: Output }]
    };
    return AddNotesButtonComponent;
}());
if (false) {
    /** @type {?} */
    AddNotesButtonComponent.prototype.orderId;
    /** @type {?} */
    AddNotesButtonComponent.prototype.noteOutput;
    /**
     * @type {?}
     * @private
     */
    AddNotesButtonComponent.prototype.modalCtrl;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotesDetailsComponent = /** @class */ (function () {
    function NotesDetailsComponent() {
    }
    /**
     * @return {?}
     */
    NotesDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    NotesDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-notes-details",
                    template: "<ion-grid>\n  <ion-row>\n    <ion-col size=\"4\" *ngFor=\"let note of notes\">\n      <ion-card color=\"light\" class=\"my-item\">\n        <ion-card-header color=\"medium\" class=\"header-class\">\n          <ion-text color=\"light\" text-regular=\"\" font-regular=\"\"\n            >Note \u2022</ion-text\n          >\n          <ion-text color=\"light\" text-regular=\"\" font-bold=\"\">\n            {{ note.forExecutive ? \"Executive\" : \"Order\" }}</ion-text\n          >\n        </ion-card-header>\n        <ion-card-content class=\"ion-no-padding\">\n          <ion-grid class=\"grid-content\">\n            <ion-row>\n              <ion-col size=\"12\">\n                <ion-text color=\"medium\" text-regular=\"\">{{\n                  note?.text\n                }}</ion-text>\n              </ion-col>\n            </ion-row>\n            <ion-row>\n              <ion-col size=\"6\">\n                <ion-row>\n                  <ion-text\n                    class=\"ion-text-uppercase letter-spacing\"\n                    color=\"medium\"\n                    text-small\n                    font-bold=\"\"\n                    >Added by</ion-text\n                  >\n                </ion-row>\n                <ion-row>\n                  <ion-text text-regular=\"\" class=\"padding-5\" color=\"dark\">{{\n                    note?.createdBy\n                  }}</ion-text>\n                </ion-row>\n              </ion-col>\n              <ion-col size=\"6\" class=\"column-class\">\n                <ion-text\n                  text-small\n                  color=\"medium\"\n                  font-bold=\"\"\n                  class=\"ion-float-right text-class\"\n                  >{{ note?.createdAt | date: \"dd-MMM-yy hh:mm a\" }}</ion-text\n                >\n              </ion-col>\n            </ion-row>\n          </ion-grid>\n        </ion-card-content>\n      </ion-card>\n    </ion-col>\n  </ion-row>\n</ion-grid>\n",
                    styles: ["ion-card.my-item .header-class{height:34px;padding:6px 15px}ion-card.my-item .padding-5{padding-top:5px}ion-card.my-item .label{font-size:var(--ion-small-font-size);font-family:font-bold;letter-spacing:2px;text-transform:uppercase}ion-card.my-item .card-content-md{line-height:15px}ion-card.my-item .grid-content{min-height:130px;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:justify;justify-content:space-between}ion-card.my-item .letter-spacing{letter-spacing:2px}ion-card.my-item .column-class{position:relative}ion-card.my-item .column-class .text-class{position:absolute;bottom:5px;right:5px}"]
                }] }
    ];
    /** @nocollapse */
    NotesDetailsComponent.ctorParameters = function () { return []; };
    NotesDetailsComponent.propDecorators = {
        notes: [{ type: Input }]
    };
    return NotesDetailsComponent;
}());
if (false) {
    /** @type {?} */
    NotesDetailsComponent.prototype.notes;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NotesDetailsModule = /** @class */ (function () {
    function NotesDetailsModule() {
    }
    NotesDetailsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [NotesDetailsComponent],
                    imports: [CommonModule, IonicModule, FormsModule],
                    exports: [NotesDetailsComponent],
                },] }
    ];
    return NotesDetailsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddNewNotesModalModule = /** @class */ (function () {
    function AddNewNotesModalModule() {
    }
    AddNewNotesModalModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AddNewNotesModalComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        DropdownModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    entryComponents: [AddNewNotesModalComponent],
                    exports: [AddNewNotesModalComponent],
                },] }
    ];
    return AddNewNotesModalModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var AddNotesButtonModule = /** @class */ (function () {
    function AddNotesButtonModule() {
    }
    AddNotesButtonModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AddNotesButtonComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        NotesDetailsModule,
                        AddNewNotesModalModule,
                    ],
                    exports: [AddNotesButtonComponent],
                },] }
    ];
    return AddNotesButtonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentSummaryComponent = /** @class */ (function () {
    function PaymentSummaryComponent() {
    }
    /**
     * @return {?}
     */
    PaymentSummaryComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    PaymentSummaryComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-payment-summary",
                    template: "<p-table *ngIf=\"selectOrder\" [value]=\"[{}]\">\n  <ng-template pTemplate=\"header\">\n    <tr class=\"table-grey-bg\">\n      <th width=\"150px\">Date</th>\n      <th width=\"100px\" *ngIf=\"channel != 'RECYKAL'\">Payment ID</th>\n      <th width=\"150px\">Reference No.</th>\n      <th width=\"150px\">Payment Mode</th>\n      <th width=\"150px\">Status</th>\n      <th>Comment</th>\n      <th width=\"100px\">Amount</th>\n    </tr>\n  </ng-template>\n  <ng-template pTemplate=\"body\" let-columns>\n    <tr class=\"custom-table-body\">\n      <td>\n        <ion-text text-regular=\"\" color=\"medium\">{{\n          selectOrder?.payment?.paymentSettlement?.createdAt\n            | date: \"dd-MMM-yy hh:mm a\"\n        }}</ion-text>\n      </td>\n      <td *ngIf=\"channel != 'RECYKAL'\">\n        <ion-text text-regular=\"\" color=\"medium\">{{\n          selectOrder?.payment?.id\n        }}</ion-text>\n      </td>\n      <td>\n        <ion-text text-regular=\"\" color=\"dark\">{{\n          selectOrder?.payment?.paymentSettlement?.referenceNumber\n        }}</ion-text>\n      </td>\n      <td>\n        <ion-text text-regular=\"\" font-bold=\"\" color=\"medium\">{{\n          selectOrder?.payment?.paymentSettlement?.orderPaymentMode\n        }}</ion-text>\n      </td>\n      <td>\n        <ion-text text-regular=\"\" color=\"medium\">{{\n          selectOrder?.payment?.statusTitle\n        }}</ion-text>\n      </td>\n      <td>\n        <ion-text text-regular=\"\" color=\"medium\">{{\n          selectOrder?.payment?.paymentSettlement?.comment || \"-\"\n        }}</ion-text>\n      </td>\n      <td>\n        <ion-text text-regular=\"\" color=\"dark\" font-bold=\"\">{{\n          selectOrder?.payment?.paymentSettlement?.amount | currency: \"INR\"\n        }}</ion-text>\n      </td>\n    </tr>\n  </ng-template>\n</p-table>\n<ion-grid>\n  <ion-row class=\"border-box\">\n    <ion-col size=\"12\">\n      <ion-row>\n        <ion-col size=\"6\">\n          <ion-text text-medium=\"\" color=\"medium\"\n            >Amount\n            <span *ngIf=\"channel != 'RECYKAL'\">{{\n              selectOrder?.tradeType === \"S\" ? \"Received\" : \"Paid\"\n            }}</span>\n            <span *ngIf=\"channel == 'RECYKAL'\">{{\n              selectOrder?.tradeType === \"B\" ? \"Received\" : \"Paid\"\n            }}</span>\n          </ion-text>\n        </ion-col>\n        <ion-col size=\"6\">\n          <ion-text\n            text-medium=\"\"\n            class=\"ion-float-right\"\n            font-bold=\"\"\n            color=\"dark\"\n            >{{\n              selectOrder?.payment?.paymentSettlement?.amountPaid\n                | currency: \"INR\"\n            }}</ion-text\n          >\n        </ion-col>\n      </ion-row>\n      <ion-row>\n        <ion-col size=\"6\">\n          <ion-text text-medium=\"\" color=\"medium\"\n            >Balance to be\n            <span *ngIf=\"channel != 'RECYKAL'\">{{\n              selectOrder?.tradeType === \"S\" ? \"received\" : \"paid\"\n            }}</span>\n            <span *ngIf=\"channel == 'RECYKAL'\">{{\n              selectOrder?.tradeType === \"B\" ? \"received\" : \"paid\"\n            }}</span>\n          </ion-text>\n        </ion-col>\n        <ion-col size=\"6\">\n          <ion-text\n            text-medium=\"\"\n            class=\"ion-float-right\"\n            font-bold=\"\"\n            color=\"danger\"\n            >{{\n              selectOrder?.payment?.paymentSettlement?.amount -\n                selectOrder?.payment?.paymentSettlement?.amountPaid\n                | currency: \"INR\"\n            }}</ion-text\n          >\n        </ion-col>\n      </ion-row>\n    </ion-col>\n  </ion-row>\n</ion-grid>\n",
                    styles: [".table-grey-bg th{background-color:var(--ion-color-medium)!important;color:#fff!important;font-size:.8571rem;font-weight:400!important;height:34px}.table-grey-bg th:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.table-grey-bg th:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}.custom-table-body td{border:none}.custom-table-body td ion-text{--color:#5b7583!important;font-size:.8571rem}.custom-table-body td ion-img{width:40px!important;margin:0 auto!important}.custom-table-body td:nth-child(2) ion-text{font-weight:600;--color:#27353c!important}.custom-table-body td:nth-child(2) ion-text:last-child{font-weight:400!important}.custom-table-body td:nth-child(4) ion-text{font-weight:600;--color:#27353c!important}.custom-table-body:nth-child(even) td{background-color:#f4f9fa!important}.custom-table-body:nth-child(even) td:first-child{border-top-left-radius:6px;border-bottom-left-radius:6px}.custom-table-body:nth-child(even) td:last-child{border-top-right-radius:6px;border-bottom-right-radius:6px}.border-box{width:40%;float:right;border-radius:5px;border:1px solid #c7d2d8}"]
                }] }
    ];
    /** @nocollapse */
    PaymentSummaryComponent.ctorParameters = function () { return []; };
    PaymentSummaryComponent.propDecorators = {
        selectOrder: [{ type: Input }],
        channel: [{ type: Input }]
    };
    return PaymentSummaryComponent;
}());
if (false) {
    /** @type {?} */
    PaymentSummaryComponent.prototype.selectOrder;
    /** @type {?} */
    PaymentSummaryComponent.prototype.channel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var PaymentSummaryModule = /** @class */ (function () {
    function PaymentSummaryModule() {
    }
    PaymentSummaryModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [PaymentSummaryComponent],
                    imports: [CommonModule, TableModule, IonicModule],
                    exports: [PaymentSummaryComponent],
                },] }
    ];
    return PaymentSummaryModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/*import { InAppBrowser} from '@ionic-native/in-app-browser/ngx';*/
var FileManagerComponentModule = /** @class */ (function () {
    function FileManagerComponentModule() {
    }
    FileManagerComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RcylFileManagerComponent],
                    imports: [CommonModule, IonicModule, FileUploadModule],
                    entryComponents: [RcylFileManagerComponent],
                    providers: [
                    /*RcylFileManagerService,InAppBrowser*/
                    ],
                },] }
    ];
    return FileManagerComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylDocumentSampleForUploadComponent = /** @class */ (function () {
    function RcylDocumentSampleForUploadComponent(orderDetailsService, fileManagerService, modalController) {
        this.orderDetailsService = orderDetailsService;
        this.fileManagerService = fileManagerService;
        this.modalController = modalController;
        this.uploadClick = new EventEmitter();
    }
    /**
     * @return {?}
     */
    RcylDocumentSampleForUploadComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.fileManagerService.documentMap.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.dataMap = data;
        }));
    };
    /**
     * @return {?}
     */
    RcylDocumentSampleForUploadComponent.prototype.uploadClicked = /**
     * @return {?}
     */
    function () {
        this.uploadClick.emit(this.orderDocumentType);
    };
    /**
     * @return {?}
     */
    RcylDocumentSampleForUploadComponent.prototype.canUploadDelete = /**
     * @return {?}
     */
    function () {
        return this.orderDetailsService.canUploadDeleteDoc(this.orderDocumentType, this.orderDetails);
    };
    /**
     * @param {?} url
     * @return {?}
     */
    RcylDocumentSampleForUploadComponent.prototype.showImg = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var modal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!url) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.modalController.create({
                                component: ImgViewerComponent,
                                componentProps: {
                                    document: (/** @type {?} */ ({
                                        url: url,
                                        fileName: "Sample Document",
                                    })),
                                    componentOptions: {
                                        showDownload: false,
                                    },
                                },
                                cssClass: "full-width-modal",
                            })];
                    case 1:
                        modal = _a.sent();
                        return [4 /*yield*/, modal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RcylDocumentSampleForUploadComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-document-sample-for-upload",
                    template: "<ion-card *ngIf=\"orderDocumentType\" padding>\n  <!--  <ion-icon name=\"custom-camera\"></ion-icon>-->\n  <ion-grid no-padding>\n    <ion-row>\n      <ion-col size=\"12\" class=\"title-text\" text-center>\n        <ion-text color=\"dark\"\n          >Upload\n          {{ dataMap[orderDocumentType]?.displayText }} document</ion-text\n        >\n      </ion-col>\n      <ion-col size=\"12\" class=\"sub-title-text\" text-center margin-top>\n        <ion-text color=\"medium\"\n          >Example of accepted\n          {{ dataMap[orderDocumentType]?.displayText }}</ion-text\n        >\n      </ion-col>\n      <ion-col size=\"12\" class=\"sample-img\" text-center>\n        <ion-img\n          [src]=\"dataMap[orderDocumentType]?.sampleImg\"\n          (click)=\"showImg(dataMap[orderDocumentType]?.sampleImg)\"\n        ></ion-img>\n      </ion-col>\n      <ion-col size=\"12\" class=\"imp-note\" margin-top>\n        <ion-text>\n          <span font-bold=\"\">Important Note:</span>\n          The image/document should be properly scanned and all the corner of\n          the document should show. Upload\n          <span font-bold=\"\">high resolution</span> photo for approval.\n        </ion-text>\n      </ion-col>\n      <ion-col size=\"12\" text-center padding-top>\n        <ion-button\n          [disabled]=\"!canUploadDelete()\"\n          size=\"large\"\n          (click)=\"uploadClicked()\"\n        >\n          <ion-icon name=\"cloud-upload\"></ion-icon> &nbsp; Upload Document\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-card>\n",
                    styles: ["ion-card{border-radius:6px;box-shadow:none;background:no-repeat padding-box #fff}ion-card ion-grid .title-text ion-text{font-size:1.231rem;line-height:.7692rem;font-weight:700;letter-spacing:0}ion-card ion-grid .sub-title-text ion-text{font-size:.9231rem;line-height:13px;letter-spacing:0}ion-card ion-grid .sample-img ion-img{height:212px;width:162px;margin:0 auto}ion-card ion-grid .imp-note{font-size:.9231rem;line-height:13px}"]
                }] }
    ];
    /** @nocollapse */
    RcylDocumentSampleForUploadComponent.ctorParameters = function () { return [
        { type: RcylOrderDetailsService },
        { type: RcylFileManagerService },
        { type: ModalController }
    ]; };
    RcylDocumentSampleForUploadComponent.propDecorators = {
        orderDocumentType: [{ type: Input }],
        orderDetails: [{ type: Input }],
        uploadClick: [{ type: Output }]
    };
    return RcylDocumentSampleForUploadComponent;
}());
if (false) {
    /** @type {?} */
    RcylDocumentSampleForUploadComponent.prototype.orderDocumentType;
    /** @type {?} */
    RcylDocumentSampleForUploadComponent.prototype.orderDetails;
    /** @type {?} */
    RcylDocumentSampleForUploadComponent.prototype.uploadClick;
    /** @type {?} */
    RcylDocumentSampleForUploadComponent.prototype.dataMap;
    /**
     * @type {?}
     * @private
     */
    RcylDocumentSampleForUploadComponent.prototype.orderDetailsService;
    /**
     * @type {?}
     * @private
     */
    RcylDocumentSampleForUploadComponent.prototype.fileManagerService;
    /**
     * @type {?}
     * @private
     */
    RcylDocumentSampleForUploadComponent.prototype.modalController;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylDocumentSampleForUploadComponentModule = /** @class */ (function () {
    function RcylDocumentSampleForUploadComponentModule() {
    }
    RcylDocumentSampleForUploadComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RcylDocumentSampleForUploadComponent],
                    imports: [CommonModule, IonicModule, ImgViewerComponentModule],
                    entryComponents: [RcylDocumentSampleForUploadComponent],
                    exports: [RcylDocumentSampleForUploadComponent],
                    providers: [
                    /*RcylFileManagerService,InAppBrowser*/
                    ],
                },] }
    ];
    return RcylDocumentSampleForUploadComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderDocumentsManagerComponentModule = /** @class */ (function () {
    function RcylOrderDocumentsManagerComponentModule() {
    }
    RcylOrderDocumentsManagerComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RcylOrderDocumentsManagerComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FileUploadModule,
                        RcylDocumentSampleForUploadComponentModule,
                        RcylSharedModule,
                    ],
                    entryComponents: [RcylOrderDocumentsManagerComponent],
                    providers: [],
                    exports: [RcylOrderDocumentsManagerComponent],
                },] }
    ];
    return RcylOrderDocumentsManagerComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylFileManagerModule = /** @class */ (function () {
    function RcylFileManagerModule() {
    }
    RcylFileManagerModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        IonicModule,
                        FileManagerComponentModule,
                        FileUploadModule,
                        RcylOrderDocumentsManagerComponentModule,
                        RcylDocumentSampleForUploadComponentModule,
                        ImgViewerComponentModule,
                    ],
                    exports: [
                        FileManagerComponentModule,
                        RcylOrderDocumentsManagerComponentModule,
                        ImgViewerComponentModule,
                        RcylDocumentSampleForUploadComponentModule,
                    ],
                },] }
    ];
    return RcylFileManagerModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkAsDispatchedModalComponent = /** @class */ (function () {
    function MarkAsDispatchedModalComponent(modalController, event) {
        this.modalController = modalController;
        this.event = event;
        this.captureWeighBridgeImg = new EventEmitter();
        this.orderDocumentTypes = OrderDocumentTypes;
    }
    /**
     * @return {?}
     */
    MarkAsDispatchedModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.event.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_DOCUMENTS_UPDATED, (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data[_this.orderDocumentTypes.SELLER_WEIGH_BRIDGE]) {
                _this.sellerWeighBridgeImgs =
                    data[_this.orderDocumentTypes.SELLER_WEIGH_BRIDGE].documents;
            }
        }));
    };
    /**
     * @return {?}
     */
    MarkAsDispatchedModalComponent.prototype.dispatchedClicked = /**
     * @return {?}
     */
    function () {
        this.modalController
            .dismiss(this.orderDetails, "MARK_AS_DISPATCHED")
            .then();
    };
    /**
     * @return {?}
     */
    MarkAsDispatchedModalComponent.prototype.weighBridgeImgCapture = /**
     * @return {?}
     */
    function () {
        this.captureWeighBridgeImg.emit(this.orderDetails);
    };
    /**
     * @param {?} n
     * @return {?}
     */
    MarkAsDispatchedModalComponent.prototype.isFloat = /**
     * @param {?} n
     * @return {?}
     */
    function (n) {
        return Number(n) === n && n % 1 !== 0;
    };
    MarkAsDispatchedModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "lib-mark-as-dispatched-modal",
                    template: "<div class=\"inner-content\" padding>\n  <ion-grid>\n    <ion-row padding-top=\"\" padding-bottom=\"\">\n      <ion-col size=\"12\" text-center class=\"order-title flex-content-center\">\n        <ion-icon name=\"document\" color=\"dark\"></ion-icon>\n        <ion-text font-bold=\"\" color=\"dark\">{{\n          orderDetails.formattedId\n        }}</ion-text>\n      </ion-col>\n    </ion-row>\n    <ion-row>\n      <ion-col size=\"12\" text-center=\"\" class=\"item-name flex-content-center\">\n        <ion-img [src]=\"orderDetails?.orderItems[0]?.item?.icon\"></ion-img>\n        <ion-text font-bold=\"\" color=\"dark\">\n          {{ orderDetails?.orderItems[0]?.item?.name }}</ion-text\n        >\n      </ion-col>\n      <ion-col size=\"12\" text-center class=\"enter-qty\" margin-top=\"\">\n        <ion-text font-bold=\"\" color=\"dark\">ENTER QUANTITY</ion-text>\n      </ion-col>\n      <ion-col size=\"12\" class=\"enter-qty-text\" text-center=\"\">\n        <ion-text color=\"medium\" text-regular=\"\">\n          That you are dispatching to the buyer. Quantity should be the same as\n          in weigh bridge bill\n        </ion-text>\n      </ion-col>\n      <ion-col\n        size=\"12\"\n        text-center\n        margin-top=\"\"\n        margin-bottom=\"\"\n        class=\"qty-input\"\n      >\n        <ion-item\n          lines=\"none\"\n          [ngClass]=\"{\n            'item-error':\n              (orderDetails.orderItems[0].verifyQty <= 0 &&\n                orderDetails.orderItems[0].verifyQty != null) ||\n              isFloat(orderDetails.orderItems[0].verifyQty)\n          }\"\n        >\n          <ion-input\n            #qtyInput\n            no-padding=\"\"\n            no-margin\n            font-bold\n            [(ngModel)]=\"orderDetails.orderItems[0].verifyQty\"\n            maxlength=\"10\"\n            clear-on-edit\n            type=\"number\"\n          ></ion-input>\n          <ion-label no-margin slot=\"end\" text-medium color=\"medium\">{{\n            orderDetails?.orderItems[0]?.item?.unitType\n          }}</ion-label>\n          <div no-margin slot=\"end\" class=\"plus-minus-btn\">\n            <ion-icon\n              name=\"arrow-dropup\"\n              color=\"medium\"\n              (click)=\"\n                orderDetails.orderItems[0].verifyQty =\n                  orderDetails.orderItems[0].verifyQty + 1\n              \"\n            ></ion-icon>\n            <ion-icon\n              name=\"arrow-dropdown\"\n              color=\"medium\"\n              (click)=\"\n                orderDetails.orderItems[0].verifyQty > 0\n                  ? (orderDetails.orderItems[0].verifyQty =\n                      orderDetails.orderItems[0].verifyQty - 1)\n                  : (orderDetails.orderItems[0].verifyQty = 0)\n              \"\n            >\n            </ion-icon>\n          </div>\n        </ion-item>\n\n        <!--<ion-input [(ngModel)]=\"orderDetails.orderItems[0].verifyQty\" clear-on-edit type=\"number\">\n                    <ion-text text-regular text-capitalize>{{orderDetails?.orderItems[0]?.item?.unitType | lowercase}}</ion-text>\n                    <div no-margin slot=\"end\" class=\"plus-minus-btn\">\n                        <ion-icon name=\"arrow-dropup\" color=\"medium\" (click)=\"qty = qty + 1 \"></ion-icon>\n                        <ion-icon name=\"arrow-dropdown\" color=\"medium\" (click)=\"qty > 0 ? qty = qty - 1 : qty = 0\"></ion-icon>\n                    </div>\n                </ion-input>-->\n      </ion-col>\n      <ion-col size=\"12\" text-center=\"\" class=\"upload-title\">\n        <ion-text font-bold=\"\" color=\"dark\">Upload Weigh-bridge</ion-text>\n      </ion-col>\n      <ion-col size=\"12\" text-center=\"\" class=\"upload-sub-title\">\n        <ion-text color=\"medium\"\n          >Before & after loading both bills required for weigh bridge</ion-text\n        >\n      </ion-col>\n      <ion-col size=\"12\" class=\"img-list\">\n        <!--\n                [showDelete]=\"(order?.status === 'CREATED')\"\n                [showCapture]=\"(order?.status === 'CREATED')\"-->\n        <rcyl-img-list\n          [docList]=\"sellerWeighBridgeImgs\"\n          (onCapture)=\"weighBridgeImgCapture()\"\n          [docType]=\"orderDocumentTypes.SELLER_WEIGH_BRIDGE\"\n          [downloadDocumentCallback]=\"deleteDocumentCallback\"\n          [deleteDocumentCallback]=\"deleteDocumentCallback\"\n          [showDelete]=\"true\"\n          [showCapture]=\"true\"\n        ></rcyl-img-list>\n      </ion-col>\n      <ion-col size=\"12\" text-center=\"\" class=\"upload-note\">\n        <ion-text color=\"medium\">\n          <i>\n            <span font-bold=\"\">Note \u2022</span> You can dispatch order only after\n            uploading the weigh-bridge bills\n          </i>\n        </ion-text>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</div>\n<ion-footer no-border>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-button\n          [disabled]=\"!this.sellerWeighBridgeImgs.length\"\n          color=\"primary\"\n          size=\"large\"\n          expand=\"block\"\n          (click)=\"dispatchedClicked()\"\n        >\n          Mark as dispatched\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: ["[font-bold]{font-weight:700}[no-border]{border-width:0!important;--border-width:0px!important}.order-title{text-transform:uppercase;opacity:1}.order-title ion-text{font-size:20px;line-height:34px}.item-name ion-img{width:22px;height:22px}.item-name ion-text{font-size:20px;line-height:20px;letter-spacing:0}.enter-qty{font-size:1.077rem;line-height:1.077rem;letter-spacing:2.8px}.enter-qty-text{font-size:1.077rem;line-height:15px;letter-spacing:0}.qty-input ion-item{width:42vw;margin:5px auto;--border-radius:10px;--background:#f2f2f2 0% 0% no-repeat padding-box}.qty-input ion-item ion-input{font-size:20px;line-height:27px;height:50px;padding:0!important}.qty-input ion-item ion-label{font-size:1.231rem;margin-left:5px;line-height:27px;padding-right:10px;text-transform:capitalize}.qty-input ion-item .plus-minus-btn{width:20px;position:absolute;right:0;top:0}.qty-input ion-item .plus-minus-btn :first-child{margin-bottom:-11px}.qty-input ion-item .plus-minus-btn ion-icon{width:100%;font-size:1.429rem}.upload-title{font-size:1.077rem;line-height:1.077rem;letter-spacing:2.8px;text-transform:uppercase}.upload-sub-title{font-size:.9231rem;line-height:1.077rem;letter-spacing:0}.upload-note{letter-spacing:0;font-size:.9231rem;line-height:12px}.flex-content-center{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}"]
                }] }
    ];
    /** @nocollapse */
    MarkAsDispatchedModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: Events }
    ]; };
    MarkAsDispatchedModalComponent.propDecorators = {
        orderDetails: [{ type: Input }],
        sellerWeighBridgeImgs: [{ type: Input }],
        captureWeighBridgeImg: [{ type: Output }],
        deleteDocumentCallback: [{ type: Input }],
        downloadDocumentCallback: [{ type: Input }]
    };
    return MarkAsDispatchedModalComponent;
}());
if (false) {
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.orderDetails;
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.sellerWeighBridgeImgs;
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.captureWeighBridgeImg;
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.deleteDocumentCallback;
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.downloadDocumentCallback;
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.qty;
    /** @type {?} */
    MarkAsDispatchedModalComponent.prototype.orderDocumentTypes;
    /**
     * @type {?}
     * @private
     */
    MarkAsDispatchedModalComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    MarkAsDispatchedModalComponent.prototype.event;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkQualityCheckModalComponent = /** @class */ (function () {
    function MarkQualityCheckModalComponent(modalController, events, formBuilder) {
        this.modalController = modalController;
        this.events = events;
        this.formBuilder = formBuilder;
        this.captureLabReportImg = new EventEmitter();
        this.orderDocumentTypes = OrderDocumentTypes;
    }
    /**
     * @return {?}
     */
    MarkQualityCheckModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.createQcForm();
        this.events.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_DOCUMENTS_UPDATED, (/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data && data[_this.orderDocumentTypes.LAB_REPORT]) {
                _this.orderLabReportDocs =
                    data[_this.orderDocumentTypes.LAB_REPORT].documents;
            }
        }));
        if (this.orderDetails && this.orderDetails.orderItems) {
            this.orderDetails.orderItems.forEach((/**
             * @param {?} item
             * @param {?} key
             * @return {?}
             */
            function (item, key) {
                if (_this.orderDetails.orderItems[key].rejectedQty === undefined) {
                    _this.orderDetails.orderItems[key].rejectedQty = 0;
                }
                if (_this.orderDetails.orderItems[key].deductedPercentage === undefined) {
                    _this.orderDetails.orderItems[key].deductedPercentage = 0;
                }
            }));
        }
    };
    /**
     * @return {?}
     */
    MarkQualityCheckModalComponent.prototype.createQcForm = /**
     * @return {?}
     */
    function () {
        this.qcForm = this.formBuilder.group({
            rejectedQty: ["", Validators.required],
            deductedPercentage: ["", Validators.required],
        });
    };
    /**
     * @return {?}
     */
    MarkQualityCheckModalComponent.prototype.doneClicked = /**
     * @return {?}
     */
    function () {
        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
            eventName: "MARKETPLACE_BEGIN_QC_CLICKED",
            params: {
                orderId: this.orderDetails.id,
            },
        });
        this.modalController
            .dismiss({
            id: this.orderDetails.id,
            orderItems: this.orderDetails.orderItems,
        }, "QC_DONE_CLICKED")
            .then();
    };
    /**
     * @return {?}
     */
    MarkQualityCheckModalComponent.prototype.labReportImgCapture = /**
     * @return {?}
     */
    function () {
        this.captureLabReportImg.emit(this.orderDetails);
    };
    /**
     * @param {?} n
     * @return {?}
     */
    MarkQualityCheckModalComponent.prototype.isFloat = /**
     * @param {?} n
     * @return {?}
     */
    function (n) {
        return Number(n) === n && n % 1 !== 0;
    };
    MarkQualityCheckModalComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-mark-qc-check-modal",
                    template: "<div class=\"inner-content\" padding>\n  <form [formGroup]=\"qcForm\">\n    <ion-grid>\n      <ion-row>\n        <ion-col size=\"12\" text-center class=\"order-title flex-content-center\">\n          <ion-icon name=\"document\" color=\"dark\"></ion-icon>&nbsp;\n          <ion-text font-bold=\"\" color=\"dark\">\n            {{ orderDetails?.formattedId }}</ion-text\n          >\n        </ion-col>\n      </ion-row>\n      <ion-row>\n        <ion-col\n          size=\"12\"\n          no-padding-top\n          text-center=\"\"\n          class=\"item-name flex-content-center\"\n        >\n          <ion-img [src]=\"orderDetails?.orderItems[0].item?.icon\"></ion-img>\n          <ion-text font-bold=\"\" color=\"dark\">{{\n            orderDetails?.orderItems[0].item?.name\n          }}</ion-text>\n        </ion-col>\n        <ion-col\n          size=\"12\"\n          text-center\n          class=\"enter-qty\"\n          margin-top=\"\"\n          padding-top\n        >\n          <ion-text font-bold=\"\" color=\"dark\">ENTER PERCENT DEDUCTION</ion-text>\n          <!--<ion-text font-bold=\"\" color=\"dark\">&</ion-text>\n                    <br/>\n                    <ion-text font-bold=\"\" color=\"dark\">REJECTED WEIGHT</ion-text>-->\n        </ion-col>\n        <ion-col size=\"12\" class=\"enter-qty-text\" text-center=\"\">\n          <ion-text color=\"medium\" text-regular=\"\">\n            Enter the percentage you want to deduct\n          </ion-text>\n        </ion-col>\n        <ion-col size=\"12\" text-center margin-bottom=\"\" class=\"qty-input\">\n          <ion-item\n            lines=\"none\"\n            [ngClass]=\"{\n              'item-error':\n                (orderDetails?.orderItems[0].deductedPercentage <= 0 &&\n                  orderDetails?.orderItems[0].deductedPercentage != null) ||\n                isFloat(orderDetails?.orderItems[0].deductedPercentage)\n            }\"\n          >\n            <ion-input\n              #qtyInput\n              no-padding=\"\"\n              no-margin\n              font-bold\n              [(ngModel)]=\"orderDetails?.orderItems[0].deductedPercentage\"\n              maxlength=\"10\"\n              clear-on-edit\n              name=\"deductedPercentage\"\n              formControlName=\"deductedPercentage\"\n              type=\"number\"\n              required=\"\"\n            ></ion-input>\n            <ion-label no-margin slot=\"end\" text-medium color=\"medium\">\n              %\n            </ion-label>\n            <div no-margin slot=\"end\" class=\"plus-minus-btn\">\n              <ion-icon\n                name=\"arrow-dropup\"\n                color=\"medium\"\n                (click)=\"\n                  orderDetails?.orderItems[0].deductedPercentage =\n                    orderDetails?.orderItems[0].deductedPercentage + 1\n                \"\n              ></ion-icon>\n              <ion-icon\n                name=\"arrow-dropdown\"\n                color=\"medium\"\n                (click)=\"\n                  orderDetails?.orderItems[0].deductedPercentage > 0\n                    ? (orderDetails?.orderItems[0].deductedPercentage =\n                        orderDetails?.orderItems[0].deductedPercentage - 1)\n                    : (orderDetails?.orderItems[0].deductedPercentage = 0)\n                \"\n              >\n              </ion-icon>\n            </div>\n          </ion-item>\n        </ion-col>\n\n        <ion-col size=\"12\" text-center class=\"enter-qty\" margin-top=\"\">\n          <ion-text font-bold=\"\" color=\"dark\">ENTER REJECTED QUANTITY</ion-text>\n        </ion-col>\n        <ion-col size=\"12\" class=\"enter-qty-text\" text-center=\"\">\n          <ion-text color=\"medium\" text-regular=\"\">\n            Enter the quantity you want to reject and deduct\n          </ion-text>\n        </ion-col>\n        <ion-col size=\"12\" text-center margin-bottom=\"\" class=\"qty-input\">\n          <ion-item\n            lines=\"none\"\n            [ngClass]=\"{\n              'item-error':\n                (orderDetails?.orderItems[0].rejectedQty <= 0 &&\n                  orderDetails?.orderItems[0].rejectedQty != null) ||\n                isFloat(orderDetails?.orderItems[0].rejectedQty)\n            }\"\n          >\n            <ion-input\n              #qtyInput\n              no-padding=\"\"\n              no-margin\n              font-bold\n              [(ngModel)]=\"orderDetails?.orderItems[0].rejectedQty\"\n              maxlength=\"10\"\n              clear-on-edit\n              name=\"rejectedQty\"\n              formControlName=\"rejectedQty\"\n              type=\"number\"\n              required=\"\"\n            ></ion-input>\n            <ion-label no-margin slot=\"end\" text-medium color=\"medium\">{{\n              orderDetails?.orderItems[0]?.item?.unitType\n            }}</ion-label>\n            <div no-margin slot=\"end\" class=\"plus-minus-btn\">\n              <ion-icon\n                name=\"arrow-dropup\"\n                color=\"medium\"\n                (click)=\"\n                  orderDetails?.orderItems[0].rejectedQty =\n                    orderDetails?.orderItems[0].rejectedQty + 1\n                \"\n              ></ion-icon>\n              <ion-icon\n                name=\"arrow-dropdown\"\n                color=\"medium\"\n                (click)=\"\n                  orderDetails?.orderItems[0].rejectedQty > 0\n                    ? (orderDetails?.orderItems[0].rejectedQty =\n                        orderDetails?.orderItems[0].rejectedQty - 1)\n                    : (orderDetails?.orderItems[0].rejectedQty = 0)\n                \"\n              >\n              </ion-icon>\n            </div>\n          </ion-item>\n        </ion-col>\n\n        <ion-col size=\"12\" text-center=\"\" margin-top class=\"upload-title\">\n          <ion-text font-bold=\"\" color=\"dark\">Upload Lab Reports</ion-text>\n        </ion-col>\n        <ion-col size=\"12\" text-center=\"\" class=\"upload-sub-title\">\n          <ion-text color=\"medium\"\n            >This reports are required as proof of deductions</ion-text\n          >\n        </ion-col>\n        <ion-col size=\"12\" class=\"img-list\">\n          <rcyl-img-list\n            [docList]=\"orderLabReportDocs\"\n            (onCapture)=\"labReportImgCapture()\"\n            [docType]=\"orderDocumentTypes.LAB_REPORT\"\n            [downloadDocumentCallback]=\"deleteDocumentCallback\"\n            [deleteDocumentCallback]=\"deleteDocumentCallback\"\n            [showDelete]=\"true\"\n            [showCapture]=\"true\"\n          ></rcyl-img-list>\n        </ion-col>\n        <ion-col size=\"12\" text-center=\"\" class=\"upload-note\">\n          <ion-text color=\"medium\">\n            <i>\n              <span font-bold=\"\">Note \u2022</span> You can mark the order as QC'ed\n              only after uploading the lab reports\n            </i>\n          </ion-text>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </form>\n</div>\n<ion-footer no-border>\n  <ion-grid>\n    <ion-row>\n      <ion-col size=\"12\">\n        <ion-button\n          [disabled]=\"qcForm.invalid || orderLabReportDocs?.length <= 0\"\n          color=\"primary\"\n          size=\"large\"\n          expand=\"block\"\n          (click)=\"doneClicked()\"\n        >\n          Done\n        </ion-button>\n      </ion-col>\n    </ion-row>\n  </ion-grid>\n</ion-footer>\n",
                    styles: ["[font-bold]{font-weight:700}[no-border]{border-width:0!important;--border-width:0px!important}[no-padding-top]{padding-top:0;--padding-top:0}.order-title{text-transform:uppercase;opacity:1}.order-title ion-text{font-size:20px;line-height:34px}.item-name ion-img{width:22px;height:22px}.item-name ion-text{font-size:20px;line-height:20px;letter-spacing:0}.enter-qty{font-size:15px;line-height:1.077rem;letter-spacing:2.8px}.enter-qty-text{font-size:1.077rem;line-height:15px;letter-spacing:0}.qty-input ion-item{width:42vw;margin:5px auto;--border-radius:10px;--background:#f2f2f2 0% 0% no-repeat padding-box}.qty-input ion-item ion-input{font-size:20px;line-height:27px;height:50px;padding:0!important;--color:var(--ion-color-danger)}.qty-input ion-item ion-label{font-size:1.231rem;margin-left:5px;line-height:27px;padding-right:10px;padding-left:5px;text-transform:capitalize}.qty-input ion-item .plus-minus-btn{width:20px;position:absolute;right:0;top:0}.qty-input ion-item .plus-minus-btn :first-child{margin-bottom:-11px}.qty-input ion-item .plus-minus-btn ion-icon{width:100%;font-size:1.429rem}.upload-title{font-size:1.077rem;line-height:1.077rem;letter-spacing:2.8px;text-transform:uppercase}.upload-sub-title{font-size:.9231rem;line-height:1.077rem;letter-spacing:0}.upload-note{letter-spacing:0;font-size:.9231rem;line-height:12px}.flex-content-center{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}"]
                }] }
    ];
    /** @nocollapse */
    MarkQualityCheckModalComponent.ctorParameters = function () { return [
        { type: ModalController },
        { type: Events },
        { type: FormBuilder }
    ]; };
    MarkQualityCheckModalComponent.propDecorators = {
        orderDetails: [{ type: Input }],
        orderLabReportDocs: [{ type: Input }],
        deleteDocumentCallback: [{ type: Input }],
        downloadDocumentCallback: [{ type: Input }],
        captureLabReportImg: [{ type: Output }]
    };
    return MarkQualityCheckModalComponent;
}());
if (false) {
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.orderDetails;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.orderLabReportDocs;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.deleteDocumentCallback;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.downloadDocumentCallback;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.captureLabReportImg;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.qty;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.qcForm;
    /** @type {?} */
    MarkQualityCheckModalComponent.prototype.orderDocumentTypes;
    /**
     * @type {?}
     * @private
     */
    MarkQualityCheckModalComponent.prototype.modalController;
    /**
     * @type {?}
     * @private
     */
    MarkQualityCheckModalComponent.prototype.events;
    /**
     * @type {?}
     * @private
     */
    MarkQualityCheckModalComponent.prototype.formBuilder;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarketOrderDetailsComponent = /** @class */ (function () {
    function MarketOrderDetailsComponent(orderDetailsService, platform, modalCtrl, loadingCtrl, toast, event, rcylOrdersService, alertController, fileManagerService, orderLogisticsService) {
        var _this = this;
        this.orderDetailsService = orderDetailsService;
        this.platform = platform;
        this.modalCtrl = modalCtrl;
        this.loadingCtrl = loadingCtrl;
        this.toast = toast;
        this.event = event;
        this.rcylOrdersService = rcylOrdersService;
        this.alertController = alertController;
        this.fileManagerService = fileManagerService;
        this.orderLogisticsService = orderLogisticsService;
        this.viewQualityReqClicked = new EventEmitter();
        this.captureOrderItemImg = new EventEmitter();
        /*@Output() orderItemImgClicked = new EventEmitter<IDocument>();
            @Output() orderItemImgDelete = new EventEmitter<IDocument>();*/
        this.captureWeighBridgeImg = new EventEmitter();
        /*@Output() weighBridgeImgClicked = new EventEmitter<IDocument>();
            @Output() weighBridgeImgDelete = new EventEmitter<IDocument>();*/
        this.captureLabReportImg = new EventEmitter();
        /*@Output() labReportImgClicked = new EventEmitter<IDocument>();
            @Output() labReportImgDelete = new EventEmitter<IDocument>();*/
        // file manager events
        this.selectAndUploadImgDocument = new EventEmitter();
        this.downloadDocument = new EventEmitter();
        this.downloadProformaInvoice = new EventEmitter();
        this.orderStatuses = OrderStatus;
        this.orderDocumentTypes = OrderDocumentTypes;
        this.orderDetailsSubscriber = new Subscription();
        this.orderLogisticsDetailsSubscription = new Subscription();
        this.downloadFile = (/**
         * @param {?} orderDoc
         * @return {?}
         */
        function (orderDoc) {
            if (_this.platform.is("cordova")) {
                _this.downloadDocument.emit(orderDoc);
            }
            else {
                _this.fileManagerService.downloadDocumentInBrowser(orderDoc);
            }
        });
        this.confirmAndDeleteDocument = (/**
         * @param {?} orderDoc
         * @return {?}
         */
        function (orderDoc) {
            return _this.fileManagerService.confirmAndDeleteDocument(orderDoc);
        });
    }
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /*this.fileManagerService
                .onUploadSuccess
                .subscribe((data) => {
                    console.log('onFIleUp', data);
                    this.getDetails();
                });*/
        /*this.APP_DATA = this.orderService.APP_DATA;*/
        this.isDesktop = this.platform.width() > 500;
        this.event.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, (/**
         * @param {?} action
         * @param {?} data
         * @return {?}
         */
        function (action, data) {
            _this.getOrderDetails();
            _this.getOrderStatusLog();
        }));
        this.fileManagerService.documentMap.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.orderDocuments = data;
        }));
        this.captureWeighBridgeImg.subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            console.log(data);
        }));
        this.event.subscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_LOGISTIC_DETAILS_UPDATED, (/**
         * @return {?}
         */
        function () {
            _this.getOrderLogisticsDetails();
        }));
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.getOrderDetails();
        this.getOrderStatusLog();
        this.getOrderLogisticsDetails();
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.getOrderDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderDetailsSubscriber = this.orderDetailsService
            .getOrder(this.orderId)
            .subscribe((/**
         * @param {?} result
         * @return {?}
         */
        function (result) {
            _this.order = result;
            _this.fetchAdditionalComments();
            if (_this.order.status === "MATERIAL_RECEIVED") {
                if (_this.order.saleOrder) {
                    _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
                        eventName: "MARKETPLACE_RECEIVED_TRANSACTION_OPENED",
                        params: {
                            orderId: _this.order.id,
                        },
                    });
                }
                else {
                    _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
                        eventName: "MARKETPLACE_DELIVERED_TRANSACTION_OPENED",
                        params: {
                            orderId: _this.order.id,
                        },
                    });
                }
            }
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.orderDetailsService.onFailed(err);
        }));
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.getOrderLogisticsDetails = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderLogisticsDetailsSubscription = this.orderLogisticsService
            .getOrderLogisticsDetails(this.orderId)
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            if (data) {
                _this.orderLogisticsDetails = (/** @type {?} */ (data));
            }
        }));
    };
    /**
     * @private
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.getOrderStatusLog = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderDetailsService
            .getOrderChangeLogs(toNumber(this.orderId))
            .subscribe((/**
         * @param {?} logs
         * @return {?}
         */
        function (logs) {
            _this.orderStatusLogs = reverse(logs);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.orderDetailsService.onFailed(err);
        }));
    };
    /**
     * @param {?} statusName
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.containsInStatusLog = /**
     * @param {?} statusName
     * @return {?}
     */
    function (statusName) {
        if (this.orderStatusLogs) {
            return this.orderStatusLogs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.id && item.toStatus === statusName ? item : false;
            })).length;
        }
        else {
            return 0;
        }
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.openCancelOrderDialog = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.getConfig.subscribe((/**
                 * @param {?} data
                 * @return {?}
                 */
                function (data) {
                    _this.showOrderCancelDialog(data, "ORDER_CANCEL");
                }));
                return [2 /*return*/];
            });
        });
    };
    /**
     * @param {?} data
     * @param {?} type
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.showOrderCancelDialog = /**
     * @param {?} data
     * @param {?} type
     * @return {?}
     */
    function (data, type) {
        return __awaiter(this, void 0, void 0, function () {
            var cancelModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: CancelReasonModalComponent,
                            cssClass: "custom-bottom-sheet",
                            componentProps: {
                                reasons: this.order.saleOrder
                                    ? data.marketplace.orderCancellationReasonsForSeller
                                    : data.marketplace.orderCancellationReasonsForBuyer,
                                type: type,
                                formattedId: this.order.formattedId,
                            },
                        })];
                    case 1:
                        cancelModal = _a.sent();
                        cancelModal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result.data) {
                                _this.cancelOrder({ orderId: _this.order.id, reason: result.data });
                            }
                        }));
                        return [4 /*yield*/, cancelModal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @param {?} cancelData
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.cancelOrder = /**
     * @param {?} cancelData
     * @return {?}
     */
    function (cancelData) {
        var _this = this;
        this.presentLoading().then((/**
         * @return {?}
         */
        function () {
            _this.orderDetailsService.cancelOrder(cancelData).subscribe((/**
             * @param {?} result
             * @return {?}
             */
            function (result) {
                _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "CANCELLED", result);
                _this.loadingCtrl.dismiss().then();
                _this.rcylOrdersService.presentToast("Order cancelled").then();
                setTimeout((/**
                 * @return {?}
                 */
                function () {
                    _this.getOrderDetails();
                }), 200);
            }), (/**
             * @param {?} err
             * @return {?}
             */
            function (err) {
                _this.orderDetailsService.onFailed(err);
                _this.loadingCtrl.dismiss().then();
            }));
        }));
    };
    /**
     * @param {?=} message
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.presentLoading = /**
     * @param {?=} message
     * @return {?}
     */
    function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var loading;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadingCtrl.create({
                            message: message || "Please wait...",
                            cssClass: "custom-class custom-loading",
                        })];
                    case 1:
                        loading = _a.sent();
                        return [4 /*yield*/, loading.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @param {?} item
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.viewQualityRequirementClicked = /**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        this.viewQualityReqClicked.emit(item);
    };
    /**
     * @param {?} toLocationId
     * @param {?} orderId
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.promptFormMarkAsReceived = /**
     * @param {?} toLocationId
     * @param {?} orderId
     * @return {?}
     */
    function (toLocationId, orderId) {
        return __awaiter(this, void 0, void 0, function () {
            var alert;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.alertController.create({
                            header: "Are you sure you want mark order as received ?",
                            buttons: [
                                {
                                    text: "No",
                                    role: "cancel",
                                    cssClass: "secondary",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () { }),
                                },
                                {
                                    text: "Yes",
                                    handler: (/**
                                     * @return {?}
                                     */
                                    function () {
                                        _this.markAsReceived(toLocationId, orderId);
                                    }),
                                },
                            ],
                        })];
                    case 1:
                        alert = _a.sent();
                        return [4 /*yield*/, alert.present()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} toLocationId
     * @param {?} orderId
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.markAsReceived = /**
     * @param {?} toLocationId
     * @param {?} orderId
     * @return {?}
     */
    function (toLocationId, orderId) {
        var _this = this;
        this.orderDetailsService
            .markAsDelivered({
            dropLocationId: toLocationId,
            id: orderId,
        })
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.SHOW_TOAST, {
                message: "Order successfully marked as received.",
                color: "dark",
            });
            _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.REFRESH_ORDERS);
            _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, data.status, data);
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.orderDetailsService.onFailed(err);
        }));
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.markForDispatch = /**
     * @return {?}
     */
    function () {
        this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
            eventName: "MARKETPLACE_MARK_AS_DISPATCHED_BTN_CLICKED",
            params: {
                orderId: this.order.id,
            },
        });
        this.showMarkAsDispatchModal().then();
    };
    /*downloadInvoiceClicked() {
          const invoices = this.order.documents.filter((doc) => {
              return doc.type === 'ORDER_INVOICE';
          });
          if(invoices.length > 0) {
              this.downloadInvoice.emit(invoices[0]);
          }
      }*/
    /*downloadInvoiceClicked() {
            const invoices = this.order.documents.filter((doc) => {
                return doc.type === 'ORDER_INVOICE';
            });
            if(invoices.length > 0) {
                this.downloadInvoice.emit(invoices[0]);
            }
        }*/
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.orderImgCapture = /*downloadInvoiceClicked() {
            const invoices = this.order.documents.filter((doc) => {
                return doc.type === 'ORDER_INVOICE';
            });
            if(invoices.length > 0) {
                this.downloadInvoice.emit(invoices[0]);
            }
        }*/
    /**
     * @return {?}
     */
    function () {
        this.captureOrderItemImg.emit(this.order);
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.fetchAdditionalComments = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.orderDetailsService
            .getAdditionalInfo(this.order && this.order.saleOrder
            ? this.order.bidId
            : this.order.offerId)
            .subscribe((/**
         * @param {?} data
         * @return {?}
         */
        function (data) {
            _this.orderAdditionalComment = data ? data.info : "";
        }), (/**
         * @param {?} err
         * @return {?}
         */
        function (err) {
            _this.orderDetailsService.onFailed(err);
        }));
    };
    /*openFileUrlCallback = (url:  string) => {
          this.openFileUrl.emit(url);
      }*/
    /*openFileUrlCallback = (url:  string) => {
            this.openFileUrl.emit(url);
        }*/
    /**
     * @param {?} docs
     * @param {?} type
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.openFileManager = /*openFileUrlCallback = (url:  string) => {
            this.openFileUrl.emit(url);
        }*/
    /**
     * @param {?} docs
     * @param {?} type
     * @return {?}
     */
    function (docs, type) {
        /*const modalFM = await this.modalCtrl.create({
                component: RcylFileManagerComponent,
                cssClass: 'custom-bottom-sheet',
                componentProps: {
                    docs: docs,
                    docType: type,
                    order: this.order,
                    openFileUrl: this.openFileUrlCallback
                }
            });*/
        switch (type) {
            case "SELLER_WEIGH_BRIDGE":
                this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
                    eventName: "MARKETPLACE_SELLER_WEIGH_BRIDGE_OPENED",
                    params: {
                        orderId: this.order.id,
                    },
                });
                break;
            case "BUYER_WEIGH_BRIDGE":
                this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
                    eventName: "MARKETPLACE_BUYER_WEIGH_BRIDGE_OPENED",
                    params: {
                        orderId: this.order.id,
                    },
                });
        }
        /* modalFM.onDidDismiss().then(result => {
    
             });
             return await modalFM.present();*/
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.showMarkAsDispatchModal = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var markAsDispatchModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: MarkAsDispatchedModalComponent,
                            cssClass: "custom-bottom-sheet",
                            componentProps: {
                                orderDetails: this.order,
                                sellerWeighBridgeImgs: this.orderDocuments.SELLER_WEIGH_BRIDGE.documents,
                                captureWeighBridgeImg: this.captureWeighBridgeImg,
                                downloadDocumentCallback: this.downloadFile,
                                deleteDocumentCallback: this.fileManagerService.confirmAndDeleteDocument,
                            },
                        })];
                    case 1:
                        markAsDispatchModal = _a.sent();
                        markAsDispatchModal.onDidDismiss().then((/**
                         * @param {?} result
                         * @return {?}
                         */
                        function (result) {
                            if (result) {
                                if (result.role === "MARK_AS_DISPATCHED" && result.data) {
                                    _this.orderDetailsService
                                        .markAsScheduled(result.data.id, result.data)
                                        .subscribe((/**
                                     * @param {?} data
                                     * @return {?}
                                     */
                                    function (data) {
                                        _this.order = data;
                                        _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "STATUS", data);
                                        _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
                                            eventName: "MARKETPLACE_ORDER_DISPATCHED",
                                            params: {
                                                orderId: _this.order.id,
                                            },
                                        });
                                        _this.rcylOrdersService.presentToast("Order marked as dispatched");
                                    }), (/**
                                     * @param {?} err
                                     * @return {?}
                                     */
                                    function (err) {
                                        _this.orderDetailsService.onFailed(err);
                                    }));
                                }
                            }
                        }));
                        return [4 /*yield*/, markAsDispatchModal.present()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.beginQc = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var markQcDoneModal;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: MarkQualityCheckModalComponent,
                            componentProps: {
                                orderDetails: this.order,
                                orderLabReportDocs: this.orderDocuments.LAB_REPORT.documents,
                                captureLabReportImg: this.captureLabReportImg,
                                downloadDocumentCallback: this.downloadFile,
                                deleteDocumentCallback: this.fileManagerService.confirmAndDeleteDocument,
                            },
                            cssClass: "custom-bottom-sheet",
                        })];
                    case 1:
                        markQcDoneModal = _a.sent();
                        markQcDoneModal.onDidDismiss().then((/**
                         * @param {?} data
                         * @return {?}
                         */
                        function (data) {
                            if (data.role === "QC_DONE_CLICKED" && data.data) {
                                _this.orderDetailsService.markAsComplete(data.data).subscribe((/**
                                 * @param {?} data
                                 * @return {?}
                                 */
                                function (data) {
                                    _this.rcylOrdersService
                                        .presentToast("Quality check completed successfully.")
                                        .then();
                                    _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED, "STATUS", data);
                                    _this.event.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ANALYTICS, {
                                        eventName: "MARKETPLACE_QC_DONE_SUCCESS",
                                        params: {
                                            orderId: _this.order.id,
                                        },
                                    });
                                }), (/**
                                 * @param {?} err
                                 * @return {?}
                                 */
                                function (err) {
                                    _this.orderDetailsService.onFailed(err);
                                }));
                                console.log(data.data);
                            }
                        }));
                        return [2 /*return*/, markQcDoneModal.present().then()];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.openDocumentManager = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var documentMgrModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: RcylOrderDocumentsManagerComponent,
                            componentProps: {
                                orderDetails: this.order,
                                orderDocumentsMap: this.orderDocuments,
                                orderStatusLogs: this.orderStatusLogs,
                                selectAndUploadImgDocument: this.selectAndUploadImgDocument,
                                downloadDocument: this.downloadDocument,
                                downloadProformaInvoice: this.downloadProformaInvoice,
                            },
                        })];
                    case 1:
                        documentMgrModal = _a.sent();
                        documentMgrModal.present().then();
                        documentMgrModal.onDidDismiss().then();
                        return [2 /*return*/, documentMgrModal];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.openTransportationDetailsModal = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var documentMgrModal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.modalCtrl.create({
                            component: TransportationDetailsModalComponent,
                            componentProps: {
                                orderDetails: this.order,
                                orderLogisticsDetails: this.orderLogisticsDetails,
                            },
                        })];
                    case 1:
                        documentMgrModal = _a.sent();
                        documentMgrModal.present().then();
                        documentMgrModal.onDidDismiss().then();
                        return [2 /*return*/, documentMgrModal];
                }
            });
        });
    };
    /**
     * @return {?}
     */
    MarketOrderDetailsComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.event.unsubscribe(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.ORDER_CHANGED);
    };
    MarketOrderDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-market-order-details",
                    template: "<div class=\"market-order-details\">\n  <ion-grid *ngIf=\"order\" no-padding>\n    <ion-row>\n      <ion-col\n        text-center=\"\"\n        size=\"12\"\n        no-padding-bottom=\"\"\n        no-padding-left\n        no-padding-right\n        class=\"order-status\"\n      >\n        <ion-text font-bold color=\"primary\">\n          \u2022\n          {{\n            (order?.status === \"ORDER_COMPLETED\" && order?.payment\n              ? order?.payment?.statusTitle\n              : order?.displayStatusTitle\n            ) | uppercase\n          }}\n          \u2022\n        </ion-text>\n      </ion-col>\n      <!--<ion-col size=\"12\" text-center>\n                <ion-button color=\"medium\" size=\"small\" >Invoices & other documents</ion-button>\n            </ion-col>-->\n      <ion-col\n        text-center=\"\"\n        size=\"12\"\n        no-padding-top=\"\"\n        no-padding-left\n        no-padding-right\n        class=\"order-status-subtitle\"\n      >\n        <ion-text color=\"medium\">\n          <span *ngIf=\"order?.status === 'CREATED'\">\n            <span *ngIf=\"order?.saleOrder\">Order allocated to buyer</span>\n            <span *ngIf=\"!order?.saleOrder\">Order allocated to seller</span>\n          </span>\n          <span *ngIf=\"order?.status === 'PICKUP_SCHEDULED'\">\n            Order dispatched to buyer\n          </span>\n          <span *ngIf=\"order?.status === 'SETTLED'\">Payment Completed.</span>\n          <span *ngIf=\"order?.status === 'MATERIAL_RECEIVED'\">\n            Order delivered to buyer location\n          </span>\n        </ion-text>\n      </ion-col>\n    </ion-row>\n\n    <!--<ion-row *ngIf=\"order?.status === 'CREATED'\">\n            <ion-col size=\"12\" text-center=\"\" no-padding-bottom=\"\" no-padding-left no-padding-right\n                     class=\"download-invoice\">\n                <ion-button color=\"medium\" size=\"small\" (click)=\"downloadInvoiceClicked()\" font-regular=\"\">\n                    <ion-icon size=\"small\" name=\"download\"></ion-icon>\n                    DOWNLOAD INVOICE\n                </ion-button>\n            </ion-col>\n            <ion-col class=\"download-invoice-subtitle\" size=\"12\" *ngIf=\"order?.status === 'CREATED'\" text-center=\"\"\n                     no-padding-top=\"\" no-padding-left no-padding-right>\n                <ion-text color=\"medium\">Download creation invoice</ion-text>\n            </ion-col>\n        </ion-row>-->\n    <!-- <ion-row *ngIf=\"order?.status === 'PICKUP_SCHEDULED'\">\n            <ion-col size=\"12\" text-center=\"\" no-padding-left no-padding-right no-padding-bottom=\"\"\n                     class=\"download-invoice\">\n                <ion-button (click)=\"openFileManager(orderSellerWeighBridgeDocs, 'SELLER_WEIGH_BRIDGE')\" color=\"medium\"\n                            size=\"small\" font-regular>\n                    <ion-icon size=\"small\" name=\"document\"></ion-icon>\n                    SELLER WEIGHBRIDGE\n                </ion-button>\n            </ion-col>\n            <ion-col class=\"download-invoice-subtitle\" size=\"12\" *ngIf=\"order?.status === 'CREATED'\" text-center=\"\"\n                     no-padding-left no-padding-right no-padding-top=\"\">\n                <ion-text color=\"medium\"> Before & after loading both bills required</ion-text>\n            </ion-col>\n        </ion-row>-->\n    <!-- <ion-row *ngIf=\"containsInStatusLog('MATERIAL_RECEIVED')\" class=\"download-buttons\">\n            <ion-col text-center [size]=\"containsInStatusLog('ORDER_COMPLETED') ? 4: 6\"\n                     class=\"download-invoice\">\n                <ion-button (click)=\"openFileManager(orderSellerWeighBridgeDocs, 'SELLER_WEIGH_BRIDGE')\" color=\"medium\"\n                            font-regular>\n                    <ion-icon size=\"small\" name=\"eye\"></ion-icon>\n                    SELLER WEIGHBRIDGE\n                </ion-button>\n            </ion-col>\n\n            <ion-col text-center [size]=\"containsInStatusLog('ORDER_COMPLETED') ? 4 : 6\" no-padding-left\n                     class=\"download-invoice\">\n                <ion-button (click)=\"openFileManager(orderBuyerWeighBridgeDocs, 'BUYER_WEIGH_BRIDGE')\" color=\"medium\"\n                            font-regular>\n                    <ion-icon size=\"small\" name=\"eye\"></ion-icon>\n                    BUYER WEIGHBRIDGE\n                </ion-button>\n            </ion-col>\n\n            <ion-col size=\"4\" *ngIf=\"containsInStatusLog('ORDER_COMPLETED')\"  no-padding-left\n                     text-center class=\"download-invoice\">\n                <ion-button (click)=\"openFileManager(orderLabReportDocs, 'LAB_REPORT')\" color=\"medium\" font-regular>\n                    <ion-icon size=\"small\" name=\"eye\"></ion-icon>\n                    LAB REPORT\n                </ion-button>\n            </ion-col>\n\n        </ion-row>-->\n\n    <ion-row>\n      <!-- item info -->\n      <ion-col size=\"12\" no-padding-left no-padding-right>\n        <ion-card no-margin no-box-shadow class=\"item-card\">\n          <ion-row *ngFor=\"let orderItem of order?.orderItems\">\n            <ion-col\n              size=\"6\"\n              text-left=\"\"\n              class=\"item-name\"\n              no-padding-left=\"\"\n              no-padding-bottom=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold>{{\n                orderItem?.item?.name\n              }}</ion-text>\n              <br />\n              <ion-text color=\"medium\" font-regular=\"\">ITEM</ion-text>\n            </ion-col>\n            <ion-col\n              size=\"6\"\n              text-right=\"\"\n              class=\"item-rate\"\n              no-padding-right=\"\"\n              no-padding-bottom=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold>{{\n                orderItem?.itemPrice | currency: \"INR\"\n              }}</ion-text>\n              <br />\n              <ion-text color=\"medium\" font-regular=\"\"\n                >Price per {{ orderItem?.item?.unitType }}</ion-text\n              >\n            </ion-col>\n            <ion-col\n              size=\"12\"\n              padding-top=\"\"\n              d-flex\n              text-right=\"\"\n              class=\"view-quality-req\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-bottom=\"\"\n            >\n              <ion-icon size=\"small\" color=\"primary\" name=\"document\"></ion-icon>\n              <ion-text\n                color=\"primary\"\n                font-bold=\"\"\n                (click)=\"viewQualityRequirementClicked(orderItem?.item)\"\n                >View Quality Requirement\n              </ion-text>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- item info end -->\n\n      <!-- quantity and amount info -->\n      <ion-col size=\"12\" no-padding-left no-padding-right>\n        <ion-card no-margin no-box-shadow class=\"card-expandable qty-amt-card\">\n          <ion-row (click)=\"qtyAmtCard = !qtyAmtCard\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\">QUANTITY & AMOUNT</ion-text>\n              <ion-icon\n                float-end=\"\"\n                [color]=\"qtyAmtCard ? 'medium' : 'light'\"\n                [name]=\"\n                  qtyAmtCard ? 'arrow-dropup-circle' : 'arrow-dropdown-circle'\n                \"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n          <ion-row *ngIf=\"qtyAmtCard\" text-center=\"\" padding-top=\"\">\n            <ion-col size=\"12\" no-padding>\n              <ion-row text-left=\"\">\n                <ion-col size=\"4\" class=\"status\" padding-start=\"\">\n                  <ion-text color=\"dark\" font-bold=\"\">Allocated</ion-text>\n                </ion-col>\n                <ion-col class=\"amt\" size=\"4\" padding-start=\"\">\n                  <ion-text color=\"medium\" font-regular=\"\">{{\n                    order?.orderItems[0]?.formattedQty\n                  }}</ion-text>\n                </ion-col>\n                <ion-col size=\"4\" padding-start=\"\" class=\"price\">\n                  <ion-text color=\"dark\" font-bold=\"\">{{\n                    order?.orderItems[0]?.initialAmount | currency: \"INR\"\n                  }}</ion-text>\n                </ion-col>\n              </ion-row>\n            </ion-col>\n            <ion-col\n              size=\"12\"\n              no-padding\n              *ngIf=\"\n                order?.orderItems[0]?.formattedVerifyQty &&\n                containsInStatusLog('PICKUP_SCHEDULED')\n              \"\n            >\n              <ion-row text-left=\"\">\n                <ion-col size=\"4\" padding-start=\"\" class=\"status\">\n                  <ion-text color=\"dark\" font-bold=\"\">Dispatched</ion-text>\n                </ion-col>\n                <ion-col class=\"amt\" size=\"4\" padding-start=\"\">\n                  <ion-text color=\"medium\" font-regular=\"\">{{\n                    order?.orderItems[0]?.formattedVerifyQty\n                  }}</ion-text>\n                </ion-col>\n                <ion-col size=\"4\" padding-start=\"\" class=\"price\">\n                  <ion-text color=\"dark\" font-bold=\"\">\n                    {{ order?.orderItems[0]?.verifiedAmount | currency: \"INR\" }}\n                  </ion-text>\n                </ion-col>\n              </ion-row>\n            </ion-col>\n            <ion-col\n              size=\"12\"\n              no-padding\n              *ngIf=\"\n                order?.orderItems[0]?.formattedReceivedQty &&\n                containsInStatusLog('ORDER_COMPLETED')\n              \"\n            >\n              <ion-row text-left=\"\">\n                <ion-col size=\"4\" padding-start=\"\" class=\"status\">\n                  <ion-text color=\"primary\" font-bold=\"\">Final</ion-text>\n                </ion-col>\n                <ion-col size=\"4\" class=\"amt\" padding-start=\"\">\n                  <ion-text color=\"primary\" font-regular=\"\">{{\n                    order?.orderItems[0]?.formattedReceivedQty\n                  }}</ion-text>\n                </ion-col>\n                <ion-col size=\"4\" padding-start=\"\" class=\"price\">\n                  <ion-text color=\"primary\" font-bold=\"\">{{\n                    order?.orderItems[0]?.receivedAmount | currency: \"INR\"\n                  }}</ion-text>\n                </ion-col>\n              </ion-row>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- quantity and amount info end -->\n\n      <!-- logistic form open -->\n      <ion-col\n        size=\"12\"\n        no-padding-left\n        no-padding-right\n        *ngIf=\"\n          order?.saleOrder &&\n          !orderLogisticsDetails &&\n          !containsInStatusLog(orderStatuses.MATERIAL_PICKED)\n        \"\n      >\n        <ion-card\n          no-margin\n          no-box-shadow\n          class=\"card-expandable transport-details-card\"\n        >\n          <ion-row (click)=\"openTransportationDetailsModal()\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\"\n                >TRANSPORTER AND DRIVER DETAILS</ion-text\n              >\n              <ion-icon\n                float-end=\"\"\n                color=\"light\"\n                name=\"arrow-dropright-circle\"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- logistic form open end -->\n\n      <!-- transporter and vehicle details -->\n      <ion-col size=\"12\" no-padding *ngIf=\"orderLogisticsDetails\">\n        <rcyl-transporter-vehicle-details\n          [enableEdit]=\"order?.saleOrder\"\n          [orderStatusLogs]=\"orderStatusLogs\"\n          (openTransportationDetailsModal)=\"openTransportationDetailsModal()\"\n          [orderLogisticsDetails]=\"orderLogisticsDetails\"\n        ></rcyl-transporter-vehicle-details>\n      </ion-col>\n      <!-- transporter and vehicle details end -->\n\n      <!-- driver information -->\n      <ion-col size=\"12\" no-padding *ngIf=\"orderLogisticsDetails\">\n        <rcyl-driver-details\n          [enableEdit]=\"order?.saleOrder\"\n          [orderLogisticsDetails]=\"orderLogisticsDetails\"\n          [orderStatusLogs]=\"orderStatusLogs\"\n          (openTransportationDetailsModal)=\"openTransportationDetailsModal()\"\n        ></rcyl-driver-details>\n      </ion-col>\n\n      <!-- driver information -->\n\n      <!-- transportation details -->\n      <ion-col size=\"12\" no-padding-left no-padding-right>\n        <ion-card\n          no-margin\n          no-box-shadow\n          class=\"card-expandable transport-details-card\"\n        >\n          <ion-row (click)=\"transDetailsCard = !transDetailsCard\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\"\n                >TRANSPORTATION DETAILS</ion-text\n              >\n              <ion-icon\n                float-end=\"\"\n                [color]=\"transDetailsCard ? 'medium' : 'light'\"\n                [name]=\"\n                  transDetailsCard\n                    ? 'arrow-dropup-circle'\n                    : 'arrow-dropdown-circle'\n                \"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n          <ion-row *ngIf=\"transDetailsCard\">\n            <ion-col\n              size=\"12\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-bottom=\"\"\n              padding-top=\"\"\n            >\n              <ion-row>\n                <ion-col size=\"10\" text-left=\"\">\n                  <ion-text color=\"medium\" class=\"to-from-location\" font-bold\n                    >Dispatched From\n                  </ion-text>\n                  <br />\n                  <ion-text color=\"dark\" class=\"location-name\">{{\n                    order?.fromLocation?.name | uppercase\n                  }}</ion-text>\n                  <br />\n                  <ion-text color=\"dark\" font-bold class=\"street\"\n                    >{{\n                      order?.fromLocation?.addressInfo?.landmark\n                        ? order?.fromLocation?.addressInfo?.landmark + \",\"\n                        : \"\"\n                    }}\n                    {{ order?.fromLocation?.addressInfo?.street }}</ion-text\n                  >\n                </ion-col>\n                <!--<ion-col size=\"2\" *ngIf=\"order?.status === 'CREATED'\">\n                                    <ion-button float-end=\"\" color=\"medium\" size=\"small\" fill=\"outline\">\n                                        EDIT\n                                    </ion-button>\n                                </ion-col>-->\n              </ion-row>\n            </ion-col>\n            <ion-col\n              size=\"12\"\n              no-padding=\"\"\n              *ngIf=\"order?.status === 'SETTLED'\"\n            >\n              <ion-row>\n                <ion-col size=\"10\" text-left=\"\">\n                  <ion-label color=\"medium\" class=\"to-from-location\" font-bold\n                    >Delivered At\n                  </ion-label>\n                  <br />\n                  <ion-text color=\"dark\" class=\"location-name\">{{\n                    order?.toLocation?.name | uppercase\n                  }}</ion-text>\n                  <br />\n                  <ion-text color=\"dark\" font-bold class=\"street\"\n                    >{{\n                      order?.toLocation?.addressInfo?.landmark\n                        ? order?.toLocation?.addressInfo?.landmark + \",\"\n                        : \"\"\n                    }}\n                    {{ order?.toLocation?.addressInfo?.street }}</ion-text\n                  >\n                </ion-col>\n                <!--<ion-col size=\"2\" *ngIf=\"order?.status === 'CREATED'\">\n                                    <ion-button float-end=\"\" color=\"light\" size=\"small\" fill=\"outline\">EDIT</ion-button>\n                                </ion-col>-->\n              </ion-row>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- transportation details end-->\n\n      <!-- buyer details -->\n      <ion-col\n        size=\"12\"\n        *ngIf=\"order?.saleOrder\"\n        no-padding-left\n        no-padding-right\n      >\n        <ion-card\n          no-margin\n          no-box-shadow\n          class=\"card-expandable buyer-seller-details-card\"\n        >\n          <ion-row (click)=\"buyerSellerDetailsCard = !buyerSellerDetailsCard\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\">BUYER DETAILS</ion-text>\n              <ion-icon\n                float-end=\"\"\n                [color]=\"buyerSellerDetailsCard ? 'medium' : 'light'\"\n                [name]=\"\n                  buyerSellerDetailsCard\n                    ? 'arrow-dropup-circle'\n                    : 'arrow-dropdown-circle'\n                \"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n          <ion-row *ngIf=\"buyerSellerDetailsCard\" padding-top=\"\">\n            <ion-col size=\"12\" no-padding-top=\"\">\n              <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                >Buyer Name</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                order?.buyer?.name\n              }}</ion-text>\n            </ion-col>\n            <ion-col size=\"12\">\n              <ion-text color=\"medium\" class=\"info-label\"\n                >Contact Number</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                order?.buyer?.mobile\n              }}</ion-text>\n            </ion-col>\n            <ion-col size=\"12\">\n              <ion-text color=\"medium\" class=\"info-label\"\n                >Buyer Address</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                {{\n                  order?.buyer?.address?.landmark\n                    ? order?.buyer?.address?.landmark + \", \"\n                    : \"\"\n                }}\n                {{ order?.buyer?.address?.street }}\n              </ion-text>\n            </ion-col>\n            <ion-col size=\"12\" *ngIf=\"orderAdditionalComment\">\n              <ion-text color=\"medium\" class=\"info-label\"\n                >Additional Comments</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                {{ orderAdditionalComment }}\n              </ion-text>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- buyer details end -->\n\n      <!-- seller details -->\n      <ion-col\n        size=\"12\"\n        *ngIf=\"!order?.saleOrder\"\n        no-padding-left\n        no-padding-right\n      >\n        <ion-card\n          no-margin\n          no-box-shadow\n          class=\"card-expandable buyer-seller-details-card\"\n        >\n          <ion-row (click)=\"buyerSellerDetailsCard = !buyerSellerDetailsCard\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\">SELLER DETAILS</ion-text>\n              <ion-icon\n                float-end=\"\"\n                [color]=\"buyerSellerDetailsCard ? 'medium' : 'light'\"\n                [name]=\"\n                  buyerSellerDetailsCard\n                    ? 'arrow-dropup-circle'\n                    : 'arrow-dropdown-circle'\n                \"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n          <ion-row *ngIf=\"buyerSellerDetailsCard\" padding-top=\"\">\n            <ion-col size=\"12\" no-padding-top=\"\">\n              <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                >Seller Name</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                order?.seller?.name\n              }}</ion-text>\n            </ion-col>\n            <ion-col size=\"12\">\n              <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                >Contact Number</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                order?.seller?.mobile\n              }}</ion-text>\n            </ion-col>\n            <ion-col size=\"12\">\n              <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                >Seller Address</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                {{\n                  order?.seller?.address?.landmark\n                    ? order?.seller?.address?.landmark + \", \"\n                    : \"\"\n                }}\n                {{ order?.seller?.address?.street }}\n              </ion-text>\n            </ion-col>\n            <ion-col size=\"12\" *ngIf=\"orderAdditionalComment\">\n              <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                >Additional Comments</ion-text\n              >\n              <br />\n              <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                {{ orderAdditionalComment }}\n              </ion-text>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- seller details end -->\n\n      <!-- view upload item image -->\n      <ion-col\n        size=\"12\"\n        no-padding-left\n        no-padding-right\n        *ngIf=\"\n          order?.saleOrder ||\n          (!order?.saleOrder &&\n            orderDocuments[orderDocumentTypes.ITEM_IMAGE]?.documents.length > 0)\n        \"\n      >\n        <ion-card\n          no-margin\n          no-box-shadow\n          class=\"card-expandable upload-img-card\"\n        >\n          <ion-row (click)=\"uploadImgCard = !uploadImgCard\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\" *ngIf=\"order?.saleOrder\"\n                >UPLOAD IMAGE\n              </ion-text>\n              <ion-text color=\"dark\" font-bold=\"\" *ngIf=\"!order?.saleOrder\"\n                >VIEW IMAGE\n              </ion-text>\n              <ion-icon\n                float-end=\"\"\n                [color]=\"uploadImgCard ? 'medium' : 'light'\"\n                [name]=\"\n                  uploadImgCard\n                    ? 'arrow-dropup-circle'\n                    : 'arrow-dropdown-circle'\n                \"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n          <ion-row *ngIf=\"uploadImgCard\">\n            <ion-col no-padding=\"\" size=\"12\">\n              <rcyl-img-list\n                [docList]=\"orderDocuments.ITEM_IMAGE.documents\"\n                (onCapture)=\"orderImgCapture()\"\n                [docType]=\"orderDocumentTypes.ITEM_IMAGE\"\n                [downloadDocumentCallback]=\"downloadFile\"\n                [deleteDocumentCallback]=\"confirmAndDeleteDocument\"\n                [showDelete]=\"order?.saleOrder\"\n                [showCapture]=\"order?.saleOrder\"\n              ></rcyl-img-list>\n            </ion-col>\n            <ion-col\n              size=\"12\"\n              text-center=\"\"\n              class=\"desc-text\"\n              *ngIf=\"order?.saleOrder\"\n            >\n              <ion-text color=\"dark\">\n                Images required for before loading, while loading and after\n                loading the material. Also, when the vehicle leaves the pickup\n                location. Please make sure that vehicle number is visible in\n                atleast one of the images that you upload\n              </ion-text>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- view upload item image end-->\n\n      <!-- document manager -->\n      <ion-col size=\"12\" no-padding-left no-padding-right>\n        <ion-card no-margin no-box-shadow class=\"card-expandable qty-amt-card\">\n          <ion-row (click)=\"openDocumentManager()\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\"\n                >INVOICES & DOCUMENTS</ion-text\n              >\n              <ion-icon\n                color=\"light\"\n                float-end=\"\"\n                name=\"arrow-dropright-circle\"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- document manager end -->\n\n      <!-- order status flow -->\n      <ion-col no-padding-left no-padding-right size=\"12\">\n        <ion-card\n          no-margin\n          no-box-shadow\n          class=\"card-expandable order-status-flow-card\"\n        >\n          <ion-row (click)=\"orderStatusFlow = !orderStatusFlow\">\n            <ion-col\n              size=\"12\"\n              class=\"card-title\"\n              no-padding-left=\"\"\n              no-padding-right=\"\"\n              no-padding-top=\"\"\n            >\n              <ion-text color=\"dark\" font-bold=\"\">ORDER STATUS FLOW</ion-text>\n              <ion-icon\n                float-end=\"\"\n                [color]=\"orderStatusFlow ? 'medium' : 'light'\"\n                [name]=\"\n                  orderStatusFlow\n                    ? 'arrow-dropup-circle'\n                    : 'arrow-dropdown-circle'\n                \"\n              ></ion-icon>\n            </ion-col>\n          </ion-row>\n          <ion-row *ngIf=\"orderStatusFlow\">\n            <ion-col size=\"12\" no-padding-top=\"\">\n              <div class=\"timeline-wrapper\">\n                <ul class=\"step-progress\">\n                  <li\n                    class=\"step-progress-item\"\n                    [ngClass]=\"{ 'is-done': containsInStatusLog('CREATED') }\"\n                  >\n                    <ion-text color=\"dark\" font-bold=\"\">Created</ion-text>\n                    <br />\n                    <ion-text color=\"medium\">\n                      {{ order?.createdDate | date: \"d MMMM, y\" }}\n                      at {{ order?.createdDate | date: \"HH:MM a\" }}\n                    </ion-text>\n                  </li>\n                  <li\n                    class=\"step-progress-item step-danger\"\n                    *ngIf=\"\n                      order?.status === 'CANCELLED' ||\n                      order?.status === 'REJECTED'\n                    \"\n                    [ngClass]=\"{\n                      'is-done':\n                        containsInStatusLog('CANCELLED') ||\n                        containsInStatusLog('REJECTED')\n                    }\"\n                  >\n                    <ion-text color=\"dark\" font-bold=\"\">Cancelled</ion-text>\n                    <br />\n                    <ion-text color=\"medium\">\n                      Your order is cancelled.\n                    </ion-text>\n                  </li>\n                  <li\n                    class=\"step-progress-item\"\n                    [ngClass]=\"{\n                      'is-done': containsInStatusLog('PICKUP_SCHEDULED')\n                    }\"\n                  >\n                    <ion-text color=\"dark\" font-bold=\"\">Dispatched</ion-text>\n                    <br />\n                    <ion-text\n                      color=\"medium\"\n                      *ngIf=\"!containsInStatusLog('PICKUP_SCHEDULED')\"\n                    >\n                      Your order is yet to dispatch.\n                    </ion-text>\n                    <ion-text\n                      color=\"medium\"\n                      *ngIf=\"containsInStatusLog('PICKUP_SCHEDULED')\"\n                    >\n                      Your order is dispatched.\n                    </ion-text>\n                  </li>\n                  <li\n                    class=\"step-progress-item\"\n                    [ngClass]=\"{\n                      'is-done': containsInStatusLog('MATERIAL_RECEIVED')\n                    }\"\n                  >\n                    <ion-text color=\"dark\" font-bold=\"\">{{\n                      order?.saleOrder ? \"Delivered\" : \"Received\"\n                    }}</ion-text>\n                    <br />\n                    <ion-text\n                      color=\"medium\"\n                      *ngIf=\"!containsInStatusLog('MATERIAL_RECEIVED')\"\n                    >\n                      Your order is yet to be\n                      {{ order?.saleOrder ? \"delivered\" : \"received\" }}.\n                    </ion-text>\n                    <ion-text\n                      color=\"medium\"\n                      *ngIf=\"containsInStatusLog('MATERIAL_RECEIVED')\"\n                    >\n                      Your order is\n                      {{ order?.saleOrder ? \"delivered\" : \"received\" }}.\n                    </ion-text>\n                  </li>\n                  <li\n                    class=\"step-progress-item\"\n                    [ngClass]=\"{\n                      'is-done':\n                        containsInStatusLog('COMPLETED') ||\n                        containsInStatusLog('ORDER_COMPLETED')\n                    }\"\n                  >\n                    <ion-text color=\"dark\" font-bold=\"\">QC Done</ion-text>\n                    <br />\n                    <ion-text color=\"medium\">Material got QC'ed.</ion-text>\n                  </li>\n                  <li\n                    class=\"step-progress-item\"\n                    [ngClass]=\"{ 'is-done': containsInStatusLog('COMPLETED') }\"\n                  >\n                    <ion-text color=\"dark\" font-bold=\"\">Completed</ion-text>\n                    <br />\n                    <ion-text color=\"medium\"\n                      >The transaction has been completed.</ion-text\n                    >\n                  </li>\n                </ul>\n              </div>\n            </ion-col>\n          </ion-row>\n        </ion-card>\n      </ion-col>\n      <!-- order status flow end -->\n\n      <!-- Bottom buttons -->\n      <ion-col\n        no-padding-left\n        *ngIf=\"order?.status === 'CREATED'\"\n        size=\"12\"\n        no-padding-right=\"\"\n        text-center\n        align-items-center=\"\"\n      >\n        <div class=\"two-bottom-btn\" text-center=\"\">\n          <ion-button\n            *ngIf=\"order?.saleOrder\"\n            class=\"bottom-btn\"\n            (click)=\"markForDispatch()\"\n            size=\"small\"\n            color=\"medium\"\n          >\n            <ion-icon name=\"time\"></ion-icon>\n            Mark for Dispatch\n          </ion-button>\n          <ion-button\n            class=\"bottom-btn\"\n            (click)=\"openCancelOrderDialog()\"\n            size=\"small\"\n            color=\"medium\"\n          >\n            <ion-icon name=\"close\" mode=\"ios\"></ion-icon>\n            Cancel Order\n          </ion-button>\n        </div>\n      </ion-col>\n      <ion-col\n        no-padding-left\n        *ngIf=\"order?.status === 'PICKUP_SCHEDULED' && !order?.saleOrder\"\n        size=\"12\"\n        no-padding-right=\"\"\n        text-center\n      >\n        <ion-button\n          class=\"bottom-btn\"\n          (click)=\"promptFormMarkAsReceived(order?.toLocation?.id, order?.id)\"\n          size=\"small\"\n          color=\"medium\"\n        >\n          <ion-icon name=\"time\"></ion-icon>\n          &nbsp;Mark as Received\n        </ion-button>\n      </ion-col>\n      <ion-col\n        *ngIf=\"order?.status === 'MATERIAL_RECEIVED' && !order?.saleOrder\"\n        no-padding-left\n        size=\"12\"\n        no-padding-right=\"\"\n        text-center\n      >\n        <ion-button\n          (click)=\"beginQc()\"\n          class=\"bottom-btn\"\n          size=\"small\"\n          color=\"medium\"\n        >\n          <ion-icon name=\"time\"></ion-icon>\n          &nbsp;Begin Quality Check\n        </ion-button>\n      </ion-col>\n      <!-- Bottom buttons end -->\n    </ion-row>\n  </ion-grid>\n</div>\n",
                    styles: [".rcyl-order-status-created{background-color:#72abea;--background:#72abea}.rcyl-order-status-scheduled{background-color:#ffa25f;--background:#ffa25f}.rcyl-order-status-on-hold{background-color:#ffd378;--background:#ffd378}.rcyl-order-status-picked{background-color:#bee2c6;--background:#bee2c6;color:rgba(0,0,0,.8);--color:rgba(0, 0, 0, 0.8)}.rcyl-order-status-received{background-color:#89cb97;--background:#89cb97}.rcyl-order-status-completed{background-color:#54b468;--background:#54b468}.rcyl-order-status-invoice-pending{background-color:#ffef8c;--background:#ffef8c;color:rgba(0,0,0,.7);--color:rgba(0, 0, 0, 0.7)}.rcyl-order-status-payment-pending{background-color:#fcd974;--background:#fcd974}.rcyl-order-status-invoice-verification-pending{background-color:#fbc45b;--background:#fbc45b}.rcyl-order-status-invoice-rejected{background-color:#ff7a5f;--background:#ff7a5f}.rcyl-order-status-rejected{background-color:#ff5545;--background:#ff5545}.rcyl-order-status-cancelled{background-color:#f2503b;--background:#f2503b}::ng-deep .full-width-modal .modal-wrapper{--width:100vw;width:100vw;--height:100vh;height:100vh;--max-width:100vw;max-width:100vw;max-height:100vh;--max-height:100vh;--background:transparent}.market-order-details [padding-5]{padding:5px}.market-order-details [font-bold]{font-weight:700}.market-order-details .order-status{text-align:center}.market-order-details .order-status ion-text{line-height:17px;letter-spacing:2.8px;opacity:1}.market-order-details .order-status-subtitle{text-align:center}.market-order-details .order-status-subtitle ion-text,.market-order-details .order-status-subtitle span{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .download-invoice ion-button{--border-radius:5px;white-space:pre-line;font-size:10px;line-height:.7692rem;letter-spacing:0;text-transform:uppercase;opacity:1;--padding-top:7px;--padding-bottom:7px;--padding-start:10px;--padding-end:10px;width:100%}.market-order-details .download-invoice ion-button ion-icon{font-size:10px;padding-right:2px}.market-order-details .download-invoice-subtitle ion-text{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .download-buttons ion-button .button-custom-content{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-flow:column;white-space:pre-line}.market-order-details ion-card{padding:10px}.market-order-details .item-card .item-name ion-text[color=dark]{font-size:1.231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .item-card .item-name ion-text[color=medium]{font-size:.9231rem;line-height:.7692rem;letter-spacing:2.4px;text-transform:uppercase;opacity:1}.market-order-details .item-card .item-rate ion-text[color=dark]{font-size:1.231rem;line-height:19px;letter-spacing:0}.market-order-details .item-card .item-rate ion-text[color=medium]{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .item-card .view-quality-req ion-icon,.market-order-details .item-card .view-quality-req ion-text{font-size:.9231rem;letter-spacing:0;opacity:1}.market-order-details .card-expandable .card-title ion-text[color=dark]{font-size:1.077rem;line-height:1.077rem;letter-spacing:2.1px;opacity:1}.market-order-details .card-expandable .card-title ion-icon{font-size:24px}.market-order-details .qty-amt-card .status{border-right:1px solid var(--ion-color-light)}.market-order-details .qty-amt-card .status ion-text[font-bold]{font-size:1.077rem;line-height:1.077rem;letter-spacing:0;opacity:1}.market-order-details .qty-amt-card .amt{border-right:1px solid var(--ion-color-light)}.market-order-details .qty-amt-card .amt ion-text[font-regular],.market-order-details .qty-amt-card .price ion-text[font-bold]{font-size:1.231rem;line-height:1.077rem;letter-spacing:0;opacity:1}.market-order-details .transport-details-card .to-from-location{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .transport-details-card .location-name{font-size:1.077rem;line-height:28px;letter-spacing:0;opacity:1;text-transform:capitalize}.market-order-details .transport-details-card .street{font-size:1.077rem;line-height:1.231rem;letter-spacing:0;opacity:1}.market-order-details .buyer-seller-details-card .info-label{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .buyer-seller-details-card .info{font-size:1.077rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .order-status-flow-card .step-progress-item ion-text[color=dark]{text-align:left;font-size:1.385rem;line-height:.7692rem;letter-spacing:0;opacity:1}.market-order-details .order-status-flow-card .step-progress-item ion-text[color=medium]{font-size:1.077rem;line-height:.7692rem;text-align:left;letter-spacing:0;color:#5b7583;opacity:1}.market-order-details .bottom-btn{font-size:1.231rem;line-height:.7692rem;letter-spacing:0;opacity:1;--border-radius:4px;--padding-start:15px;--padding-end:15px;--padding-top:10px;--padding-bottom:10px}.market-order-details .two-bottom-btn .bottom-btn{--padding-start:6px;--padding-end:6px;-webkit-margin-end:4px;margin-inline-end:4px}.market-order-details .upload-img-card .desc-text ion-text{font-size:.9231rem;line-height:15px;letter-spacing:0;opacity:1}.market-order-details .timeline-wrapper{min-width:400px}.market-order-details .step-progress{position:relative;padding-left:45px;list-style:none}.market-order-details .step-progress::before{display:inline-block;content:\"\";position:absolute;top:0;left:15px;width:10px;height:100%;border-left:1.5px dashed var(--ion-color-light)}.market-order-details .step-progress-item{position:relative;counter-increment:list}.market-order-details .step-progress-item:not(:last-child){padding-bottom:20px}.market-order-details .step-progress-item::before{display:inline-block;content:\"\";position:absolute;left:-30px;height:100%;width:10px}.market-order-details .step-progress-item::after{content:\"\";display:inline-block;position:absolute;top:0;left:-37px;width:12px;height:12px;border:1.5px solid var(--ion-color-light);border-radius:50%;background-color:var(--ion-color-light)}.market-order-details .step-danger::after{border:1.5px solid!important;background-color:var(--ion-color-danger)!important}.market-order-details .step-danger::before{border-left:1.5px dashed!important}.market-order-details .step-progress-item.is-done::before{border-left:1.5px dashed var(--ion-color-primary-tint)}.market-order-details .step-progress-item.is-done::after{font-size:10px;color:var(--ion-color-light);text-align:center;border:1.5px solid var(--ion-color-primary-tint);background-color:var(--ion-color-primary)}.market-order-details .step-progress strong{display:block}::ng-deep .custom-bottom-sheet{--height:auto}::ng-deep .custom-bottom-sheet.bottom{-webkit-box-align:end;align-items:flex-end}::ng-deep .custom-bottom-sheet .modal-wrapper{bottom:0;position:absolute;border-radius:10px 10px 0 0}::ng-deep .custom-bottom-sheet .ion-page{position:relative;display:block;contain:content}::ng-deep .custom-bottom-sheet .ion-page .inner-content{max-height:82vh;overflow:auto;padding:0 10px}"]
                }] }
    ];
    /** @nocollapse */
    MarketOrderDetailsComponent.ctorParameters = function () { return [
        { type: RcylOrderDetailsService },
        { type: Platform },
        { type: ModalController },
        { type: LoadingController },
        { type: ToastController },
        { type: Events },
        { type: RcylOrdersService },
        { type: AlertController },
        { type: RcylFileManagerService },
        { type: RcylOrderLogisticsService }
    ]; };
    MarketOrderDetailsComponent.propDecorators = {
        orderId: [{ type: Input }],
        getConfig: [{ type: Input }],
        viewQualityReqClicked: [{ type: Output }],
        captureOrderItemImg: [{ type: Output }],
        captureWeighBridgeImg: [{ type: Output }],
        captureLabReportImg: [{ type: Output }],
        selectAndUploadImgDocument: [{ type: Output }],
        downloadDocument: [{ type: Output }],
        downloadProformaInvoice: [{ type: Output }]
    };
    return MarketOrderDetailsComponent;
}());
if (false) {
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderId;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.getConfig;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.viewQualityReqClicked;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.captureOrderItemImg;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.captureWeighBridgeImg;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.captureLabReportImg;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.selectAndUploadImgDocument;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.downloadDocument;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.downloadProformaInvoice;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.order;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderStatuses;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderDocuments;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderDocumentTypes;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderLogisticsDetails;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderStatusLogs;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.isDesktop;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.qtyAmtCard;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.transDetailsCard;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.transporterDetails;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.driverDetails;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.buyerSellerDetailsCard;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.uploadImgCard;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderStatusFlow;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.orderAdditionalComment;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.orderDetailsSubscriber;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.orderLogisticsDetailsSubscription;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.downloadFile;
    /** @type {?} */
    MarketOrderDetailsComponent.prototype.confirmAndDeleteDocument;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.orderDetailsService;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.platform;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.modalCtrl;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.loadingCtrl;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.event;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.rcylOrdersService;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.alertController;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.fileManagerService;
    /**
     * @type {?}
     * @private
     */
    MarketOrderDetailsComponent.prototype.orderLogisticsService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkAsDispatchedModalModule = /** @class */ (function () {
    function MarkAsDispatchedModalModule() {
    }
    MarkAsDispatchedModalModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MarkAsDispatchedModalComponent],
                    imports: [CommonModule, IonicModule, RcylImgListModule, FormsModule],
                    entryComponents: [MarkAsDispatchedModalComponent],
                    exports: [MarkAsDispatchedModalComponent],
                    providers: [],
                },] }
    ];
    return MarkAsDispatchedModalModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var MarkQualityCheckModalModule = /** @class */ (function () {
    function MarkQualityCheckModalModule() {
    }
    MarkQualityCheckModalModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [MarkQualityCheckModalComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        RcylImgListModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    entryComponents: [MarkQualityCheckModalComponent],
                    exports: [MarkQualityCheckModalComponent],
                    providers: [],
                },] }
    ];
    return MarkQualityCheckModalModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TransportationDetailsModalComponentModule = /** @class */ (function () {
    function TransportationDetailsModalComponentModule() {
    }
    TransportationDetailsModalComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [TransportationDetailsModalComponent],
                    imports: [
                        CommonModule,
                        IonicModule,
                        ReactiveFormsModule,
                        DropdownModule,
                        FormsModule,
                    ],
                    entryComponents: [TransportationDetailsModalComponent],
                    exports: [TransportationDetailsModalComponent],
                },] }
    ];
    return TransportationDetailsModalComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylTransporterVehicleDetailsComponent = /** @class */ (function () {
    function RcylTransporterVehicleDetailsComponent(orderConfig) {
        this.orderConfig = orderConfig;
        this.openTransportationDetailsModal = new EventEmitter();
        this.orderStatuses = OrderStatus;
    }
    /**
     * @return {?}
     */
    RcylTransporterVehicleDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} statusName
     * @return {?}
     */
    RcylTransporterVehicleDetailsComponent.prototype.containsInStatusLog = /**
     * @param {?} statusName
     * @return {?}
     */
    function (statusName) {
        if (this.orderStatusLogs) {
            return this.orderStatusLogs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.id && item.toStatus === statusName ? item : false;
            })).length;
        }
        else {
            return 0;
        }
    };
    RcylTransporterVehicleDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-transporter-vehicle-details",
                    template: "<div [ngSwitch]=\"orderConfig?.channel\">\n  <ng-template [ngSwitchCase]=\"'RECYKAL'\">\n    <ion-grid no-padding>\n      <ion-row no-padding>\n        <ion-col\n          size=\"12\"\n          no-padding-left\n          no-padding-right\n          *ngIf=\"orderLogisticsDetails\"\n        >\n          <ion-card\n            no-margin\n            no-box-shadow\n            class=\"card-expandable transporter-details-card\"\n          >\n            <ion-row\n              (click)=\"\n                transporterDetailsExpandCollapse =\n                  !transporterDetailsExpandCollapse\n              \"\n            >\n              <ion-col\n                size=\"12\"\n                class=\"card-title\"\n                no-padding-left=\"\"\n                no-padding-right=\"\"\n                no-padding-top=\"\"\n              >\n                <ion-text color=\"dark\" font-bold=\"\"\n                  >Transporter and vehicle details</ion-text\n                >\n                <ion-icon\n                  float-end=\"\"\n                  [color]=\"\n                    transporterDetailsExpandCollapse ? 'medium' : 'light'\n                  \"\n                  [name]=\"\n                    transporterDetailsExpandCollapse\n                      ? 'arrow-dropup-circle'\n                      : 'arrow-dropdown-circle'\n                  \"\n                ></ion-icon>\n              </ion-col>\n            </ion-row>\n            <ion-row *ngIf=\"transporterDetailsExpandCollapse\">\n              <ion-col\n                size=\"12\"\n                no-padding-left=\"\"\n                no-padding-right=\"\"\n                no-padding-bottom=\"\"\n                padding-top=\"\"\n              >\n                <ion-row>\n                  <ion-col size=\"10\" text-left=\"\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold>\n                      Transporter Name\n                    </ion-text>\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                      {{\n                        orderLogisticsDetails?.logisticsTransporters?.name\n                          ? orderLogisticsDetails?.logisticsTransporters?.name\n                          : \"-\"\n                      }}\n                    </ion-text>\n                  </ion-col>\n                  <ion-col size=\"2\" *ngIf=\"enableEdit\">\n                    <ion-button\n                      [disabled]=\"\n                        containsInStatusLog(orderStatuses.MATERIAL_PICKED)\n                      \"\n                      float-end=\"\"\n                      color=\"medium\"\n                      size=\"small\"\n                      fill=\"outline\"\n                      (click)=\"openTransportationDetailsModal.emit()\"\n                    >\n                      EDIT\n                    </ion-button>\n                  </ion-col>\n\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Vehicle Type</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                      {{\n                        orderLogisticsDetails?.logisticsVehicle?.vehicleType\n                          ? orderLogisticsDetails?.logisticsVehicle?.vehicleType\n                          : \"-\"\n                      }}\n                    </ion-text>\n                  </ion-col>\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Vehicle Capacity</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.vehicleCapacity\n                        ? orderLogisticsDetails?.vehicleCapacity + \" Tonnes\"\n                        : \"-\"\n                    }}</ion-text>\n                  </ion-col>\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Vehicle Number</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.vehicleNumber\n                        ? orderLogisticsDetails?.vehicleNumber\n                        : \"-\"\n                    }}</ion-text>\n                  </ion-col>\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Validity of National Permit/State Permit</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.vehiclePermit ? \"Yes\" : \"No\"\n                    }}</ion-text>\n                  </ion-col>\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Insurance Available</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.vehicleInsurance ? \"Yes\" : \"No\"\n                    }}</ion-text>\n                  </ion-col>\n                </ion-row>\n              </ion-col>\n            </ion-row>\n          </ion-card>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </ng-template>\n  <ng-template [ngSwitchCase]=\"'STARGAZE'\">\n    <ion-card class=\"transporter-details-card card-details\">\n      <ion-grid>\n        <ion-row *ngIf=\"orderLogisticsDetails; else noTransportDetails\">\n          <ion-col size=\"6\" text-left=\"\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold\n            >\n              Transporter Name\n            </ion-text>\n            <br />\n            <ion-text color=\"dark\" class=\"info\">\n              {{\n                orderLogisticsDetails?.logisticsTransporters?.name\n                  ? orderLogisticsDetails?.logisticsTransporters?.name\n                  : \"-\"\n              }}\n            </ion-text>\n          </ion-col>\n\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Vehicle Number</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.vehicleNumber\n                ? orderLogisticsDetails?.vehicleNumber\n                : \"-\"\n            }}</ion-text>\n          </ion-col>\n\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Vehicle Type</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">\n              {{\n                orderLogisticsDetails?.logisticsVehicle?.vehicleType\n                  ? orderLogisticsDetails?.logisticsVehicle?.vehicleType\n                  : \"-\"\n              }}\n            </ion-text>\n          </ion-col>\n\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Validity of National Permit/State Permit</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.vehiclePermit ? \"Yes\" : \"No\"\n            }}</ion-text>\n          </ion-col>\n\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Vehicle Capacity</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.vehicleCapacity\n                ? orderLogisticsDetails?.vehicleCapacity + \" Tonnes\"\n                : \"-\"\n            }}</ion-text>\n          </ion-col>\n\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Insurance Available</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.vehicleInsurance ? \"Yes\" : \"No\"\n            }}</ion-text>\n          </ion-col>\n        </ion-row>\n        <ng-template #noTransportDetails>\n          <div\n            style=\"\n              height: 15vh;\n              display: flex;\n              width: 100%;\n              flex-direction: column;\n            \"\n            align-items-center\n            justify-content-center\n          >\n            <div text-center *ngIf=\"!orderLogisticsDetails\">\n              <ion-title font-bold class=\"text-large\" color=\"medium\"\n                >No Transport Details</ion-title\n              >\n              <ion-text color=\"medium\"\n                >There are no Transport Details. Please add your\n                details</ion-text\n              >\n            </div>\n          </div>\n        </ng-template>\n      </ion-grid>\n    </ion-card>\n  </ng-template>\n</div>\n",
                    styles: [".card-expandable .card-title ion-text[color=dark]{font-size:1.077rem;line-height:1.077rem;letter-spacing:2.1px;opacity:1;text-transform:uppercase}.card-expandable .card-title ion-icon{font-size:24px}.transporter-details-card .info-label{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.transporter-details-card .info{font-size:1.077rem;line-height:.7692rem;letter-spacing:0;opacity:1}ion-card{padding:10px}.card-details{background-color:var(--ion-color-light);box-shadow:none;padding:0!important;margin-top:-5px!important;margin-left:5px!important;margin-right:5px!important;border-bottom-left-radius:5px;border-bottom-right-radius:5px}.letter-spacing-1{letter-spacing:1px}"]
                }] }
    ];
    /** @nocollapse */
    RcylTransporterVehicleDetailsComponent.ctorParameters = function () { return [
        { type: RcylOrderConfigService }
    ]; };
    RcylTransporterVehicleDetailsComponent.propDecorators = {
        orderLogisticsDetails: [{ type: Input }],
        orderStatusLogs: [{ type: Input }],
        enableEdit: [{ type: Input }],
        openTransportationDetailsModal: [{ type: Output }]
    };
    return RcylTransporterVehicleDetailsComponent;
}());
if (false) {
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.orderLogisticsDetails;
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.orderStatusLogs;
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.enableEdit;
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.openTransportationDetailsModal;
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.transporterDetailsExpandCollapse;
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.orderStatuses;
    /** @type {?} */
    RcylTransporterVehicleDetailsComponent.prototype.orderConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylTransporterVehicleDetailsComponentModule = /** @class */ (function () {
    function RcylTransporterVehicleDetailsComponentModule() {
    }
    RcylTransporterVehicleDetailsComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RcylTransporterVehicleDetailsComponent],
                    imports: [CommonModule, IonicModule, ReactiveFormsModule],
                    exports: [RcylTransporterVehicleDetailsComponent],
                },] }
    ];
    return RcylTransporterVehicleDetailsComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylDriverDetailsComponent = /** @class */ (function () {
    function RcylDriverDetailsComponent(orderLogisticsService, orderConfig) {
        this.orderLogisticsService = orderLogisticsService;
        this.orderConfig = orderConfig;
        this.openTransportationDetailsModal = new EventEmitter();
        this.orderStatuses = OrderStatus;
    }
    /**
     * @return {?}
     */
    RcylDriverDetailsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () { };
    /**
     * @param {?} val
     * @return {?}
     */
    RcylDriverDetailsComponent.prototype.getIdProofDisplayName = /**
     * @param {?} val
     * @return {?}
     */
    function (val) {
        return this.orderLogisticsService.getIdProofDisplayNameByVal(val);
    };
    /**
     * @param {?} statusName
     * @return {?}
     */
    RcylDriverDetailsComponent.prototype.containsInStatusLog = /**
     * @param {?} statusName
     * @return {?}
     */
    function (statusName) {
        if (this.orderStatusLogs) {
            return this.orderStatusLogs.filter((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return item.id && item.toStatus === statusName ? item : false;
            })).length;
        }
        else {
            return 0;
        }
    };
    RcylDriverDetailsComponent.decorators = [
        { type: Component, args: [{
                    selector: "rcyl-driver-details",
                    template: "<div [ngSwitch]=\"orderConfig?.channel\">\n  <!--Recykal app driver details and UI-->\n\n  <ng-template [ngSwitchCase]=\"'RECYKAL'\">\n    <ion-grid no-padding>\n      <ion-row no-padding>\n        <ion-col\n          size=\"12\"\n          no-padding-left\n          no-padding-right\n          *ngIf=\"orderLogisticsDetails\"\n        >\n          <ion-card\n            no-margin\n            no-box-shadow\n            class=\"card-expandable driver-details-card\"\n          >\n            <ion-row (click)=\"driverDetails = !driverDetails\">\n              <ion-col\n                size=\"12\"\n                class=\"card-title\"\n                no-padding-left=\"\"\n                no-padding-right=\"\"\n                no-padding-top=\"\"\n              >\n                <ion-text color=\"dark\" font-bold=\"\"\n                  >Driver Information</ion-text\n                >\n                <ion-icon\n                  float-end=\"\"\n                  [color]=\"driverDetails ? 'medium' : 'light'\"\n                  [name]=\"\n                    driverDetails\n                      ? 'arrow-dropup-circle'\n                      : 'arrow-dropdown-circle'\n                  \"\n                ></ion-icon>\n              </ion-col>\n            </ion-row>\n            <ion-row *ngIf=\"driverDetails\">\n              <ion-col\n                size=\"12\"\n                no-padding-left=\"\"\n                no-padding-right=\"\"\n                no-padding-bottom=\"\"\n                padding-top=\"\"\n              >\n                <ion-row>\n                  <ion-col size=\"10\" text-left=\"\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold>\n                      Driver Name\n                    </ion-text>\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.driverName\n                        ? orderLogisticsDetails?.driverName\n                        : \"-\"\n                    }}</ion-text>\n                  </ion-col>\n                  <ion-col size=\"2\" *ngIf=\"enableEdit\">\n                    <ion-button\n                      float-end=\"\"\n                      [disabled]=\"\n                        containsInStatusLog(orderStatuses.MATERIAL_PICKED)\n                      \"\n                      color=\"medium\"\n                      size=\"small\"\n                      fill=\"outline\"\n                      (click)=\"openTransportationDetailsModal.emit()\"\n                    >\n                      EDIT\n                    </ion-button>\n                  </ion-col>\n\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Driver Mobile Number</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.driverContact\n                        ? orderLogisticsDetails?.driverContact\n                        : \"-\"\n                    }}</ion-text>\n                  </ion-col>\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >ID Proof</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">\n                      <span\n                        *ngIf=\"\n                          orderLogisticsDetails?.idProofNo &&\n                          orderLogisticsDetails?.idProof\n                        \"\n                      >\n                        {{ orderLogisticsDetails?.idProofNo }} ({{\n                          getIdProofDisplayName(orderLogisticsDetails?.idProof)\n                        }})\n                      </span>\n                      <span\n                        *ngIf=\"\n                          !(\n                            orderLogisticsDetails?.idProofNo &&\n                            orderLogisticsDetails?.idProof\n                          )\n                        \"\n                        >-</span\n                      >\n                    </ion-text>\n                  </ion-col>\n                  <ion-col size=\"12\">\n                    <ion-text color=\"medium\" class=\"info-label\" font-bold=\"\"\n                      >Driving License</ion-text\n                    >\n                    <br />\n                    <ion-text color=\"dark\" class=\"info\" font-bold=\"\">{{\n                      orderLogisticsDetails?.driverLicenceNo\n                        ? orderLogisticsDetails?.driverLicenceNo\n                        : \"-\"\n                    }}</ion-text>\n                  </ion-col>\n                </ion-row>\n              </ion-col>\n            </ion-row>\n          </ion-card>\n        </ion-col>\n      </ion-row>\n    </ion-grid>\n  </ng-template>\n\n  <!--Stargaze driver details and UI-->\n\n  <ng-template [ngSwitchCase]=\"'STARGAZE'\">\n    <ion-card class=\"driver-details-card card-details\">\n      <ion-grid>\n        <ion-row *ngIf=\"orderLogisticsDetails; else noDriverDetails\">\n          <ion-col size=\"6\" text-left=\"\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold\n            >\n              Driver Name\n            </ion-text>\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.driverName\n                ? orderLogisticsDetails?.driverName\n                : \"-\"\n            }}</ion-text>\n          </ion-col>\n\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Driver Mobile Number</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.driverContact\n                ? orderLogisticsDetails?.driverContact\n                : \"-\"\n            }}</ion-text>\n          </ion-col>\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >ID Proof</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">\n              <span\n                *ngIf=\"\n                  orderLogisticsDetails?.idProofNo &&\n                  orderLogisticsDetails?.idProof\n                \"\n              >\n                {{ orderLogisticsDetails?.idProofNo }} ({{\n                  getIdProofDisplayName(orderLogisticsDetails?.idProof)\n                }})\n              </span>\n              <span\n                *ngIf=\"\n                  !(\n                    orderLogisticsDetails?.idProofNo &&\n                    orderLogisticsDetails?.idProof\n                  )\n                \"\n                >-</span\n              >\n            </ion-text>\n          </ion-col>\n          <ion-col size=\"6\">\n            <ion-text\n              color=\"medium\"\n              class=\"text-small ion-text-uppercase letter-spacing-1\"\n              font-bold=\"\"\n              >Driving License</ion-text\n            >\n            <br />\n            <ion-text color=\"dark\" class=\"info\">{{\n              orderLogisticsDetails?.driverLicenceNo\n                ? orderLogisticsDetails?.driverLicenceNo\n                : \"-\"\n            }}</ion-text>\n          </ion-col>\n        </ion-row>\n        <ng-template #noDriverDetails>\n          <div\n            style=\"\n              height: 15vh;\n              display: flex;\n              width: 100%;\n              flex-direction: column;\n            \"\n            align-items-center\n            justify-content-center\n          >\n            <div text-center *ngIf=\"!orderLogisticsDetails\">\n              <ion-title font-bold class=\"text-large\" color=\"medium\"\n                >No Driver Details</ion-title\n              >\n              <ion-text color=\"medium\"\n                >There are no Driver Details. Please add your details</ion-text\n              >\n            </div>\n          </div>\n        </ng-template>\n      </ion-grid>\n    </ion-card>\n  </ng-template>\n</div>\n",
                    styles: [".card-expandable .card-title ion-text[color=dark]{font-size:1.077rem;line-height:1.077rem;letter-spacing:2.1px;opacity:1;text-transform:uppercase}.card-expandable .card-title ion-icon{font-size:24px}.driver-details-card .info-label{font-size:.9231rem;line-height:.7692rem;letter-spacing:0;opacity:1}.driver-details-card .info{font-size:1.077rem;line-height:.7692rem;letter-spacing:0;opacity:1}ion-card{padding:10px}.card-details{background-color:var(--ion-color-light);box-shadow:none;padding:0!important;margin-top:-5px!important;margin-left:5px!important;margin-right:5px!important}.letter-spacing-1{letter-spacing:1px}"]
                }] }
    ];
    /** @nocollapse */
    RcylDriverDetailsComponent.ctorParameters = function () { return [
        { type: RcylOrderLogisticsService },
        { type: RcylOrderConfigService }
    ]; };
    RcylDriverDetailsComponent.propDecorators = {
        orderLogisticsDetails: [{ type: Input }],
        enableEdit: [{ type: Input }],
        orderStatusLogs: [{ type: Input }],
        openTransportationDetailsModal: [{ type: Output }]
    };
    return RcylDriverDetailsComponent;
}());
if (false) {
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.orderLogisticsDetails;
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.enableEdit;
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.orderStatusLogs;
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.openTransportationDetailsModal;
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.driverDetails;
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.orderStatuses;
    /**
     * @type {?}
     * @private
     */
    RcylDriverDetailsComponent.prototype.orderLogisticsService;
    /** @type {?} */
    RcylDriverDetailsComponent.prototype.orderConfig;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylDriverDetailsComponentModule = /** @class */ (function () {
    function RcylDriverDetailsComponentModule() {
    }
    RcylDriverDetailsComponentModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [RcylDriverDetailsComponent],
                    imports: [CommonModule, IonicModule, ReactiveFormsModule],
                    exports: [RcylDriverDetailsComponent],
                },] }
    ];
    return RcylDriverDetailsComponentModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderDetailsModule = /** @class */ (function () {
    function RcylOrderDetailsModule() {
    }
    RcylOrderDetailsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [
                        RcylOrderDetailsComponent,
                        CustomerDetailsComponent,
                        PickupDetailsComponent,
                        StatusDetailsComponent,
                        ItemDetailsComponent,
                        RcylSelectTimeslotModalComponent,
                        MarketOrderDetailsComponent,
                        CancelReasonModalComponent,
                    ],
                    imports: [
                        CommonModule,
                        IonicModule,
                        TableModule,
                        FormsModule,
                        FileUploadModule,
                        CancelOrderButtonModule,
                        StatusFlowModule,
                        CancelOrderButtonModule,
                        TimeslotButtonModule,
                        VerifyInvoiceButtonModule,
                        MakePaymentButtonModule,
                        AddItemButtonModule,
                        RcylSharedModule,
                        AddNotesButtonModule,
                        NotesDetailsModule,
                        PaymentSummaryModule,
                        OrderStatusModule,
                        RcylFileManagerModule,
                        MarkAsDispatchedModalModule,
                        MarkQualityCheckModalModule,
                        TransportationDetailsModalComponentModule,
                        RcylTransporterVehicleDetailsComponentModule,
                        RcylDriverDetailsComponentModule,
                        TooltipModule,
                        CalendarModule,
                        OverlayPanelModule,
                    ],
                    exports: [
                        RcylOrderDetailsComponent,
                        CustomerDetailsComponent,
                        PickupDetailsComponent,
                        StatusDetailsComponent,
                        ItemDetailsComponent,
                        RcylSelectTimeslotModalComponent,
                        RcylFileManagerModule,
                        MarketOrderDetailsComponent,
                        MarkAsDispatchedModalModule,
                        CancelReasonModalComponent,
                        MarkQualityCheckModalModule,
                    ],
                    entryComponents: [
                        RcylSelectTimeslotModalComponent,
                        CancelReasonModalComponent,
                    ],
                },] }
    ];
    return RcylOrderDetailsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// WARNING: interface has both a type and a value, skipping emit
/** @type {?} */
var RcylOrdersConfig = new InjectionToken("RcylOrdersConfig");
var RcylOrdersModule = /** @class */ (function () {
    function RcylOrdersModule() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    RcylOrdersModule.forRoot = /**
     * @param {?} config
     * @return {?}
     */
    function (config) {
        return {
            ngModule: RcylOrdersModule,
            providers: [
                {
                    provide: RcylOrderConfigService,
                    useValue: config,
                },
            ],
        };
    };
    RcylOrdersModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        IonicModule,
                        OrderListModule,
                        RcylSharedModule,
                        RcylOrderDetailsModule,
                    ],
                    exports: [OrderListModule, RcylSharedModule, RcylOrderDetailsModule],
                },] }
    ];
    return RcylOrdersModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderConfigService = /** @class */ (function () {
    function RcylOrderConfigService(config) {
        this.config = config;
        this.channel = this.config.channel;
        this.apiUrl = this.config.apiUrl;
        console.log("RcylOrderConfigService", config);
    }
    RcylOrderConfigService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    RcylOrderConfigService.ctorParameters = function () { return [
        { type: RcylOrdersConfig, decorators: [{ type: Inject, args: [RcylOrderConfigService,] }] }
    ]; };
    /** @nocollapse */ RcylOrderConfigService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RcylOrderConfigService_Factory() { return new RcylOrderConfigService(ɵɵinject(RcylOrderConfigService)); }, token: RcylOrderConfigService, providedIn: "root" });
    return RcylOrderConfigService;
}());
if (false) {
    /** @type {?} */
    RcylOrderConfigService.prototype.channel;
    /** @type {?} */
    RcylOrderConfigService.prototype.apiUrl;
    /**
     * @type {?}
     * @private
     */
    RcylOrderConfigService.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrdersService = /** @class */ (function () {
    function RcylOrdersService(toast, orderConfig, events) {
        this.toast = toast;
        this.orderConfig = orderConfig;
        this.events = events;
    }
    /**
     * @param {?} msg
     * @return {?}
     */
    RcylOrdersService.prototype.presentToast = /**
     * @param {?} msg
     * @return {?}
     */
    function (msg) {
        return __awaiter(this, void 0, void 0, function () {
            var toast;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.orderConfig.channel === Channel.RECYKAL)) return [3 /*break*/, 1];
                        this.events.publish(RCYL_ORDERS_GLOBALS.EVENTS_TO_PUBLISH.SHOW_TOAST, {
                            message: msg,
                        });
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.toast.create({
                            message: msg,
                            duration: 3000,
                            cssClass: "custom-toast",
                            position: "bottom",
                        })];
                    case 2:
                        toast = _a.sent();
                        toast.present().then();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RcylOrdersService.decorators = [
        { type: Injectable, args: [{
                    providedIn: "root",
                },] }
    ];
    /** @nocollapse */
    RcylOrdersService.ctorParameters = function () { return [
        { type: ToastController },
        { type: RcylOrderConfigService },
        { type: Events }
    ]; };
    /** @nocollapse */ RcylOrdersService.ngInjectableDef = ɵɵdefineInjectable({ factory: function RcylOrdersService_Factory() { return new RcylOrdersService(ɵɵinject(ToastController), ɵɵinject(RcylOrderConfigService), ɵɵinject(Events)); }, token: RcylOrdersService, providedIn: "root" });
    return RcylOrdersService;
}());
if (false) {
    /**
     * @type {?}
     * @private
     */
    RcylOrdersService.prototype.toast;
    /**
     * @type {?}
     * @private
     */
    RcylOrdersService.prototype.orderConfig;
    /**
     * @type {?}
     * @private
     */
    RcylOrdersService.prototype.events;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var RcylOrderLogisticsModule = /** @class */ (function () {
    function RcylOrderLogisticsModule() {
    }
    RcylOrderLogisticsModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        IonicModule,
                        TransportationDetailsModalComponentModule,
                        RcylDriverDetailsComponentModule,
                        RcylTransporterVehicleDetailsComponentModule,
                    ],
                    exports: [
                        TransportationDetailsModalComponentModule,
                        RcylDriverDetailsComponentModule,
                        RcylTransporterVehicleDetailsComponentModule,
                    ],
                    entryComponents: [],
                },] }
    ];
    return RcylOrderLogisticsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Channel, DropDownType, FileManagerComponentModule, FilterInputType, ImgViewerComponent, ImgViewerComponentModule, OrderListColumn, OrderListModule, OrderTemplateType, OrderType, Page, RCYL_ORDERS_GLOBALS, RcylFileManagerModule, RcylFileManagerService, RcylOrderDetailsModule, RcylOrderDocumentsManagerComponent, RcylOrderDocumentsManagerComponentModule, RcylOrderLogisticsModule, RcylOrdersConfig, RcylOrdersModule, RcylOrdersService, RcylSharedModule, RcylOrderConfigService as ɵa, OrderListComponent as ɵb, MakePaymentButtonModule as ɵba, MakePaymentButtonComponent as ɵbb, VerifyInvoiceButtonModule as ɵbc, VerifyInvoiceButtonComponent as ɵbd, DataFilterInputsModule as ɵbe, DataFilterInputsComponent as ɵbf, DataFilterInputsService as ɵbg, MarketOrderCardModule as ɵbh, MarketOrderCardComponent as ɵbi, OrderStatusModule as ɵbj, OrderStatusDirective as ɵbk, OrderCardModule as ɵbl, OrderCardComponent as ɵbm, RcylOrderDetailsComponent as ɵbn, RcylOrderDetailsService as ɵbo, RcylOrderLogisticsService as ɵbp, CustomerDetailsComponent as ɵbq, PickupDetailsComponent as ɵbr, StatusDetailsComponent as ɵbs, StatusDetailsService as ɵbt, ItemDetailsComponent as ɵbu, RcylSelectTimeslotModalComponent as ɵbv, MarketOrderDetailsComponent as ɵbw, CancelReasonModalComponent as ɵbx, CancelOrderButtonModule as ɵby, CancelOrderButtonComponent as ɵbz, OrderListService as ɵc, StatusFlowModule as ɵca, StatusFlowComponent as ɵcb, TimeslotButtonModule as ɵcc, TimeslotButtonComponent as ɵcd, AddItemButtonModule as ɵce, AddItemButtonComponent as ɵcf, ItemListModule as ɵcg, ItemListComponent as ɵch, ItemListService as ɵci, ItemComponent as ɵcj, RateQuantityModule as ɵck, RateQuantityComponent as ɵcl, AddNotesButtonModule as ɵcm, AddNotesButtonComponent as ɵcn, NotesDetailsModule as ɵco, NotesDetailsComponent as ɵcp, AddNewNotesModalModule as ɵcq, AddNewNotesModalComponent as ɵcr, UpdateNotesService as ɵcs, PaymentSummaryModule as ɵct, PaymentSummaryComponent as ɵcu, RcylFileManagerComponent as ɵcv, RcylDocumentSampleForUploadComponentModule as ɵcw, RcylDocumentSampleForUploadComponent as ɵcx, MarkAsDispatchedModalModule as ɵcy, MarkAsDispatchedModalComponent as ɵcz, OrderListDataModule as ɵd, MarkQualityCheckModalModule as ɵda, MarkQualityCheckModalComponent as ɵdb, TransportationDetailsModalComponentModule as ɵdc, TransportationDetailsModalComponent as ɵdd, RcylTransporterVehicleDetailsComponentModule as ɵde, RcylTransporterVehicleDetailsComponent as ɵdf, RcylDriverDetailsComponentModule as ɵdg, RcylDriverDetailsComponent as ɵdh, OrderListDataComponent as ɵe, SelectPickupExecutiveComponent as ɵf, SelectPickupExecutiveService as ɵg, DropLocationsComponent as ɵh, DropLocationsService as ɵi, MakePaymentModalComponent as ɵj, MakePaymentService as ɵk, LocationItemComponent as ɵl, CancelOrderModalComponent as ɵm, CancelOrderModalService as ɵn, TimeSlotModalComponent as ɵo, TimeSlotModalService as ɵp, InvoiceVerifyModalComponent as ɵq, InvoiceVerifyService as ɵr, AddressPipe as ɵs, RcylKeysPipe as ɵt, RcylFilterPipe as ɵu, OrderByPipe as ɵv, RcylImgListModule as ɵw, RcylImgListComponent as ɵx, ManageColumnsModule as ɵy, ManageColumnsComponent as ɵz };
//# sourceMappingURL=rcyl-orders.js.map
